/*! For license information please see app.bundle.js.LICENSE.txt */
!(function () {
    var e = {
            829: function (e, t) {
                var n;
                !(function (t, n) {
                    "use strict";
                    "object" == typeof e.exports
                        ? (e.exports = t.document
                              ? n(t, !0)
                              : function (e) {
                                    if (!e.document) throw new Error("jQuery requires a window with a document");
                                    return n(e);
                                })
                        : n(t);
                })("undefined" != typeof window ? window : this, function (i, s) {
                    "use strict";
                    var r = [],
                        a = Object.getPrototypeOf,
                        o = r.slice,
                        l = r.flat
                            ? function (e) {
                                  return r.flat.call(e);
                              }
                            : function (e) {
                                  return r.concat.apply([], e);
                              },
                        c = r.push,
                        d = r.indexOf,
                        u = {},
                        p = u.toString,
                        h = u.hasOwnProperty,
                        f = h.toString,
                        m = f.call(Object),
                        g = {},
                        v = function (e) {
                            return (
                                "function" == typeof e && "number" != typeof e.nodeType && "function" != typeof e.item
                            );
                        },
                        y = function (e) {
                            return null != e && e === e.window;
                        },
                        b = i.document,
                        w = { type: !0, src: !0, nonce: !0, noModule: !0 };
                    function C(e, t, n) {
                        var i,
                            s,
                            r = (n = n || b).createElement("script");
                        if (((r.text = e), t))
                            for (i in w) (s = t[i] || (t.getAttribute && t.getAttribute(i))) && r.setAttribute(i, s);
                        n.head.appendChild(r).parentNode.removeChild(r);
                    }
                    function x(e) {
                        return null == e
                            ? e + ""
                            : "object" == typeof e || "function" == typeof e
                              ? u[p.call(e)] || "object"
                              : typeof e;
                    }
                    var S = "3.6.4",
                        E = function (e, t) {
                            return new E.fn.init(e, t);
                        };
                    function T(e) {
                        var t = !!e && "length" in e && e.length,
                            n = x(e);
                        return (
                            !v(e) &&
                            !y(e) &&
                            ("array" === n || 0 === t || ("number" == typeof t && t > 0 && t - 1 in e))
                        );
                    }
                    (E.fn = E.prototype =
                        {
                            jquery: S,
                            constructor: E,
                            length: 0,
                            toArray: function () {
                                return o.call(this);
                            },
                            get: function (e) {
                                return null == e ? o.call(this) : e < 0 ? this[e + this.length] : this[e];
                            },
                            pushStack: function (e) {
                                var t = E.merge(this.constructor(), e);
                                return (t.prevObject = this), t;
                            },
                            each: function (e) {
                                return E.each(this, e);
                            },
                            map: function (e) {
                                return this.pushStack(
                                    E.map(this, function (t, n) {
                                        return e.call(t, n, t);
                                    })
                                );
                            },
                            slice: function () {
                                return this.pushStack(o.apply(this, arguments));
                            },
                            first: function () {
                                return this.eq(0);
                            },
                            last: function () {
                                return this.eq(-1);
                            },
                            even: function () {
                                return this.pushStack(
                                    E.grep(this, function (e, t) {
                                        return (t + 1) % 2;
                                    })
                                );
                            },
                            odd: function () {
                                return this.pushStack(
                                    E.grep(this, function (e, t) {
                                        return t % 2;
                                    })
                                );
                            },
                            eq: function (e) {
                                var t = this.length,
                                    n = +e + (e < 0 ? t : 0);
                                return this.pushStack(n >= 0 && n < t ? [this[n]] : []);
                            },
                            end: function () {
                                return this.prevObject || this.constructor();
                            },
                            push: c,
                            sort: r.sort,
                            splice: r.splice,
                        }),
                        (E.extend = E.fn.extend =
                            function () {
                                var e,
                                    t,
                                    n,
                                    i,
                                    s,
                                    r,
                                    a = arguments[0] || {},
                                    o = 1,
                                    l = arguments.length,
                                    c = !1;
                                for (
                                    "boolean" == typeof a && ((c = a), (a = arguments[o] || {}), o++),
                                        "object" == typeof a || v(a) || (a = {}),
                                        o === l && ((a = this), o--);
                                    o < l;
                                    o++
                                )
                                    if (null != (e = arguments[o]))
                                        for (t in e)
                                            (i = e[t]),
                                                "__proto__" !== t &&
                                                    a !== i &&
                                                    (c && i && (E.isPlainObject(i) || (s = Array.isArray(i)))
                                                        ? ((n = a[t]),
                                                          (r =
                                                              s && !Array.isArray(n)
                                                                  ? []
                                                                  : s || E.isPlainObject(n)
                                                                    ? n
                                                                    : {}),
                                                          (s = !1),
                                                          (a[t] = E.extend(c, r, i)))
                                                        : void 0 !== i && (a[t] = i));
                                return a;
                            }),
                        E.extend({
                            expando: "jQuery" + (S + Math.random()).replace(/\D/g, ""),
                            isReady: !0,
                            error: function (e) {
                                throw new Error(e);
                            },
                            noop: function () {},
                            isPlainObject: function (e) {
                                var t, n;
                                return !(
                                    !e ||
                                    "[object Object]" !== p.call(e) ||
                                    ((t = a(e)) &&
                                        ("function" != typeof (n = h.call(t, "constructor") && t.constructor) ||
                                            f.call(n) !== m))
                                );
                            },
                            isEmptyObject: function (e) {
                                var t;
                                for (t in e) return !1;
                                return !0;
                            },
                            globalEval: function (e, t, n) {
                                C(e, { nonce: t && t.nonce }, n);
                            },
                            each: function (e, t) {
                                var n,
                                    i = 0;
                                if (T(e)) for (n = e.length; i < n && !1 !== t.call(e[i], i, e[i]); i++);
                                else for (i in e) if (!1 === t.call(e[i], i, e[i])) break;
                                return e;
                            },
                            makeArray: function (e, t) {
                                var n = t || [];
                                return (
                                    null != e &&
                                        (T(Object(e)) ? E.merge(n, "string" == typeof e ? [e] : e) : c.call(n, e)),
                                    n
                                );
                            },
                            inArray: function (e, t, n) {
                                return null == t ? -1 : d.call(t, e, n);
                            },
                            merge: function (e, t) {
                                for (var n = +t.length, i = 0, s = e.length; i < n; i++) e[s++] = t[i];
                                return (e.length = s), e;
                            },
                            grep: function (e, t, n) {
                                for (var i = [], s = 0, r = e.length, a = !n; s < r; s++)
                                    !t(e[s], s) !== a && i.push(e[s]);
                                return i;
                            },
                            map: function (e, t, n) {
                                var i,
                                    s,
                                    r = 0,
                                    a = [];
                                if (T(e)) for (i = e.length; r < i; r++) null != (s = t(e[r], r, n)) && a.push(s);
                                else for (r in e) null != (s = t(e[r], r, n)) && a.push(s);
                                return l(a);
                            },
                            guid: 1,
                            support: g,
                        }),
                        "function" == typeof Symbol && (E.fn[Symbol.iterator] = r[Symbol.iterator]),
                        E.each(
                            "Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "),
                            function (e, t) {
                                u["[object " + t + "]"] = t.toLowerCase();
                            }
                        );
                    var $ = (function (e) {
                        var t,
                            n,
                            i,
                            s,
                            r,
                            a,
                            o,
                            l,
                            c,
                            d,
                            u,
                            p,
                            h,
                            f,
                            m,
                            g,
                            v,
                            y,
                            b,
                            w = "sizzle" + 1 * new Date(),
                            C = e.document,
                            x = 0,
                            S = 0,
                            E = le(),
                            T = le(),
                            $ = le(),
                            k = le(),
                            M = function (e, t) {
                                return e === t && (u = !0), 0;
                            },
                            L = {}.hasOwnProperty,
                            A = [],
                            I = A.pop,
                            _ = A.push,
                            P = A.push,
                            D = A.slice,
                            O = function (e, t) {
                                for (var n = 0, i = e.length; n < i; n++) if (e[n] === t) return n;
                                return -1;
                            },
                            N =
                                "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",
                            F = "[\\x20\\t\\r\\n\\f]",
                            j = "(?:\\\\[\\da-fA-F]{1,6}" + F + "?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+",
                            z =
                                "\\[" +
                                F +
                                "*(" +
                                j +
                                ")(?:" +
                                F +
                                "*([*^$|!~]?=)" +
                                F +
                                "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" +
                                j +
                                "))|)" +
                                F +
                                "*\\]",
                            B =
                                ":(" +
                                j +
                                ")(?:\\((('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|((?:\\\\.|[^\\\\()[\\]]|" +
                                z +
                                ")*)|.*)\\)|)",
                            q = new RegExp(F + "+", "g"),
                            H = new RegExp("^" + F + "+|((?:^|[^\\\\])(?:\\\\.)*)" + F + "+$", "g"),
                            R = new RegExp("^" + F + "*," + F + "*"),
                            V = new RegExp("^" + F + "*([>+~]|" + F + ")" + F + "*"),
                            G = new RegExp(F + "|>"),
                            W = new RegExp(B),
                            U = new RegExp("^" + j + "$"),
                            X = {
                                ID: new RegExp("^#(" + j + ")"),
                                CLASS: new RegExp("^\\.(" + j + ")"),
                                TAG: new RegExp("^(" + j + "|[*])"),
                                ATTR: new RegExp("^" + z),
                                PSEUDO: new RegExp("^" + B),
                                CHILD: new RegExp(
                                    "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" +
                                        F +
                                        "*(even|odd|(([+-]|)(\\d*)n|)" +
                                        F +
                                        "*(?:([+-]|)" +
                                        F +
                                        "*(\\d+)|))" +
                                        F +
                                        "*\\)|)",
                                    "i"
                                ),
                                bool: new RegExp("^(?:" + N + ")$", "i"),
                                needsContext: new RegExp(
                                    "^" +
                                        F +
                                        "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" +
                                        F +
                                        "*((?:-\\d)?\\d*)" +
                                        F +
                                        "*\\)|)(?=[^-]|$)",
                                    "i"
                                ),
                            },
                            Y = /HTML$/i,
                            K = /^(?:input|select|textarea|button)$/i,
                            Q = /^h\d$/i,
                            J = /^[^{]+\{\s*\[native \w/,
                            Z = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
                            ee = /[+~]/,
                            te = new RegExp("\\\\[\\da-fA-F]{1,6}" + F + "?|\\\\([^\\r\\n\\f])", "g"),
                            ne = function (e, t) {
                                var n = "0x" + e.slice(1) - 65536;
                                return (
                                    t ||
                                    (n < 0
                                        ? String.fromCharCode(n + 65536)
                                        : String.fromCharCode((n >> 10) | 55296, (1023 & n) | 56320))
                                );
                            },
                            ie = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,
                            se = function (e, t) {
                                return t
                                    ? "\0" === e
                                        ? "�"
                                        : e.slice(0, -1) + "\\" + e.charCodeAt(e.length - 1).toString(16) + " "
                                    : "\\" + e;
                            },
                            re = function () {
                                p();
                            },
                            ae = we(
                                function (e) {
                                    return !0 === e.disabled && "fieldset" === e.nodeName.toLowerCase();
                                },
                                { dir: "parentNode", next: "legend" }
                            );
                        try {
                            P.apply((A = D.call(C.childNodes)), C.childNodes), A[C.childNodes.length].nodeType;
                        } catch (e) {
                            P = {
                                apply: A.length
                                    ? function (e, t) {
                                          _.apply(e, D.call(t));
                                      }
                                    : function (e, t) {
                                          for (var n = e.length, i = 0; (e[n++] = t[i++]); );
                                          e.length = n - 1;
                                      },
                            };
                        }
                        function oe(e, t, i, s) {
                            var r,
                                o,
                                c,
                                d,
                                u,
                                f,
                                v,
                                y = t && t.ownerDocument,
                                C = t ? t.nodeType : 9;
                            if (((i = i || []), "string" != typeof e || !e || (1 !== C && 9 !== C && 11 !== C)))
                                return i;
                            if (!s && (p(t), (t = t || h), m)) {
                                if (11 !== C && (u = Z.exec(e)))
                                    if ((r = u[1])) {
                                        if (9 === C) {
                                            if (!(c = t.getElementById(r))) return i;
                                            if (c.id === r) return i.push(c), i;
                                        } else if (y && (c = y.getElementById(r)) && b(t, c) && c.id === r)
                                            return i.push(c), i;
                                    } else {
                                        if (u[2]) return P.apply(i, t.getElementsByTagName(e)), i;
                                        if ((r = u[3]) && n.getElementsByClassName && t.getElementsByClassName)
                                            return P.apply(i, t.getElementsByClassName(r)), i;
                                    }
                                if (
                                    n.qsa &&
                                    !k[e + " "] &&
                                    (!g || !g.test(e)) &&
                                    (1 !== C || "object" !== t.nodeName.toLowerCase())
                                ) {
                                    if (((v = e), (y = t), 1 === C && (G.test(e) || V.test(e)))) {
                                        for (
                                            ((y = (ee.test(e) && ve(t.parentNode)) || t) === t && n.scope) ||
                                                ((d = t.getAttribute("id"))
                                                    ? (d = d.replace(ie, se))
                                                    : t.setAttribute("id", (d = w))),
                                                o = (f = a(e)).length;
                                            o--;

                                        )
                                            f[o] = (d ? "#" + d : ":scope") + " " + be(f[o]);
                                        v = f.join(",");
                                    }
                                    try {
                                        return P.apply(i, y.querySelectorAll(v)), i;
                                    } catch (t) {
                                        k(e, !0);
                                    } finally {
                                        d === w && t.removeAttribute("id");
                                    }
                                }
                            }
                            return l(e.replace(H, "$1"), t, i, s);
                        }
                        function le() {
                            var e = [];
                            return function t(n, s) {
                                return e.push(n + " ") > i.cacheLength && delete t[e.shift()], (t[n + " "] = s);
                            };
                        }
                        function ce(e) {
                            return (e[w] = !0), e;
                        }
                        function de(e) {
                            var t = h.createElement("fieldset");
                            try {
                                return !!e(t);
                            } catch (e) {
                                return !1;
                            } finally {
                                t.parentNode && t.parentNode.removeChild(t), (t = null);
                            }
                        }
                        function ue(e, t) {
                            for (var n = e.split("|"), s = n.length; s--; ) i.attrHandle[n[s]] = t;
                        }
                        function pe(e, t) {
                            var n = t && e,
                                i = n && 1 === e.nodeType && 1 === t.nodeType && e.sourceIndex - t.sourceIndex;
                            if (i) return i;
                            if (n) for (; (n = n.nextSibling); ) if (n === t) return -1;
                            return e ? 1 : -1;
                        }
                        function he(e) {
                            return function (t) {
                                return "input" === t.nodeName.toLowerCase() && t.type === e;
                            };
                        }
                        function fe(e) {
                            return function (t) {
                                var n = t.nodeName.toLowerCase();
                                return ("input" === n || "button" === n) && t.type === e;
                            };
                        }
                        function me(e) {
                            return function (t) {
                                return "form" in t
                                    ? t.parentNode && !1 === t.disabled
                                        ? "label" in t
                                            ? "label" in t.parentNode
                                                ? t.parentNode.disabled === e
                                                : t.disabled === e
                                            : t.isDisabled === e || (t.isDisabled !== !e && ae(t) === e)
                                        : t.disabled === e
                                    : "label" in t && t.disabled === e;
                            };
                        }
                        function ge(e) {
                            return ce(function (t) {
                                return (
                                    (t = +t),
                                    ce(function (n, i) {
                                        for (var s, r = e([], n.length, t), a = r.length; a--; )
                                            n[(s = r[a])] && (n[s] = !(i[s] = n[s]));
                                    })
                                );
                            });
                        }
                        function ve(e) {
                            return e && void 0 !== e.getElementsByTagName && e;
                        }
                        for (t in ((n = oe.support = {}),
                        (r = oe.isXML =
                            function (e) {
                                var t = e && e.namespaceURI,
                                    n = e && (e.ownerDocument || e).documentElement;
                                return !Y.test(t || (n && n.nodeName) || "HTML");
                            }),
                        (p = oe.setDocument =
                            function (e) {
                                var t,
                                    s,
                                    a = e ? e.ownerDocument || e : C;
                                return a != h && 9 === a.nodeType && a.documentElement
                                    ? ((f = (h = a).documentElement),
                                      (m = !r(h)),
                                      C != h &&
                                          (s = h.defaultView) &&
                                          s.top !== s &&
                                          (s.addEventListener
                                              ? s.addEventListener("unload", re, !1)
                                              : s.attachEvent && s.attachEvent("onunload", re)),
                                      (n.scope = de(function (e) {
                                          return (
                                              f.appendChild(e).appendChild(h.createElement("div")),
                                              void 0 !== e.querySelectorAll &&
                                                  !e.querySelectorAll(":scope fieldset div").length
                                          );
                                      })),
                                      (n.cssHas = de(function () {
                                          try {
                                              return h.querySelector(":has(*,:jqfake)"), !1;
                                          } catch (e) {
                                              return !0;
                                          }
                                      })),
                                      (n.attributes = de(function (e) {
                                          return (e.className = "i"), !e.getAttribute("className");
                                      })),
                                      (n.getElementsByTagName = de(function (e) {
                                          return (
                                              e.appendChild(h.createComment("")), !e.getElementsByTagName("*").length
                                          );
                                      })),
                                      (n.getElementsByClassName = J.test(h.getElementsByClassName)),
                                      (n.getById = de(function (e) {
                                          return (
                                              (f.appendChild(e).id = w),
                                              !h.getElementsByName || !h.getElementsByName(w).length
                                          );
                                      })),
                                      n.getById
                                          ? ((i.filter.ID = function (e) {
                                                var t = e.replace(te, ne);
                                                return function (e) {
                                                    return e.getAttribute("id") === t;
                                                };
                                            }),
                                            (i.find.ID = function (e, t) {
                                                if (void 0 !== t.getElementById && m) {
                                                    var n = t.getElementById(e);
                                                    return n ? [n] : [];
                                                }
                                            }))
                                          : ((i.filter.ID = function (e) {
                                                var t = e.replace(te, ne);
                                                return function (e) {
                                                    var n = void 0 !== e.getAttributeNode && e.getAttributeNode("id");
                                                    return n && n.value === t;
                                                };
                                            }),
                                            (i.find.ID = function (e, t) {
                                                if (void 0 !== t.getElementById && m) {
                                                    var n,
                                                        i,
                                                        s,
                                                        r = t.getElementById(e);
                                                    if (r) {
                                                        if ((n = r.getAttributeNode("id")) && n.value === e) return [r];
                                                        for (s = t.getElementsByName(e), i = 0; (r = s[i++]); )
                                                            if ((n = r.getAttributeNode("id")) && n.value === e)
                                                                return [r];
                                                    }
                                                    return [];
                                                }
                                            })),
                                      (i.find.TAG = n.getElementsByTagName
                                          ? function (e, t) {
                                                return void 0 !== t.getElementsByTagName
                                                    ? t.getElementsByTagName(e)
                                                    : n.qsa
                                                      ? t.querySelectorAll(e)
                                                      : void 0;
                                            }
                                          : function (e, t) {
                                                var n,
                                                    i = [],
                                                    s = 0,
                                                    r = t.getElementsByTagName(e);
                                                if ("*" === e) {
                                                    for (; (n = r[s++]); ) 1 === n.nodeType && i.push(n);
                                                    return i;
                                                }
                                                return r;
                                            }),
                                      (i.find.CLASS =
                                          n.getElementsByClassName &&
                                          function (e, t) {
                                              if (void 0 !== t.getElementsByClassName && m)
                                                  return t.getElementsByClassName(e);
                                          }),
                                      (v = []),
                                      (g = []),
                                      (n.qsa = J.test(h.querySelectorAll)) &&
                                          (de(function (e) {
                                              var t;
                                              (f.appendChild(e).innerHTML =
                                                  "<a id='" +
                                                  w +
                                                  "'></a><select id='" +
                                                  w +
                                                  "-\r\\' msallowcapture=''><option selected=''></option></select>"),
                                                  e.querySelectorAll("[msallowcapture^='']").length &&
                                                      g.push("[*^$]=" + F + "*(?:''|\"\")"),
                                                  e.querySelectorAll("[selected]").length ||
                                                      g.push("\\[" + F + "*(?:value|" + N + ")"),
                                                  e.querySelectorAll("[id~=" + w + "-]").length || g.push("~="),
                                                  (t = h.createElement("input")).setAttribute("name", ""),
                                                  e.appendChild(t),
                                                  e.querySelectorAll("[name='']").length ||
                                                      g.push("\\[" + F + "*name" + F + "*=" + F + "*(?:''|\"\")"),
                                                  e.querySelectorAll(":checked").length || g.push(":checked"),
                                                  e.querySelectorAll("a#" + w + "+*").length || g.push(".#.+[+~]"),
                                                  e.querySelectorAll("\\\f"),
                                                  g.push("[\\r\\n\\f]");
                                          }),
                                          de(function (e) {
                                              e.innerHTML =
                                                  "<a href='' disabled='disabled'></a><select disabled='disabled'><option/></select>";
                                              var t = h.createElement("input");
                                              t.setAttribute("type", "hidden"),
                                                  e.appendChild(t).setAttribute("name", "D"),
                                                  e.querySelectorAll("[name=d]").length &&
                                                      g.push("name" + F + "*[*^$|!~]?="),
                                                  2 !== e.querySelectorAll(":enabled").length &&
                                                      g.push(":enabled", ":disabled"),
                                                  (f.appendChild(e).disabled = !0),
                                                  2 !== e.querySelectorAll(":disabled").length &&
                                                      g.push(":enabled", ":disabled"),
                                                  e.querySelectorAll("*,:x"),
                                                  g.push(",.*:");
                                          })),
                                      (n.matchesSelector = J.test(
                                          (y =
                                              f.matches ||
                                              f.webkitMatchesSelector ||
                                              f.mozMatchesSelector ||
                                              f.oMatchesSelector ||
                                              f.msMatchesSelector)
                                      )) &&
                                          de(function (e) {
                                              (n.disconnectedMatch = y.call(e, "*")),
                                                  y.call(e, "[s!='']:x"),
                                                  v.push("!=", B);
                                          }),
                                      n.cssHas || g.push(":has"),
                                      (g = g.length && new RegExp(g.join("|"))),
                                      (v = v.length && new RegExp(v.join("|"))),
                                      (t = J.test(f.compareDocumentPosition)),
                                      (b =
                                          t || J.test(f.contains)
                                              ? function (e, t) {
                                                    var n = (9 === e.nodeType && e.documentElement) || e,
                                                        i = t && t.parentNode;
                                                    return (
                                                        e === i ||
                                                        !(
                                                            !i ||
                                                            1 !== i.nodeType ||
                                                            !(n.contains
                                                                ? n.contains(i)
                                                                : e.compareDocumentPosition &&
                                                                  16 & e.compareDocumentPosition(i))
                                                        )
                                                    );
                                                }
                                              : function (e, t) {
                                                    if (t) for (; (t = t.parentNode); ) if (t === e) return !0;
                                                    return !1;
                                                }),
                                      (M = t
                                          ? function (e, t) {
                                                if (e === t) return (u = !0), 0;
                                                var i = !e.compareDocumentPosition - !t.compareDocumentPosition;
                                                return (
                                                    i ||
                                                    (1 &
                                                        (i =
                                                            (e.ownerDocument || e) == (t.ownerDocument || t)
                                                                ? e.compareDocumentPosition(t)
                                                                : 1) ||
                                                    (!n.sortDetached && t.compareDocumentPosition(e) === i)
                                                        ? e == h || (e.ownerDocument == C && b(C, e))
                                                            ? -1
                                                            : t == h || (t.ownerDocument == C && b(C, t))
                                                              ? 1
                                                              : d
                                                                ? O(d, e) - O(d, t)
                                                                : 0
                                                        : 4 & i
                                                          ? -1
                                                          : 1)
                                                );
                                            }
                                          : function (e, t) {
                                                if (e === t) return (u = !0), 0;
                                                var n,
                                                    i = 0,
                                                    s = e.parentNode,
                                                    r = t.parentNode,
                                                    a = [e],
                                                    o = [t];
                                                if (!s || !r)
                                                    return e == h
                                                        ? -1
                                                        : t == h
                                                          ? 1
                                                          : s
                                                            ? -1
                                                            : r
                                                              ? 1
                                                              : d
                                                                ? O(d, e) - O(d, t)
                                                                : 0;
                                                if (s === r) return pe(e, t);
                                                for (n = e; (n = n.parentNode); ) a.unshift(n);
                                                for (n = t; (n = n.parentNode); ) o.unshift(n);
                                                for (; a[i] === o[i]; ) i++;
                                                return i ? pe(a[i], o[i]) : a[i] == C ? -1 : o[i] == C ? 1 : 0;
                                            }),
                                      h)
                                    : h;
                            }),
                        (oe.matches = function (e, t) {
                            return oe(e, null, null, t);
                        }),
                        (oe.matchesSelector = function (e, t) {
                            if (
                                (p(e),
                                n.matchesSelector && m && !k[t + " "] && (!v || !v.test(t)) && (!g || !g.test(t)))
                            )
                                try {
                                    var i = y.call(e, t);
                                    if (i || n.disconnectedMatch || (e.document && 11 !== e.document.nodeType))
                                        return i;
                                } catch (e) {
                                    k(t, !0);
                                }
                            return oe(t, h, null, [e]).length > 0;
                        }),
                        (oe.contains = function (e, t) {
                            return (e.ownerDocument || e) != h && p(e), b(e, t);
                        }),
                        (oe.attr = function (e, t) {
                            (e.ownerDocument || e) != h && p(e);
                            var s = i.attrHandle[t.toLowerCase()],
                                r = s && L.call(i.attrHandle, t.toLowerCase()) ? s(e, t, !m) : void 0;
                            return void 0 !== r
                                ? r
                                : n.attributes || !m
                                  ? e.getAttribute(t)
                                  : (r = e.getAttributeNode(t)) && r.specified
                                    ? r.value
                                    : null;
                        }),
                        (oe.escape = function (e) {
                            return (e + "").replace(ie, se);
                        }),
                        (oe.error = function (e) {
                            throw new Error("Syntax error, unrecognized expression: " + e);
                        }),
                        (oe.uniqueSort = function (e) {
                            var t,
                                i = [],
                                s = 0,
                                r = 0;
                            if (((u = !n.detectDuplicates), (d = !n.sortStable && e.slice(0)), e.sort(M), u)) {
                                for (; (t = e[r++]); ) t === e[r] && (s = i.push(r));
                                for (; s--; ) e.splice(i[s], 1);
                            }
                            return (d = null), e;
                        }),
                        (s = oe.getText =
                            function (e) {
                                var t,
                                    n = "",
                                    i = 0,
                                    r = e.nodeType;
                                if (r) {
                                    if (1 === r || 9 === r || 11 === r) {
                                        if ("string" == typeof e.textContent) return e.textContent;
                                        for (e = e.firstChild; e; e = e.nextSibling) n += s(e);
                                    } else if (3 === r || 4 === r) return e.nodeValue;
                                } else for (; (t = e[i++]); ) n += s(t);
                                return n;
                            }),
                        (i = oe.selectors =
                            {
                                cacheLength: 50,
                                createPseudo: ce,
                                match: X,
                                attrHandle: {},
                                find: {},
                                relative: {
                                    ">": { dir: "parentNode", first: !0 },
                                    " ": { dir: "parentNode" },
                                    "+": { dir: "previousSibling", first: !0 },
                                    "~": { dir: "previousSibling" },
                                },
                                preFilter: {
                                    ATTR: function (e) {
                                        return (
                                            (e[1] = e[1].replace(te, ne)),
                                            (e[3] = (e[3] || e[4] || e[5] || "").replace(te, ne)),
                                            "~=" === e[2] && (e[3] = " " + e[3] + " "),
                                            e.slice(0, 4)
                                        );
                                    },
                                    CHILD: function (e) {
                                        return (
                                            (e[1] = e[1].toLowerCase()),
                                            "nth" === e[1].slice(0, 3)
                                                ? (e[3] || oe.error(e[0]),
                                                  (e[4] = +(e[4]
                                                      ? e[5] + (e[6] || 1)
                                                      : 2 * ("even" === e[3] || "odd" === e[3]))),
                                                  (e[5] = +(e[7] + e[8] || "odd" === e[3])))
                                                : e[3] && oe.error(e[0]),
                                            e
                                        );
                                    },
                                    PSEUDO: function (e) {
                                        var t,
                                            n = !e[6] && e[2];
                                        return X.CHILD.test(e[0])
                                            ? null
                                            : (e[3]
                                                  ? (e[2] = e[4] || e[5] || "")
                                                  : n &&
                                                    W.test(n) &&
                                                    (t = a(n, !0)) &&
                                                    (t = n.indexOf(")", n.length - t) - n.length) &&
                                                    ((e[0] = e[0].slice(0, t)), (e[2] = n.slice(0, t))),
                                              e.slice(0, 3));
                                    },
                                },
                                filter: {
                                    TAG: function (e) {
                                        var t = e.replace(te, ne).toLowerCase();
                                        return "*" === e
                                            ? function () {
                                                  return !0;
                                              }
                                            : function (e) {
                                                  return e.nodeName && e.nodeName.toLowerCase() === t;
                                              };
                                    },
                                    CLASS: function (e) {
                                        var t = E[e + " "];
                                        return (
                                            t ||
                                            ((t = new RegExp("(^|" + F + ")" + e + "(" + F + "|$)")) &&
                                                E(e, function (e) {
                                                    return t.test(
                                                        ("string" == typeof e.className && e.className) ||
                                                            (void 0 !== e.getAttribute && e.getAttribute("class")) ||
                                                            ""
                                                    );
                                                }))
                                        );
                                    },
                                    ATTR: function (e, t, n) {
                                        return function (i) {
                                            var s = oe.attr(i, e);
                                            return null == s
                                                ? "!=" === t
                                                : !t ||
                                                      ((s += ""),
                                                      "=" === t
                                                          ? s === n
                                                          : "!=" === t
                                                            ? s !== n
                                                            : "^=" === t
                                                              ? n && 0 === s.indexOf(n)
                                                              : "*=" === t
                                                                ? n && s.indexOf(n) > -1
                                                                : "$=" === t
                                                                  ? n && s.slice(-n.length) === n
                                                                  : "~=" === t
                                                                    ? (" " + s.replace(q, " ") + " ").indexOf(n) > -1
                                                                    : "|=" === t &&
                                                                      (s === n ||
                                                                          s.slice(0, n.length + 1) === n + "-"));
                                        };
                                    },
                                    CHILD: function (e, t, n, i, s) {
                                        var r = "nth" !== e.slice(0, 3),
                                            a = "last" !== e.slice(-4),
                                            o = "of-type" === t;
                                        return 1 === i && 0 === s
                                            ? function (e) {
                                                  return !!e.parentNode;
                                              }
                                            : function (t, n, l) {
                                                  var c,
                                                      d,
                                                      u,
                                                      p,
                                                      h,
                                                      f,
                                                      m = r !== a ? "nextSibling" : "previousSibling",
                                                      g = t.parentNode,
                                                      v = o && t.nodeName.toLowerCase(),
                                                      y = !l && !o,
                                                      b = !1;
                                                  if (g) {
                                                      if (r) {
                                                          for (; m; ) {
                                                              for (p = t; (p = p[m]); )
                                                                  if (
                                                                      o
                                                                          ? p.nodeName.toLowerCase() === v
                                                                          : 1 === p.nodeType
                                                                  )
                                                                      return !1;
                                                              f = m = "only" === e && !f && "nextSibling";
                                                          }
                                                          return !0;
                                                      }
                                                      if (((f = [a ? g.firstChild : g.lastChild]), a && y)) {
                                                          for (
                                                              b =
                                                                  (h =
                                                                      (c =
                                                                          (d =
                                                                              (u = (p = g)[w] || (p[w] = {}))[
                                                                                  p.uniqueID
                                                                              ] || (u[p.uniqueID] = {}))[e] ||
                                                                          [])[0] === x && c[1]) && c[2],
                                                                  p = h && g.childNodes[h];
                                                              (p = (++h && p && p[m]) || (b = h = 0) || f.pop());

                                                          )
                                                              if (1 === p.nodeType && ++b && p === t) {
                                                                  d[e] = [x, h, b];
                                                                  break;
                                                              }
                                                      } else if (
                                                          (y &&
                                                              (b = h =
                                                                  (c =
                                                                      (d =
                                                                          (u = (p = t)[w] || (p[w] = {}))[p.uniqueID] ||
                                                                          (u[p.uniqueID] = {}))[e] || [])[0] === x &&
                                                                  c[1]),
                                                          !1 === b)
                                                      )
                                                          for (
                                                              ;
                                                              (p = (++h && p && p[m]) || (b = h = 0) || f.pop()) &&
                                                              ((o
                                                                  ? p.nodeName.toLowerCase() !== v
                                                                  : 1 !== p.nodeType) ||
                                                                  !++b ||
                                                                  (y &&
                                                                      ((d =
                                                                          (u = p[w] || (p[w] = {}))[p.uniqueID] ||
                                                                          (u[p.uniqueID] = {}))[e] = [x, b]),
                                                                  p !== t));

                                                          );
                                                      return (b -= s) === i || (b % i == 0 && b / i >= 0);
                                                  }
                                              };
                                    },
                                    PSEUDO: function (e, t) {
                                        var n,
                                            s =
                                                i.pseudos[e] ||
                                                i.setFilters[e.toLowerCase()] ||
                                                oe.error("unsupported pseudo: " + e);
                                        return s[w]
                                            ? s(t)
                                            : s.length > 1
                                              ? ((n = [e, e, "", t]),
                                                i.setFilters.hasOwnProperty(e.toLowerCase())
                                                    ? ce(function (e, n) {
                                                          for (var i, r = s(e, t), a = r.length; a--; )
                                                              e[(i = O(e, r[a]))] = !(n[i] = r[a]);
                                                      })
                                                    : function (e) {
                                                          return s(e, 0, n);
                                                      })
                                              : s;
                                    },
                                },
                                pseudos: {
                                    not: ce(function (e) {
                                        var t = [],
                                            n = [],
                                            i = o(e.replace(H, "$1"));
                                        return i[w]
                                            ? ce(function (e, t, n, s) {
                                                  for (var r, a = i(e, null, s, []), o = e.length; o--; )
                                                      (r = a[o]) && (e[o] = !(t[o] = r));
                                              })
                                            : function (e, s, r) {
                                                  return (t[0] = e), i(t, null, r, n), (t[0] = null), !n.pop();
                                              };
                                    }),
                                    has: ce(function (e) {
                                        return function (t) {
                                            return oe(e, t).length > 0;
                                        };
                                    }),
                                    contains: ce(function (e) {
                                        return (
                                            (e = e.replace(te, ne)),
                                            function (t) {
                                                return (t.textContent || s(t)).indexOf(e) > -1;
                                            }
                                        );
                                    }),
                                    lang: ce(function (e) {
                                        return (
                                            U.test(e || "") || oe.error("unsupported lang: " + e),
                                            (e = e.replace(te, ne).toLowerCase()),
                                            function (t) {
                                                var n;
                                                do {
                                                    if (
                                                        (n = m
                                                            ? t.lang
                                                            : t.getAttribute("xml:lang") || t.getAttribute("lang"))
                                                    )
                                                        return (n = n.toLowerCase()) === e || 0 === n.indexOf(e + "-");
                                                } while ((t = t.parentNode) && 1 === t.nodeType);
                                                return !1;
                                            }
                                        );
                                    }),
                                    target: function (t) {
                                        var n = e.location && e.location.hash;
                                        return n && n.slice(1) === t.id;
                                    },
                                    root: function (e) {
                                        return e === f;
                                    },
                                    focus: function (e) {
                                        return (
                                            e === h.activeElement &&
                                            (!h.hasFocus || h.hasFocus()) &&
                                            !!(e.type || e.href || ~e.tabIndex)
                                        );
                                    },
                                    enabled: me(!1),
                                    disabled: me(!0),
                                    checked: function (e) {
                                        var t = e.nodeName.toLowerCase();
                                        return ("input" === t && !!e.checked) || ("option" === t && !!e.selected);
                                    },
                                    selected: function (e) {
                                        return e.parentNode && e.parentNode.selectedIndex, !0 === e.selected;
                                    },
                                    empty: function (e) {
                                        for (e = e.firstChild; e; e = e.nextSibling) if (e.nodeType < 6) return !1;
                                        return !0;
                                    },
                                    parent: function (e) {
                                        return !i.pseudos.empty(e);
                                    },
                                    header: function (e) {
                                        return Q.test(e.nodeName);
                                    },
                                    input: function (e) {
                                        return K.test(e.nodeName);
                                    },
                                    button: function (e) {
                                        var t = e.nodeName.toLowerCase();
                                        return ("input" === t && "button" === e.type) || "button" === t;
                                    },
                                    text: function (e) {
                                        var t;
                                        return (
                                            "input" === e.nodeName.toLowerCase() &&
                                            "text" === e.type &&
                                            (null == (t = e.getAttribute("type")) || "text" === t.toLowerCase())
                                        );
                                    },
                                    first: ge(function () {
                                        return [0];
                                    }),
                                    last: ge(function (e, t) {
                                        return [t - 1];
                                    }),
                                    eq: ge(function (e, t, n) {
                                        return [n < 0 ? n + t : n];
                                    }),
                                    even: ge(function (e, t) {
                                        for (var n = 0; n < t; n += 2) e.push(n);
                                        return e;
                                    }),
                                    odd: ge(function (e, t) {
                                        for (var n = 1; n < t; n += 2) e.push(n);
                                        return e;
                                    }),
                                    lt: ge(function (e, t, n) {
                                        for (var i = n < 0 ? n + t : n > t ? t : n; --i >= 0; ) e.push(i);
                                        return e;
                                    }),
                                    gt: ge(function (e, t, n) {
                                        for (var i = n < 0 ? n + t : n; ++i < t; ) e.push(i);
                                        return e;
                                    }),
                                },
                            }),
                        (i.pseudos.nth = i.pseudos.eq),
                        { radio: !0, checkbox: !0, file: !0, password: !0, image: !0 }))
                            i.pseudos[t] = he(t);
                        for (t in { submit: !0, reset: !0 }) i.pseudos[t] = fe(t);
                        function ye() {}
                        function be(e) {
                            for (var t = 0, n = e.length, i = ""; t < n; t++) i += e[t].value;
                            return i;
                        }
                        function we(e, t, n) {
                            var i = t.dir,
                                s = t.next,
                                r = s || i,
                                a = n && "parentNode" === r,
                                o = S++;
                            return t.first
                                ? function (t, n, s) {
                                      for (; (t = t[i]); ) if (1 === t.nodeType || a) return e(t, n, s);
                                      return !1;
                                  }
                                : function (t, n, l) {
                                      var c,
                                          d,
                                          u,
                                          p = [x, o];
                                      if (l) {
                                          for (; (t = t[i]); ) if ((1 === t.nodeType || a) && e(t, n, l)) return !0;
                                      } else
                                          for (; (t = t[i]); )
                                              if (1 === t.nodeType || a)
                                                  if (
                                                      ((d =
                                                          (u = t[w] || (t[w] = {}))[t.uniqueID] ||
                                                          (u[t.uniqueID] = {})),
                                                      s && s === t.nodeName.toLowerCase())
                                                  )
                                                      t = t[i] || t;
                                                  else {
                                                      if ((c = d[r]) && c[0] === x && c[1] === o) return (p[2] = c[2]);
                                                      if (((d[r] = p), (p[2] = e(t, n, l)))) return !0;
                                                  }
                                      return !1;
                                  };
                        }
                        function Ce(e) {
                            return e.length > 1
                                ? function (t, n, i) {
                                      for (var s = e.length; s--; ) if (!e[s](t, n, i)) return !1;
                                      return !0;
                                  }
                                : e[0];
                        }
                        function xe(e, t, n, i, s) {
                            for (var r, a = [], o = 0, l = e.length, c = null != t; o < l; o++)
                                (r = e[o]) && ((n && !n(r, i, s)) || (a.push(r), c && t.push(o)));
                            return a;
                        }
                        function Se(e, t, n, i, s, r) {
                            return (
                                i && !i[w] && (i = Se(i)),
                                s && !s[w] && (s = Se(s, r)),
                                ce(function (r, a, o, l) {
                                    var c,
                                        d,
                                        u,
                                        p = [],
                                        h = [],
                                        f = a.length,
                                        m =
                                            r ||
                                            (function (e, t, n) {
                                                for (var i = 0, s = t.length; i < s; i++) oe(e, t[i], n);
                                                return n;
                                            })(t || "*", o.nodeType ? [o] : o, []),
                                        g = !e || (!r && t) ? m : xe(m, p, e, o, l),
                                        v = n ? (s || (r ? e : f || i) ? [] : a) : g;
                                    if ((n && n(g, v, o, l), i))
                                        for (c = xe(v, h), i(c, [], o, l), d = c.length; d--; )
                                            (u = c[d]) && (v[h[d]] = !(g[h[d]] = u));
                                    if (r) {
                                        if (s || e) {
                                            if (s) {
                                                for (c = [], d = v.length; d--; ) (u = v[d]) && c.push((g[d] = u));
                                                s(null, (v = []), c, l);
                                            }
                                            for (d = v.length; d--; )
                                                (u = v[d]) && (c = s ? O(r, u) : p[d]) > -1 && (r[c] = !(a[c] = u));
                                        }
                                    } else
                                        (v = xe(v === a ? v.splice(f, v.length) : v)),
                                            s ? s(null, a, v, l) : P.apply(a, v);
                                })
                            );
                        }
                        function Ee(e) {
                            for (
                                var t,
                                    n,
                                    s,
                                    r = e.length,
                                    a = i.relative[e[0].type],
                                    o = a || i.relative[" "],
                                    l = a ? 1 : 0,
                                    d = we(
                                        function (e) {
                                            return e === t;
                                        },
                                        o,
                                        !0
                                    ),
                                    u = we(
                                        function (e) {
                                            return O(t, e) > -1;
                                        },
                                        o,
                                        !0
                                    ),
                                    p = [
                                        function (e, n, i) {
                                            var s =
                                                (!a && (i || n !== c)) || ((t = n).nodeType ? d(e, n, i) : u(e, n, i));
                                            return (t = null), s;
                                        },
                                    ];
                                l < r;
                                l++
                            )
                                if ((n = i.relative[e[l].type])) p = [we(Ce(p), n)];
                                else {
                                    if ((n = i.filter[e[l].type].apply(null, e[l].matches))[w]) {
                                        for (s = ++l; s < r && !i.relative[e[s].type]; s++);
                                        return Se(
                                            l > 1 && Ce(p),
                                            l > 1 &&
                                                be(
                                                    e
                                                        .slice(0, l - 1)
                                                        .concat({ value: " " === e[l - 2].type ? "*" : "" })
                                                ).replace(H, "$1"),
                                            n,
                                            l < s && Ee(e.slice(l, s)),
                                            s < r && Ee((e = e.slice(s))),
                                            s < r && be(e)
                                        );
                                    }
                                    p.push(n);
                                }
                            return Ce(p);
                        }
                        return (
                            (ye.prototype = i.filters = i.pseudos),
                            (i.setFilters = new ye()),
                            (a = oe.tokenize =
                                function (e, t) {
                                    var n,
                                        s,
                                        r,
                                        a,
                                        o,
                                        l,
                                        c,
                                        d = T[e + " "];
                                    if (d) return t ? 0 : d.slice(0);
                                    for (o = e, l = [], c = i.preFilter; o; ) {
                                        for (a in ((n && !(s = R.exec(o))) ||
                                            (s && (o = o.slice(s[0].length) || o), l.push((r = []))),
                                        (n = !1),
                                        (s = V.exec(o)) &&
                                            ((n = s.shift()),
                                            r.push({ value: n, type: s[0].replace(H, " ") }),
                                            (o = o.slice(n.length))),
                                        i.filter))
                                            !(s = X[a].exec(o)) ||
                                                (c[a] && !(s = c[a](s))) ||
                                                ((n = s.shift()),
                                                r.push({ value: n, type: a, matches: s }),
                                                (o = o.slice(n.length)));
                                        if (!n) break;
                                    }
                                    return t ? o.length : o ? oe.error(e) : T(e, l).slice(0);
                                }),
                            (o = oe.compile =
                                function (e, t) {
                                    var n,
                                        s = [],
                                        r = [],
                                        o = $[e + " "];
                                    if (!o) {
                                        for (t || (t = a(e)), n = t.length; n--; )
                                            (o = Ee(t[n]))[w] ? s.push(o) : r.push(o);
                                        (o = $(
                                            e,
                                            (function (e, t) {
                                                var n = t.length > 0,
                                                    s = e.length > 0,
                                                    r = function (r, a, o, l, d) {
                                                        var u,
                                                            f,
                                                            g,
                                                            v = 0,
                                                            y = "0",
                                                            b = r && [],
                                                            w = [],
                                                            C = c,
                                                            S = r || (s && i.find.TAG("*", d)),
                                                            E = (x += null == C ? 1 : Math.random() || 0.1),
                                                            T = S.length;
                                                        for (
                                                            d && (c = a == h || a || d);
                                                            y !== T && null != (u = S[y]);
                                                            y++
                                                        ) {
                                                            if (s && u) {
                                                                for (
                                                                    f = 0,
                                                                        a || u.ownerDocument == h || (p(u), (o = !m));
                                                                    (g = e[f++]);

                                                                )
                                                                    if (g(u, a || h, o)) {
                                                                        l.push(u);
                                                                        break;
                                                                    }
                                                                d && (x = E);
                                                            }
                                                            n && ((u = !g && u) && v--, r && b.push(u));
                                                        }
                                                        if (((v += y), n && y !== v)) {
                                                            for (f = 0; (g = t[f++]); ) g(b, w, a, o);
                                                            if (r) {
                                                                if (v > 0)
                                                                    for (; y--; ) b[y] || w[y] || (w[y] = I.call(l));
                                                                w = xe(w);
                                                            }
                                                            P.apply(l, w),
                                                                d &&
                                                                    !r &&
                                                                    w.length > 0 &&
                                                                    v + t.length > 1 &&
                                                                    oe.uniqueSort(l);
                                                        }
                                                        return d && ((x = E), (c = C)), b;
                                                    };
                                                return n ? ce(r) : r;
                                            })(r, s)
                                        )),
                                            (o.selector = e);
                                    }
                                    return o;
                                }),
                            (l = oe.select =
                                function (e, t, n, s) {
                                    var r,
                                        l,
                                        c,
                                        d,
                                        u,
                                        p = "function" == typeof e && e,
                                        h = !s && a((e = p.selector || e));
                                    if (((n = n || []), 1 === h.length)) {
                                        if (
                                            (l = h[0] = h[0].slice(0)).length > 2 &&
                                            "ID" === (c = l[0]).type &&
                                            9 === t.nodeType &&
                                            m &&
                                            i.relative[l[1].type]
                                        ) {
                                            if (!(t = (i.find.ID(c.matches[0].replace(te, ne), t) || [])[0])) return n;
                                            p && (t = t.parentNode), (e = e.slice(l.shift().value.length));
                                        }
                                        for (
                                            r = X.needsContext.test(e) ? 0 : l.length;
                                            r-- && ((c = l[r]), !i.relative[(d = c.type)]);

                                        )
                                            if (
                                                (u = i.find[d]) &&
                                                (s = u(
                                                    c.matches[0].replace(te, ne),
                                                    (ee.test(l[0].type) && ve(t.parentNode)) || t
                                                ))
                                            ) {
                                                if ((l.splice(r, 1), !(e = s.length && be(l)))) return P.apply(n, s), n;
                                                break;
                                            }
                                    }
                                    return (p || o(e, h))(s, t, !m, n, !t || (ee.test(e) && ve(t.parentNode)) || t), n;
                                }),
                            (n.sortStable = w.split("").sort(M).join("") === w),
                            (n.detectDuplicates = !!u),
                            p(),
                            (n.sortDetached = de(function (e) {
                                return 1 & e.compareDocumentPosition(h.createElement("fieldset"));
                            })),
                            de(function (e) {
                                return (e.innerHTML = "<a href='#'></a>"), "#" === e.firstChild.getAttribute("href");
                            }) ||
                                ue("type|href|height|width", function (e, t, n) {
                                    if (!n) return e.getAttribute(t, "type" === t.toLowerCase() ? 1 : 2);
                                }),
                            (n.attributes &&
                                de(function (e) {
                                    return (
                                        (e.innerHTML = "<input/>"),
                                        e.firstChild.setAttribute("value", ""),
                                        "" === e.firstChild.getAttribute("value")
                                    );
                                })) ||
                                ue("value", function (e, t, n) {
                                    if (!n && "input" === e.nodeName.toLowerCase()) return e.defaultValue;
                                }),
                            de(function (e) {
                                return null == e.getAttribute("disabled");
                            }) ||
                                ue(N, function (e, t, n) {
                                    var i;
                                    if (!n)
                                        return !0 === e[t]
                                            ? t.toLowerCase()
                                            : (i = e.getAttributeNode(t)) && i.specified
                                              ? i.value
                                              : null;
                                }),
                            oe
                        );
                    })(i);
                    (E.find = $),
                        (E.expr = $.selectors),
                        (E.expr[":"] = E.expr.pseudos),
                        (E.uniqueSort = E.unique = $.uniqueSort),
                        (E.text = $.getText),
                        (E.isXMLDoc = $.isXML),
                        (E.contains = $.contains),
                        (E.escapeSelector = $.escape);
                    var k = function (e, t, n) {
                            for (var i = [], s = void 0 !== n; (e = e[t]) && 9 !== e.nodeType; )
                                if (1 === e.nodeType) {
                                    if (s && E(e).is(n)) break;
                                    i.push(e);
                                }
                            return i;
                        },
                        M = function (e, t) {
                            for (var n = []; e; e = e.nextSibling) 1 === e.nodeType && e !== t && n.push(e);
                            return n;
                        },
                        L = E.expr.match.needsContext;
                    function A(e, t) {
                        return e.nodeName && e.nodeName.toLowerCase() === t.toLowerCase();
                    }
                    var I = /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;
                    function _(e, t, n) {
                        return v(t)
                            ? E.grep(e, function (e, i) {
                                  return !!t.call(e, i, e) !== n;
                              })
                            : t.nodeType
                              ? E.grep(e, function (e) {
                                    return (e === t) !== n;
                                })
                              : "string" != typeof t
                                ? E.grep(e, function (e) {
                                      return d.call(t, e) > -1 !== n;
                                  })
                                : E.filter(t, e, n);
                    }
                    (E.filter = function (e, t, n) {
                        var i = t[0];
                        return (
                            n && (e = ":not(" + e + ")"),
                            1 === t.length && 1 === i.nodeType
                                ? E.find.matchesSelector(i, e)
                                    ? [i]
                                    : []
                                : E.find.matches(
                                      e,
                                      E.grep(t, function (e) {
                                          return 1 === e.nodeType;
                                      })
                                  )
                        );
                    }),
                        E.fn.extend({
                            find: function (e) {
                                var t,
                                    n,
                                    i = this.length,
                                    s = this;
                                if ("string" != typeof e)
                                    return this.pushStack(
                                        E(e).filter(function () {
                                            for (t = 0; t < i; t++) if (E.contains(s[t], this)) return !0;
                                        })
                                    );
                                for (n = this.pushStack([]), t = 0; t < i; t++) E.find(e, s[t], n);
                                return i > 1 ? E.uniqueSort(n) : n;
                            },
                            filter: function (e) {
                                return this.pushStack(_(this, e || [], !1));
                            },
                            not: function (e) {
                                return this.pushStack(_(this, e || [], !0));
                            },
                            is: function (e) {
                                return !!_(this, "string" == typeof e && L.test(e) ? E(e) : e || [], !1).length;
                            },
                        });
                    var P,
                        D = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/;
                    ((E.fn.init = function (e, t, n) {
                        var i, s;
                        if (!e) return this;
                        if (((n = n || P), "string" == typeof e)) {
                            if (
                                !(i =
                                    "<" === e[0] && ">" === e[e.length - 1] && e.length >= 3
                                        ? [null, e, null]
                                        : D.exec(e)) ||
                                (!i[1] && t)
                            )
                                return !t || t.jquery ? (t || n).find(e) : this.constructor(t).find(e);
                            if (i[1]) {
                                if (
                                    ((t = t instanceof E ? t[0] : t),
                                    E.merge(this, E.parseHTML(i[1], t && t.nodeType ? t.ownerDocument || t : b, !0)),
                                    I.test(i[1]) && E.isPlainObject(t))
                                )
                                    for (i in t) v(this[i]) ? this[i](t[i]) : this.attr(i, t[i]);
                                return this;
                            }
                            return (s = b.getElementById(i[2])) && ((this[0] = s), (this.length = 1)), this;
                        }
                        return e.nodeType
                            ? ((this[0] = e), (this.length = 1), this)
                            : v(e)
                              ? void 0 !== n.ready
                                  ? n.ready(e)
                                  : e(E)
                              : E.makeArray(e, this);
                    }).prototype = E.fn),
                        (P = E(b));
                    var O = /^(?:parents|prev(?:Until|All))/,
                        N = { children: !0, contents: !0, next: !0, prev: !0 };
                    function F(e, t) {
                        for (; (e = e[t]) && 1 !== e.nodeType; );
                        return e;
                    }
                    E.fn.extend({
                        has: function (e) {
                            var t = E(e, this),
                                n = t.length;
                            return this.filter(function () {
                                for (var e = 0; e < n; e++) if (E.contains(this, t[e])) return !0;
                            });
                        },
                        closest: function (e, t) {
                            var n,
                                i = 0,
                                s = this.length,
                                r = [],
                                a = "string" != typeof e && E(e);
                            if (!L.test(e))
                                for (; i < s; i++)
                                    for (n = this[i]; n && n !== t; n = n.parentNode)
                                        if (
                                            n.nodeType < 11 &&
                                            (a ? a.index(n) > -1 : 1 === n.nodeType && E.find.matchesSelector(n, e))
                                        ) {
                                            r.push(n);
                                            break;
                                        }
                            return this.pushStack(r.length > 1 ? E.uniqueSort(r) : r);
                        },
                        index: function (e) {
                            return e
                                ? "string" == typeof e
                                    ? d.call(E(e), this[0])
                                    : d.call(this, e.jquery ? e[0] : e)
                                : this[0] && this[0].parentNode
                                  ? this.first().prevAll().length
                                  : -1;
                        },
                        add: function (e, t) {
                            return this.pushStack(E.uniqueSort(E.merge(this.get(), E(e, t))));
                        },
                        addBack: function (e) {
                            return this.add(null == e ? this.prevObject : this.prevObject.filter(e));
                        },
                    }),
                        E.each(
                            {
                                parent: function (e) {
                                    var t = e.parentNode;
                                    return t && 11 !== t.nodeType ? t : null;
                                },
                                parents: function (e) {
                                    return k(e, "parentNode");
                                },
                                parentsUntil: function (e, t, n) {
                                    return k(e, "parentNode", n);
                                },
                                next: function (e) {
                                    return F(e, "nextSibling");
                                },
                                prev: function (e) {
                                    return F(e, "previousSibling");
                                },
                                nextAll: function (e) {
                                    return k(e, "nextSibling");
                                },
                                prevAll: function (e) {
                                    return k(e, "previousSibling");
                                },
                                nextUntil: function (e, t, n) {
                                    return k(e, "nextSibling", n);
                                },
                                prevUntil: function (e, t, n) {
                                    return k(e, "previousSibling", n);
                                },
                                siblings: function (e) {
                                    return M((e.parentNode || {}).firstChild, e);
                                },
                                children: function (e) {
                                    return M(e.firstChild);
                                },
                                contents: function (e) {
                                    return null != e.contentDocument && a(e.contentDocument)
                                        ? e.contentDocument
                                        : (A(e, "template") && (e = e.content || e), E.merge([], e.childNodes));
                                },
                            },
                            function (e, t) {
                                E.fn[e] = function (n, i) {
                                    var s = E.map(this, t, n);
                                    return (
                                        "Until" !== e.slice(-5) && (i = n),
                                        i && "string" == typeof i && (s = E.filter(i, s)),
                                        this.length > 1 && (N[e] || E.uniqueSort(s), O.test(e) && s.reverse()),
                                        this.pushStack(s)
                                    );
                                };
                            }
                        );
                    var j = /[^\x20\t\r\n\f]+/g;
                    function z(e) {
                        return e;
                    }
                    function B(e) {
                        throw e;
                    }
                    function q(e, t, n, i) {
                        var s;
                        try {
                            e && v((s = e.promise))
                                ? s.call(e).done(t).fail(n)
                                : e && v((s = e.then))
                                  ? s.call(e, t, n)
                                  : t.apply(void 0, [e].slice(i));
                        } catch (e) {
                            n.apply(void 0, [e]);
                        }
                    }
                    (E.Callbacks = function (e) {
                        e =
                            "string" == typeof e
                                ? (function (e) {
                                      var t = {};
                                      return (
                                          E.each(e.match(j) || [], function (e, n) {
                                              t[n] = !0;
                                          }),
                                          t
                                      );
                                  })(e)
                                : E.extend({}, e);
                        var t,
                            n,
                            i,
                            s,
                            r = [],
                            a = [],
                            o = -1,
                            l = function () {
                                for (s = s || e.once, i = t = !0; a.length; o = -1)
                                    for (n = a.shift(); ++o < r.length; )
                                        !1 === r[o].apply(n[0], n[1]) && e.stopOnFalse && ((o = r.length), (n = !1));
                                e.memory || (n = !1), (t = !1), s && (r = n ? [] : "");
                            },
                            c = {
                                add: function () {
                                    return (
                                        r &&
                                            (n && !t && ((o = r.length - 1), a.push(n)),
                                            (function t(n) {
                                                E.each(n, function (n, i) {
                                                    v(i)
                                                        ? (e.unique && c.has(i)) || r.push(i)
                                                        : i && i.length && "string" !== x(i) && t(i);
                                                });
                                            })(arguments),
                                            n && !t && l()),
                                        this
                                    );
                                },
                                remove: function () {
                                    return (
                                        E.each(arguments, function (e, t) {
                                            for (var n; (n = E.inArray(t, r, n)) > -1; ) r.splice(n, 1), n <= o && o--;
                                        }),
                                        this
                                    );
                                },
                                has: function (e) {
                                    return e ? E.inArray(e, r) > -1 : r.length > 0;
                                },
                                empty: function () {
                                    return r && (r = []), this;
                                },
                                disable: function () {
                                    return (s = a = []), (r = n = ""), this;
                                },
                                disabled: function () {
                                    return !r;
                                },
                                lock: function () {
                                    return (s = a = []), n || t || (r = n = ""), this;
                                },
                                locked: function () {
                                    return !!s;
                                },
                                fireWith: function (e, n) {
                                    return (
                                        s || ((n = [e, (n = n || []).slice ? n.slice() : n]), a.push(n), t || l()), this
                                    );
                                },
                                fire: function () {
                                    return c.fireWith(this, arguments), this;
                                },
                                fired: function () {
                                    return !!i;
                                },
                            };
                        return c;
                    }),
                        E.extend({
                            Deferred: function (e) {
                                var t = [
                                        ["notify", "progress", E.Callbacks("memory"), E.Callbacks("memory"), 2],
                                        [
                                            "resolve",
                                            "done",
                                            E.Callbacks("once memory"),
                                            E.Callbacks("once memory"),
                                            0,
                                            "resolved",
                                        ],
                                        [
                                            "reject",
                                            "fail",
                                            E.Callbacks("once memory"),
                                            E.Callbacks("once memory"),
                                            1,
                                            "rejected",
                                        ],
                                    ],
                                    n = "pending",
                                    s = {
                                        state: function () {
                                            return n;
                                        },
                                        always: function () {
                                            return r.done(arguments).fail(arguments), this;
                                        },
                                        catch: function (e) {
                                            return s.then(null, e);
                                        },
                                        pipe: function () {
                                            var e = arguments;
                                            return E.Deferred(function (n) {
                                                E.each(t, function (t, i) {
                                                    var s = v(e[i[4]]) && e[i[4]];
                                                    r[i[1]](function () {
                                                        var e = s && s.apply(this, arguments);
                                                        e && v(e.promise)
                                                            ? e
                                                                  .promise()
                                                                  .progress(n.notify)
                                                                  .done(n.resolve)
                                                                  .fail(n.reject)
                                                            : n[i[0] + "With"](this, s ? [e] : arguments);
                                                    });
                                                }),
                                                    (e = null);
                                            }).promise();
                                        },
                                        then: function (e, n, s) {
                                            var r = 0;
                                            function a(e, t, n, s) {
                                                return function () {
                                                    var o = this,
                                                        l = arguments,
                                                        c = function () {
                                                            var i, c;
                                                            if (!(e < r)) {
                                                                if ((i = n.apply(o, l)) === t.promise())
                                                                    throw new TypeError("Thenable self-resolution");
                                                                (c =
                                                                    i &&
                                                                    ("object" == typeof i || "function" == typeof i) &&
                                                                    i.then),
                                                                    v(c)
                                                                        ? s
                                                                            ? c.call(i, a(r, t, z, s), a(r, t, B, s))
                                                                            : (r++,
                                                                              c.call(
                                                                                  i,
                                                                                  a(r, t, z, s),
                                                                                  a(r, t, B, s),
                                                                                  a(r, t, z, t.notifyWith)
                                                                              ))
                                                                        : (n !== z && ((o = void 0), (l = [i])),
                                                                          (s || t.resolveWith)(o, l));
                                                            }
                                                        },
                                                        d = s
                                                            ? c
                                                            : function () {
                                                                  try {
                                                                      c();
                                                                  } catch (i) {
                                                                      E.Deferred.exceptionHook &&
                                                                          E.Deferred.exceptionHook(i, d.stackTrace),
                                                                          e + 1 >= r &&
                                                                              (n !== B && ((o = void 0), (l = [i])),
                                                                              t.rejectWith(o, l));
                                                                  }
                                                              };
                                                    e
                                                        ? d()
                                                        : (E.Deferred.getStackHook &&
                                                              (d.stackTrace = E.Deferred.getStackHook()),
                                                          i.setTimeout(d));
                                                };
                                            }
                                            return E.Deferred(function (i) {
                                                t[0][3].add(a(0, i, v(s) ? s : z, i.notifyWith)),
                                                    t[1][3].add(a(0, i, v(e) ? e : z)),
                                                    t[2][3].add(a(0, i, v(n) ? n : B));
                                            }).promise();
                                        },
                                        promise: function (e) {
                                            return null != e ? E.extend(e, s) : s;
                                        },
                                    },
                                    r = {};
                                return (
                                    E.each(t, function (e, i) {
                                        var a = i[2],
                                            o = i[5];
                                        (s[i[1]] = a.add),
                                            o &&
                                                a.add(
                                                    function () {
                                                        n = o;
                                                    },
                                                    t[3 - e][2].disable,
                                                    t[3 - e][3].disable,
                                                    t[0][2].lock,
                                                    t[0][3].lock
                                                ),
                                            a.add(i[3].fire),
                                            (r[i[0]] = function () {
                                                return r[i[0] + "With"](this === r ? void 0 : this, arguments), this;
                                            }),
                                            (r[i[0] + "With"] = a.fireWith);
                                    }),
                                    s.promise(r),
                                    e && e.call(r, r),
                                    r
                                );
                            },
                            when: function (e) {
                                var t = arguments.length,
                                    n = t,
                                    i = Array(n),
                                    s = o.call(arguments),
                                    r = E.Deferred(),
                                    a = function (e) {
                                        return function (n) {
                                            (i[e] = this),
                                                (s[e] = arguments.length > 1 ? o.call(arguments) : n),
                                                --t || r.resolveWith(i, s);
                                        };
                                    };
                                if (
                                    t <= 1 &&
                                    (q(e, r.done(a(n)).resolve, r.reject, !t),
                                    "pending" === r.state() || v(s[n] && s[n].then))
                                )
                                    return r.then();
                                for (; n--; ) q(s[n], a(n), r.reject);
                                return r.promise();
                            },
                        });
                    var H = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
                    (E.Deferred.exceptionHook = function (e, t) {
                        i.console &&
                            i.console.warn &&
                            e &&
                            H.test(e.name) &&
                            i.console.warn("jQuery.Deferred exception: " + e.message, e.stack, t);
                    }),
                        (E.readyException = function (e) {
                            i.setTimeout(function () {
                                throw e;
                            });
                        });
                    var R = E.Deferred();
                    function V() {
                        b.removeEventListener("DOMContentLoaded", V), i.removeEventListener("load", V), E.ready();
                    }
                    (E.fn.ready = function (e) {
                        return (
                            R.then(e).catch(function (e) {
                                E.readyException(e);
                            }),
                            this
                        );
                    }),
                        E.extend({
                            isReady: !1,
                            readyWait: 1,
                            ready: function (e) {
                                (!0 === e ? --E.readyWait : E.isReady) ||
                                    ((E.isReady = !0), (!0 !== e && --E.readyWait > 0) || R.resolveWith(b, [E]));
                            },
                        }),
                        (E.ready.then = R.then),
                        "complete" === b.readyState || ("loading" !== b.readyState && !b.documentElement.doScroll)
                            ? i.setTimeout(E.ready)
                            : (b.addEventListener("DOMContentLoaded", V), i.addEventListener("load", V));
                    var G = function (e, t, n, i, s, r, a) {
                            var o = 0,
                                l = e.length,
                                c = null == n;
                            if ("object" === x(n)) for (o in ((s = !0), n)) G(e, t, o, n[o], !0, r, a);
                            else if (
                                void 0 !== i &&
                                ((s = !0),
                                v(i) || (a = !0),
                                c &&
                                    (a
                                        ? (t.call(e, i), (t = null))
                                        : ((c = t),
                                          (t = function (e, t, n) {
                                              return c.call(E(e), n);
                                          }))),
                                t)
                            )
                                for (; o < l; o++) t(e[o], n, a ? i : i.call(e[o], o, t(e[o], n)));
                            return s ? e : c ? t.call(e) : l ? t(e[0], n) : r;
                        },
                        W = /^-ms-/,
                        U = /-([a-z])/g;
                    function X(e, t) {
                        return t.toUpperCase();
                    }
                    function Y(e) {
                        return e.replace(W, "ms-").replace(U, X);
                    }
                    var K = function (e) {
                        return 1 === e.nodeType || 9 === e.nodeType || !+e.nodeType;
                    };
                    function Q() {
                        this.expando = E.expando + Q.uid++;
                    }
                    (Q.uid = 1),
                        (Q.prototype = {
                            cache: function (e) {
                                var t = e[this.expando];
                                return (
                                    t ||
                                        ((t = {}),
                                        K(e) &&
                                            (e.nodeType
                                                ? (e[this.expando] = t)
                                                : Object.defineProperty(e, this.expando, {
                                                      value: t,
                                                      configurable: !0,
                                                  }))),
                                    t
                                );
                            },
                            set: function (e, t, n) {
                                var i,
                                    s = this.cache(e);
                                if ("string" == typeof t) s[Y(t)] = n;
                                else for (i in t) s[Y(i)] = t[i];
                                return s;
                            },
                            get: function (e, t) {
                                return void 0 === t ? this.cache(e) : e[this.expando] && e[this.expando][Y(t)];
                            },
                            access: function (e, t, n) {
                                return void 0 === t || (t && "string" == typeof t && void 0 === n)
                                    ? this.get(e, t)
                                    : (this.set(e, t, n), void 0 !== n ? n : t);
                            },
                            remove: function (e, t) {
                                var n,
                                    i = e[this.expando];
                                if (void 0 !== i) {
                                    if (void 0 !== t) {
                                        n = (t = Array.isArray(t) ? t.map(Y) : (t = Y(t)) in i ? [t] : t.match(j) || [])
                                            .length;
                                        for (; n--; ) delete i[t[n]];
                                    }
                                    (void 0 === t || E.isEmptyObject(i)) &&
                                        (e.nodeType ? (e[this.expando] = void 0) : delete e[this.expando]);
                                }
                            },
                            hasData: function (e) {
                                var t = e[this.expando];
                                return void 0 !== t && !E.isEmptyObject(t);
                            },
                        });
                    var J = new Q(),
                        Z = new Q(),
                        ee = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
                        te = /[A-Z]/g;
                    function ne(e, t, n) {
                        var i;
                        if (void 0 === n && 1 === e.nodeType)
                            if (
                                ((i = "data-" + t.replace(te, "-$&").toLowerCase()),
                                "string" == typeof (n = e.getAttribute(i)))
                            ) {
                                try {
                                    n = (function (e) {
                                        return (
                                            "true" === e ||
                                            ("false" !== e &&
                                                ("null" === e
                                                    ? null
                                                    : e === +e + ""
                                                      ? +e
                                                      : ee.test(e)
                                                        ? JSON.parse(e)
                                                        : e))
                                        );
                                    })(n);
                                } catch (e) {}
                                Z.set(e, t, n);
                            } else n = void 0;
                        return n;
                    }
                    E.extend({
                        hasData: function (e) {
                            return Z.hasData(e) || J.hasData(e);
                        },
                        data: function (e, t, n) {
                            return Z.access(e, t, n);
                        },
                        removeData: function (e, t) {
                            Z.remove(e, t);
                        },
                        _data: function (e, t, n) {
                            return J.access(e, t, n);
                        },
                        _removeData: function (e, t) {
                            J.remove(e, t);
                        },
                    }),
                        E.fn.extend({
                            data: function (e, t) {
                                var n,
                                    i,
                                    s,
                                    r = this[0],
                                    a = r && r.attributes;
                                if (void 0 === e) {
                                    if (
                                        this.length &&
                                        ((s = Z.get(r)), 1 === r.nodeType && !J.get(r, "hasDataAttrs"))
                                    ) {
                                        for (n = a.length; n--; )
                                            a[n] &&
                                                0 === (i = a[n].name).indexOf("data-") &&
                                                ((i = Y(i.slice(5))), ne(r, i, s[i]));
                                        J.set(r, "hasDataAttrs", !0);
                                    }
                                    return s;
                                }
                                return "object" == typeof e
                                    ? this.each(function () {
                                          Z.set(this, e);
                                      })
                                    : G(
                                          this,
                                          function (t) {
                                              var n;
                                              if (r && void 0 === t)
                                                  return void 0 !== (n = Z.get(r, e)) || void 0 !== (n = ne(r, e))
                                                      ? n
                                                      : void 0;
                                              this.each(function () {
                                                  Z.set(this, e, t);
                                              });
                                          },
                                          null,
                                          t,
                                          arguments.length > 1,
                                          null,
                                          !0
                                      );
                            },
                            removeData: function (e) {
                                return this.each(function () {
                                    Z.remove(this, e);
                                });
                            },
                        }),
                        E.extend({
                            queue: function (e, t, n) {
                                var i;
                                if (e)
                                    return (
                                        (t = (t || "fx") + "queue"),
                                        (i = J.get(e, t)),
                                        n &&
                                            (!i || Array.isArray(n) ? (i = J.access(e, t, E.makeArray(n))) : i.push(n)),
                                        i || []
                                    );
                            },
                            dequeue: function (e, t) {
                                t = t || "fx";
                                var n = E.queue(e, t),
                                    i = n.length,
                                    s = n.shift(),
                                    r = E._queueHooks(e, t);
                                "inprogress" === s && ((s = n.shift()), i--),
                                    s &&
                                        ("fx" === t && n.unshift("inprogress"),
                                        delete r.stop,
                                        s.call(
                                            e,
                                            function () {
                                                E.dequeue(e, t);
                                            },
                                            r
                                        )),
                                    !i && r && r.empty.fire();
                            },
                            _queueHooks: function (e, t) {
                                var n = t + "queueHooks";
                                return (
                                    J.get(e, n) ||
                                    J.access(e, n, {
                                        empty: E.Callbacks("once memory").add(function () {
                                            J.remove(e, [t + "queue", n]);
                                        }),
                                    })
                                );
                            },
                        }),
                        E.fn.extend({
                            queue: function (e, t) {
                                var n = 2;
                                return (
                                    "string" != typeof e && ((t = e), (e = "fx"), n--),
                                    arguments.length < n
                                        ? E.queue(this[0], e)
                                        : void 0 === t
                                          ? this
                                          : this.each(function () {
                                                var n = E.queue(this, e, t);
                                                E._queueHooks(this, e),
                                                    "fx" === e && "inprogress" !== n[0] && E.dequeue(this, e);
                                            })
                                );
                            },
                            dequeue: function (e) {
                                return this.each(function () {
                                    E.dequeue(this, e);
                                });
                            },
                            clearQueue: function (e) {
                                return this.queue(e || "fx", []);
                            },
                            promise: function (e, t) {
                                var n,
                                    i = 1,
                                    s = E.Deferred(),
                                    r = this,
                                    a = this.length,
                                    o = function () {
                                        --i || s.resolveWith(r, [r]);
                                    };
                                for ("string" != typeof e && ((t = e), (e = void 0)), e = e || "fx"; a--; )
                                    (n = J.get(r[a], e + "queueHooks")) && n.empty && (i++, n.empty.add(o));
                                return o(), s.promise(t);
                            },
                        });
                    var ie = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source,
                        se = new RegExp("^(?:([+-])=|)(" + ie + ")([a-z%]*)$", "i"),
                        re = ["Top", "Right", "Bottom", "Left"],
                        ae = b.documentElement,
                        oe = function (e) {
                            return E.contains(e.ownerDocument, e);
                        },
                        le = { composed: !0 };
                    ae.getRootNode &&
                        (oe = function (e) {
                            return E.contains(e.ownerDocument, e) || e.getRootNode(le) === e.ownerDocument;
                        });
                    var ce = function (e, t) {
                        return (
                            "none" === (e = t || e).style.display ||
                            ("" === e.style.display && oe(e) && "none" === E.css(e, "display"))
                        );
                    };
                    function de(e, t, n, i) {
                        var s,
                            r,
                            a = 20,
                            o = i
                                ? function () {
                                      return i.cur();
                                  }
                                : function () {
                                      return E.css(e, t, "");
                                  },
                            l = o(),
                            c = (n && n[3]) || (E.cssNumber[t] ? "" : "px"),
                            d = e.nodeType && (E.cssNumber[t] || ("px" !== c && +l)) && se.exec(E.css(e, t));
                        if (d && d[3] !== c) {
                            for (l /= 2, c = c || d[3], d = +l || 1; a--; )
                                E.style(e, t, d + c), (1 - r) * (1 - (r = o() / l || 0.5)) <= 0 && (a = 0), (d /= r);
                            (d *= 2), E.style(e, t, d + c), (n = n || []);
                        }
                        return (
                            n &&
                                ((d = +d || +l || 0),
                                (s = n[1] ? d + (n[1] + 1) * n[2] : +n[2]),
                                i && ((i.unit = c), (i.start = d), (i.end = s))),
                            s
                        );
                    }
                    var ue = {};
                    function pe(e) {
                        var t,
                            n = e.ownerDocument,
                            i = e.nodeName,
                            s = ue[i];
                        return (
                            s ||
                            ((t = n.body.appendChild(n.createElement(i))),
                            (s = E.css(t, "display")),
                            t.parentNode.removeChild(t),
                            "none" === s && (s = "block"),
                            (ue[i] = s),
                            s)
                        );
                    }
                    function he(e, t) {
                        for (var n, i, s = [], r = 0, a = e.length; r < a; r++)
                            (i = e[r]).style &&
                                ((n = i.style.display),
                                t
                                    ? ("none" === n &&
                                          ((s[r] = J.get(i, "display") || null), s[r] || (i.style.display = "")),
                                      "" === i.style.display && ce(i) && (s[r] = pe(i)))
                                    : "none" !== n && ((s[r] = "none"), J.set(i, "display", n)));
                        for (r = 0; r < a; r++) null != s[r] && (e[r].style.display = s[r]);
                        return e;
                    }
                    E.fn.extend({
                        show: function () {
                            return he(this, !0);
                        },
                        hide: function () {
                            return he(this);
                        },
                        toggle: function (e) {
                            return "boolean" == typeof e
                                ? e
                                    ? this.show()
                                    : this.hide()
                                : this.each(function () {
                                      ce(this) ? E(this).show() : E(this).hide();
                                  });
                        },
                    });
                    var fe,
                        me,
                        ge = /^(?:checkbox|radio)$/i,
                        ve = /<([a-z][^\/\0>\x20\t\r\n\f]*)/i,
                        ye = /^$|^module$|\/(?:java|ecma)script/i;
                    (fe = b.createDocumentFragment().appendChild(b.createElement("div"))),
                        (me = b.createElement("input")).setAttribute("type", "radio"),
                        me.setAttribute("checked", "checked"),
                        me.setAttribute("name", "t"),
                        fe.appendChild(me),
                        (g.checkClone = fe.cloneNode(!0).cloneNode(!0).lastChild.checked),
                        (fe.innerHTML = "<textarea>x</textarea>"),
                        (g.noCloneChecked = !!fe.cloneNode(!0).lastChild.defaultValue),
                        (fe.innerHTML = "<option></option>"),
                        (g.option = !!fe.lastChild);
                    var be = {
                        thead: [1, "<table>", "</table>"],
                        col: [2, "<table><colgroup>", "</colgroup></table>"],
                        tr: [2, "<table><tbody>", "</tbody></table>"],
                        td: [3, "<table><tbody><tr>", "</tr></tbody></table>"],
                        _default: [0, "", ""],
                    };
                    function we(e, t) {
                        var n;
                        return (
                            (n =
                                void 0 !== e.getElementsByTagName
                                    ? e.getElementsByTagName(t || "*")
                                    : void 0 !== e.querySelectorAll
                                      ? e.querySelectorAll(t || "*")
                                      : []),
                            void 0 === t || (t && A(e, t)) ? E.merge([e], n) : n
                        );
                    }
                    function Ce(e, t) {
                        for (var n = 0, i = e.length; n < i; n++)
                            J.set(e[n], "globalEval", !t || J.get(t[n], "globalEval"));
                    }
                    (be.tbody = be.tfoot = be.colgroup = be.caption = be.thead),
                        (be.th = be.td),
                        g.option || (be.optgroup = be.option = [1, "<select multiple='multiple'>", "</select>"]);
                    var xe = /<|&#?\w+;/;
                    function Se(e, t, n, i, s) {
                        for (
                            var r, a, o, l, c, d, u = t.createDocumentFragment(), p = [], h = 0, f = e.length;
                            h < f;
                            h++
                        )
                            if ((r = e[h]) || 0 === r)
                                if ("object" === x(r)) E.merge(p, r.nodeType ? [r] : r);
                                else if (xe.test(r)) {
                                    for (
                                        a = a || u.appendChild(t.createElement("div")),
                                            o = (ve.exec(r) || ["", ""])[1].toLowerCase(),
                                            l = be[o] || be._default,
                                            a.innerHTML = l[1] + E.htmlPrefilter(r) + l[2],
                                            d = l[0];
                                        d--;

                                    )
                                        a = a.lastChild;
                                    E.merge(p, a.childNodes), ((a = u.firstChild).textContent = "");
                                } else p.push(t.createTextNode(r));
                        for (u.textContent = "", h = 0; (r = p[h++]); )
                            if (i && E.inArray(r, i) > -1) s && s.push(r);
                            else if (((c = oe(r)), (a = we(u.appendChild(r), "script")), c && Ce(a), n))
                                for (d = 0; (r = a[d++]); ) ye.test(r.type || "") && n.push(r);
                        return u;
                    }
                    var Ee = /^([^.]*)(?:\.(.+)|)/;
                    function Te() {
                        return !0;
                    }
                    function $e() {
                        return !1;
                    }
                    function ke(e, t) {
                        return (
                            (e ===
                                (function () {
                                    try {
                                        return b.activeElement;
                                    } catch (e) {}
                                })()) ==
                            ("focus" === t)
                        );
                    }
                    function Me(e, t, n, i, s, r) {
                        var a, o;
                        if ("object" == typeof t) {
                            for (o in ("string" != typeof n && ((i = i || n), (n = void 0)), t))
                                Me(e, o, n, i, t[o], r);
                            return e;
                        }
                        if (
                            (null == i && null == s
                                ? ((s = n), (i = n = void 0))
                                : null == s &&
                                  ("string" == typeof n ? ((s = i), (i = void 0)) : ((s = i), (i = n), (n = void 0))),
                            !1 === s)
                        )
                            s = $e;
                        else if (!s) return e;
                        return (
                            1 === r &&
                                ((a = s),
                                (s = function (e) {
                                    return E().off(e), a.apply(this, arguments);
                                }),
                                (s.guid = a.guid || (a.guid = E.guid++))),
                            e.each(function () {
                                E.event.add(this, t, s, i, n);
                            })
                        );
                    }
                    function Le(e, t, n) {
                        n
                            ? (J.set(e, t, !1),
                              E.event.add(e, t, {
                                  namespace: !1,
                                  handler: function (e) {
                                      var i,
                                          s,
                                          r = J.get(this, t);
                                      if (1 & e.isTrigger && this[t]) {
                                          if (r.length) (E.event.special[t] || {}).delegateType && e.stopPropagation();
                                          else if (
                                              ((r = o.call(arguments)),
                                              J.set(this, t, r),
                                              (i = n(this, t)),
                                              this[t](),
                                              r !== (s = J.get(this, t)) || i ? J.set(this, t, !1) : (s = {}),
                                              r !== s)
                                          )
                                              return e.stopImmediatePropagation(), e.preventDefault(), s && s.value;
                                      } else
                                          r.length &&
                                              (J.set(this, t, {
                                                  value: E.event.trigger(
                                                      E.extend(r[0], E.Event.prototype),
                                                      r.slice(1),
                                                      this
                                                  ),
                                              }),
                                              e.stopImmediatePropagation());
                                  },
                              }))
                            : void 0 === J.get(e, t) && E.event.add(e, t, Te);
                    }
                    (E.event = {
                        global: {},
                        add: function (e, t, n, i, s) {
                            var r,
                                a,
                                o,
                                l,
                                c,
                                d,
                                u,
                                p,
                                h,
                                f,
                                m,
                                g = J.get(e);
                            if (K(e))
                                for (
                                    n.handler && ((n = (r = n).handler), (s = r.selector)),
                                        s && E.find.matchesSelector(ae, s),
                                        n.guid || (n.guid = E.guid++),
                                        (l = g.events) || (l = g.events = Object.create(null)),
                                        (a = g.handle) ||
                                            (a = g.handle =
                                                function (t) {
                                                    return void 0 !== E && E.event.triggered !== t.type
                                                        ? E.event.dispatch.apply(e, arguments)
                                                        : void 0;
                                                }),
                                        c = (t = (t || "").match(j) || [""]).length;
                                    c--;

                                )
                                    (h = m = (o = Ee.exec(t[c]) || [])[1]),
                                        (f = (o[2] || "").split(".").sort()),
                                        h &&
                                            ((u = E.event.special[h] || {}),
                                            (h = (s ? u.delegateType : u.bindType) || h),
                                            (u = E.event.special[h] || {}),
                                            (d = E.extend(
                                                {
                                                    type: h,
                                                    origType: m,
                                                    data: i,
                                                    handler: n,
                                                    guid: n.guid,
                                                    selector: s,
                                                    needsContext: s && E.expr.match.needsContext.test(s),
                                                    namespace: f.join("."),
                                                },
                                                r
                                            )),
                                            (p = l[h]) ||
                                                (((p = l[h] = []).delegateCount = 0),
                                                (u.setup && !1 !== u.setup.call(e, i, f, a)) ||
                                                    (e.addEventListener && e.addEventListener(h, a))),
                                            u.add && (u.add.call(e, d), d.handler.guid || (d.handler.guid = n.guid)),
                                            s ? p.splice(p.delegateCount++, 0, d) : p.push(d),
                                            (E.event.global[h] = !0));
                        },
                        remove: function (e, t, n, i, s) {
                            var r,
                                a,
                                o,
                                l,
                                c,
                                d,
                                u,
                                p,
                                h,
                                f,
                                m,
                                g = J.hasData(e) && J.get(e);
                            if (g && (l = g.events)) {
                                for (c = (t = (t || "").match(j) || [""]).length; c--; )
                                    if (
                                        ((h = m = (o = Ee.exec(t[c]) || [])[1]),
                                        (f = (o[2] || "").split(".").sort()),
                                        h)
                                    ) {
                                        for (
                                            u = E.event.special[h] || {},
                                                p = l[(h = (i ? u.delegateType : u.bindType) || h)] || [],
                                                o = o[2] && new RegExp("(^|\\.)" + f.join("\\.(?:.*\\.|)") + "(\\.|$)"),
                                                a = r = p.length;
                                            r--;

                                        )
                                            (d = p[r]),
                                                (!s && m !== d.origType) ||
                                                    (n && n.guid !== d.guid) ||
                                                    (o && !o.test(d.namespace)) ||
                                                    (i && i !== d.selector && ("**" !== i || !d.selector)) ||
                                                    (p.splice(r, 1),
                                                    d.selector && p.delegateCount--,
                                                    u.remove && u.remove.call(e, d));
                                        a &&
                                            !p.length &&
                                            ((u.teardown && !1 !== u.teardown.call(e, f, g.handle)) ||
                                                E.removeEvent(e, h, g.handle),
                                            delete l[h]);
                                    } else for (h in l) E.event.remove(e, h + t[c], n, i, !0);
                                E.isEmptyObject(l) && J.remove(e, "handle events");
                            }
                        },
                        dispatch: function (e) {
                            var t,
                                n,
                                i,
                                s,
                                r,
                                a,
                                o = new Array(arguments.length),
                                l = E.event.fix(e),
                                c = (J.get(this, "events") || Object.create(null))[l.type] || [],
                                d = E.event.special[l.type] || {};
                            for (o[0] = l, t = 1; t < arguments.length; t++) o[t] = arguments[t];
                            if (((l.delegateTarget = this), !d.preDispatch || !1 !== d.preDispatch.call(this, l))) {
                                for (
                                    a = E.event.handlers.call(this, l, c), t = 0;
                                    (s = a[t++]) && !l.isPropagationStopped();

                                )
                                    for (
                                        l.currentTarget = s.elem, n = 0;
                                        (r = s.handlers[n++]) && !l.isImmediatePropagationStopped();

                                    )
                                        (l.rnamespace && !1 !== r.namespace && !l.rnamespace.test(r.namespace)) ||
                                            ((l.handleObj = r),
                                            (l.data = r.data),
                                            void 0 !==
                                                (i = ((E.event.special[r.origType] || {}).handle || r.handler).apply(
                                                    s.elem,
                                                    o
                                                )) &&
                                                !1 === (l.result = i) &&
                                                (l.preventDefault(), l.stopPropagation()));
                                return d.postDispatch && d.postDispatch.call(this, l), l.result;
                            }
                        },
                        handlers: function (e, t) {
                            var n,
                                i,
                                s,
                                r,
                                a,
                                o = [],
                                l = t.delegateCount,
                                c = e.target;
                            if (l && c.nodeType && !("click" === e.type && e.button >= 1))
                                for (; c !== this; c = c.parentNode || this)
                                    if (1 === c.nodeType && ("click" !== e.type || !0 !== c.disabled)) {
                                        for (r = [], a = {}, n = 0; n < l; n++)
                                            void 0 === a[(s = (i = t[n]).selector + " ")] &&
                                                (a[s] = i.needsContext
                                                    ? E(s, this).index(c) > -1
                                                    : E.find(s, this, null, [c]).length),
                                                a[s] && r.push(i);
                                        r.length && o.push({ elem: c, handlers: r });
                                    }
                            return (c = this), l < t.length && o.push({ elem: c, handlers: t.slice(l) }), o;
                        },
                        addProp: function (e, t) {
                            Object.defineProperty(E.Event.prototype, e, {
                                enumerable: !0,
                                configurable: !0,
                                get: v(t)
                                    ? function () {
                                          if (this.originalEvent) return t(this.originalEvent);
                                      }
                                    : function () {
                                          if (this.originalEvent) return this.originalEvent[e];
                                      },
                                set: function (t) {
                                    Object.defineProperty(this, e, {
                                        enumerable: !0,
                                        configurable: !0,
                                        writable: !0,
                                        value: t,
                                    });
                                },
                            });
                        },
                        fix: function (e) {
                            return e[E.expando] ? e : new E.Event(e);
                        },
                        special: {
                            load: { noBubble: !0 },
                            click: {
                                setup: function (e) {
                                    var t = this || e;
                                    return ge.test(t.type) && t.click && A(t, "input") && Le(t, "click", Te), !1;
                                },
                                trigger: function (e) {
                                    var t = this || e;
                                    return ge.test(t.type) && t.click && A(t, "input") && Le(t, "click"), !0;
                                },
                                _default: function (e) {
                                    var t = e.target;
                                    return (
                                        (ge.test(t.type) && t.click && A(t, "input") && J.get(t, "click")) || A(t, "a")
                                    );
                                },
                            },
                            beforeunload: {
                                postDispatch: function (e) {
                                    void 0 !== e.result && e.originalEvent && (e.originalEvent.returnValue = e.result);
                                },
                            },
                        },
                    }),
                        (E.removeEvent = function (e, t, n) {
                            e.removeEventListener && e.removeEventListener(t, n);
                        }),
                        (E.Event = function (e, t) {
                            if (!(this instanceof E.Event)) return new E.Event(e, t);
                            e && e.type
                                ? ((this.originalEvent = e),
                                  (this.type = e.type),
                                  (this.isDefaultPrevented =
                                      e.defaultPrevented || (void 0 === e.defaultPrevented && !1 === e.returnValue)
                                          ? Te
                                          : $e),
                                  (this.target = e.target && 3 === e.target.nodeType ? e.target.parentNode : e.target),
                                  (this.currentTarget = e.currentTarget),
                                  (this.relatedTarget = e.relatedTarget))
                                : (this.type = e),
                                t && E.extend(this, t),
                                (this.timeStamp = (e && e.timeStamp) || Date.now()),
                                (this[E.expando] = !0);
                        }),
                        (E.Event.prototype = {
                            constructor: E.Event,
                            isDefaultPrevented: $e,
                            isPropagationStopped: $e,
                            isImmediatePropagationStopped: $e,
                            isSimulated: !1,
                            preventDefault: function () {
                                var e = this.originalEvent;
                                (this.isDefaultPrevented = Te), e && !this.isSimulated && e.preventDefault();
                            },
                            stopPropagation: function () {
                                var e = this.originalEvent;
                                (this.isPropagationStopped = Te), e && !this.isSimulated && e.stopPropagation();
                            },
                            stopImmediatePropagation: function () {
                                var e = this.originalEvent;
                                (this.isImmediatePropagationStopped = Te),
                                    e && !this.isSimulated && e.stopImmediatePropagation(),
                                    this.stopPropagation();
                            },
                        }),
                        E.each(
                            {
                                altKey: !0,
                                bubbles: !0,
                                cancelable: !0,
                                changedTouches: !0,
                                ctrlKey: !0,
                                detail: !0,
                                eventPhase: !0,
                                metaKey: !0,
                                pageX: !0,
                                pageY: !0,
                                shiftKey: !0,
                                view: !0,
                                char: !0,
                                code: !0,
                                charCode: !0,
                                key: !0,
                                keyCode: !0,
                                button: !0,
                                buttons: !0,
                                clientX: !0,
                                clientY: !0,
                                offsetX: !0,
                                offsetY: !0,
                                pointerId: !0,
                                pointerType: !0,
                                screenX: !0,
                                screenY: !0,
                                targetTouches: !0,
                                toElement: !0,
                                touches: !0,
                                which: !0,
                            },
                            E.event.addProp
                        ),
                        E.each({ focus: "focusin", blur: "focusout" }, function (e, t) {
                            E.event.special[e] = {
                                setup: function () {
                                    return Le(this, e, ke), !1;
                                },
                                trigger: function () {
                                    return Le(this, e), !0;
                                },
                                _default: function (t) {
                                    return J.get(t.target, e);
                                },
                                delegateType: t,
                            };
                        }),
                        E.each(
                            {
                                mouseenter: "mouseover",
                                mouseleave: "mouseout",
                                pointerenter: "pointerover",
                                pointerleave: "pointerout",
                            },
                            function (e, t) {
                                E.event.special[e] = {
                                    delegateType: t,
                                    bindType: t,
                                    handle: function (e) {
                                        var n,
                                            i = e.relatedTarget,
                                            s = e.handleObj;
                                        return (
                                            (i && (i === this || E.contains(this, i))) ||
                                                ((e.type = s.origType),
                                                (n = s.handler.apply(this, arguments)),
                                                (e.type = t)),
                                            n
                                        );
                                    },
                                };
                            }
                        ),
                        E.fn.extend({
                            on: function (e, t, n, i) {
                                return Me(this, e, t, n, i);
                            },
                            one: function (e, t, n, i) {
                                return Me(this, e, t, n, i, 1);
                            },
                            off: function (e, t, n) {
                                var i, s;
                                if (e && e.preventDefault && e.handleObj)
                                    return (
                                        (i = e.handleObj),
                                        E(e.delegateTarget).off(
                                            i.namespace ? i.origType + "." + i.namespace : i.origType,
                                            i.selector,
                                            i.handler
                                        ),
                                        this
                                    );
                                if ("object" == typeof e) {
                                    for (s in e) this.off(s, t, e[s]);
                                    return this;
                                }
                                return (
                                    (!1 !== t && "function" != typeof t) || ((n = t), (t = void 0)),
                                    !1 === n && (n = $e),
                                    this.each(function () {
                                        E.event.remove(this, e, n, t);
                                    })
                                );
                            },
                        });
                    var Ae = /<script|<style|<link/i,
                        Ie = /checked\s*(?:[^=]|=\s*.checked.)/i,
                        _e = /^\s*<!\[CDATA\[|\]\]>\s*$/g;
                    function Pe(e, t) {
                        return (
                            (A(e, "table") &&
                                A(11 !== t.nodeType ? t : t.firstChild, "tr") &&
                                E(e).children("tbody")[0]) ||
                            e
                        );
                    }
                    function De(e) {
                        return (e.type = (null !== e.getAttribute("type")) + "/" + e.type), e;
                    }
                    function Oe(e) {
                        return (
                            "true/" === (e.type || "").slice(0, 5)
                                ? (e.type = e.type.slice(5))
                                : e.removeAttribute("type"),
                            e
                        );
                    }
                    function Ne(e, t) {
                        var n, i, s, r, a, o;
                        if (1 === t.nodeType) {
                            if (J.hasData(e) && (o = J.get(e).events))
                                for (s in (J.remove(t, "handle events"), o))
                                    for (n = 0, i = o[s].length; n < i; n++) E.event.add(t, s, o[s][n]);
                            Z.hasData(e) && ((r = Z.access(e)), (a = E.extend({}, r)), Z.set(t, a));
                        }
                    }
                    function Fe(e, t) {
                        var n = t.nodeName.toLowerCase();
                        "input" === n && ge.test(e.type)
                            ? (t.checked = e.checked)
                            : ("input" !== n && "textarea" !== n) || (t.defaultValue = e.defaultValue);
                    }
                    function je(e, t, n, i) {
                        t = l(t);
                        var s,
                            r,
                            a,
                            o,
                            c,
                            d,
                            u = 0,
                            p = e.length,
                            h = p - 1,
                            f = t[0],
                            m = v(f);
                        if (m || (p > 1 && "string" == typeof f && !g.checkClone && Ie.test(f)))
                            return e.each(function (s) {
                                var r = e.eq(s);
                                m && (t[0] = f.call(this, s, r.html())), je(r, t, n, i);
                            });
                        if (
                            p &&
                            ((r = (s = Se(t, e[0].ownerDocument, !1, e, i)).firstChild),
                            1 === s.childNodes.length && (s = r),
                            r || i)
                        ) {
                            for (o = (a = E.map(we(s, "script"), De)).length; u < p; u++)
                                (c = s),
                                    u !== h && ((c = E.clone(c, !0, !0)), o && E.merge(a, we(c, "script"))),
                                    n.call(e[u], c, u);
                            if (o)
                                for (d = a[a.length - 1].ownerDocument, E.map(a, Oe), u = 0; u < o; u++)
                                    (c = a[u]),
                                        ye.test(c.type || "") &&
                                            !J.access(c, "globalEval") &&
                                            E.contains(d, c) &&
                                            (c.src && "module" !== (c.type || "").toLowerCase()
                                                ? E._evalUrl &&
                                                  !c.noModule &&
                                                  E._evalUrl(c.src, { nonce: c.nonce || c.getAttribute("nonce") }, d)
                                                : C(c.textContent.replace(_e, ""), c, d));
                        }
                        return e;
                    }
                    function ze(e, t, n) {
                        for (var i, s = t ? E.filter(t, e) : e, r = 0; null != (i = s[r]); r++)
                            n || 1 !== i.nodeType || E.cleanData(we(i)),
                                i.parentNode && (n && oe(i) && Ce(we(i, "script")), i.parentNode.removeChild(i));
                        return e;
                    }
                    E.extend({
                        htmlPrefilter: function (e) {
                            return e;
                        },
                        clone: function (e, t, n) {
                            var i,
                                s,
                                r,
                                a,
                                o = e.cloneNode(!0),
                                l = oe(e);
                            if (!(g.noCloneChecked || (1 !== e.nodeType && 11 !== e.nodeType) || E.isXMLDoc(e)))
                                for (a = we(o), i = 0, s = (r = we(e)).length; i < s; i++) Fe(r[i], a[i]);
                            if (t)
                                if (n)
                                    for (r = r || we(e), a = a || we(o), i = 0, s = r.length; i < s; i++)
                                        Ne(r[i], a[i]);
                                else Ne(e, o);
                            return (a = we(o, "script")).length > 0 && Ce(a, !l && we(e, "script")), o;
                        },
                        cleanData: function (e) {
                            for (var t, n, i, s = E.event.special, r = 0; void 0 !== (n = e[r]); r++)
                                if (K(n)) {
                                    if ((t = n[J.expando])) {
                                        if (t.events)
                                            for (i in t.events)
                                                s[i] ? E.event.remove(n, i) : E.removeEvent(n, i, t.handle);
                                        n[J.expando] = void 0;
                                    }
                                    n[Z.expando] && (n[Z.expando] = void 0);
                                }
                        },
                    }),
                        E.fn.extend({
                            detach: function (e) {
                                return ze(this, e, !0);
                            },
                            remove: function (e) {
                                return ze(this, e);
                            },
                            text: function (e) {
                                return G(
                                    this,
                                    function (e) {
                                        return void 0 === e
                                            ? E.text(this)
                                            : this.empty().each(function () {
                                                  (1 !== this.nodeType &&
                                                      11 !== this.nodeType &&
                                                      9 !== this.nodeType) ||
                                                      (this.textContent = e);
                                              });
                                    },
                                    null,
                                    e,
                                    arguments.length
                                );
                            },
                            append: function () {
                                return je(this, arguments, function (e) {
                                    (1 !== this.nodeType && 11 !== this.nodeType && 9 !== this.nodeType) ||
                                        Pe(this, e).appendChild(e);
                                });
                            },
                            prepend: function () {
                                return je(this, arguments, function (e) {
                                    if (1 === this.nodeType || 11 === this.nodeType || 9 === this.nodeType) {
                                        var t = Pe(this, e);
                                        t.insertBefore(e, t.firstChild);
                                    }
                                });
                            },
                            before: function () {
                                return je(this, arguments, function (e) {
                                    this.parentNode && this.parentNode.insertBefore(e, this);
                                });
                            },
                            after: function () {
                                return je(this, arguments, function (e) {
                                    this.parentNode && this.parentNode.insertBefore(e, this.nextSibling);
                                });
                            },
                            empty: function () {
                                for (var e, t = 0; null != (e = this[t]); t++)
                                    1 === e.nodeType && (E.cleanData(we(e, !1)), (e.textContent = ""));
                                return this;
                            },
                            clone: function (e, t) {
                                return (
                                    (e = null != e && e),
                                    (t = null == t ? e : t),
                                    this.map(function () {
                                        return E.clone(this, e, t);
                                    })
                                );
                            },
                            html: function (e) {
                                return G(
                                    this,
                                    function (e) {
                                        var t = this[0] || {},
                                            n = 0,
                                            i = this.length;
                                        if (void 0 === e && 1 === t.nodeType) return t.innerHTML;
                                        if (
                                            "string" == typeof e &&
                                            !Ae.test(e) &&
                                            !be[(ve.exec(e) || ["", ""])[1].toLowerCase()]
                                        ) {
                                            e = E.htmlPrefilter(e);
                                            try {
                                                for (; n < i; n++)
                                                    1 === (t = this[n] || {}).nodeType &&
                                                        (E.cleanData(we(t, !1)), (t.innerHTML = e));
                                                t = 0;
                                            } catch (e) {}
                                        }
                                        t && this.empty().append(e);
                                    },
                                    null,
                                    e,
                                    arguments.length
                                );
                            },
                            replaceWith: function () {
                                var e = [];
                                return je(
                                    this,
                                    arguments,
                                    function (t) {
                                        var n = this.parentNode;
                                        E.inArray(this, e) < 0 && (E.cleanData(we(this)), n && n.replaceChild(t, this));
                                    },
                                    e
                                );
                            },
                        }),
                        E.each(
                            {
                                appendTo: "append",
                                prependTo: "prepend",
                                insertBefore: "before",
                                insertAfter: "after",
                                replaceAll: "replaceWith",
                            },
                            function (e, t) {
                                E.fn[e] = function (e) {
                                    for (var n, i = [], s = E(e), r = s.length - 1, a = 0; a <= r; a++)
                                        (n = a === r ? this : this.clone(!0)), E(s[a])[t](n), c.apply(i, n.get());
                                    return this.pushStack(i);
                                };
                            }
                        );
                    var Be = new RegExp("^(" + ie + ")(?!px)[a-z%]+$", "i"),
                        qe = /^--/,
                        He = function (e) {
                            var t = e.ownerDocument.defaultView;
                            return (t && t.opener) || (t = i), t.getComputedStyle(e);
                        },
                        Re = function (e, t, n) {
                            var i,
                                s,
                                r = {};
                            for (s in t) (r[s] = e.style[s]), (e.style[s] = t[s]);
                            for (s in ((i = n.call(e)), t)) e.style[s] = r[s];
                            return i;
                        },
                        Ve = new RegExp(re.join("|"), "i"),
                        Ge = "[\\x20\\t\\r\\n\\f]",
                        We = new RegExp("^" + Ge + "+|((?:^|[^\\\\])(?:\\\\.)*)" + Ge + "+$", "g");
                    function Ue(e, t, n) {
                        var i,
                            s,
                            r,
                            a,
                            o = qe.test(t),
                            l = e.style;
                        return (
                            (n = n || He(e)) &&
                                ((a = n.getPropertyValue(t) || n[t]),
                                o && a && (a = a.replace(We, "$1") || void 0),
                                "" !== a || oe(e) || (a = E.style(e, t)),
                                !g.pixelBoxStyles() &&
                                    Be.test(a) &&
                                    Ve.test(t) &&
                                    ((i = l.width),
                                    (s = l.minWidth),
                                    (r = l.maxWidth),
                                    (l.minWidth = l.maxWidth = l.width = a),
                                    (a = n.width),
                                    (l.width = i),
                                    (l.minWidth = s),
                                    (l.maxWidth = r))),
                            void 0 !== a ? a + "" : a
                        );
                    }
                    function Xe(e, t) {
                        return {
                            get: function () {
                                if (!e()) return (this.get = t).apply(this, arguments);
                                delete this.get;
                            },
                        };
                    }
                    !(function () {
                        function e() {
                            if (d) {
                                (c.style.cssText =
                                    "position:absolute;left:-11111px;width:60px;margin-top:1px;padding:0;border:0"),
                                    (d.style.cssText =
                                        "position:relative;display:block;box-sizing:border-box;overflow:scroll;margin:auto;border:1px;padding:1px;width:60%;top:1%"),
                                    ae.appendChild(c).appendChild(d);
                                var e = i.getComputedStyle(d);
                                (n = "1%" !== e.top),
                                    (l = 12 === t(e.marginLeft)),
                                    (d.style.right = "60%"),
                                    (a = 36 === t(e.right)),
                                    (s = 36 === t(e.width)),
                                    (d.style.position = "absolute"),
                                    (r = 12 === t(d.offsetWidth / 3)),
                                    ae.removeChild(c),
                                    (d = null);
                            }
                        }
                        function t(e) {
                            return Math.round(parseFloat(e));
                        }
                        var n,
                            s,
                            r,
                            a,
                            o,
                            l,
                            c = b.createElement("div"),
                            d = b.createElement("div");
                        d.style &&
                            ((d.style.backgroundClip = "content-box"),
                            (d.cloneNode(!0).style.backgroundClip = ""),
                            (g.clearCloneStyle = "content-box" === d.style.backgroundClip),
                            E.extend(g, {
                                boxSizingReliable: function () {
                                    return e(), s;
                                },
                                pixelBoxStyles: function () {
                                    return e(), a;
                                },
                                pixelPosition: function () {
                                    return e(), n;
                                },
                                reliableMarginLeft: function () {
                                    return e(), l;
                                },
                                scrollboxSize: function () {
                                    return e(), r;
                                },
                                reliableTrDimensions: function () {
                                    var e, t, n, s;
                                    return (
                                        null == o &&
                                            ((e = b.createElement("table")),
                                            (t = b.createElement("tr")),
                                            (n = b.createElement("div")),
                                            (e.style.cssText =
                                                "position:absolute;left:-11111px;border-collapse:separate"),
                                            (t.style.cssText = "border:1px solid"),
                                            (t.style.height = "1px"),
                                            (n.style.height = "9px"),
                                            (n.style.display = "block"),
                                            ae.appendChild(e).appendChild(t).appendChild(n),
                                            (s = i.getComputedStyle(t)),
                                            (o =
                                                parseInt(s.height, 10) +
                                                    parseInt(s.borderTopWidth, 10) +
                                                    parseInt(s.borderBottomWidth, 10) ===
                                                t.offsetHeight),
                                            ae.removeChild(e)),
                                        o
                                    );
                                },
                            }));
                    })();
                    var Ye = ["Webkit", "Moz", "ms"],
                        Ke = b.createElement("div").style,
                        Qe = {};
                    function Je(e) {
                        return (
                            E.cssProps[e] ||
                            Qe[e] ||
                            (e in Ke
                                ? e
                                : (Qe[e] =
                                      (function (e) {
                                          for (var t = e[0].toUpperCase() + e.slice(1), n = Ye.length; n--; )
                                              if ((e = Ye[n] + t) in Ke) return e;
                                      })(e) || e))
                        );
                    }
                    var Ze = /^(none|table(?!-c[ea]).+)/,
                        et = { position: "absolute", visibility: "hidden", display: "block" },
                        tt = { letterSpacing: "0", fontWeight: "400" };
                    function nt(e, t, n) {
                        var i = se.exec(t);
                        return i ? Math.max(0, i[2] - (n || 0)) + (i[3] || "px") : t;
                    }
                    function it(e, t, n, i, s, r) {
                        var a = "width" === t ? 1 : 0,
                            o = 0,
                            l = 0;
                        if (n === (i ? "border" : "content")) return 0;
                        for (; a < 4; a += 2)
                            "margin" === n && (l += E.css(e, n + re[a], !0, s)),
                                i
                                    ? ("content" === n && (l -= E.css(e, "padding" + re[a], !0, s)),
                                      "margin" !== n && (l -= E.css(e, "border" + re[a] + "Width", !0, s)))
                                    : ((l += E.css(e, "padding" + re[a], !0, s)),
                                      "padding" !== n
                                          ? (l += E.css(e, "border" + re[a] + "Width", !0, s))
                                          : (o += E.css(e, "border" + re[a] + "Width", !0, s)));
                        return (
                            !i &&
                                r >= 0 &&
                                (l +=
                                    Math.max(
                                        0,
                                        Math.ceil(e["offset" + t[0].toUpperCase() + t.slice(1)] - r - l - o - 0.5)
                                    ) || 0),
                            l
                        );
                    }
                    function st(e, t, n) {
                        var i = He(e),
                            s = (!g.boxSizingReliable() || n) && "border-box" === E.css(e, "boxSizing", !1, i),
                            r = s,
                            a = Ue(e, t, i),
                            o = "offset" + t[0].toUpperCase() + t.slice(1);
                        if (Be.test(a)) {
                            if (!n) return a;
                            a = "auto";
                        }
                        return (
                            ((!g.boxSizingReliable() && s) ||
                                (!g.reliableTrDimensions() && A(e, "tr")) ||
                                "auto" === a ||
                                (!parseFloat(a) && "inline" === E.css(e, "display", !1, i))) &&
                                e.getClientRects().length &&
                                ((s = "border-box" === E.css(e, "boxSizing", !1, i)), (r = o in e) && (a = e[o])),
                            (a = parseFloat(a) || 0) + it(e, t, n || (s ? "border" : "content"), r, i, a) + "px"
                        );
                    }
                    function rt(e, t, n, i, s) {
                        return new rt.prototype.init(e, t, n, i, s);
                    }
                    E.extend({
                        cssHooks: {
                            opacity: {
                                get: function (e, t) {
                                    if (t) {
                                        var n = Ue(e, "opacity");
                                        return "" === n ? "1" : n;
                                    }
                                },
                            },
                        },
                        cssNumber: {
                            animationIterationCount: !0,
                            columnCount: !0,
                            fillOpacity: !0,
                            flexGrow: !0,
                            flexShrink: !0,
                            fontWeight: !0,
                            gridArea: !0,
                            gridColumn: !0,
                            gridColumnEnd: !0,
                            gridColumnStart: !0,
                            gridRow: !0,
                            gridRowEnd: !0,
                            gridRowStart: !0,
                            lineHeight: !0,
                            opacity: !0,
                            order: !0,
                            orphans: !0,
                            widows: !0,
                            zIndex: !0,
                            zoom: !0,
                        },
                        cssProps: {},
                        style: function (e, t, n, i) {
                            if (e && 3 !== e.nodeType && 8 !== e.nodeType && e.style) {
                                var s,
                                    r,
                                    a,
                                    o = Y(t),
                                    l = qe.test(t),
                                    c = e.style;
                                if ((l || (t = Je(o)), (a = E.cssHooks[t] || E.cssHooks[o]), void 0 === n))
                                    return a && "get" in a && void 0 !== (s = a.get(e, !1, i)) ? s : c[t];
                                "string" == (r = typeof n) &&
                                    (s = se.exec(n)) &&
                                    s[1] &&
                                    ((n = de(e, t, s)), (r = "number")),
                                    null != n &&
                                        n == n &&
                                        ("number" !== r || l || (n += (s && s[3]) || (E.cssNumber[o] ? "" : "px")),
                                        g.clearCloneStyle ||
                                            "" !== n ||
                                            0 !== t.indexOf("background") ||
                                            (c[t] = "inherit"),
                                        (a && "set" in a && void 0 === (n = a.set(e, n, i))) ||
                                            (l ? c.setProperty(t, n) : (c[t] = n)));
                            }
                        },
                        css: function (e, t, n, i) {
                            var s,
                                r,
                                a,
                                o = Y(t);
                            return (
                                qe.test(t) || (t = Je(o)),
                                (a = E.cssHooks[t] || E.cssHooks[o]) && "get" in a && (s = a.get(e, !0, n)),
                                void 0 === s && (s = Ue(e, t, i)),
                                "normal" === s && t in tt && (s = tt[t]),
                                "" === n || n ? ((r = parseFloat(s)), !0 === n || isFinite(r) ? r || 0 : s) : s
                            );
                        },
                    }),
                        E.each(["height", "width"], function (e, t) {
                            E.cssHooks[t] = {
                                get: function (e, n, i) {
                                    if (n)
                                        return !Ze.test(E.css(e, "display")) ||
                                            (e.getClientRects().length && e.getBoundingClientRect().width)
                                            ? st(e, t, i)
                                            : Re(e, et, function () {
                                                  return st(e, t, i);
                                              });
                                },
                                set: function (e, n, i) {
                                    var s,
                                        r = He(e),
                                        a = !g.scrollboxSize() && "absolute" === r.position,
                                        o = (a || i) && "border-box" === E.css(e, "boxSizing", !1, r),
                                        l = i ? it(e, t, i, o, r) : 0;
                                    return (
                                        o &&
                                            a &&
                                            (l -= Math.ceil(
                                                e["offset" + t[0].toUpperCase() + t.slice(1)] -
                                                    parseFloat(r[t]) -
                                                    it(e, t, "border", !1, r) -
                                                    0.5
                                            )),
                                        l &&
                                            (s = se.exec(n)) &&
                                            "px" !== (s[3] || "px") &&
                                            ((e.style[t] = n), (n = E.css(e, t))),
                                        nt(0, n, l)
                                    );
                                },
                            };
                        }),
                        (E.cssHooks.marginLeft = Xe(g.reliableMarginLeft, function (e, t) {
                            if (t)
                                return (
                                    (parseFloat(Ue(e, "marginLeft")) ||
                                        e.getBoundingClientRect().left -
                                            Re(e, { marginLeft: 0 }, function () {
                                                return e.getBoundingClientRect().left;
                                            })) + "px"
                                );
                        })),
                        E.each({ margin: "", padding: "", border: "Width" }, function (e, t) {
                            (E.cssHooks[e + t] = {
                                expand: function (n) {
                                    for (var i = 0, s = {}, r = "string" == typeof n ? n.split(" ") : [n]; i < 4; i++)
                                        s[e + re[i] + t] = r[i] || r[i - 2] || r[0];
                                    return s;
                                },
                            }),
                                "margin" !== e && (E.cssHooks[e + t].set = nt);
                        }),
                        E.fn.extend({
                            css: function (e, t) {
                                return G(
                                    this,
                                    function (e, t, n) {
                                        var i,
                                            s,
                                            r = {},
                                            a = 0;
                                        if (Array.isArray(t)) {
                                            for (i = He(e), s = t.length; a < s; a++) r[t[a]] = E.css(e, t[a], !1, i);
                                            return r;
                                        }
                                        return void 0 !== n ? E.style(e, t, n) : E.css(e, t);
                                    },
                                    e,
                                    t,
                                    arguments.length > 1
                                );
                            },
                        }),
                        (E.Tween = rt),
                        (rt.prototype = {
                            constructor: rt,
                            init: function (e, t, n, i, s, r) {
                                (this.elem = e),
                                    (this.prop = n),
                                    (this.easing = s || E.easing._default),
                                    (this.options = t),
                                    (this.start = this.now = this.cur()),
                                    (this.end = i),
                                    (this.unit = r || (E.cssNumber[n] ? "" : "px"));
                            },
                            cur: function () {
                                var e = rt.propHooks[this.prop];
                                return e && e.get ? e.get(this) : rt.propHooks._default.get(this);
                            },
                            run: function (e) {
                                var t,
                                    n = rt.propHooks[this.prop];
                                return (
                                    this.options.duration
                                        ? (this.pos = t =
                                              E.easing[this.easing](
                                                  e,
                                                  this.options.duration * e,
                                                  0,
                                                  1,
                                                  this.options.duration
                                              ))
                                        : (this.pos = t = e),
                                    (this.now = (this.end - this.start) * t + this.start),
                                    this.options.step && this.options.step.call(this.elem, this.now, this),
                                    n && n.set ? n.set(this) : rt.propHooks._default.set(this),
                                    this
                                );
                            },
                        }),
                        (rt.prototype.init.prototype = rt.prototype),
                        (rt.propHooks = {
                            _default: {
                                get: function (e) {
                                    var t;
                                    return 1 !== e.elem.nodeType ||
                                        (null != e.elem[e.prop] && null == e.elem.style[e.prop])
                                        ? e.elem[e.prop]
                                        : (t = E.css(e.elem, e.prop, "")) && "auto" !== t
                                          ? t
                                          : 0;
                                },
                                set: function (e) {
                                    E.fx.step[e.prop]
                                        ? E.fx.step[e.prop](e)
                                        : 1 !== e.elem.nodeType ||
                                            (!E.cssHooks[e.prop] && null == e.elem.style[Je(e.prop)])
                                          ? (e.elem[e.prop] = e.now)
                                          : E.style(e.elem, e.prop, e.now + e.unit);
                                },
                            },
                        }),
                        (rt.propHooks.scrollTop = rt.propHooks.scrollLeft =
                            {
                                set: function (e) {
                                    e.elem.nodeType && e.elem.parentNode && (e.elem[e.prop] = e.now);
                                },
                            }),
                        (E.easing = {
                            linear: function (e) {
                                return e;
                            },
                            swing: function (e) {
                                return 0.5 - Math.cos(e * Math.PI) / 2;
                            },
                            _default: "swing",
                        }),
                        (E.fx = rt.prototype.init),
                        (E.fx.step = {});
                    var at,
                        ot,
                        lt = /^(?:toggle|show|hide)$/,
                        ct = /queueHooks$/;
                    function dt() {
                        ot &&
                            (!1 === b.hidden && i.requestAnimationFrame
                                ? i.requestAnimationFrame(dt)
                                : i.setTimeout(dt, E.fx.interval),
                            E.fx.tick());
                    }
                    function ut() {
                        return (
                            i.setTimeout(function () {
                                at = void 0;
                            }),
                            (at = Date.now())
                        );
                    }
                    function pt(e, t) {
                        var n,
                            i = 0,
                            s = { height: e };
                        for (t = t ? 1 : 0; i < 4; i += 2 - t) s["margin" + (n = re[i])] = s["padding" + n] = e;
                        return t && (s.opacity = s.width = e), s;
                    }
                    function ht(e, t, n) {
                        for (
                            var i, s = (ft.tweeners[t] || []).concat(ft.tweeners["*"]), r = 0, a = s.length;
                            r < a;
                            r++
                        )
                            if ((i = s[r].call(n, t, e))) return i;
                    }
                    function ft(e, t, n) {
                        var i,
                            s,
                            r = 0,
                            a = ft.prefilters.length,
                            o = E.Deferred().always(function () {
                                delete l.elem;
                            }),
                            l = function () {
                                if (s) return !1;
                                for (
                                    var t = at || ut(),
                                        n = Math.max(0, c.startTime + c.duration - t),
                                        i = 1 - (n / c.duration || 0),
                                        r = 0,
                                        a = c.tweens.length;
                                    r < a;
                                    r++
                                )
                                    c.tweens[r].run(i);
                                return (
                                    o.notifyWith(e, [c, i, n]),
                                    i < 1 && a ? n : (a || o.notifyWith(e, [c, 1, 0]), o.resolveWith(e, [c]), !1)
                                );
                            },
                            c = o.promise({
                                elem: e,
                                props: E.extend({}, t),
                                opts: E.extend(!0, { specialEasing: {}, easing: E.easing._default }, n),
                                originalProperties: t,
                                originalOptions: n,
                                startTime: at || ut(),
                                duration: n.duration,
                                tweens: [],
                                createTween: function (t, n) {
                                    var i = E.Tween(e, c.opts, t, n, c.opts.specialEasing[t] || c.opts.easing);
                                    return c.tweens.push(i), i;
                                },
                                stop: function (t) {
                                    var n = 0,
                                        i = t ? c.tweens.length : 0;
                                    if (s) return this;
                                    for (s = !0; n < i; n++) c.tweens[n].run(1);
                                    return (
                                        t
                                            ? (o.notifyWith(e, [c, 1, 0]), o.resolveWith(e, [c, t]))
                                            : o.rejectWith(e, [c, t]),
                                        this
                                    );
                                },
                            }),
                            d = c.props;
                        for (
                            (function (e, t) {
                                var n, i, s, r, a;
                                for (n in e)
                                    if (
                                        ((s = t[(i = Y(n))]),
                                        (r = e[n]),
                                        Array.isArray(r) && ((s = r[1]), (r = e[n] = r[0])),
                                        n !== i && ((e[i] = r), delete e[n]),
                                        (a = E.cssHooks[i]) && ("expand" in a))
                                    )
                                        for (n in ((r = a.expand(r)), delete e[i], r))
                                            (n in e) || ((e[n] = r[n]), (t[n] = s));
                                    else t[i] = s;
                            })(d, c.opts.specialEasing);
                            r < a;
                            r++
                        )
                            if ((i = ft.prefilters[r].call(c, e, d, c.opts)))
                                return v(i.stop) && (E._queueHooks(c.elem, c.opts.queue).stop = i.stop.bind(i)), i;
                        return (
                            E.map(d, ht, c),
                            v(c.opts.start) && c.opts.start.call(e, c),
                            c
                                .progress(c.opts.progress)
                                .done(c.opts.done, c.opts.complete)
                                .fail(c.opts.fail)
                                .always(c.opts.always),
                            E.fx.timer(E.extend(l, { elem: e, anim: c, queue: c.opts.queue })),
                            c
                        );
                    }
                    (E.Animation = E.extend(ft, {
                        tweeners: {
                            "*": [
                                function (e, t) {
                                    var n = this.createTween(e, t);
                                    return de(n.elem, e, se.exec(t), n), n;
                                },
                            ],
                        },
                        tweener: function (e, t) {
                            v(e) ? ((t = e), (e = ["*"])) : (e = e.match(j));
                            for (var n, i = 0, s = e.length; i < s; i++)
                                (n = e[i]), (ft.tweeners[n] = ft.tweeners[n] || []), ft.tweeners[n].unshift(t);
                        },
                        prefilters: [
                            function (e, t, n) {
                                var i,
                                    s,
                                    r,
                                    a,
                                    o,
                                    l,
                                    c,
                                    d,
                                    u = "width" in t || "height" in t,
                                    p = this,
                                    h = {},
                                    f = e.style,
                                    m = e.nodeType && ce(e),
                                    g = J.get(e, "fxshow");
                                for (i in (n.queue ||
                                    (null == (a = E._queueHooks(e, "fx")).unqueued &&
                                        ((a.unqueued = 0),
                                        (o = a.empty.fire),
                                        (a.empty.fire = function () {
                                            a.unqueued || o();
                                        })),
                                    a.unqueued++,
                                    p.always(function () {
                                        p.always(function () {
                                            a.unqueued--, E.queue(e, "fx").length || a.empty.fire();
                                        });
                                    })),
                                t))
                                    if (((s = t[i]), lt.test(s))) {
                                        if ((delete t[i], (r = r || "toggle" === s), s === (m ? "hide" : "show"))) {
                                            if ("show" !== s || !g || void 0 === g[i]) continue;
                                            m = !0;
                                        }
                                        h[i] = (g && g[i]) || E.style(e, i);
                                    }
                                if ((l = !E.isEmptyObject(t)) || !E.isEmptyObject(h))
                                    for (i in (u &&
                                        1 === e.nodeType &&
                                        ((n.overflow = [f.overflow, f.overflowX, f.overflowY]),
                                        null == (c = g && g.display) && (c = J.get(e, "display")),
                                        "none" === (d = E.css(e, "display")) &&
                                            (c
                                                ? (d = c)
                                                : (he([e], !0),
                                                  (c = e.style.display || c),
                                                  (d = E.css(e, "display")),
                                                  he([e]))),
                                        ("inline" === d || ("inline-block" === d && null != c)) &&
                                            "none" === E.css(e, "float") &&
                                            (l ||
                                                (p.done(function () {
                                                    f.display = c;
                                                }),
                                                null == c && ((d = f.display), (c = "none" === d ? "" : d))),
                                            (f.display = "inline-block"))),
                                    n.overflow &&
                                        ((f.overflow = "hidden"),
                                        p.always(function () {
                                            (f.overflow = n.overflow[0]),
                                                (f.overflowX = n.overflow[1]),
                                                (f.overflowY = n.overflow[2]);
                                        })),
                                    (l = !1),
                                    h))
                                        l ||
                                            (g
                                                ? "hidden" in g && (m = g.hidden)
                                                : (g = J.access(e, "fxshow", { display: c })),
                                            r && (g.hidden = !m),
                                            m && he([e], !0),
                                            p.done(function () {
                                                for (i in (m || he([e]), J.remove(e, "fxshow"), h)) E.style(e, i, h[i]);
                                            })),
                                            (l = ht(m ? g[i] : 0, i, p)),
                                            i in g || ((g[i] = l.start), m && ((l.end = l.start), (l.start = 0)));
                            },
                        ],
                        prefilter: function (e, t) {
                            t ? ft.prefilters.unshift(e) : ft.prefilters.push(e);
                        },
                    })),
                        (E.speed = function (e, t, n) {
                            var i =
                                e && "object" == typeof e
                                    ? E.extend({}, e)
                                    : {
                                          complete: n || (!n && t) || (v(e) && e),
                                          duration: e,
                                          easing: (n && t) || (t && !v(t) && t),
                                      };
                            return (
                                E.fx.off
                                    ? (i.duration = 0)
                                    : "number" != typeof i.duration &&
                                      (i.duration in E.fx.speeds
                                          ? (i.duration = E.fx.speeds[i.duration])
                                          : (i.duration = E.fx.speeds._default)),
                                (null != i.queue && !0 !== i.queue) || (i.queue = "fx"),
                                (i.old = i.complete),
                                (i.complete = function () {
                                    v(i.old) && i.old.call(this), i.queue && E.dequeue(this, i.queue);
                                }),
                                i
                            );
                        }),
                        E.fn.extend({
                            fadeTo: function (e, t, n, i) {
                                return this.filter(ce).css("opacity", 0).show().end().animate({ opacity: t }, e, n, i);
                            },
                            animate: function (e, t, n, i) {
                                var s = E.isEmptyObject(e),
                                    r = E.speed(t, n, i),
                                    a = function () {
                                        var t = ft(this, E.extend({}, e), r);
                                        (s || J.get(this, "finish")) && t.stop(!0);
                                    };
                                return (a.finish = a), s || !1 === r.queue ? this.each(a) : this.queue(r.queue, a);
                            },
                            stop: function (e, t, n) {
                                var i = function (e) {
                                    var t = e.stop;
                                    delete e.stop, t(n);
                                };
                                return (
                                    "string" != typeof e && ((n = t), (t = e), (e = void 0)),
                                    t && this.queue(e || "fx", []),
                                    this.each(function () {
                                        var t = !0,
                                            s = null != e && e + "queueHooks",
                                            r = E.timers,
                                            a = J.get(this);
                                        if (s) a[s] && a[s].stop && i(a[s]);
                                        else for (s in a) a[s] && a[s].stop && ct.test(s) && i(a[s]);
                                        for (s = r.length; s--; )
                                            r[s].elem !== this ||
                                                (null != e && r[s].queue !== e) ||
                                                (r[s].anim.stop(n), (t = !1), r.splice(s, 1));
                                        (!t && n) || E.dequeue(this, e);
                                    })
                                );
                            },
                            finish: function (e) {
                                return (
                                    !1 !== e && (e = e || "fx"),
                                    this.each(function () {
                                        var t,
                                            n = J.get(this),
                                            i = n[e + "queue"],
                                            s = n[e + "queueHooks"],
                                            r = E.timers,
                                            a = i ? i.length : 0;
                                        for (
                                            n.finish = !0,
                                                E.queue(this, e, []),
                                                s && s.stop && s.stop.call(this, !0),
                                                t = r.length;
                                            t--;

                                        )
                                            r[t].elem === this &&
                                                r[t].queue === e &&
                                                (r[t].anim.stop(!0), r.splice(t, 1));
                                        for (t = 0; t < a; t++) i[t] && i[t].finish && i[t].finish.call(this);
                                        delete n.finish;
                                    })
                                );
                            },
                        }),
                        E.each(["toggle", "show", "hide"], function (e, t) {
                            var n = E.fn[t];
                            E.fn[t] = function (e, i, s) {
                                return null == e || "boolean" == typeof e
                                    ? n.apply(this, arguments)
                                    : this.animate(pt(t, !0), e, i, s);
                            };
                        }),
                        E.each(
                            {
                                slideDown: pt("show"),
                                slideUp: pt("hide"),
                                slideToggle: pt("toggle"),
                                fadeIn: { opacity: "show" },
                                fadeOut: { opacity: "hide" },
                                fadeToggle: { opacity: "toggle" },
                            },
                            function (e, t) {
                                E.fn[e] = function (e, n, i) {
                                    return this.animate(t, e, n, i);
                                };
                            }
                        ),
                        (E.timers = []),
                        (E.fx.tick = function () {
                            var e,
                                t = 0,
                                n = E.timers;
                            for (at = Date.now(); t < n.length; t++) (e = n[t])() || n[t] !== e || n.splice(t--, 1);
                            n.length || E.fx.stop(), (at = void 0);
                        }),
                        (E.fx.timer = function (e) {
                            E.timers.push(e), E.fx.start();
                        }),
                        (E.fx.interval = 13),
                        (E.fx.start = function () {
                            ot || ((ot = !0), dt());
                        }),
                        (E.fx.stop = function () {
                            ot = null;
                        }),
                        (E.fx.speeds = { slow: 600, fast: 200, _default: 400 }),
                        (E.fn.delay = function (e, t) {
                            return (
                                (e = (E.fx && E.fx.speeds[e]) || e),
                                (t = t || "fx"),
                                this.queue(t, function (t, n) {
                                    var s = i.setTimeout(t, e);
                                    n.stop = function () {
                                        i.clearTimeout(s);
                                    };
                                })
                            );
                        }),
                        (function () {
                            var e = b.createElement("input"),
                                t = b.createElement("select").appendChild(b.createElement("option"));
                            (e.type = "checkbox"),
                                (g.checkOn = "" !== e.value),
                                (g.optSelected = t.selected),
                                ((e = b.createElement("input")).value = "t"),
                                (e.type = "radio"),
                                (g.radioValue = "t" === e.value);
                        })();
                    var mt,
                        gt = E.expr.attrHandle;
                    E.fn.extend({
                        attr: function (e, t) {
                            return G(this, E.attr, e, t, arguments.length > 1);
                        },
                        removeAttr: function (e) {
                            return this.each(function () {
                                E.removeAttr(this, e);
                            });
                        },
                    }),
                        E.extend({
                            attr: function (e, t, n) {
                                var i,
                                    s,
                                    r = e.nodeType;
                                if (3 !== r && 8 !== r && 2 !== r)
                                    return void 0 === e.getAttribute
                                        ? E.prop(e, t, n)
                                        : ((1 === r && E.isXMLDoc(e)) ||
                                              (s =
                                                  E.attrHooks[t.toLowerCase()] ||
                                                  (E.expr.match.bool.test(t) ? mt : void 0)),
                                          void 0 !== n
                                              ? null === n
                                                  ? void E.removeAttr(e, t)
                                                  : s && "set" in s && void 0 !== (i = s.set(e, n, t))
                                                    ? i
                                                    : (e.setAttribute(t, n + ""), n)
                                              : s && "get" in s && null !== (i = s.get(e, t))
                                                ? i
                                                : null == (i = E.find.attr(e, t))
                                                  ? void 0
                                                  : i);
                            },
                            attrHooks: {
                                type: {
                                    set: function (e, t) {
                                        if (!g.radioValue && "radio" === t && A(e, "input")) {
                                            var n = e.value;
                                            return e.setAttribute("type", t), n && (e.value = n), t;
                                        }
                                    },
                                },
                            },
                            removeAttr: function (e, t) {
                                var n,
                                    i = 0,
                                    s = t && t.match(j);
                                if (s && 1 === e.nodeType) for (; (n = s[i++]); ) e.removeAttribute(n);
                            },
                        }),
                        (mt = {
                            set: function (e, t, n) {
                                return !1 === t ? E.removeAttr(e, n) : e.setAttribute(n, n), n;
                            },
                        }),
                        E.each(E.expr.match.bool.source.match(/\w+/g), function (e, t) {
                            var n = gt[t] || E.find.attr;
                            gt[t] = function (e, t, i) {
                                var s,
                                    r,
                                    a = t.toLowerCase();
                                return (
                                    i || ((r = gt[a]), (gt[a] = s), (s = null != n(e, t, i) ? a : null), (gt[a] = r)), s
                                );
                            };
                        });
                    var vt = /^(?:input|select|textarea|button)$/i,
                        yt = /^(?:a|area)$/i;
                    function bt(e) {
                        return (e.match(j) || []).join(" ");
                    }
                    function wt(e) {
                        return (e.getAttribute && e.getAttribute("class")) || "";
                    }
                    function Ct(e) {
                        return Array.isArray(e) ? e : ("string" == typeof e && e.match(j)) || [];
                    }
                    E.fn.extend({
                        prop: function (e, t) {
                            return G(this, E.prop, e, t, arguments.length > 1);
                        },
                        removeProp: function (e) {
                            return this.each(function () {
                                delete this[E.propFix[e] || e];
                            });
                        },
                    }),
                        E.extend({
                            prop: function (e, t, n) {
                                var i,
                                    s,
                                    r = e.nodeType;
                                if (3 !== r && 8 !== r && 2 !== r)
                                    return (
                                        (1 === r && E.isXMLDoc(e)) || ((t = E.propFix[t] || t), (s = E.propHooks[t])),
                                        void 0 !== n
                                            ? s && "set" in s && void 0 !== (i = s.set(e, n, t))
                                                ? i
                                                : (e[t] = n)
                                            : s && "get" in s && null !== (i = s.get(e, t))
                                              ? i
                                              : e[t]
                                    );
                            },
                            propHooks: {
                                tabIndex: {
                                    get: function (e) {
                                        var t = E.find.attr(e, "tabindex");
                                        return t
                                            ? parseInt(t, 10)
                                            : vt.test(e.nodeName) || (yt.test(e.nodeName) && e.href)
                                              ? 0
                                              : -1;
                                    },
                                },
                            },
                            propFix: { for: "htmlFor", class: "className" },
                        }),
                        g.optSelected ||
                            (E.propHooks.selected = {
                                get: function (e) {
                                    var t = e.parentNode;
                                    return t && t.parentNode && t.parentNode.selectedIndex, null;
                                },
                                set: function (e) {
                                    var t = e.parentNode;
                                    t && (t.selectedIndex, t.parentNode && t.parentNode.selectedIndex);
                                },
                            }),
                        E.each(
                            [
                                "tabIndex",
                                "readOnly",
                                "maxLength",
                                "cellSpacing",
                                "cellPadding",
                                "rowSpan",
                                "colSpan",
                                "useMap",
                                "frameBorder",
                                "contentEditable",
                            ],
                            function () {
                                E.propFix[this.toLowerCase()] = this;
                            }
                        ),
                        E.fn.extend({
                            addClass: function (e) {
                                var t, n, i, s, r, a;
                                return v(e)
                                    ? this.each(function (t) {
                                          E(this).addClass(e.call(this, t, wt(this)));
                                      })
                                    : (t = Ct(e)).length
                                      ? this.each(function () {
                                            if (((i = wt(this)), (n = 1 === this.nodeType && " " + bt(i) + " "))) {
                                                for (r = 0; r < t.length; r++)
                                                    (s = t[r]), n.indexOf(" " + s + " ") < 0 && (n += s + " ");
                                                (a = bt(n)), i !== a && this.setAttribute("class", a);
                                            }
                                        })
                                      : this;
                            },
                            removeClass: function (e) {
                                var t, n, i, s, r, a;
                                return v(e)
                                    ? this.each(function (t) {
                                          E(this).removeClass(e.call(this, t, wt(this)));
                                      })
                                    : arguments.length
                                      ? (t = Ct(e)).length
                                          ? this.each(function () {
                                                if (((i = wt(this)), (n = 1 === this.nodeType && " " + bt(i) + " "))) {
                                                    for (r = 0; r < t.length; r++)
                                                        for (s = t[r]; n.indexOf(" " + s + " ") > -1; )
                                                            n = n.replace(" " + s + " ", " ");
                                                    (a = bt(n)), i !== a && this.setAttribute("class", a);
                                                }
                                            })
                                          : this
                                      : this.attr("class", "");
                            },
                            toggleClass: function (e, t) {
                                var n,
                                    i,
                                    s,
                                    r,
                                    a = typeof e,
                                    o = "string" === a || Array.isArray(e);
                                return v(e)
                                    ? this.each(function (n) {
                                          E(this).toggleClass(e.call(this, n, wt(this), t), t);
                                      })
                                    : "boolean" == typeof t && o
                                      ? t
                                          ? this.addClass(e)
                                          : this.removeClass(e)
                                      : ((n = Ct(e)),
                                        this.each(function () {
                                            if (o)
                                                for (r = E(this), s = 0; s < n.length; s++)
                                                    (i = n[s]), r.hasClass(i) ? r.removeClass(i) : r.addClass(i);
                                            else
                                                (void 0 !== e && "boolean" !== a) ||
                                                    ((i = wt(this)) && J.set(this, "__className__", i),
                                                    this.setAttribute &&
                                                        this.setAttribute(
                                                            "class",
                                                            i || !1 === e ? "" : J.get(this, "__className__") || ""
                                                        ));
                                        }));
                            },
                            hasClass: function (e) {
                                var t,
                                    n,
                                    i = 0;
                                for (t = " " + e + " "; (n = this[i++]); )
                                    if (1 === n.nodeType && (" " + bt(wt(n)) + " ").indexOf(t) > -1) return !0;
                                return !1;
                            },
                        });
                    var xt = /\r/g;
                    E.fn.extend({
                        val: function (e) {
                            var t,
                                n,
                                i,
                                s = this[0];
                            return arguments.length
                                ? ((i = v(e)),
                                  this.each(function (n) {
                                      var s;
                                      1 === this.nodeType &&
                                          (null == (s = i ? e.call(this, n, E(this).val()) : e)
                                              ? (s = "")
                                              : "number" == typeof s
                                                ? (s += "")
                                                : Array.isArray(s) &&
                                                  (s = E.map(s, function (e) {
                                                      return null == e ? "" : e + "";
                                                  })),
                                          ((t = E.valHooks[this.type] || E.valHooks[this.nodeName.toLowerCase()]) &&
                                              "set" in t &&
                                              void 0 !== t.set(this, s, "value")) ||
                                              (this.value = s));
                                  }))
                                : s
                                  ? (t = E.valHooks[s.type] || E.valHooks[s.nodeName.toLowerCase()]) &&
                                    "get" in t &&
                                    void 0 !== (n = t.get(s, "value"))
                                      ? n
                                      : "string" == typeof (n = s.value)
                                        ? n.replace(xt, "")
                                        : null == n
                                          ? ""
                                          : n
                                  : void 0;
                        },
                    }),
                        E.extend({
                            valHooks: {
                                option: {
                                    get: function (e) {
                                        var t = E.find.attr(e, "value");
                                        return null != t ? t : bt(E.text(e));
                                    },
                                },
                                select: {
                                    get: function (e) {
                                        var t,
                                            n,
                                            i,
                                            s = e.options,
                                            r = e.selectedIndex,
                                            a = "select-one" === e.type,
                                            o = a ? null : [],
                                            l = a ? r + 1 : s.length;
                                        for (i = r < 0 ? l : a ? r : 0; i < l; i++)
                                            if (
                                                ((n = s[i]).selected || i === r) &&
                                                !n.disabled &&
                                                (!n.parentNode.disabled || !A(n.parentNode, "optgroup"))
                                            ) {
                                                if (((t = E(n).val()), a)) return t;
                                                o.push(t);
                                            }
                                        return o;
                                    },
                                    set: function (e, t) {
                                        for (var n, i, s = e.options, r = E.makeArray(t), a = s.length; a--; )
                                            ((i = s[a]).selected = E.inArray(E.valHooks.option.get(i), r) > -1) &&
                                                (n = !0);
                                        return n || (e.selectedIndex = -1), r;
                                    },
                                },
                            },
                        }),
                        E.each(["radio", "checkbox"], function () {
                            (E.valHooks[this] = {
                                set: function (e, t) {
                                    if (Array.isArray(t)) return (e.checked = E.inArray(E(e).val(), t) > -1);
                                },
                            }),
                                g.checkOn ||
                                    (E.valHooks[this].get = function (e) {
                                        return null === e.getAttribute("value") ? "on" : e.value;
                                    });
                        }),
                        (g.focusin = "onfocusin" in i);
                    var St = /^(?:focusinfocus|focusoutblur)$/,
                        Et = function (e) {
                            e.stopPropagation();
                        };
                    E.extend(E.event, {
                        trigger: function (e, t, n, s) {
                            var r,
                                a,
                                o,
                                l,
                                c,
                                d,
                                u,
                                p,
                                f = [n || b],
                                m = h.call(e, "type") ? e.type : e,
                                g = h.call(e, "namespace") ? e.namespace.split(".") : [];
                            if (
                                ((a = p = o = n = n || b),
                                3 !== n.nodeType &&
                                    8 !== n.nodeType &&
                                    !St.test(m + E.event.triggered) &&
                                    (m.indexOf(".") > -1 && ((g = m.split(".")), (m = g.shift()), g.sort()),
                                    (c = m.indexOf(":") < 0 && "on" + m),
                                    ((e = e[E.expando] ? e : new E.Event(m, "object" == typeof e && e)).isTrigger = s
                                        ? 2
                                        : 3),
                                    (e.namespace = g.join(".")),
                                    (e.rnamespace = e.namespace
                                        ? new RegExp("(^|\\.)" + g.join("\\.(?:.*\\.|)") + "(\\.|$)")
                                        : null),
                                    (e.result = void 0),
                                    e.target || (e.target = n),
                                    (t = null == t ? [e] : E.makeArray(t, [e])),
                                    (u = E.event.special[m] || {}),
                                    s || !u.trigger || !1 !== u.trigger.apply(n, t)))
                            ) {
                                if (!s && !u.noBubble && !y(n)) {
                                    for (
                                        l = u.delegateType || m, St.test(l + m) || (a = a.parentNode);
                                        a;
                                        a = a.parentNode
                                    )
                                        f.push(a), (o = a);
                                    o === (n.ownerDocument || b) && f.push(o.defaultView || o.parentWindow || i);
                                }
                                for (r = 0; (a = f[r++]) && !e.isPropagationStopped(); )
                                    (p = a),
                                        (e.type = r > 1 ? l : u.bindType || m),
                                        (d =
                                            (J.get(a, "events") || Object.create(null))[e.type] &&
                                            J.get(a, "handle")) && d.apply(a, t),
                                        (d = c && a[c]) &&
                                            d.apply &&
                                            K(a) &&
                                            ((e.result = d.apply(a, t)), !1 === e.result && e.preventDefault());
                                return (
                                    (e.type = m),
                                    s ||
                                        e.isDefaultPrevented() ||
                                        (u._default && !1 !== u._default.apply(f.pop(), t)) ||
                                        !K(n) ||
                                        (c &&
                                            v(n[m]) &&
                                            !y(n) &&
                                            ((o = n[c]) && (n[c] = null),
                                            (E.event.triggered = m),
                                            e.isPropagationStopped() && p.addEventListener(m, Et),
                                            n[m](),
                                            e.isPropagationStopped() && p.removeEventListener(m, Et),
                                            (E.event.triggered = void 0),
                                            o && (n[c] = o))),
                                    e.result
                                );
                            }
                        },
                        simulate: function (e, t, n) {
                            var i = E.extend(new E.Event(), n, { type: e, isSimulated: !0 });
                            E.event.trigger(i, null, t);
                        },
                    }),
                        E.fn.extend({
                            trigger: function (e, t) {
                                return this.each(function () {
                                    E.event.trigger(e, t, this);
                                });
                            },
                            triggerHandler: function (e, t) {
                                var n = this[0];
                                if (n) return E.event.trigger(e, t, n, !0);
                            },
                        }),
                        g.focusin ||
                            E.each({ focus: "focusin", blur: "focusout" }, function (e, t) {
                                var n = function (e) {
                                    E.event.simulate(t, e.target, E.event.fix(e));
                                };
                                E.event.special[t] = {
                                    setup: function () {
                                        var i = this.ownerDocument || this.document || this,
                                            s = J.access(i, t);
                                        s || i.addEventListener(e, n, !0), J.access(i, t, (s || 0) + 1);
                                    },
                                    teardown: function () {
                                        var i = this.ownerDocument || this.document || this,
                                            s = J.access(i, t) - 1;
                                        s ? J.access(i, t, s) : (i.removeEventListener(e, n, !0), J.remove(i, t));
                                    },
                                };
                            });
                    var Tt = i.location,
                        $t = { guid: Date.now() },
                        kt = /\?/;
                    E.parseXML = function (e) {
                        var t, n;
                        if (!e || "string" != typeof e) return null;
                        try {
                            t = new i.DOMParser().parseFromString(e, "text/xml");
                        } catch (e) {}
                        return (
                            (n = t && t.getElementsByTagName("parsererror")[0]),
                            (t && !n) ||
                                E.error(
                                    "Invalid XML: " +
                                        (n
                                            ? E.map(n.childNodes, function (e) {
                                                  return e.textContent;
                                              }).join("\n")
                                            : e)
                                ),
                            t
                        );
                    };
                    var Mt = /\[\]$/,
                        Lt = /\r?\n/g,
                        At = /^(?:submit|button|image|reset|file)$/i,
                        It = /^(?:input|select|textarea|keygen)/i;
                    function _t(e, t, n, i) {
                        var s;
                        if (Array.isArray(t))
                            E.each(t, function (t, s) {
                                n || Mt.test(e)
                                    ? i(e, s)
                                    : _t(e + "[" + ("object" == typeof s && null != s ? t : "") + "]", s, n, i);
                            });
                        else if (n || "object" !== x(t)) i(e, t);
                        else for (s in t) _t(e + "[" + s + "]", t[s], n, i);
                    }
                    (E.param = function (e, t) {
                        var n,
                            i = [],
                            s = function (e, t) {
                                var n = v(t) ? t() : t;
                                i[i.length] = encodeURIComponent(e) + "=" + encodeURIComponent(null == n ? "" : n);
                            };
                        if (null == e) return "";
                        if (Array.isArray(e) || (e.jquery && !E.isPlainObject(e)))
                            E.each(e, function () {
                                s(this.name, this.value);
                            });
                        else for (n in e) _t(n, e[n], t, s);
                        return i.join("&");
                    }),
                        E.fn.extend({
                            serialize: function () {
                                return E.param(this.serializeArray());
                            },
                            serializeArray: function () {
                                return this.map(function () {
                                    var e = E.prop(this, "elements");
                                    return e ? E.makeArray(e) : this;
                                })
                                    .filter(function () {
                                        var e = this.type;
                                        return (
                                            this.name &&
                                            !E(this).is(":disabled") &&
                                            It.test(this.nodeName) &&
                                            !At.test(e) &&
                                            (this.checked || !ge.test(e))
                                        );
                                    })
                                    .map(function (e, t) {
                                        var n = E(this).val();
                                        return null == n
                                            ? null
                                            : Array.isArray(n)
                                              ? E.map(n, function (e) {
                                                    return { name: t.name, value: e.replace(Lt, "\r\n") };
                                                })
                                              : { name: t.name, value: n.replace(Lt, "\r\n") };
                                    })
                                    .get();
                            },
                        });
                    var Pt = /%20/g,
                        Dt = /#.*$/,
                        Ot = /([?&])_=[^&]*/,
                        Nt = /^(.*?):[ \t]*([^\r\n]*)$/gm,
                        Ft = /^(?:GET|HEAD)$/,
                        jt = /^\/\//,
                        zt = {},
                        Bt = {},
                        qt = "*/".concat("*"),
                        Ht = b.createElement("a");
                    function Rt(e) {
                        return function (t, n) {
                            "string" != typeof t && ((n = t), (t = "*"));
                            var i,
                                s = 0,
                                r = t.toLowerCase().match(j) || [];
                            if (v(n))
                                for (; (i = r[s++]); )
                                    "+" === i[0]
                                        ? ((i = i.slice(1) || "*"), (e[i] = e[i] || []).unshift(n))
                                        : (e[i] = e[i] || []).push(n);
                        };
                    }
                    function Vt(e, t, n, i) {
                        var s = {},
                            r = e === Bt;
                        function a(o) {
                            var l;
                            return (
                                (s[o] = !0),
                                E.each(e[o] || [], function (e, o) {
                                    var c = o(t, n, i);
                                    return "string" != typeof c || r || s[c]
                                        ? r
                                            ? !(l = c)
                                            : void 0
                                        : (t.dataTypes.unshift(c), a(c), !1);
                                }),
                                l
                            );
                        }
                        return a(t.dataTypes[0]) || (!s["*"] && a("*"));
                    }
                    function Gt(e, t) {
                        var n,
                            i,
                            s = E.ajaxSettings.flatOptions || {};
                        for (n in t) void 0 !== t[n] && ((s[n] ? e : i || (i = {}))[n] = t[n]);
                        return i && E.extend(!0, e, i), e;
                    }
                    (Ht.href = Tt.href),
                        E.extend({
                            active: 0,
                            lastModified: {},
                            etag: {},
                            ajaxSettings: {
                                url: Tt.href,
                                type: "GET",
                                isLocal: /^(?:about|app|app-storage|.+-extension|file|res|widget):$/.test(Tt.protocol),
                                global: !0,
                                processData: !0,
                                async: !0,
                                contentType: "application/x-www-form-urlencoded; charset=UTF-8",
                                accepts: {
                                    "*": qt,
                                    text: "text/plain",
                                    html: "text/html",
                                    xml: "application/xml, text/xml",
                                    json: "application/json, text/javascript",
                                },
                                contents: { xml: /\bxml\b/, html: /\bhtml/, json: /\bjson\b/ },
                                responseFields: { xml: "responseXML", text: "responseText", json: "responseJSON" },
                                converters: {
                                    "* text": String,
                                    "text html": !0,
                                    "text json": JSON.parse,
                                    "text xml": E.parseXML,
                                },
                                flatOptions: { url: !0, context: !0 },
                            },
                            ajaxSetup: function (e, t) {
                                return t ? Gt(Gt(e, E.ajaxSettings), t) : Gt(E.ajaxSettings, e);
                            },
                            ajaxPrefilter: Rt(zt),
                            ajaxTransport: Rt(Bt),
                            ajax: function (e, t) {
                                "object" == typeof e && ((t = e), (e = void 0)), (t = t || {});
                                var n,
                                    s,
                                    r,
                                    a,
                                    o,
                                    l,
                                    c,
                                    d,
                                    u,
                                    p,
                                    h = E.ajaxSetup({}, t),
                                    f = h.context || h,
                                    m = h.context && (f.nodeType || f.jquery) ? E(f) : E.event,
                                    g = E.Deferred(),
                                    v = E.Callbacks("once memory"),
                                    y = h.statusCode || {},
                                    w = {},
                                    C = {},
                                    x = "canceled",
                                    S = {
                                        readyState: 0,
                                        getResponseHeader: function (e) {
                                            var t;
                                            if (c) {
                                                if (!a)
                                                    for (a = {}; (t = Nt.exec(r)); )
                                                        a[t[1].toLowerCase() + " "] = (
                                                            a[t[1].toLowerCase() + " "] || []
                                                        ).concat(t[2]);
                                                t = a[e.toLowerCase() + " "];
                                            }
                                            return null == t ? null : t.join(", ");
                                        },
                                        getAllResponseHeaders: function () {
                                            return c ? r : null;
                                        },
                                        setRequestHeader: function (e, t) {
                                            return (
                                                null == c &&
                                                    ((e = C[e.toLowerCase()] = C[e.toLowerCase()] || e), (w[e] = t)),
                                                this
                                            );
                                        },
                                        overrideMimeType: function (e) {
                                            return null == c && (h.mimeType = e), this;
                                        },
                                        statusCode: function (e) {
                                            var t;
                                            if (e)
                                                if (c) S.always(e[S.status]);
                                                else for (t in e) y[t] = [y[t], e[t]];
                                            return this;
                                        },
                                        abort: function (e) {
                                            var t = e || x;
                                            return n && n.abort(t), T(0, t), this;
                                        },
                                    };
                                if (
                                    (g.promise(S),
                                    (h.url = ((e || h.url || Tt.href) + "").replace(jt, Tt.protocol + "//")),
                                    (h.type = t.method || t.type || h.method || h.type),
                                    (h.dataTypes = (h.dataType || "*").toLowerCase().match(j) || [""]),
                                    null == h.crossDomain)
                                ) {
                                    l = b.createElement("a");
                                    try {
                                        (l.href = h.url),
                                            (l.href = l.href),
                                            (h.crossDomain =
                                                Ht.protocol + "//" + Ht.host != l.protocol + "//" + l.host);
                                    } catch (e) {
                                        h.crossDomain = !0;
                                    }
                                }
                                if (
                                    (h.data &&
                                        h.processData &&
                                        "string" != typeof h.data &&
                                        (h.data = E.param(h.data, h.traditional)),
                                    Vt(zt, h, t, S),
                                    c)
                                )
                                    return S;
                                for (u in ((d = E.event && h.global) && 0 == E.active++ && E.event.trigger("ajaxStart"),
                                (h.type = h.type.toUpperCase()),
                                (h.hasContent = !Ft.test(h.type)),
                                (s = h.url.replace(Dt, "")),
                                h.hasContent
                                    ? h.data &&
                                      h.processData &&
                                      0 === (h.contentType || "").indexOf("application/x-www-form-urlencoded") &&
                                      (h.data = h.data.replace(Pt, "+"))
                                    : ((p = h.url.slice(s.length)),
                                      h.data &&
                                          (h.processData || "string" == typeof h.data) &&
                                          ((s += (kt.test(s) ? "&" : "?") + h.data), delete h.data),
                                      !1 === h.cache &&
                                          ((s = s.replace(Ot, "$1")),
                                          (p = (kt.test(s) ? "&" : "?") + "_=" + $t.guid++ + p)),
                                      (h.url = s + p)),
                                h.ifModified &&
                                    (E.lastModified[s] && S.setRequestHeader("If-Modified-Since", E.lastModified[s]),
                                    E.etag[s] && S.setRequestHeader("If-None-Match", E.etag[s])),
                                ((h.data && h.hasContent && !1 !== h.contentType) || t.contentType) &&
                                    S.setRequestHeader("Content-Type", h.contentType),
                                S.setRequestHeader(
                                    "Accept",
                                    h.dataTypes[0] && h.accepts[h.dataTypes[0]]
                                        ? h.accepts[h.dataTypes[0]] +
                                              ("*" !== h.dataTypes[0] ? ", " + qt + "; q=0.01" : "")
                                        : h.accepts["*"]
                                ),
                                h.headers))
                                    S.setRequestHeader(u, h.headers[u]);
                                if (h.beforeSend && (!1 === h.beforeSend.call(f, S, h) || c)) return S.abort();
                                if (
                                    ((x = "abort"),
                                    v.add(h.complete),
                                    S.done(h.success),
                                    S.fail(h.error),
                                    (n = Vt(Bt, h, t, S)))
                                ) {
                                    if (((S.readyState = 1), d && m.trigger("ajaxSend", [S, h]), c)) return S;
                                    h.async &&
                                        h.timeout > 0 &&
                                        (o = i.setTimeout(function () {
                                            S.abort("timeout");
                                        }, h.timeout));
                                    try {
                                        (c = !1), n.send(w, T);
                                    } catch (e) {
                                        if (c) throw e;
                                        T(-1, e);
                                    }
                                } else T(-1, "No Transport");
                                function T(e, t, a, l) {
                                    var u,
                                        p,
                                        b,
                                        w,
                                        C,
                                        x = t;
                                    c ||
                                        ((c = !0),
                                        o && i.clearTimeout(o),
                                        (n = void 0),
                                        (r = l || ""),
                                        (S.readyState = e > 0 ? 4 : 0),
                                        (u = (e >= 200 && e < 300) || 304 === e),
                                        a &&
                                            (w = (function (e, t, n) {
                                                for (var i, s, r, a, o = e.contents, l = e.dataTypes; "*" === l[0]; )
                                                    l.shift(),
                                                        void 0 === i &&
                                                            (i = e.mimeType || t.getResponseHeader("Content-Type"));
                                                if (i)
                                                    for (s in o)
                                                        if (o[s] && o[s].test(i)) {
                                                            l.unshift(s);
                                                            break;
                                                        }
                                                if (l[0] in n) r = l[0];
                                                else {
                                                    for (s in n) {
                                                        if (!l[0] || e.converters[s + " " + l[0]]) {
                                                            r = s;
                                                            break;
                                                        }
                                                        a || (a = s);
                                                    }
                                                    r = r || a;
                                                }
                                                if (r) return r !== l[0] && l.unshift(r), n[r];
                                            })(h, S, a)),
                                        !u &&
                                            E.inArray("script", h.dataTypes) > -1 &&
                                            E.inArray("json", h.dataTypes) < 0 &&
                                            (h.converters["text script"] = function () {}),
                                        (w = (function (e, t, n, i) {
                                            var s,
                                                r,
                                                a,
                                                o,
                                                l,
                                                c = {},
                                                d = e.dataTypes.slice();
                                            if (d[1]) for (a in e.converters) c[a.toLowerCase()] = e.converters[a];
                                            for (r = d.shift(); r; )
                                                if (
                                                    (e.responseFields[r] && (n[e.responseFields[r]] = t),
                                                    !l && i && e.dataFilter && (t = e.dataFilter(t, e.dataType)),
                                                    (l = r),
                                                    (r = d.shift()))
                                                )
                                                    if ("*" === r) r = l;
                                                    else if ("*" !== l && l !== r) {
                                                        if (!(a = c[l + " " + r] || c["* " + r]))
                                                            for (s in c)
                                                                if (
                                                                    (o = s.split(" "))[1] === r &&
                                                                    (a = c[l + " " + o[0]] || c["* " + o[0]])
                                                                ) {
                                                                    !0 === a
                                                                        ? (a = c[s])
                                                                        : !0 !== c[s] && ((r = o[0]), d.unshift(o[1]));
                                                                    break;
                                                                }
                                                        if (!0 !== a)
                                                            if (a && e.throws) t = a(t);
                                                            else
                                                                try {
                                                                    t = a(t);
                                                                } catch (e) {
                                                                    return {
                                                                        state: "parsererror",
                                                                        error: a
                                                                            ? e
                                                                            : "No conversion from " + l + " to " + r,
                                                                    };
                                                                }
                                                    }
                                            return { state: "success", data: t };
                                        })(h, w, S, u)),
                                        u
                                            ? (h.ifModified &&
                                                  ((C = S.getResponseHeader("Last-Modified")) &&
                                                      (E.lastModified[s] = C),
                                                  (C = S.getResponseHeader("etag")) && (E.etag[s] = C)),
                                              204 === e || "HEAD" === h.type
                                                  ? (x = "nocontent")
                                                  : 304 === e
                                                    ? (x = "notmodified")
                                                    : ((x = w.state), (p = w.data), (u = !(b = w.error))))
                                            : ((b = x), (!e && x) || ((x = "error"), e < 0 && (e = 0))),
                                        (S.status = e),
                                        (S.statusText = (t || x) + ""),
                                        u ? g.resolveWith(f, [p, x, S]) : g.rejectWith(f, [S, x, b]),
                                        S.statusCode(y),
                                        (y = void 0),
                                        d && m.trigger(u ? "ajaxSuccess" : "ajaxError", [S, h, u ? p : b]),
                                        v.fireWith(f, [S, x]),
                                        d &&
                                            (m.trigger("ajaxComplete", [S, h]),
                                            --E.active || E.event.trigger("ajaxStop")));
                                }
                                return S;
                            },
                            getJSON: function (e, t, n) {
                                return E.get(e, t, n, "json");
                            },
                            getScript: function (e, t) {
                                return E.get(e, void 0, t, "script");
                            },
                        }),
                        E.each(["get", "post"], function (e, t) {
                            E[t] = function (e, n, i, s) {
                                return (
                                    v(n) && ((s = s || i), (i = n), (n = void 0)),
                                    E.ajax(
                                        E.extend(
                                            { url: e, type: t, dataType: s, data: n, success: i },
                                            E.isPlainObject(e) && e
                                        )
                                    )
                                );
                            };
                        }),
                        E.ajaxPrefilter(function (e) {
                            var t;
                            for (t in e.headers)
                                "content-type" === t.toLowerCase() && (e.contentType = e.headers[t] || "");
                        }),
                        (E._evalUrl = function (e, t, n) {
                            return E.ajax({
                                url: e,
                                type: "GET",
                                dataType: "script",
                                cache: !0,
                                async: !1,
                                global: !1,
                                converters: { "text script": function () {} },
                                dataFilter: function (e) {
                                    E.globalEval(e, t, n);
                                },
                            });
                        }),
                        E.fn.extend({
                            wrapAll: function (e) {
                                var t;
                                return (
                                    this[0] &&
                                        (v(e) && (e = e.call(this[0])),
                                        (t = E(e, this[0].ownerDocument).eq(0).clone(!0)),
                                        this[0].parentNode && t.insertBefore(this[0]),
                                        t
                                            .map(function () {
                                                for (var e = this; e.firstElementChild; ) e = e.firstElementChild;
                                                return e;
                                            })
                                            .append(this)),
                                    this
                                );
                            },
                            wrapInner: function (e) {
                                return v(e)
                                    ? this.each(function (t) {
                                          E(this).wrapInner(e.call(this, t));
                                      })
                                    : this.each(function () {
                                          var t = E(this),
                                              n = t.contents();
                                          n.length ? n.wrapAll(e) : t.append(e);
                                      });
                            },
                            wrap: function (e) {
                                var t = v(e);
                                return this.each(function (n) {
                                    E(this).wrapAll(t ? e.call(this, n) : e);
                                });
                            },
                            unwrap: function (e) {
                                return (
                                    this.parent(e)
                                        .not("body")
                                        .each(function () {
                                            E(this).replaceWith(this.childNodes);
                                        }),
                                    this
                                );
                            },
                        }),
                        (E.expr.pseudos.hidden = function (e) {
                            return !E.expr.pseudos.visible(e);
                        }),
                        (E.expr.pseudos.visible = function (e) {
                            return !!(e.offsetWidth || e.offsetHeight || e.getClientRects().length);
                        }),
                        (E.ajaxSettings.xhr = function () {
                            try {
                                return new i.XMLHttpRequest();
                            } catch (e) {}
                        });
                    var Wt = { 0: 200, 1223: 204 },
                        Ut = E.ajaxSettings.xhr();
                    (g.cors = !!Ut && "withCredentials" in Ut),
                        (g.ajax = Ut = !!Ut),
                        E.ajaxTransport(function (e) {
                            var t, n;
                            if (g.cors || (Ut && !e.crossDomain))
                                return {
                                    send: function (s, r) {
                                        var a,
                                            o = e.xhr();
                                        if ((o.open(e.type, e.url, e.async, e.username, e.password), e.xhrFields))
                                            for (a in e.xhrFields) o[a] = e.xhrFields[a];
                                        for (a in (e.mimeType && o.overrideMimeType && o.overrideMimeType(e.mimeType),
                                        e.crossDomain ||
                                            s["X-Requested-With"] ||
                                            (s["X-Requested-With"] = "XMLHttpRequest"),
                                        s))
                                            o.setRequestHeader(a, s[a]);
                                        (t = function (e) {
                                            return function () {
                                                t &&
                                                    ((t =
                                                        n =
                                                        o.onload =
                                                        o.onerror =
                                                        o.onabort =
                                                        o.ontimeout =
                                                        o.onreadystatechange =
                                                            null),
                                                    "abort" === e
                                                        ? o.abort()
                                                        : "error" === e
                                                          ? "number" != typeof o.status
                                                              ? r(0, "error")
                                                              : r(o.status, o.statusText)
                                                          : r(
                                                                Wt[o.status] || o.status,
                                                                o.statusText,
                                                                "text" !== (o.responseType || "text") ||
                                                                    "string" != typeof o.responseText
                                                                    ? { binary: o.response }
                                                                    : { text: o.responseText },
                                                                o.getAllResponseHeaders()
                                                            ));
                                            };
                                        }),
                                            (o.onload = t()),
                                            (n = o.onerror = o.ontimeout = t("error")),
                                            void 0 !== o.onabort
                                                ? (o.onabort = n)
                                                : (o.onreadystatechange = function () {
                                                      4 === o.readyState &&
                                                          i.setTimeout(function () {
                                                              t && n();
                                                          });
                                                  }),
                                            (t = t("abort"));
                                        try {
                                            o.send((e.hasContent && e.data) || null);
                                        } catch (e) {
                                            if (t) throw e;
                                        }
                                    },
                                    abort: function () {
                                        t && t();
                                    },
                                };
                        }),
                        E.ajaxPrefilter(function (e) {
                            e.crossDomain && (e.contents.script = !1);
                        }),
                        E.ajaxSetup({
                            accepts: {
                                script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript",
                            },
                            contents: { script: /\b(?:java|ecma)script\b/ },
                            converters: {
                                "text script": function (e) {
                                    return E.globalEval(e), e;
                                },
                            },
                        }),
                        E.ajaxPrefilter("script", function (e) {
                            void 0 === e.cache && (e.cache = !1), e.crossDomain && (e.type = "GET");
                        }),
                        E.ajaxTransport("script", function (e) {
                            var t, n;
                            if (e.crossDomain || e.scriptAttrs)
                                return {
                                    send: function (i, s) {
                                        (t = E("<script>")
                                            .attr(e.scriptAttrs || {})
                                            .prop({ charset: e.scriptCharset, src: e.url })
                                            .on(
                                                "load error",
                                                (n = function (e) {
                                                    t.remove(),
                                                        (n = null),
                                                        e && s("error" === e.type ? 404 : 200, e.type);
                                                })
                                            )),
                                            b.head.appendChild(t[0]);
                                    },
                                    abort: function () {
                                        n && n();
                                    },
                                };
                        });
                    var Xt,
                        Yt = [],
                        Kt = /(=)\?(?=&|$)|\?\?/;
                    E.ajaxSetup({
                        jsonp: "callback",
                        jsonpCallback: function () {
                            var e = Yt.pop() || E.expando + "_" + $t.guid++;
                            return (this[e] = !0), e;
                        },
                    }),
                        E.ajaxPrefilter("json jsonp", function (e, t, n) {
                            var s,
                                r,
                                a,
                                o =
                                    !1 !== e.jsonp &&
                                    (Kt.test(e.url)
                                        ? "url"
                                        : "string" == typeof e.data &&
                                          0 === (e.contentType || "").indexOf("application/x-www-form-urlencoded") &&
                                          Kt.test(e.data) &&
                                          "data");
                            if (o || "jsonp" === e.dataTypes[0])
                                return (
                                    (s = e.jsonpCallback = v(e.jsonpCallback) ? e.jsonpCallback() : e.jsonpCallback),
                                    o
                                        ? (e[o] = e[o].replace(Kt, "$1" + s))
                                        : !1 !== e.jsonp && (e.url += (kt.test(e.url) ? "&" : "?") + e.jsonp + "=" + s),
                                    (e.converters["script json"] = function () {
                                        return a || E.error(s + " was not called"), a[0];
                                    }),
                                    (e.dataTypes[0] = "json"),
                                    (r = i[s]),
                                    (i[s] = function () {
                                        a = arguments;
                                    }),
                                    n.always(function () {
                                        void 0 === r ? E(i).removeProp(s) : (i[s] = r),
                                            e[s] && ((e.jsonpCallback = t.jsonpCallback), Yt.push(s)),
                                            a && v(r) && r(a[0]),
                                            (a = r = void 0);
                                    }),
                                    "script"
                                );
                        }),
                        (g.createHTMLDocument =
                            (((Xt = b.implementation.createHTMLDocument("").body).innerHTML =
                                "<form></form><form></form>"),
                            2 === Xt.childNodes.length)),
                        (E.parseHTML = function (e, t, n) {
                            return "string" != typeof e
                                ? []
                                : ("boolean" == typeof t && ((n = t), (t = !1)),
                                  t ||
                                      (g.createHTMLDocument
                                          ? (((i = (t = b.implementation.createHTMLDocument("")).createElement(
                                                "base"
                                            )).href = b.location.href),
                                            t.head.appendChild(i))
                                          : (t = b)),
                                  (r = !n && []),
                                  (s = I.exec(e))
                                      ? [t.createElement(s[1])]
                                      : ((s = Se([e], t, r)),
                                        r && r.length && E(r).remove(),
                                        E.merge([], s.childNodes)));
                            var i, s, r;
                        }),
                        (E.fn.load = function (e, t, n) {
                            var i,
                                s,
                                r,
                                a = this,
                                o = e.indexOf(" ");
                            return (
                                o > -1 && ((i = bt(e.slice(o))), (e = e.slice(0, o))),
                                v(t) ? ((n = t), (t = void 0)) : t && "object" == typeof t && (s = "POST"),
                                a.length > 0 &&
                                    E.ajax({ url: e, type: s || "GET", dataType: "html", data: t })
                                        .done(function (e) {
                                            (r = arguments), a.html(i ? E("<div>").append(E.parseHTML(e)).find(i) : e);
                                        })
                                        .always(
                                            n &&
                                                function (e, t) {
                                                    a.each(function () {
                                                        n.apply(this, r || [e.responseText, t, e]);
                                                    });
                                                }
                                        ),
                                this
                            );
                        }),
                        (E.expr.pseudos.animated = function (e) {
                            return E.grep(E.timers, function (t) {
                                return e === t.elem;
                            }).length;
                        }),
                        (E.offset = {
                            setOffset: function (e, t, n) {
                                var i,
                                    s,
                                    r,
                                    a,
                                    o,
                                    l,
                                    c = E.css(e, "position"),
                                    d = E(e),
                                    u = {};
                                "static" === c && (e.style.position = "relative"),
                                    (o = d.offset()),
                                    (r = E.css(e, "top")),
                                    (l = E.css(e, "left")),
                                    ("absolute" === c || "fixed" === c) && (r + l).indexOf("auto") > -1
                                        ? ((a = (i = d.position()).top), (s = i.left))
                                        : ((a = parseFloat(r) || 0), (s = parseFloat(l) || 0)),
                                    v(t) && (t = t.call(e, n, E.extend({}, o))),
                                    null != t.top && (u.top = t.top - o.top + a),
                                    null != t.left && (u.left = t.left - o.left + s),
                                    "using" in t ? t.using.call(e, u) : d.css(u);
                            },
                        }),
                        E.fn.extend({
                            offset: function (e) {
                                if (arguments.length)
                                    return void 0 === e
                                        ? this
                                        : this.each(function (t) {
                                              E.offset.setOffset(this, e, t);
                                          });
                                var t,
                                    n,
                                    i = this[0];
                                return i
                                    ? i.getClientRects().length
                                        ? ((t = i.getBoundingClientRect()),
                                          (n = i.ownerDocument.defaultView),
                                          { top: t.top + n.pageYOffset, left: t.left + n.pageXOffset })
                                        : { top: 0, left: 0 }
                                    : void 0;
                            },
                            position: function () {
                                if (this[0]) {
                                    var e,
                                        t,
                                        n,
                                        i = this[0],
                                        s = { top: 0, left: 0 };
                                    if ("fixed" === E.css(i, "position")) t = i.getBoundingClientRect();
                                    else {
                                        for (
                                            t = this.offset(),
                                                n = i.ownerDocument,
                                                e = i.offsetParent || n.documentElement;
                                            e &&
                                            (e === n.body || e === n.documentElement) &&
                                            "static" === E.css(e, "position");

                                        )
                                            e = e.parentNode;
                                        e &&
                                            e !== i &&
                                            1 === e.nodeType &&
                                            (((s = E(e).offset()).top += E.css(e, "borderTopWidth", !0)),
                                            (s.left += E.css(e, "borderLeftWidth", !0)));
                                    }
                                    return {
                                        top: t.top - s.top - E.css(i, "marginTop", !0),
                                        left: t.left - s.left - E.css(i, "marginLeft", !0),
                                    };
                                }
                            },
                            offsetParent: function () {
                                return this.map(function () {
                                    for (var e = this.offsetParent; e && "static" === E.css(e, "position"); )
                                        e = e.offsetParent;
                                    return e || ae;
                                });
                            },
                        }),
                        E.each({ scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function (e, t) {
                            var n = "pageYOffset" === t;
                            E.fn[e] = function (i) {
                                return G(
                                    this,
                                    function (e, i, s) {
                                        var r;
                                        if ((y(e) ? (r = e) : 9 === e.nodeType && (r = e.defaultView), void 0 === s))
                                            return r ? r[t] : e[i];
                                        r ? r.scrollTo(n ? r.pageXOffset : s, n ? s : r.pageYOffset) : (e[i] = s);
                                    },
                                    e,
                                    i,
                                    arguments.length
                                );
                            };
                        }),
                        E.each(["top", "left"], function (e, t) {
                            E.cssHooks[t] = Xe(g.pixelPosition, function (e, n) {
                                if (n) return (n = Ue(e, t)), Be.test(n) ? E(e).position()[t] + "px" : n;
                            });
                        }),
                        E.each({ Height: "height", Width: "width" }, function (e, t) {
                            E.each({ padding: "inner" + e, content: t, "": "outer" + e }, function (n, i) {
                                E.fn[i] = function (s, r) {
                                    var a = arguments.length && (n || "boolean" != typeof s),
                                        o = n || (!0 === s || !0 === r ? "margin" : "border");
                                    return G(
                                        this,
                                        function (t, n, s) {
                                            var r;
                                            return y(t)
                                                ? 0 === i.indexOf("outer")
                                                    ? t["inner" + e]
                                                    : t.document.documentElement["client" + e]
                                                : 9 === t.nodeType
                                                  ? ((r = t.documentElement),
                                                    Math.max(
                                                        t.body["scroll" + e],
                                                        r["scroll" + e],
                                                        t.body["offset" + e],
                                                        r["offset" + e],
                                                        r["client" + e]
                                                    ))
                                                  : void 0 === s
                                                    ? E.css(t, n, o)
                                                    : E.style(t, n, s, o);
                                        },
                                        t,
                                        a ? s : void 0,
                                        a
                                    );
                                };
                            });
                        }),
                        E.each(
                            ["ajaxStart", "ajaxStop", "ajaxComplete", "ajaxError", "ajaxSuccess", "ajaxSend"],
                            function (e, t) {
                                E.fn[t] = function (e) {
                                    return this.on(t, e);
                                };
                            }
                        ),
                        E.fn.extend({
                            bind: function (e, t, n) {
                                return this.on(e, null, t, n);
                            },
                            unbind: function (e, t) {
                                return this.off(e, null, t);
                            },
                            delegate: function (e, t, n, i) {
                                return this.on(t, e, n, i);
                            },
                            undelegate: function (e, t, n) {
                                return 1 === arguments.length ? this.off(e, "**") : this.off(t, e || "**", n);
                            },
                            hover: function (e, t) {
                                return this.mouseenter(e).mouseleave(t || e);
                            },
                        }),
                        E.each(
                            "blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu".split(
                                " "
                            ),
                            function (e, t) {
                                E.fn[t] = function (e, n) {
                                    return arguments.length > 0 ? this.on(t, null, e, n) : this.trigger(t);
                                };
                            }
                        );
                    var Qt = /^[\s\uFEFF\xA0]+|([^\s\uFEFF\xA0])[\s\uFEFF\xA0]+$/g;
                    (E.proxy = function (e, t) {
                        var n, i, s;
                        if (("string" == typeof t && ((n = e[t]), (t = e), (e = n)), v(e)))
                            return (
                                (i = o.call(arguments, 2)),
                                (s = function () {
                                    return e.apply(t || this, i.concat(o.call(arguments)));
                                }),
                                (s.guid = e.guid = e.guid || E.guid++),
                                s
                            );
                    }),
                        (E.holdReady = function (e) {
                            e ? E.readyWait++ : E.ready(!0);
                        }),
                        (E.isArray = Array.isArray),
                        (E.parseJSON = JSON.parse),
                        (E.nodeName = A),
                        (E.isFunction = v),
                        (E.isWindow = y),
                        (E.camelCase = Y),
                        (E.type = x),
                        (E.now = Date.now),
                        (E.isNumeric = function (e) {
                            var t = E.type(e);
                            return ("number" === t || "string" === t) && !isNaN(e - parseFloat(e));
                        }),
                        (E.trim = function (e) {
                            return null == e ? "" : (e + "").replace(Qt, "$1");
                        }),
                        void 0 ===
                            (n = function () {
                                return E;
                            }.apply(t, [])) || (e.exports = n);
                    var Jt = i.jQuery,
                        Zt = i.$;
                    return (
                        (E.noConflict = function (e) {
                            return i.$ === E && (i.$ = Zt), e && i.jQuery === E && (i.jQuery = Jt), E;
                        }),
                        void 0 === s && (i.jQuery = i.$ = E),
                        E
                    );
                });
            },
            227: function (e, t, n) {
                (t.formatArgs = function (t) {
                    if (
                        ((t[0] =
                            (this.useColors ? "%c" : "") +
                            this.namespace +
                            (this.useColors ? " %c" : " ") +
                            t[0] +
                            (this.useColors ? "%c " : " ") +
                            "+" +
                            e.exports.humanize(this.diff)),
                        !this.useColors)
                    )
                        return;
                    const n = "color: " + this.color;
                    t.splice(1, 0, n, "color: inherit");
                    let i = 0,
                        s = 0;
                    t[0].replace(/%[a-zA-Z%]/g, (e) => {
                        "%%" !== e && (i++, "%c" === e && (s = i));
                    }),
                        t.splice(s, 0, n);
                }),
                    (t.save = function (e) {
                        try {
                            e ? t.storage.setItem("debug", e) : t.storage.removeItem("debug");
                        } catch (e) {}
                    }),
                    (t.load = function () {
                        let e;
                        try {
                            e = t.storage.getItem("debug");
                        } catch (e) {}
                        return !e && "undefined" != typeof process && "env" in process && (e = process.env.DEBUG), e;
                    }),
                    (t.useColors = function () {
                        return (
                            !(
                                "undefined" == typeof window ||
                                !window.process ||
                                ("renderer" !== window.process.type && !window.process.__nwjs)
                            ) ||
                            (("undefined" == typeof navigator ||
                                !navigator.userAgent ||
                                !navigator.userAgent.toLowerCase().match(/(edge|trident)\/(\d+)/)) &&
                                (("undefined" != typeof document &&
                                    document.documentElement &&
                                    document.documentElement.style &&
                                    document.documentElement.style.WebkitAppearance) ||
                                    ("undefined" != typeof window &&
                                        window.console &&
                                        (window.console.firebug ||
                                            (window.console.exception && window.console.table))) ||
                                    ("undefined" != typeof navigator &&
                                        navigator.userAgent &&
                                        navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) &&
                                        parseInt(RegExp.$1, 10) >= 31) ||
                                    ("undefined" != typeof navigator &&
                                        navigator.userAgent &&
                                        navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/))))
                        );
                    }),
                    (t.storage = (function () {
                        try {
                            return localStorage;
                        } catch (e) {}
                    })()),
                    (t.destroy = (() => {
                        let e = !1;
                        return () => {
                            e ||
                                ((e = !0),
                                console.warn(
                                    "Instance method `debug.destroy()` is deprecated and no longer does anything. It will be removed in the next major version of `debug`."
                                ));
                        };
                    })()),
                    (t.colors = [
                        "#0000CC",
                        "#0000FF",
                        "#0033CC",
                        "#0033FF",
                        "#0066CC",
                        "#0066FF",
                        "#0099CC",
                        "#0099FF",
                        "#00CC00",
                        "#00CC33",
                        "#00CC66",
                        "#00CC99",
                        "#00CCCC",
                        "#00CCFF",
                        "#3300CC",
                        "#3300FF",
                        "#3333CC",
                        "#3333FF",
                        "#3366CC",
                        "#3366FF",
                        "#3399CC",
                        "#3399FF",
                        "#33CC00",
                        "#33CC33",
                        "#33CC66",
                        "#33CC99",
                        "#33CCCC",
                        "#33CCFF",
                        "#6600CC",
                        "#6600FF",
                        "#6633CC",
                        "#6633FF",
                        "#66CC00",
                        "#66CC33",
                        "#9900CC",
                        "#9900FF",
                        "#9933CC",
                        "#9933FF",
                        "#99CC00",
                        "#99CC33",
                        "#CC0000",
                        "#CC0033",
                        "#CC0066",
                        "#CC0099",
                        "#CC00CC",
                        "#CC00FF",
                        "#CC3300",
                        "#CC3333",
                        "#CC3366",
                        "#CC3399",
                        "#CC33CC",
                        "#CC33FF",
                        "#CC6600",
                        "#CC6633",
                        "#CC9900",
                        "#CC9933",
                        "#CCCC00",
                        "#CCCC33",
                        "#FF0000",
                        "#FF0033",
                        "#FF0066",
                        "#FF0099",
                        "#FF00CC",
                        "#FF00FF",
                        "#FF3300",
                        "#FF3333",
                        "#FF3366",
                        "#FF3399",
                        "#FF33CC",
                        "#FF33FF",
                        "#FF6600",
                        "#FF6633",
                        "#FF9900",
                        "#FF9933",
                        "#FFCC00",
                        "#FFCC33",
                    ]),
                    (t.log = console.debug || console.log || (() => {})),
                    (e.exports = n(447)(t));
                const { formatters: i } = e.exports;
                i.j = function (e) {
                    try {
                        return JSON.stringify(e);
                    } catch (e) {
                        return "[UnexpectedJSONParseError]: " + e.message;
                    }
                };
            },
            447: function (e, t, n) {
                e.exports = function (e) {
                    function t(e) {
                        let n,
                            s,
                            r,
                            a = null;
                        function o(...e) {
                            if (!o.enabled) return;
                            const i = o,
                                s = Number(new Date()),
                                r = s - (n || s);
                            (i.diff = r),
                                (i.prev = n),
                                (i.curr = s),
                                (n = s),
                                (e[0] = t.coerce(e[0])),
                                "string" != typeof e[0] && e.unshift("%O");
                            let a = 0;
                            (e[0] = e[0].replace(/%([a-zA-Z%])/g, (n, s) => {
                                if ("%%" === n) return "%";
                                a++;
                                const r = t.formatters[s];
                                if ("function" == typeof r) {
                                    const t = e[a];
                                    (n = r.call(i, t)), e.splice(a, 1), a--;
                                }
                                return n;
                            })),
                                t.formatArgs.call(i, e),
                                (i.log || t.log).apply(i, e);
                        }
                        return (
                            (o.namespace = e),
                            (o.useColors = t.useColors()),
                            (o.color = t.selectColor(e)),
                            (o.extend = i),
                            (o.destroy = t.destroy),
                            Object.defineProperty(o, "enabled", {
                                enumerable: !0,
                                configurable: !1,
                                get: () =>
                                    null !== a
                                        ? a
                                        : (s !== t.namespaces && ((s = t.namespaces), (r = t.enabled(e))), r),
                                set: (e) => {
                                    a = e;
                                },
                            }),
                            "function" == typeof t.init && t.init(o),
                            o
                        );
                    }
                    function i(e, n) {
                        const i = t(this.namespace + (void 0 === n ? ":" : n) + e);
                        return (i.log = this.log), i;
                    }
                    function s(e) {
                        return e
                            .toString()
                            .substring(2, e.toString().length - 2)
                            .replace(/\.\*\?$/, "*");
                    }
                    return (
                        (t.debug = t),
                        (t.default = t),
                        (t.coerce = function (e) {
                            return e instanceof Error ? e.stack || e.message : e;
                        }),
                        (t.disable = function () {
                            const e = [...t.names.map(s), ...t.skips.map(s).map((e) => "-" + e)].join(",");
                            return t.enable(""), e;
                        }),
                        (t.enable = function (e) {
                            let n;
                            t.save(e), (t.namespaces = e), (t.names = []), (t.skips = []);
                            const i = ("string" == typeof e ? e : "").split(/[\s,]+/),
                                s = i.length;
                            for (n = 0; n < s; n++)
                                i[n] &&
                                    ("-" === (e = i[n].replace(/\*/g, ".*?"))[0]
                                        ? t.skips.push(new RegExp("^" + e.slice(1) + "$"))
                                        : t.names.push(new RegExp("^" + e + "$")));
                        }),
                        (t.enabled = function (e) {
                            if ("*" === e[e.length - 1]) return !0;
                            let n, i;
                            for (n = 0, i = t.skips.length; n < i; n++) if (t.skips[n].test(e)) return !1;
                            for (n = 0, i = t.names.length; n < i; n++) if (t.names[n].test(e)) return !0;
                            return !1;
                        }),
                        (t.humanize = n(824)),
                        (t.destroy = function () {
                            console.warn(
                                "Instance method `debug.destroy()` is deprecated and no longer does anything. It will be removed in the next major version of `debug`."
                            );
                        }),
                        Object.keys(e).forEach((n) => {
                            t[n] = e[n];
                        }),
                        (t.names = []),
                        (t.skips = []),
                        (t.formatters = {}),
                        (t.selectColor = function (e) {
                            let n = 0;
                            for (let t = 0; t < e.length; t++) (n = (n << 5) - n + e.charCodeAt(t)), (n |= 0);
                            return t.colors[Math.abs(n) % t.colors.length];
                        }),
                        t.enable(t.load()),
                        t
                    );
                };
            },
            158: function (e, t, n) {
                var i, s;
                "undefined" != typeof window && window,
                    void 0 ===
                        (s =
                            "function" ==
                            typeof (i = function () {
                                "use strict";
                                function e() {}
                                var t = e.prototype;
                                return (
                                    (t.on = function (e, t) {
                                        if (e && t) {
                                            var n = (this._events = this._events || {}),
                                                i = (n[e] = n[e] || []);
                                            return -1 == i.indexOf(t) && i.push(t), this;
                                        }
                                    }),
                                    (t.once = function (e, t) {
                                        if (e && t) {
                                            this.on(e, t);
                                            var n = (this._onceEvents = this._onceEvents || {});
                                            return ((n[e] = n[e] || {})[t] = !0), this;
                                        }
                                    }),
                                    (t.off = function (e, t) {
                                        var n = this._events && this._events[e];
                                        if (n && n.length) {
                                            var i = n.indexOf(t);
                                            return -1 != i && n.splice(i, 1), this;
                                        }
                                    }),
                                    (t.emitEvent = function (e, t) {
                                        var n = this._events && this._events[e];
                                        if (n && n.length) {
                                            (n = n.slice(0)), (t = t || []);
                                            for (
                                                var i = this._onceEvents && this._onceEvents[e], s = 0;
                                                s < n.length;
                                                s++
                                            ) {
                                                var r = n[s];
                                                i && i[r] && (this.off(e, r), delete i[r]), r.apply(this, t);
                                            }
                                            return this;
                                        }
                                    }),
                                    (t.allOff = function () {
                                        delete this._events, delete this._onceEvents;
                                    }),
                                    e
                                );
                            })
                                ? i.call(t, n, t, e)
                                : i) || (e.exports = s);
            },
            564: function (e, t, n) {
                var i, s;
                !(function (r, a) {
                    "use strict";
                    (i = [n(158)]),
                        (s = function (e) {
                            return (function (e, t) {
                                var n = e.jQuery,
                                    i = e.console;
                                function s(e, t) {
                                    for (var n in t) e[n] = t[n];
                                    return e;
                                }
                                var r = Array.prototype.slice;
                                function a(e, t, o) {
                                    if (!(this instanceof a)) return new a(e, t, o);
                                    var l,
                                        c = e;
                                    "string" == typeof e && (c = document.querySelectorAll(e)),
                                        c
                                            ? ((this.elements =
                                                  ((l = c),
                                                  Array.isArray(l)
                                                      ? l
                                                      : "object" == typeof l && "number" == typeof l.length
                                                        ? r.call(l)
                                                        : [l])),
                                              (this.options = s({}, this.options)),
                                              "function" == typeof t ? (o = t) : s(this.options, t),
                                              o && this.on("always", o),
                                              this.getImages(),
                                              n && (this.jqDeferred = new n.Deferred()),
                                              setTimeout(this.check.bind(this)))
                                            : i.error("Bad element for imagesLoaded " + (c || e));
                                }
                                (a.prototype = Object.create(t.prototype)),
                                    (a.prototype.options = {}),
                                    (a.prototype.getImages = function () {
                                        (this.images = []), this.elements.forEach(this.addElementImages, this);
                                    }),
                                    (a.prototype.addElementImages = function (e) {
                                        "IMG" == e.nodeName && this.addImage(e),
                                            !0 === this.options.background && this.addElementBackgroundImages(e);
                                        var t = e.nodeType;
                                        if (t && o[t]) {
                                            for (var n = e.querySelectorAll("img"), i = 0; i < n.length; i++) {
                                                var s = n[i];
                                                this.addImage(s);
                                            }
                                            if ("string" == typeof this.options.background) {
                                                var r = e.querySelectorAll(this.options.background);
                                                for (i = 0; i < r.length; i++) {
                                                    var a = r[i];
                                                    this.addElementBackgroundImages(a);
                                                }
                                            }
                                        }
                                    });
                                var o = { 1: !0, 9: !0, 11: !0 };
                                function l(e) {
                                    this.img = e;
                                }
                                function c(e, t) {
                                    (this.url = e), (this.element = t), (this.img = new Image());
                                }
                                return (
                                    (a.prototype.addElementBackgroundImages = function (e) {
                                        var t = getComputedStyle(e);
                                        if (t)
                                            for (
                                                var n = /url\((['"])?(.*?)\1\)/gi, i = n.exec(t.backgroundImage);
                                                null !== i;

                                            ) {
                                                var s = i && i[2];
                                                s && this.addBackground(s, e), (i = n.exec(t.backgroundImage));
                                            }
                                    }),
                                    (a.prototype.addImage = function (e) {
                                        var t = new l(e);
                                        this.images.push(t);
                                    }),
                                    (a.prototype.addBackground = function (e, t) {
                                        var n = new c(e, t);
                                        this.images.push(n);
                                    }),
                                    (a.prototype.check = function () {
                                        var e = this;
                                        function t(t, n, i) {
                                            setTimeout(function () {
                                                e.progress(t, n, i);
                                            });
                                        }
                                        (this.progressedCount = 0),
                                            (this.hasAnyBroken = !1),
                                            this.images.length
                                                ? this.images.forEach(function (e) {
                                                      e.once("progress", t), e.check();
                                                  })
                                                : this.complete();
                                    }),
                                    (a.prototype.progress = function (e, t, n) {
                                        this.progressedCount++,
                                            (this.hasAnyBroken = this.hasAnyBroken || !e.isLoaded),
                                            this.emitEvent("progress", [this, e, t]),
                                            this.jqDeferred &&
                                                this.jqDeferred.notify &&
                                                this.jqDeferred.notify(this, e),
                                            this.progressedCount == this.images.length && this.complete(),
                                            this.options.debug && i && i.log("progress: " + n, e, t);
                                    }),
                                    (a.prototype.complete = function () {
                                        var e = this.hasAnyBroken ? "fail" : "done";
                                        if (
                                            ((this.isComplete = !0),
                                            this.emitEvent(e, [this]),
                                            this.emitEvent("always", [this]),
                                            this.jqDeferred)
                                        ) {
                                            var t = this.hasAnyBroken ? "reject" : "resolve";
                                            this.jqDeferred[t](this);
                                        }
                                    }),
                                    (l.prototype = Object.create(t.prototype)),
                                    (l.prototype.check = function () {
                                        this.getIsImageComplete()
                                            ? this.confirm(0 !== this.img.naturalWidth, "naturalWidth")
                                            : ((this.proxyImage = new Image()),
                                              this.proxyImage.addEventListener("load", this),
                                              this.proxyImage.addEventListener("error", this),
                                              this.img.addEventListener("load", this),
                                              this.img.addEventListener("error", this),
                                              (this.proxyImage.src = this.img.src));
                                    }),
                                    (l.prototype.getIsImageComplete = function () {
                                        return this.img.complete && this.img.naturalWidth;
                                    }),
                                    (l.prototype.confirm = function (e, t) {
                                        (this.isLoaded = e), this.emitEvent("progress", [this, this.img, t]);
                                    }),
                                    (l.prototype.handleEvent = function (e) {
                                        var t = "on" + e.type;
                                        this[t] && this[t](e);
                                    }),
                                    (l.prototype.onload = function () {
                                        this.confirm(!0, "onload"), this.unbindEvents();
                                    }),
                                    (l.prototype.onerror = function () {
                                        this.confirm(!1, "onerror"), this.unbindEvents();
                                    }),
                                    (l.prototype.unbindEvents = function () {
                                        this.proxyImage.removeEventListener("load", this),
                                            this.proxyImage.removeEventListener("error", this),
                                            this.img.removeEventListener("load", this),
                                            this.img.removeEventListener("error", this);
                                    }),
                                    (c.prototype = Object.create(l.prototype)),
                                    (c.prototype.check = function () {
                                        this.img.addEventListener("load", this),
                                            this.img.addEventListener("error", this),
                                            (this.img.src = this.url),
                                            this.getIsImageComplete() &&
                                                (this.confirm(0 !== this.img.naturalWidth, "naturalWidth"),
                                                this.unbindEvents());
                                    }),
                                    (c.prototype.unbindEvents = function () {
                                        this.img.removeEventListener("load", this),
                                            this.img.removeEventListener("error", this);
                                    }),
                                    (c.prototype.confirm = function (e, t) {
                                        (this.isLoaded = e), this.emitEvent("progress", [this, this.element, t]);
                                    }),
                                    (a.makeJQueryPlugin = function (t) {
                                        (t = t || e.jQuery) &&
                                            ((n = t).fn.imagesLoaded = function (e, t) {
                                                return new a(this, e, t).jqDeferred.promise(n(this));
                                            });
                                    }),
                                    a.makeJQueryPlugin(),
                                    a
                                );
                            })(r, e);
                        }.apply(t, i)),
                        void 0 === s || (e.exports = s);
                })("undefined" != typeof window ? window : this);
            },
            197: function (e) {
                var t;
                (t = function (e) {
                    "use strict";
                    return (function () {
                        for (
                            var t = [
                                    ["Afghanistan (‫افغانستان‬‎)", "af", "93"],
                                    ["Albania (Shqipëri)", "al", "355"],
                                    ["Algeria (‫الجزائر‬‎)", "dz", "213"],
                                    ["American Samoa", "as", "1", 5, ["684"]],
                                    ["Andorra", "ad", "376"],
                                    ["Angola", "ao", "244"],
                                    ["Anguilla", "ai", "1", 6, ["264"]],
                                    ["Antigua and Barbuda", "ag", "1", 7, ["268"]],
                                    ["Argentina", "ar", "54"],
                                    ["Armenia (Հայաստան)", "am", "374"],
                                    ["Aruba", "aw", "297"],
                                    ["Ascension Island", "ac", "247"],
                                    ["Australia", "au", "61", 0],
                                    ["Austria (Österreich)", "at", "43"],
                                    ["Azerbaijan (Azərbaycan)", "az", "994"],
                                    ["Bahamas", "bs", "1", 8, ["242"]],
                                    ["Bahrain (‫البحرين‬‎)", "bh", "973"],
                                    ["Bangladesh (বাংলাদেশ)", "bd", "880"],
                                    ["Barbados", "bb", "1", 9, ["246"]],
                                    ["Belarus (Беларусь)", "by", "375"],
                                    ["Belgium (België)", "be", "32"],
                                    ["Belize", "bz", "501"],
                                    ["Benin (Bénin)", "bj", "229"],
                                    ["Bermuda", "bm", "1", 10, ["441"]],
                                    ["Bhutan (འབྲུག)", "bt", "975"],
                                    ["Bolivia", "bo", "591"],
                                    ["Bosnia and Herzegovina (Босна и Херцеговина)", "ba", "387"],
                                    ["Botswana", "bw", "267"],
                                    ["Brazil (Brasil)", "br", "55"],
                                    ["British Indian Ocean Territory", "io", "246"],
                                    ["British Virgin Islands", "vg", "1", 11, ["284"]],
                                    ["Brunei", "bn", "673"],
                                    ["Bulgaria (България)", "bg", "359"],
                                    ["Burkina Faso", "bf", "226"],
                                    ["Burundi (Uburundi)", "bi", "257"],
                                    ["Cambodia (កម្ពុជា)", "kh", "855"],
                                    ["Cameroon (Cameroun)", "cm", "237"],
                                    [
                                        "Canada",
                                        "ca",
                                        "1",
                                        1,
                                        [
                                            "204",
                                            "226",
                                            "236",
                                            "249",
                                            "250",
                                            "263",
                                            "289",
                                            "306",
                                            "343",
                                            "354",
                                            "365",
                                            "367",
                                            "368",
                                            "382",
                                            "387",
                                            "403",
                                            "416",
                                            "418",
                                            "428",
                                            "431",
                                            "437",
                                            "438",
                                            "450",
                                            "584",
                                            "468",
                                            "474",
                                            "506",
                                            "514",
                                            "519",
                                            "548",
                                            "579",
                                            "581",
                                            "584",
                                            "587",
                                            "604",
                                            "613",
                                            "639",
                                            "647",
                                            "672",
                                            "683",
                                            "705",
                                            "709",
                                            "742",
                                            "753",
                                            "778",
                                            "780",
                                            "782",
                                            "807",
                                            "819",
                                            "825",
                                            "867",
                                            "873",
                                            "902",
                                            "905",
                                        ],
                                    ],
                                    ["Cape Verde (Kabu Verdi)", "cv", "238"],
                                    ["Caribbean Netherlands", "bq", "599", 1, ["3", "4", "7"]],
                                    ["Cayman Islands", "ky", "1", 12, ["345"]],
                                    ["Central African Republic (République centrafricaine)", "cf", "236"],
                                    ["Chad (Tchad)", "td", "235"],
                                    ["Chile", "cl", "56"],
                                    ["China (中国)", "cn", "86"],
                                    ["Christmas Island", "cx", "61", 2, ["89164"]],
                                    ["Cocos (Keeling) Islands", "cc", "61", 1, ["89162"]],
                                    ["Colombia", "co", "57"],
                                    ["Comoros (‫جزر القمر‬‎)", "km", "269"],
                                    ["Congo (DRC) (Jamhuri ya Kidemokrasia ya Kongo)", "cd", "243"],
                                    ["Congo (Republic) (Congo-Brazzaville)", "cg", "242"],
                                    ["Cook Islands", "ck", "682"],
                                    ["Costa Rica", "cr", "506"],
                                    ["Côte d’Ivoire", "ci", "225"],
                                    ["Croatia (Hrvatska)", "hr", "385"],
                                    ["Cuba", "cu", "53"],
                                    ["Curaçao", "cw", "599", 0],
                                    ["Cyprus (Κύπρος)", "cy", "357"],
                                    ["Czech Republic (Česká republika)", "cz", "420"],
                                    ["Denmark (Danmark)", "dk", "45"],
                                    ["Djibouti", "dj", "253"],
                                    ["Dominica", "dm", "1", 13, ["767"]],
                                    ["Dominican Republic (República Dominicana)", "do", "1", 2, ["809", "829", "849"]],
                                    ["Ecuador", "ec", "593"],
                                    ["Egypt (‫مصر‬‎)", "eg", "20"],
                                    ["El Salvador", "sv", "503"],
                                    ["Equatorial Guinea (Guinea Ecuatorial)", "gq", "240"],
                                    ["Eritrea", "er", "291"],
                                    ["Estonia (Eesti)", "ee", "372"],
                                    ["Eswatini", "sz", "268"],
                                    ["Ethiopia", "et", "251"],
                                    ["Falkland Islands (Islas Malvinas)", "fk", "500"],
                                    ["Faroe Islands (Føroyar)", "fo", "298"],
                                    ["Fiji", "fj", "679"],
                                    ["Finland (Suomi)", "fi", "358", 0],
                                    ["France", "fr", "33"],
                                    ["French Guiana (Guyane française)", "gf", "594"],
                                    ["French Polynesia (Polynésie française)", "pf", "689"],
                                    ["Gabon", "ga", "241"],
                                    ["Gambia", "gm", "220"],
                                    ["Georgia (საქართველო)", "ge", "995"],
                                    ["Germany (Deutschland)", "de", "49"],
                                    ["Ghana (Gaana)", "gh", "233"],
                                    ["Gibraltar", "gi", "350"],
                                    ["Greece (Ελλάδα)", "gr", "30"],
                                    ["Greenland (Kalaallit Nunaat)", "gl", "299"],
                                    ["Grenada", "gd", "1", 14, ["473"]],
                                    ["Guadeloupe", "gp", "590", 0],
                                    ["Guam", "gu", "1", 15, ["671"]],
                                    ["Guatemala", "gt", "502"],
                                    ["Guernsey", "gg", "44", 1, ["1481", "7781", "7839", "7911"]],
                                    ["Guinea (Guinée)", "gn", "224"],
                                    ["Guinea-Bissau (Guiné Bissau)", "gw", "245"],
                                    ["Guyana", "gy", "592"],
                                    ["Haiti", "ht", "509"],
                                    ["Honduras", "hn", "504"],
                                    ["Hong Kong (香港)", "hk", "852"],
                                    ["Hungary (Magyarország)", "hu", "36"],
                                    ["Iceland (Ísland)", "is", "354"],
                                    ["India (भारत)", "in", "91"],
                                    ["Indonesia", "id", "62"],
                                    ["Iran (‫ایران‬‎)", "ir", "98"],
                                    ["Iraq (‫العراق‬‎)", "iq", "964"],
                                    ["Ireland", "ie", "353"],
                                    ["Isle of Man", "im", "44", 2, ["1624", "74576", "7524", "7924", "7624"]],
                                    ["Israel (‫ישראל‬‎)", "il", "972"],
                                    ["Italy (Italia)", "it", "39", 0],
                                    ["Jamaica", "jm", "1", 4, ["876", "658"]],
                                    ["Japan (日本)", "jp", "81"],
                                    ["Jersey", "je", "44", 3, ["1534", "7509", "7700", "7797", "7829", "7937"]],
                                    ["Jordan (‫الأردن‬‎)", "jo", "962"],
                                    ["Kazakhstan (Казахстан)", "kz", "7", 1, ["33", "7"]],
                                    ["Kenya", "ke", "254"],
                                    ["Kiribati", "ki", "686"],
                                    ["Kosovo", "xk", "383"],
                                    ["Kuwait (‫الكويت‬‎)", "kw", "965"],
                                    ["Kyrgyzstan (Кыргызстан)", "kg", "996"],
                                    ["Laos (ລາວ)", "la", "856"],
                                    ["Latvia (Latvija)", "lv", "371"],
                                    ["Lebanon (‫لبنان‬‎)", "lb", "961"],
                                    ["Lesotho", "ls", "266"],
                                    ["Liberia", "lr", "231"],
                                    ["Libya (‫ليبيا‬‎)", "ly", "218"],
                                    ["Liechtenstein", "li", "423"],
                                    ["Lithuania (Lietuva)", "lt", "370"],
                                    ["Luxembourg", "lu", "352"],
                                    ["Macau (澳門)", "mo", "853"],
                                    ["Madagascar (Madagasikara)", "mg", "261"],
                                    ["Malawi", "mw", "265"],
                                    ["Malaysia", "my", "60"],
                                    ["Maldives", "mv", "960"],
                                    ["Mali", "ml", "223"],
                                    ["Malta", "mt", "356"],
                                    ["Marshall Islands", "mh", "692"],
                                    ["Martinique", "mq", "596"],
                                    ["Mauritania (‫موريتانيا‬‎)", "mr", "222"],
                                    ["Mauritius (Moris)", "mu", "230"],
                                    ["Mayotte", "yt", "262", 1, ["269", "639"]],
                                    ["Mexico (México)", "mx", "52"],
                                    ["Micronesia", "fm", "691"],
                                    ["Moldova (Republica Moldova)", "md", "373"],
                                    ["Monaco", "mc", "377"],
                                    ["Mongolia (Монгол)", "mn", "976"],
                                    ["Montenegro (Crna Gora)", "me", "382"],
                                    ["Montserrat", "ms", "1", 16, ["664"]],
                                    ["Morocco (‫المغرب‬‎)", "ma", "212", 0],
                                    ["Mozambique (Moçambique)", "mz", "258"],
                                    ["Myanmar (Burma) (မြန်မာ)", "mm", "95"],
                                    ["Namibia (Namibië)", "na", "264"],
                                    ["Nauru", "nr", "674"],
                                    ["Nepal (नेपाल)", "np", "977"],
                                    ["Netherlands (Nederland)", "nl", "31"],
                                    ["New Caledonia (Nouvelle-Calédonie)", "nc", "687"],
                                    ["New Zealand", "nz", "64"],
                                    ["Nicaragua", "ni", "505"],
                                    ["Niger (Nijar)", "ne", "227"],
                                    ["Nigeria", "ng", "234"],
                                    ["Niue", "nu", "683"],
                                    ["Norfolk Island", "nf", "672"],
                                    ["North Korea (조선 민주주의 인민 공화국)", "kp", "850"],
                                    ["North Macedonia (Северна Македонија)", "mk", "389"],
                                    ["Northern Mariana Islands", "mp", "1", 17, ["670"]],
                                    ["Norway (Norge)", "no", "47", 0],
                                    ["Oman (‫عُمان‬‎)", "om", "968"],
                                    ["Pakistan (‫پاکستان‬‎)", "pk", "92"],
                                    ["Palau", "pw", "680"],
                                    ["Palestine (‫فلسطين‬‎)", "ps", "970"],
                                    ["Panama (Panamá)", "pa", "507"],
                                    ["Papua New Guinea", "pg", "675"],
                                    ["Paraguay", "py", "595"],
                                    ["Peru (Perú)", "pe", "51"],
                                    ["Philippines", "ph", "63"],
                                    ["Poland (Polska)", "pl", "48"],
                                    ["Portugal", "pt", "351"],
                                    ["Puerto Rico", "pr", "1", 3, ["787", "939"]],
                                    ["Qatar (‫قطر‬‎)", "qa", "974"],
                                    ["Réunion (La Réunion)", "re", "262", 0],
                                    ["Romania (România)", "ro", "40"],
                                    ["Russia (Россия)", "ru", "7", 0],
                                    ["Rwanda", "rw", "250"],
                                    ["Saint Barthélemy", "bl", "590", 1],
                                    ["Saint Helena", "sh", "290"],
                                    ["Saint Kitts and Nevis", "kn", "1", 18, ["869"]],
                                    ["Saint Lucia", "lc", "1", 19, ["758"]],
                                    ["Saint Martin (Saint-Martin (partie française))", "mf", "590", 2],
                                    ["Saint Pierre and Miquelon (Saint-Pierre-et-Miquelon)", "pm", "508"],
                                    ["Saint Vincent and the Grenadines", "vc", "1", 20, ["784"]],
                                    ["Samoa", "ws", "685"],
                                    ["San Marino", "sm", "378"],
                                    ["São Tomé and Príncipe (São Tomé e Príncipe)", "st", "239"],
                                    ["Saudi Arabia (‫المملكة العربية السعودية‬‎)", "sa", "966"],
                                    ["Senegal (Sénégal)", "sn", "221"],
                                    ["Serbia (Србија)", "rs", "381"],
                                    ["Seychelles", "sc", "248"],
                                    ["Sierra Leone", "sl", "232"],
                                    ["Singapore", "sg", "65"],
                                    ["Sint Maarten", "sx", "1", 21, ["721"]],
                                    ["Slovakia (Slovensko)", "sk", "421"],
                                    ["Slovenia (Slovenija)", "si", "386"],
                                    ["Solomon Islands", "sb", "677"],
                                    ["Somalia (Soomaaliya)", "so", "252"],
                                    ["South Africa", "za", "27"],
                                    ["South Korea (대한민국)", "kr", "82"],
                                    ["South Sudan (‫جنوب السودان‬‎)", "ss", "211"],
                                    ["Spain (España)", "es", "34"],
                                    ["Sri Lanka (ශ්‍රී ලංකාව)", "lk", "94"],
                                    ["Sudan (‫السودان‬‎)", "sd", "249"],
                                    ["Suriname", "sr", "597"],
                                    ["Svalbard and Jan Mayen", "sj", "47", 1, ["79"]],
                                    ["Sweden (Sverige)", "se", "46"],
                                    ["Switzerland (Schweiz)", "ch", "41"],
                                    ["Syria (‫سوريا‬‎)", "sy", "963"],
                                    ["Taiwan (台灣)", "tw", "886"],
                                    ["Tajikistan", "tj", "992"],
                                    ["Tanzania", "tz", "255"],
                                    ["Thailand (ไทย)", "th", "66"],
                                    ["Timor-Leste", "tl", "670"],
                                    ["Togo", "tg", "228"],
                                    ["Tokelau", "tk", "690"],
                                    ["Tonga", "to", "676"],
                                    ["Trinidad and Tobago", "tt", "1", 22, ["868"]],
                                    ["Tunisia (‫تونس‬‎)", "tn", "216"],
                                    ["Turkey (Türkiye)", "tr", "90"],
                                    ["Turkmenistan", "tm", "993"],
                                    ["Turks and Caicos Islands", "tc", "1", 23, ["649"]],
                                    ["Tuvalu", "tv", "688"],
                                    ["U.S. Virgin Islands", "vi", "1", 24, ["340"]],
                                    ["Uganda", "ug", "256"],
                                    ["Ukraine (Україна)", "ua", "380"],
                                    ["United Arab Emirates (‫الإمارات العربية المتحدة‬‎)", "ae", "971"],
                                    ["United Kingdom", "gb", "44", 0],
                                    ["United States", "us", "1", 0],
                                    ["Uruguay", "uy", "598"],
                                    ["Uzbekistan (Oʻzbekiston)", "uz", "998"],
                                    ["Vanuatu", "vu", "678"],
                                    ["Vatican City (Città del Vaticano)", "va", "39", 1, ["06698"]],
                                    ["Venezuela", "ve", "58"],
                                    ["Vietnam (Việt Nam)", "vn", "84"],
                                    ["Wallis and Futuna (Wallis-et-Futuna)", "wf", "681"],
                                    ["Western Sahara (‫الصحراء الغربية‬‎)", "eh", "212", 1, ["5288", "5289"]],
                                    ["Yemen (‫اليمن‬‎)", "ye", "967"],
                                    ["Zambia", "zm", "260"],
                                    ["Zimbabwe", "zw", "263"],
                                    ["Åland Islands", "ax", "358", 1, ["18"]],
                                ],
                                n = 0;
                            n < t.length;
                            n++
                        ) {
                            var i = t[n];
                            t[n] = {
                                name: i[0],
                                iso2: i[1],
                                dialCode: i[2],
                                priority: i[3] || 0,
                                areaCodes: i[4] || null,
                            };
                        }
                        function s(e, t, n) {
                            return (
                                (t = a(t)) in e
                                    ? Object.defineProperty(e, t, {
                                          value: n,
                                          enumerable: !0,
                                          configurable: !0,
                                          writable: !0,
                                      })
                                    : (e[t] = n),
                                e
                            );
                        }
                        function r(e, t) {
                            for (var n = 0; n < t.length; n++) {
                                var i = t[n];
                                (i.enumerable = i.enumerable || !1),
                                    (i.configurable = !0),
                                    "value" in i && (i.writable = !0),
                                    Object.defineProperty(e, a(i.key), i);
                            }
                        }
                        function a(t) {
                            var n = (function (t, n) {
                                if ("object" != typeof t || null === t) return t;
                                var i = t[Symbol.toPrimitive];
                                if (i !== e) {
                                    var s = i.call(t, "string");
                                    if ("object" != typeof s) return s;
                                    throw new TypeError("@@toPrimitive must return a primitive value.");
                                }
                                return String(t);
                            })(t);
                            return "symbol" == typeof n ? n : String(n);
                        }
                        var o = {
                            getInstance: function (e) {
                                var t = e.getAttribute("data-intl-tel-input-id");
                                return window.intlTelInputGlobals.instances[t];
                            },
                            instances: {},
                            documentReady: function () {
                                return "complete" === document.readyState;
                            },
                        };
                        "object" == typeof window && (window.intlTelInputGlobals = o);
                        var l = 0,
                            c = {
                                allowDropdown: !0,
                                autoInsertDialCode: !1,
                                autoPlaceholder: "polite",
                                customContainer: "",
                                customPlaceholder: null,
                                dropdownContainer: null,
                                excludeCountries: [],
                                formatOnDisplay: !0,
                                geoIpLookup: null,
                                hiddenInput: "",
                                initialCountry: "",
                                localizedCountries: null,
                                nationalMode: !0,
                                onlyCountries: [],
                                placeholderNumberType: "MOBILE",
                                preferredCountries: ["us", "gb"],
                                separateDialCode: !1,
                                showFlags: !0,
                                useFullscreenPopup:
                                    /Android.+Mobile|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
                                        navigator.userAgent
                                    ) || window.innerWidth <= 500,
                                utilsScript: "",
                            },
                            d = [
                                "800",
                                "822",
                                "833",
                                "844",
                                "855",
                                "866",
                                "877",
                                "880",
                                "881",
                                "882",
                                "883",
                                "884",
                                "885",
                                "886",
                                "887",
                                "888",
                                "889",
                            ],
                            u = function (e, t) {
                                for (var n = Object.keys(e), i = 0; i < n.length; i++) t(n[i], e[n[i]]);
                            },
                            p = function (e) {
                                u(window.intlTelInputGlobals.instances, function (t) {
                                    window.intlTelInputGlobals.instances[t][e]();
                                });
                            },
                            h = (function () {
                                function n(e, t) {
                                    var i = this;
                                    !(function (e, t) {
                                        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                                    })(this, n),
                                        (this.id = l++),
                                        (this.telInput = e),
                                        (this.activeItem = null),
                                        (this.highlightedItem = null);
                                    var s = t || {};
                                    (this.options = {}),
                                        u(c, function (e, t) {
                                            i.options[e] = s.hasOwnProperty(e) ? s[e] : t;
                                        }),
                                        (this.hadInitialPlaceholder = Boolean(e.getAttribute("placeholder")));
                                }
                                var i, a;
                                return (
                                    (i = n),
                                    (a = [
                                        {
                                            key: "_init",
                                            value: function () {
                                                var e = this;
                                                this.options.nationalMode && (this.options.autoInsertDialCode = !1),
                                                    this.options.separateDialCode &&
                                                        (this.options.autoInsertDialCode = !1);
                                                var t = this.options.allowDropdown && !this.options.separateDialCode;
                                                if (
                                                    (!this.options.showFlags && t && (this.options.showFlags = !0),
                                                    this.options.useFullscreenPopup &&
                                                        (document.body.classList.add("iti-fullscreen-popup"),
                                                        this.options.dropdownContainer ||
                                                            (this.options.dropdownContainer = document.body)),
                                                    (this.isRTL = !!this.telInput.closest("[dir=rtl]")),
                                                    "undefined" != typeof Promise)
                                                ) {
                                                    var n = new Promise(function (t, n) {
                                                            (e.resolveAutoCountryPromise = t),
                                                                (e.rejectAutoCountryPromise = n);
                                                        }),
                                                        i = new Promise(function (t, n) {
                                                            (e.resolveUtilsScriptPromise = t),
                                                                (e.rejectUtilsScriptPromise = n);
                                                        });
                                                    this.promise = Promise.all([n, i]);
                                                } else
                                                    (this.resolveAutoCountryPromise = this.rejectAutoCountryPromise =
                                                        function () {}),
                                                        (this.resolveUtilsScriptPromise =
                                                            this.rejectUtilsScriptPromise =
                                                                function () {});
                                                (this.selectedCountryData = {}),
                                                    this._processCountryData(),
                                                    this._generateMarkup(),
                                                    this._setInitialState(),
                                                    this._initListeners(),
                                                    this._initRequests();
                                            },
                                        },
                                        {
                                            key: "_processCountryData",
                                            value: function () {
                                                this._processAllCountries(),
                                                    this._processCountryCodes(),
                                                    this._processPreferredCountries(),
                                                    this.options.localizedCountries &&
                                                        this._translateCountriesByLocale(),
                                                    (this.options.onlyCountries.length ||
                                                        this.options.localizedCountries) &&
                                                        this.countries.sort(this._countryNameSort);
                                            },
                                        },
                                        {
                                            key: "_addCountryCode",
                                            value: function (t, n, i) {
                                                n.length > this.countryCodeMaxLen &&
                                                    (this.countryCodeMaxLen = n.length),
                                                    this.countryCodes.hasOwnProperty(n) || (this.countryCodes[n] = []);
                                                for (var s = 0; s < this.countryCodes[n].length; s++)
                                                    if (this.countryCodes[n][s] === t) return;
                                                var r = i !== e ? i : this.countryCodes[n].length;
                                                this.countryCodes[n][r] = t;
                                            },
                                        },
                                        {
                                            key: "_processAllCountries",
                                            value: function () {
                                                if (this.options.onlyCountries.length) {
                                                    var e = this.options.onlyCountries.map(function (e) {
                                                        return e.toLowerCase();
                                                    });
                                                    this.countries = t.filter(function (t) {
                                                        return e.indexOf(t.iso2) > -1;
                                                    });
                                                } else if (this.options.excludeCountries.length) {
                                                    var n = this.options.excludeCountries.map(function (e) {
                                                        return e.toLowerCase();
                                                    });
                                                    this.countries = t.filter(function (e) {
                                                        return -1 === n.indexOf(e.iso2);
                                                    });
                                                } else this.countries = t;
                                            },
                                        },
                                        {
                                            key: "_translateCountriesByLocale",
                                            value: function () {
                                                for (var e = 0; e < this.countries.length; e++) {
                                                    var t = this.countries[e].iso2.toLowerCase();
                                                    this.options.localizedCountries.hasOwnProperty(t) &&
                                                        (this.countries[e].name = this.options.localizedCountries[t]);
                                                }
                                            },
                                        },
                                        {
                                            key: "_countryNameSort",
                                            value: function (e, t) {
                                                return e.name < t.name ? -1 : e.name > t.name ? 1 : 0;
                                            },
                                        },
                                        {
                                            key: "_processCountryCodes",
                                            value: function () {
                                                (this.countryCodeMaxLen = 0),
                                                    (this.dialCodes = {}),
                                                    (this.countryCodes = {});
                                                for (var e = 0; e < this.countries.length; e++) {
                                                    var t = this.countries[e];
                                                    this.dialCodes[t.dialCode] || (this.dialCodes[t.dialCode] = !0),
                                                        this._addCountryCode(t.iso2, t.dialCode, t.priority);
                                                }
                                                for (var n = 0; n < this.countries.length; n++) {
                                                    var i = this.countries[n];
                                                    if (i.areaCodes)
                                                        for (
                                                            var s = this.countryCodes[i.dialCode][0], r = 0;
                                                            r < i.areaCodes.length;
                                                            r++
                                                        ) {
                                                            for (var a = i.areaCodes[r], o = 1; o < a.length; o++) {
                                                                var l = i.dialCode + a.substr(0, o);
                                                                this._addCountryCode(s, l),
                                                                    this._addCountryCode(i.iso2, l);
                                                            }
                                                            this._addCountryCode(i.iso2, i.dialCode + a);
                                                        }
                                                }
                                            },
                                        },
                                        {
                                            key: "_processPreferredCountries",
                                            value: function () {
                                                this.preferredCountries = [];
                                                for (var e = 0; e < this.options.preferredCountries.length; e++) {
                                                    var t = this.options.preferredCountries[e].toLowerCase(),
                                                        n = this._getCountryData(t, !1, !0);
                                                    n && this.preferredCountries.push(n);
                                                }
                                            },
                                        },
                                        {
                                            key: "_createEl",
                                            value: function (e, t, n) {
                                                var i = document.createElement(e);
                                                return (
                                                    t &&
                                                        u(t, function (e, t) {
                                                            return i.setAttribute(e, t);
                                                        }),
                                                    n && n.appendChild(i),
                                                    i
                                                );
                                            },
                                        },
                                        {
                                            key: "_generateMarkup",
                                            value: function () {
                                                this.telInput.hasAttribute("autocomplete") ||
                                                    (this.telInput.form &&
                                                        this.telInput.form.hasAttribute("autocomplete")) ||
                                                    this.telInput.setAttribute("autocomplete", "off");
                                                var e = this.options,
                                                    t = e.allowDropdown,
                                                    n = e.separateDialCode,
                                                    i = e.showFlags,
                                                    r = e.customContainer,
                                                    a = e.hiddenInput,
                                                    o = e.dropdownContainer,
                                                    l = "iti";
                                                t && (l += " iti--allow-dropdown"),
                                                    n && (l += " iti--separate-dial-code"),
                                                    i && (l += " iti--show-flags"),
                                                    r && (l += " ".concat(r));
                                                var c = this._createEl("div", { class: l });
                                                this.telInput.parentNode.insertBefore(c, this.telInput);
                                                var d = t || i || n;
                                                if (
                                                    (d &&
                                                        (this.flagsContainer = this._createEl(
                                                            "div",
                                                            { class: "iti__flag-container" },
                                                            c
                                                        )),
                                                    c.appendChild(this.telInput),
                                                    d &&
                                                        (this.selectedFlag = this._createEl(
                                                            "div",
                                                            (function (e) {
                                                                for (var t = 1; t < arguments.length; t++) {
                                                                    var n =
                                                                            null != arguments[t]
                                                                                ? Object(arguments[t])
                                                                                : {},
                                                                        i = Object.keys(n);
                                                                    "function" == typeof Object.getOwnPropertySymbols &&
                                                                        i.push.apply(
                                                                            i,
                                                                            Object.getOwnPropertySymbols(n).filter(
                                                                                function (e) {
                                                                                    return Object.getOwnPropertyDescriptor(
                                                                                        n,
                                                                                        e
                                                                                    ).enumerable;
                                                                                }
                                                                            )
                                                                        ),
                                                                        i.forEach(function (t) {
                                                                            s(e, t, n[t]);
                                                                        });
                                                                }
                                                                return e;
                                                            })(
                                                                { class: "iti__selected-flag" },
                                                                t && {
                                                                    role: "combobox",
                                                                    "aria-haspopup": "listbox",
                                                                    "aria-controls": "iti-".concat(
                                                                        this.id,
                                                                        "__country-listbox"
                                                                    ),
                                                                    "aria-expanded": "false",
                                                                    "aria-label": "Telephone country code",
                                                                }
                                                            ),
                                                            this.flagsContainer
                                                        )),
                                                    i &&
                                                        (this.selectedFlagInner = this._createEl(
                                                            "div",
                                                            { class: "iti__flag" },
                                                            this.selectedFlag
                                                        )),
                                                    this.selectedFlag &&
                                                        this.telInput.disabled &&
                                                        this.selectedFlag.setAttribute("aria-disabled", "true"),
                                                    n &&
                                                        (this.selectedDialCode = this._createEl(
                                                            "div",
                                                            { class: "iti__selected-dial-code" },
                                                            this.selectedFlag
                                                        )),
                                                    t &&
                                                        (this.telInput.disabled ||
                                                            this.selectedFlag.setAttribute("tabindex", "0"),
                                                        (this.dropdownArrow = this._createEl(
                                                            "div",
                                                            { class: "iti__arrow" },
                                                            this.selectedFlag
                                                        )),
                                                        (this.countryList = this._createEl("ul", {
                                                            class: "iti__country-list iti__hide",
                                                            id: "iti-".concat(this.id, "__country-listbox"),
                                                            role: "listbox",
                                                            "aria-label": "List of countries",
                                                        })),
                                                        this.preferredCountries.length &&
                                                            (this._appendListItems(
                                                                this.preferredCountries,
                                                                "iti__preferred",
                                                                !0
                                                            ),
                                                            this._createEl(
                                                                "li",
                                                                { class: "iti__divider", "aria-hidden": "true" },
                                                                this.countryList
                                                            )),
                                                        this._appendListItems(this.countries, "iti__standard"),
                                                        o
                                                            ? ((this.dropdown = this._createEl("div", {
                                                                  class: "iti iti--container",
                                                              })),
                                                              this.dropdown.appendChild(this.countryList))
                                                            : this.flagsContainer.appendChild(this.countryList)),
                                                    a)
                                                ) {
                                                    var u = a,
                                                        p = this.telInput.getAttribute("name");
                                                    if (p) {
                                                        var h = p.lastIndexOf("[");
                                                        -1 !== h && (u = "".concat(p.substr(0, h), "[").concat(u, "]"));
                                                    }
                                                    (this.hiddenInput = this._createEl("input", {
                                                        type: "hidden",
                                                        name: u,
                                                    })),
                                                        c.appendChild(this.hiddenInput);
                                                }
                                            },
                                        },
                                        {
                                            key: "_appendListItems",
                                            value: function (e, t, n) {
                                                for (var i = "", s = 0; s < e.length; s++) {
                                                    var r = e[s],
                                                        a = n ? "-preferred" : "";
                                                    (i += "<li class='iti__country "
                                                        .concat(t, "' tabIndex='-1' id='iti-")
                                                        .concat(this.id, "__item-")
                                                        .concat(r.iso2)
                                                        .concat(a, "' role='option' data-dial-code='")
                                                        .concat(r.dialCode, "' data-country-code='")
                                                        .concat(r.iso2, "' aria-selected='false'>")),
                                                        this.options.showFlags &&
                                                            (i +=
                                                                "<div class='iti__flag-box'><div class='iti__flag iti__".concat(
                                                                    r.iso2,
                                                                    "'></div></div>"
                                                                )),
                                                        (i += "<span class='iti__country-name'>".concat(
                                                            r.name,
                                                            "</span>"
                                                        )),
                                                        (i += "<span class='iti__dial-code'>+".concat(
                                                            r.dialCode,
                                                            "</span>"
                                                        )),
                                                        (i += "</li>");
                                                }
                                                this.countryList.insertAdjacentHTML("beforeend", i);
                                            },
                                        },
                                        {
                                            key: "_setInitialState",
                                            value: function () {
                                                var e = this.telInput.getAttribute("value"),
                                                    t = this.telInput.value,
                                                    n = !e || "+" !== e.charAt(0) || (t && "+" === t.charAt(0)) ? t : e,
                                                    i = this._getDialCode(n),
                                                    s = this._isRegionlessNanp(n),
                                                    r = this.options,
                                                    a = r.initialCountry,
                                                    o = r.autoInsertDialCode;
                                                i && !s
                                                    ? this._updateFlagFromNumber(n)
                                                    : "auto" !== a &&
                                                      (a
                                                          ? this._setFlag(a.toLowerCase())
                                                          : i && s
                                                            ? this._setFlag("us")
                                                            : ((this.defaultCountry = this.preferredCountries.length
                                                                  ? this.preferredCountries[0].iso2
                                                                  : this.countries[0].iso2),
                                                              n || this._setFlag(this.defaultCountry)),
                                                      !n &&
                                                          o &&
                                                          (this.telInput.value = "+".concat(
                                                              this.selectedCountryData.dialCode
                                                          ))),
                                                    n && this._updateValFromNumber(n);
                                            },
                                        },
                                        {
                                            key: "_initListeners",
                                            value: function () {
                                                this._initKeyListeners(),
                                                    this.options.autoInsertDialCode && this._initBlurListeners(),
                                                    this.options.allowDropdown && this._initDropdownListeners(),
                                                    this.hiddenInput && this._initHiddenInputListener();
                                            },
                                        },
                                        {
                                            key: "_initHiddenInputListener",
                                            value: function () {
                                                var e = this;
                                                (this._handleHiddenInputSubmit = function () {
                                                    e.hiddenInput.value = e.getNumber();
                                                }),
                                                    this.telInput.form &&
                                                        this.telInput.form.addEventListener(
                                                            "submit",
                                                            this._handleHiddenInputSubmit
                                                        );
                                            },
                                        },
                                        {
                                            key: "_getClosestLabel",
                                            value: function () {
                                                for (var e = this.telInput; e && "LABEL" !== e.tagName; )
                                                    e = e.parentNode;
                                                return e;
                                            },
                                        },
                                        {
                                            key: "_initDropdownListeners",
                                            value: function () {
                                                var e = this;
                                                this._handleLabelClick = function (t) {
                                                    e.countryList.classList.contains("iti__hide")
                                                        ? e.telInput.focus()
                                                        : t.preventDefault();
                                                };
                                                var t = this._getClosestLabel();
                                                t && t.addEventListener("click", this._handleLabelClick),
                                                    (this._handleClickSelectedFlag = function () {
                                                        !e.countryList.classList.contains("iti__hide") ||
                                                            e.telInput.disabled ||
                                                            e.telInput.readOnly ||
                                                            e._showDropdown();
                                                    }),
                                                    this.selectedFlag.addEventListener(
                                                        "click",
                                                        this._handleClickSelectedFlag
                                                    ),
                                                    (this._handleFlagsContainerKeydown = function (t) {
                                                        e.countryList.classList.contains("iti__hide") &&
                                                            -1 !==
                                                                [
                                                                    "ArrowUp",
                                                                    "Up",
                                                                    "ArrowDown",
                                                                    "Down",
                                                                    " ",
                                                                    "Enter",
                                                                ].indexOf(t.key) &&
                                                            (t.preventDefault(),
                                                            t.stopPropagation(),
                                                            e._showDropdown()),
                                                            "Tab" === t.key && e._closeDropdown();
                                                    }),
                                                    this.flagsContainer.addEventListener(
                                                        "keydown",
                                                        this._handleFlagsContainerKeydown
                                                    );
                                            },
                                        },
                                        {
                                            key: "_initRequests",
                                            value: function () {
                                                var e = this;
                                                this.options.utilsScript && !window.intlTelInputUtils
                                                    ? window.intlTelInputGlobals.documentReady()
                                                        ? window.intlTelInputGlobals.loadUtils(this.options.utilsScript)
                                                        : window.addEventListener("load", function () {
                                                              window.intlTelInputGlobals.loadUtils(
                                                                  e.options.utilsScript
                                                              );
                                                          })
                                                    : this.resolveUtilsScriptPromise(),
                                                    "auto" === this.options.initialCountry
                                                        ? this._loadAutoCountry()
                                                        : this.resolveAutoCountryPromise();
                                            },
                                        },
                                        {
                                            key: "_loadAutoCountry",
                                            value: function () {
                                                window.intlTelInputGlobals.autoCountry
                                                    ? this.handleAutoCountry()
                                                    : window.intlTelInputGlobals.startedLoadingAutoCountry ||
                                                      ((window.intlTelInputGlobals.startedLoadingAutoCountry = !0),
                                                      "function" == typeof this.options.geoIpLookup &&
                                                          this.options.geoIpLookup(
                                                              function (e) {
                                                                  (window.intlTelInputGlobals.autoCountry =
                                                                      e.toLowerCase()),
                                                                      setTimeout(function () {
                                                                          return p("handleAutoCountry");
                                                                      });
                                                              },
                                                              function () {
                                                                  return p("rejectAutoCountryPromise");
                                                              }
                                                          ));
                                            },
                                        },
                                        {
                                            key: "_initKeyListeners",
                                            value: function () {
                                                var e = this;
                                                (this._handleKeyupEvent = function () {
                                                    e._updateFlagFromNumber(e.telInput.value) &&
                                                        e._triggerCountryChange();
                                                }),
                                                    this.telInput.addEventListener("keyup", this._handleKeyupEvent),
                                                    (this._handleClipboardEvent = function () {
                                                        setTimeout(e._handleKeyupEvent);
                                                    }),
                                                    this.telInput.addEventListener("cut", this._handleClipboardEvent),
                                                    this.telInput.addEventListener("paste", this._handleClipboardEvent);
                                            },
                                        },
                                        {
                                            key: "_cap",
                                            value: function (e) {
                                                var t = this.telInput.getAttribute("maxlength");
                                                return t && e.length > t ? e.substr(0, t) : e;
                                            },
                                        },
                                        {
                                            key: "_initBlurListeners",
                                            value: function () {
                                                var e = this;
                                                (this._handleSubmitOrBlurEvent = function () {
                                                    e._removeEmptyDialCode();
                                                }),
                                                    this.telInput.form &&
                                                        this.telInput.form.addEventListener(
                                                            "submit",
                                                            this._handleSubmitOrBlurEvent
                                                        ),
                                                    this.telInput.addEventListener(
                                                        "blur",
                                                        this._handleSubmitOrBlurEvent
                                                    );
                                            },
                                        },
                                        {
                                            key: "_removeEmptyDialCode",
                                            value: function () {
                                                if ("+" === this.telInput.value.charAt(0)) {
                                                    var e = this._getNumeric(this.telInput.value);
                                                    (e && this.selectedCountryData.dialCode !== e) ||
                                                        (this.telInput.value = "");
                                                }
                                            },
                                        },
                                        {
                                            key: "_getNumeric",
                                            value: function (e) {
                                                return e.replace(/\D/g, "");
                                            },
                                        },
                                        {
                                            key: "_trigger",
                                            value: function (e) {
                                                var t = document.createEvent("Event");
                                                t.initEvent(e, !0, !0), this.telInput.dispatchEvent(t);
                                            },
                                        },
                                        {
                                            key: "_showDropdown",
                                            value: function () {
                                                this.countryList.classList.remove("iti__hide"),
                                                    this.selectedFlag.setAttribute("aria-expanded", "true"),
                                                    this._setDropdownPosition(),
                                                    this.activeItem &&
                                                        (this._highlightListItem(this.activeItem, !1),
                                                        this._scrollTo(this.activeItem, !0)),
                                                    this._bindDropdownListeners(),
                                                    this.dropdownArrow.classList.add("iti__arrow--up"),
                                                    this._trigger("open:countrydropdown");
                                            },
                                        },
                                        {
                                            key: "_toggleClass",
                                            value: function (e, t, n) {
                                                n && !e.classList.contains(t)
                                                    ? e.classList.add(t)
                                                    : !n && e.classList.contains(t) && e.classList.remove(t);
                                            },
                                        },
                                        {
                                            key: "_setDropdownPosition",
                                            value: function () {
                                                var e = this;
                                                if (
                                                    (this.options.dropdownContainer &&
                                                        this.options.dropdownContainer.appendChild(this.dropdown),
                                                    !this.options.useFullscreenPopup)
                                                ) {
                                                    var t = this.telInput.getBoundingClientRect(),
                                                        n = window.pageYOffset || document.documentElement.scrollTop,
                                                        i = t.top + n,
                                                        s = this.countryList.offsetHeight,
                                                        r = i + this.telInput.offsetHeight + s < n + window.innerHeight,
                                                        a = i - s > n;
                                                    if (
                                                        (this._toggleClass(
                                                            this.countryList,
                                                            "iti__country-list--dropup",
                                                            !r && a
                                                        ),
                                                        this.options.dropdownContainer)
                                                    ) {
                                                        var o = !r && a ? 0 : this.telInput.offsetHeight;
                                                        (this.dropdown.style.top = "".concat(i + o, "px")),
                                                            (this.dropdown.style.left = "".concat(
                                                                t.left + document.body.scrollLeft,
                                                                "px"
                                                            )),
                                                            (this._handleWindowScroll = function () {
                                                                return e._closeDropdown();
                                                            }),
                                                            window.addEventListener("scroll", this._handleWindowScroll);
                                                    }
                                                }
                                            },
                                        },
                                        {
                                            key: "_getClosestListItem",
                                            value: function (e) {
                                                for (
                                                    var t = e;
                                                    t &&
                                                    t !== this.countryList &&
                                                    !t.classList.contains("iti__country");

                                                )
                                                    t = t.parentNode;
                                                return t === this.countryList ? null : t;
                                            },
                                        },
                                        {
                                            key: "_bindDropdownListeners",
                                            value: function () {
                                                var e = this;
                                                (this._handleMouseoverCountryList = function (t) {
                                                    var n = e._getClosestListItem(t.target);
                                                    n && e._highlightListItem(n, !1);
                                                }),
                                                    this.countryList.addEventListener(
                                                        "mouseover",
                                                        this._handleMouseoverCountryList
                                                    ),
                                                    (this._handleClickCountryList = function (t) {
                                                        var n = e._getClosestListItem(t.target);
                                                        n && e._selectListItem(n);
                                                    }),
                                                    this.countryList.addEventListener(
                                                        "click",
                                                        this._handleClickCountryList
                                                    );
                                                var t = !0;
                                                (this._handleClickOffToClose = function () {
                                                    t || e._closeDropdown(), (t = !1);
                                                }),
                                                    document.documentElement.addEventListener(
                                                        "click",
                                                        this._handleClickOffToClose
                                                    );
                                                var n = "",
                                                    i = null;
                                                (this._handleKeydownOnDropdown = function (t) {
                                                    t.preventDefault(),
                                                        "ArrowUp" === t.key ||
                                                        "Up" === t.key ||
                                                        "ArrowDown" === t.key ||
                                                        "Down" === t.key
                                                            ? e._handleUpDownKey(t.key)
                                                            : "Enter" === t.key
                                                              ? e._handleEnterKey()
                                                              : "Escape" === t.key
                                                                ? e._closeDropdown()
                                                                : /^[a-zA-ZÀ-ÿа-яА-Я ]$/.test(t.key) &&
                                                                  (i && clearTimeout(i),
                                                                  (n += t.key.toLowerCase()),
                                                                  e._searchForCountry(n),
                                                                  (i = setTimeout(function () {
                                                                      n = "";
                                                                  }, 1e3)));
                                                }),
                                                    document.addEventListener("keydown", this._handleKeydownOnDropdown);
                                            },
                                        },
                                        {
                                            key: "_handleUpDownKey",
                                            value: function (e) {
                                                var t =
                                                    "ArrowUp" === e || "Up" === e
                                                        ? this.highlightedItem.previousElementSibling
                                                        : this.highlightedItem.nextElementSibling;
                                                t &&
                                                    (t.classList.contains("iti__divider") &&
                                                        (t =
                                                            "ArrowUp" === e || "Up" === e
                                                                ? t.previousElementSibling
                                                                : t.nextElementSibling),
                                                    this._highlightListItem(t, !0));
                                            },
                                        },
                                        {
                                            key: "_handleEnterKey",
                                            value: function () {
                                                this.highlightedItem && this._selectListItem(this.highlightedItem);
                                            },
                                        },
                                        {
                                            key: "_searchForCountry",
                                            value: function (e) {
                                                for (var t = 0; t < this.countries.length; t++)
                                                    if (this._startsWith(this.countries[t].name, e)) {
                                                        var n = this.countryList.querySelector(
                                                            "#iti-"
                                                                .concat(this.id, "__item-")
                                                                .concat(this.countries[t].iso2)
                                                        );
                                                        this._highlightListItem(n, !1), this._scrollTo(n, !0);
                                                        break;
                                                    }
                                            },
                                        },
                                        {
                                            key: "_startsWith",
                                            value: function (e, t) {
                                                return e.substr(0, t.length).toLowerCase() === t;
                                            },
                                        },
                                        {
                                            key: "_updateValFromNumber",
                                            value: function (e) {
                                                var t = e;
                                                if (
                                                    this.options.formatOnDisplay &&
                                                    window.intlTelInputUtils &&
                                                    this.selectedCountryData
                                                ) {
                                                    var n =
                                                            this.options.nationalMode ||
                                                            ("+" !== t.charAt(0) && !this.options.separateDialCode),
                                                        i = intlTelInputUtils.numberFormat,
                                                        s = i.NATIONAL,
                                                        r = i.INTERNATIONAL,
                                                        a = n ? s : r;
                                                    t = intlTelInputUtils.formatNumber(
                                                        t,
                                                        this.selectedCountryData.iso2,
                                                        a
                                                    );
                                                }
                                                (t = this._beforeSetNumber(t)), (this.telInput.value = t);
                                            },
                                        },
                                        {
                                            key: "_updateFlagFromNumber",
                                            value: function (e) {
                                                var t = e,
                                                    n = this.selectedCountryData.dialCode;
                                                t &&
                                                    "1" === n &&
                                                    "+" !== t.charAt(0) &&
                                                    ("1" !== t.charAt(0) && (t = "1".concat(t)), (t = "+".concat(t))),
                                                    this.options.separateDialCode &&
                                                        n &&
                                                        "+" !== t.charAt(0) &&
                                                        (t = "+".concat(n).concat(t));
                                                var i = this._getDialCode(t, !0),
                                                    s = this._getNumeric(t),
                                                    r = null;
                                                if (i) {
                                                    var a = this.countryCodes[this._getNumeric(i)],
                                                        o =
                                                            -1 !== a.indexOf(this.selectedCountryData.iso2) &&
                                                            s.length <= i.length - 1;
                                                    if (!(("1" === n && this._isRegionlessNanp(s)) || o))
                                                        for (var l = 0; l < a.length; l++)
                                                            if (a[l]) {
                                                                r = a[l];
                                                                break;
                                                            }
                                                } else
                                                    "+" === t.charAt(0) && s.length
                                                        ? (r = "")
                                                        : (t && "+" !== t) || (r = this.defaultCountry);
                                                return null !== r && this._setFlag(r);
                                            },
                                        },
                                        {
                                            key: "_isRegionlessNanp",
                                            value: function (e) {
                                                var t = this._getNumeric(e);
                                                if ("1" === t.charAt(0)) {
                                                    var n = t.substr(1, 3);
                                                    return -1 !== d.indexOf(n);
                                                }
                                                return !1;
                                            },
                                        },
                                        {
                                            key: "_highlightListItem",
                                            value: function (e, t) {
                                                var n = this.highlightedItem;
                                                n && n.classList.remove("iti__highlight"),
                                                    (this.highlightedItem = e),
                                                    this.highlightedItem.classList.add("iti__highlight"),
                                                    this.selectedFlag.setAttribute(
                                                        "aria-activedescendant",
                                                        e.getAttribute("id")
                                                    ),
                                                    t && this.highlightedItem.focus();
                                            },
                                        },
                                        {
                                            key: "_getCountryData",
                                            value: function (e, n, i) {
                                                for (var s = n ? t : this.countries, r = 0; r < s.length; r++)
                                                    if (s[r].iso2 === e) return s[r];
                                                if (i) return null;
                                                throw new Error("No country data for '".concat(e, "'"));
                                            },
                                        },
                                        {
                                            key: "_setFlag",
                                            value: function (e) {
                                                var t = this.options,
                                                    n = t.allowDropdown,
                                                    i = t.separateDialCode,
                                                    s = t.showFlags,
                                                    r = this.selectedCountryData.iso2 ? this.selectedCountryData : {};
                                                if (
                                                    ((this.selectedCountryData = e
                                                        ? this._getCountryData(e, !1, !1)
                                                        : {}),
                                                    this.selectedCountryData.iso2 &&
                                                        (this.defaultCountry = this.selectedCountryData.iso2),
                                                    s &&
                                                        this.selectedFlagInner.setAttribute(
                                                            "class",
                                                            "iti__flag iti__".concat(e)
                                                        ),
                                                    this._setSelectedCountryFlagTitleAttribute(e, i),
                                                    i)
                                                ) {
                                                    var a = this.selectedCountryData.dialCode
                                                        ? "+".concat(this.selectedCountryData.dialCode)
                                                        : "";
                                                    this.selectedDialCode.innerHTML = a;
                                                    var o =
                                                        this.selectedFlag.offsetWidth ||
                                                        this._getHiddenSelectedFlagWidth();
                                                    this.isRTL
                                                        ? (this.telInput.style.paddingRight = "".concat(o + 6, "px"))
                                                        : (this.telInput.style.paddingLeft = "".concat(o + 6, "px"));
                                                }
                                                if ((this._updatePlaceholder(), n)) {
                                                    var l = this.activeItem;
                                                    if (
                                                        (l &&
                                                            (l.classList.remove("iti__active"),
                                                            l.setAttribute("aria-selected", "false")),
                                                        e)
                                                    ) {
                                                        var c =
                                                            this.countryList.querySelector(
                                                                "#iti-"
                                                                    .concat(this.id, "__item-")
                                                                    .concat(e, "-preferred")
                                                            ) ||
                                                            this.countryList.querySelector(
                                                                "#iti-".concat(this.id, "__item-").concat(e)
                                                            );
                                                        c.setAttribute("aria-selected", "true"),
                                                            c.classList.add("iti__active"),
                                                            (this.activeItem = c);
                                                    }
                                                }
                                                return r.iso2 !== e;
                                            },
                                        },
                                        {
                                            key: "_setSelectedCountryFlagTitleAttribute",
                                            value: function (e, t) {
                                                var n;
                                                this.selectedFlag &&
                                                    ((n =
                                                        e && !t
                                                            ? ""
                                                                  .concat(this.selectedCountryData.name, ": +")
                                                                  .concat(this.selectedCountryData.dialCode)
                                                            : e
                                                              ? this.selectedCountryData.name
                                                              : "Unknown"),
                                                    this.selectedFlag.setAttribute("title", n));
                                            },
                                        },
                                        {
                                            key: "_getHiddenSelectedFlagWidth",
                                            value: function () {
                                                var e = this.telInput.parentNode.cloneNode();
                                                (e.style.visibility = "hidden"), document.body.appendChild(e);
                                                var t = this.flagsContainer.cloneNode();
                                                e.appendChild(t);
                                                var n = this.selectedFlag.cloneNode(!0);
                                                t.appendChild(n);
                                                var i = n.offsetWidth;
                                                return e.parentNode.removeChild(e), i;
                                            },
                                        },
                                        {
                                            key: "_updatePlaceholder",
                                            value: function () {
                                                var e =
                                                    "aggressive" === this.options.autoPlaceholder ||
                                                    (!this.hadInitialPlaceholder &&
                                                        "polite" === this.options.autoPlaceholder);
                                                if (window.intlTelInputUtils && e) {
                                                    var t =
                                                            intlTelInputUtils.numberType[
                                                                this.options.placeholderNumberType
                                                            ],
                                                        n = this.selectedCountryData.iso2
                                                            ? intlTelInputUtils.getExampleNumber(
                                                                  this.selectedCountryData.iso2,
                                                                  this.options.nationalMode,
                                                                  t
                                                              )
                                                            : "";
                                                    (n = this._beforeSetNumber(n)),
                                                        "function" == typeof this.options.customPlaceholder &&
                                                            (n = this.options.customPlaceholder(
                                                                n,
                                                                this.selectedCountryData
                                                            )),
                                                        this.telInput.setAttribute("placeholder", n);
                                                }
                                            },
                                        },
                                        {
                                            key: "_selectListItem",
                                            value: function (e) {
                                                var t = this._setFlag(e.getAttribute("data-country-code"));
                                                this._closeDropdown(),
                                                    this._updateDialCode(e.getAttribute("data-dial-code")),
                                                    this.telInput.focus();
                                                var n = this.telInput.value.length;
                                                this.telInput.setSelectionRange(n, n),
                                                    t && this._triggerCountryChange();
                                            },
                                        },
                                        {
                                            key: "_closeDropdown",
                                            value: function () {
                                                this.countryList.classList.add("iti__hide"),
                                                    this.selectedFlag.setAttribute("aria-expanded", "false"),
                                                    this.selectedFlag.removeAttribute("aria-activedescendant"),
                                                    this.dropdownArrow.classList.remove("iti__arrow--up"),
                                                    document.removeEventListener(
                                                        "keydown",
                                                        this._handleKeydownOnDropdown
                                                    ),
                                                    document.documentElement.removeEventListener(
                                                        "click",
                                                        this._handleClickOffToClose
                                                    ),
                                                    this.countryList.removeEventListener(
                                                        "mouseover",
                                                        this._handleMouseoverCountryList
                                                    ),
                                                    this.countryList.removeEventListener(
                                                        "click",
                                                        this._handleClickCountryList
                                                    ),
                                                    this.options.dropdownContainer &&
                                                        (this.options.useFullscreenPopup ||
                                                            window.removeEventListener(
                                                                "scroll",
                                                                this._handleWindowScroll
                                                            ),
                                                        this.dropdown.parentNode &&
                                                            this.dropdown.parentNode.removeChild(this.dropdown)),
                                                    this._trigger("close:countrydropdown");
                                            },
                                        },
                                        {
                                            key: "_scrollTo",
                                            value: function (e, t) {
                                                var n = this.countryList,
                                                    i = window.pageYOffset || document.documentElement.scrollTop,
                                                    s = n.offsetHeight,
                                                    r = n.getBoundingClientRect().top + i,
                                                    a = r + s,
                                                    o = e.offsetHeight,
                                                    l = e.getBoundingClientRect().top + i,
                                                    c = l + o,
                                                    d = l - r + n.scrollTop,
                                                    u = s / 2 - o / 2;
                                                if (l < r) t && (d -= u), (n.scrollTop = d);
                                                else if (c > a) {
                                                    t && (d += u);
                                                    var p = s - o;
                                                    n.scrollTop = d - p;
                                                }
                                            },
                                        },
                                        {
                                            key: "_updateDialCode",
                                            value: function (e) {
                                                var t,
                                                    n = this.telInput.value,
                                                    i = "+".concat(e);
                                                if ("+" === n.charAt(0)) {
                                                    var s = this._getDialCode(n);
                                                    (t = s ? n.replace(s, i) : i), (this.telInput.value = t);
                                                } else
                                                    this.options.autoInsertDialCode &&
                                                        ((t = n ? i + n : i), (this.telInput.value = t));
                                            },
                                        },
                                        {
                                            key: "_getDialCode",
                                            value: function (e, t) {
                                                var n = "";
                                                if ("+" === e.charAt(0))
                                                    for (var i = "", s = 0; s < e.length; s++) {
                                                        var r = e.charAt(s);
                                                        if (!isNaN(parseInt(r, 10))) {
                                                            if (((i += r), t))
                                                                this.countryCodes[i] && (n = e.substr(0, s + 1));
                                                            else if (this.dialCodes[i]) {
                                                                n = e.substr(0, s + 1);
                                                                break;
                                                            }
                                                            if (i.length === this.countryCodeMaxLen) break;
                                                        }
                                                    }
                                                return n;
                                            },
                                        },
                                        {
                                            key: "_getFullNumber",
                                            value: function () {
                                                var e = this.telInput.value.trim(),
                                                    t = this.selectedCountryData.dialCode,
                                                    n = this._getNumeric(e);
                                                return (
                                                    (this.options.separateDialCode && "+" !== e.charAt(0) && t && n
                                                        ? "+".concat(t)
                                                        : "") + e
                                                );
                                            },
                                        },
                                        {
                                            key: "_beforeSetNumber",
                                            value: function (e) {
                                                var t = e;
                                                if (this.options.separateDialCode) {
                                                    var n = this._getDialCode(t);
                                                    if (n) {
                                                        var i =
                                                            " " ===
                                                                t[
                                                                    (n = "+".concat(this.selectedCountryData.dialCode))
                                                                        .length
                                                                ] || "-" === t[n.length]
                                                                ? n.length + 1
                                                                : n.length;
                                                        t = t.substr(i);
                                                    }
                                                }
                                                return this._cap(t);
                                            },
                                        },
                                        {
                                            key: "_triggerCountryChange",
                                            value: function () {
                                                this._trigger("countrychange");
                                            },
                                        },
                                        {
                                            key: "handleAutoCountry",
                                            value: function () {
                                                "auto" === this.options.initialCountry &&
                                                    ((this.defaultCountry = window.intlTelInputGlobals.autoCountry),
                                                    this.telInput.value || this.setCountry(this.defaultCountry),
                                                    this.resolveAutoCountryPromise());
                                            },
                                        },
                                        {
                                            key: "handleUtils",
                                            value: function () {
                                                window.intlTelInputUtils &&
                                                    (this.telInput.value &&
                                                        this._updateValFromNumber(this.telInput.value),
                                                    this._updatePlaceholder()),
                                                    this.resolveUtilsScriptPromise();
                                            },
                                        },
                                        {
                                            key: "destroy",
                                            value: function () {
                                                var e = this.telInput.form;
                                                if (this.options.allowDropdown) {
                                                    this._closeDropdown(),
                                                        this.selectedFlag.removeEventListener(
                                                            "click",
                                                            this._handleClickSelectedFlag
                                                        ),
                                                        this.flagsContainer.removeEventListener(
                                                            "keydown",
                                                            this._handleFlagsContainerKeydown
                                                        );
                                                    var t = this._getClosestLabel();
                                                    t && t.removeEventListener("click", this._handleLabelClick);
                                                }
                                                this.hiddenInput &&
                                                    e &&
                                                    e.removeEventListener("submit", this._handleHiddenInputSubmit),
                                                    this.options.autoInsertDialCode &&
                                                        (e &&
                                                            e.removeEventListener(
                                                                "submit",
                                                                this._handleSubmitOrBlurEvent
                                                            ),
                                                        this.telInput.removeEventListener(
                                                            "blur",
                                                            this._handleSubmitOrBlurEvent
                                                        )),
                                                    this.telInput.removeEventListener("keyup", this._handleKeyupEvent),
                                                    this.telInput.removeEventListener(
                                                        "cut",
                                                        this._handleClipboardEvent
                                                    ),
                                                    this.telInput.removeEventListener(
                                                        "paste",
                                                        this._handleClipboardEvent
                                                    ),
                                                    this.telInput.removeAttribute("data-intl-tel-input-id");
                                                var n = this.telInput.parentNode;
                                                n.parentNode.insertBefore(this.telInput, n),
                                                    n.parentNode.removeChild(n),
                                                    delete window.intlTelInputGlobals.instances[this.id];
                                            },
                                        },
                                        {
                                            key: "getExtension",
                                            value: function () {
                                                return window.intlTelInputUtils
                                                    ? intlTelInputUtils.getExtension(
                                                          this._getFullNumber(),
                                                          this.selectedCountryData.iso2
                                                      )
                                                    : "";
                                            },
                                        },
                                        {
                                            key: "getNumber",
                                            value: function (e) {
                                                if (window.intlTelInputUtils) {
                                                    var t = this.selectedCountryData.iso2;
                                                    return intlTelInputUtils.formatNumber(this._getFullNumber(), t, e);
                                                }
                                                return "";
                                            },
                                        },
                                        {
                                            key: "getNumberType",
                                            value: function () {
                                                return window.intlTelInputUtils
                                                    ? intlTelInputUtils.getNumberType(
                                                          this._getFullNumber(),
                                                          this.selectedCountryData.iso2
                                                      )
                                                    : -99;
                                            },
                                        },
                                        {
                                            key: "getSelectedCountryData",
                                            value: function () {
                                                return this.selectedCountryData;
                                            },
                                        },
                                        {
                                            key: "getValidationError",
                                            value: function () {
                                                if (window.intlTelInputUtils) {
                                                    var e = this.selectedCountryData.iso2;
                                                    return intlTelInputUtils.getValidationError(
                                                        this._getFullNumber(),
                                                        e
                                                    );
                                                }
                                                return -99;
                                            },
                                        },
                                        {
                                            key: "isValidNumber",
                                            value: function () {
                                                var e = this._getFullNumber().trim();
                                                return window.intlTelInputUtils
                                                    ? intlTelInputUtils.isValidNumber(e, this.selectedCountryData.iso2)
                                                    : null;
                                            },
                                        },
                                        {
                                            key: "isPossibleNumber",
                                            value: function () {
                                                var e = this._getFullNumber().trim();
                                                return window.intlTelInputUtils
                                                    ? intlTelInputUtils.isPossibleNumber(
                                                          e,
                                                          this.selectedCountryData.iso2
                                                      )
                                                    : null;
                                            },
                                        },
                                        {
                                            key: "setCountry",
                                            value: function (e) {
                                                var t = e.toLowerCase();
                                                this.selectedCountryData.iso2 !== t &&
                                                    (this._setFlag(t),
                                                    this._updateDialCode(this.selectedCountryData.dialCode),
                                                    this._triggerCountryChange());
                                            },
                                        },
                                        {
                                            key: "setNumber",
                                            value: function (e) {
                                                var t = this._updateFlagFromNumber(e);
                                                this._updateValFromNumber(e), t && this._triggerCountryChange();
                                            },
                                        },
                                        {
                                            key: "setPlaceholderNumberType",
                                            value: function (e) {
                                                (this.options.placeholderNumberType = e), this._updatePlaceholder();
                                            },
                                        },
                                    ]),
                                    a && r(i.prototype, a),
                                    Object.defineProperty(i, "prototype", { writable: !1 }),
                                    n
                                );
                            })();
                        o.getCountryData = function () {
                            return t;
                        };
                        var f = function (e, t, n) {
                            var i = document.createElement("script");
                            (i.onload = function () {
                                p("handleUtils"), t && t();
                            }),
                                (i.onerror = function () {
                                    p("rejectUtilsScriptPromise"), n && n();
                                }),
                                (i.className = "iti-load-utils"),
                                (i.async = !0),
                                (i.src = e),
                                document.body.appendChild(i);
                        };
                        return (
                            (o.loadUtils = function (e) {
                                if (
                                    !window.intlTelInputUtils &&
                                    !window.intlTelInputGlobals.startedLoadingUtilsScript
                                ) {
                                    if (
                                        ((window.intlTelInputGlobals.startedLoadingUtilsScript = !0),
                                        "undefined" != typeof Promise)
                                    )
                                        return new Promise(function (t, n) {
                                            return f(e, t, n);
                                        });
                                    f(e);
                                }
                                return null;
                            }),
                            (o.defaults = c),
                            (o.version = "18.3.3"),
                            function (e, t) {
                                var n = new h(e, t);
                                return (
                                    n._init(),
                                    e.setAttribute("data-intl-tel-input-id", n.id),
                                    (window.intlTelInputGlobals.instances[n.id] = n),
                                    n
                                );
                            }
                        );
                    })();
                }),
                    e.exports ? (e.exports = t()) : (window.intlTelInput = t());
            },
            699: function (e, t, n) {
                e.exports = n(197);
            },
            90: function (e) {
                !(function (t, n) {
                    var i = (function (e, t, n) {
                        "use strict";
                        var i, s;
                        if (
                            ((function () {
                                var t,
                                    n = {
                                        lazyClass: "lazyload",
                                        loadedClass: "lazyloaded",
                                        loadingClass: "lazyloading",
                                        preloadClass: "lazypreload",
                                        errorClass: "lazyerror",
                                        autosizesClass: "lazyautosizes",
                                        fastLoadedClass: "ls-is-cached",
                                        iframeLoadMode: 0,
                                        srcAttr: "data-src",
                                        srcsetAttr: "data-srcset",
                                        sizesAttr: "data-sizes",
                                        minSize: 40,
                                        customMedia: {},
                                        init: !0,
                                        expFactor: 1.2,
                                        hFac: 0.8,
                                        loadMode: 2,
                                        loadHidden: !0,
                                        ricTimeout: 0,
                                        throttleDelay: 100,
                                    };
                                for (t in ((s = e.lazySizesConfig || e.lazysizesConfig || {}), n))
                                    t in s || (s[t] = n[t]);
                            })(),
                            !t || !t.getElementsByClassName)
                        )
                            return { init: function () {}, cfg: s, noSupport: !0 };
                        var r,
                            a,
                            o,
                            l,
                            c,
                            d,
                            u,
                            p,
                            h,
                            f,
                            m,
                            g,
                            v,
                            y,
                            b,
                            w,
                            C,
                            x,
                            S,
                            E,
                            T,
                            $,
                            k,
                            M,
                            L,
                            A,
                            I,
                            _,
                            P,
                            D,
                            O,
                            N,
                            F,
                            j,
                            z,
                            B,
                            q,
                            H,
                            R,
                            V,
                            G,
                            W,
                            U,
                            X,
                            Y = t.documentElement,
                            K = e.HTMLPictureElement,
                            Q = "addEventListener",
                            J = "getAttribute",
                            Z = e[Q].bind(e),
                            ee = e.setTimeout,
                            te = e.requestAnimationFrame || ee,
                            ne = e.requestIdleCallback,
                            ie = /^picture$/i,
                            se = ["load", "error", "lazyincluded", "_lazyloaded"],
                            re = {},
                            ae = Array.prototype.forEach,
                            oe = function (e, t) {
                                return (
                                    re[t] || (re[t] = new RegExp("(\\s|^)" + t + "(\\s|$)")),
                                    re[t].test(e[J]("class") || "") && re[t]
                                );
                            },
                            le = function (e, t) {
                                oe(e, t) || e.setAttribute("class", (e[J]("class") || "").trim() + " " + t);
                            },
                            ce = function (e, t) {
                                var n;
                                (n = oe(e, t)) && e.setAttribute("class", (e[J]("class") || "").replace(n, " "));
                            },
                            de = function (e, t, n) {
                                var i = n ? Q : "removeEventListener";
                                n && de(e, t),
                                    se.forEach(function (n) {
                                        e[i](n, t);
                                    });
                            },
                            ue = function (e, n, s, r, a) {
                                var o = t.createEvent("Event");
                                return (
                                    s || (s = {}),
                                    (s.instance = i),
                                    o.initEvent(n, !r, !a),
                                    (o.detail = s),
                                    e.dispatchEvent(o),
                                    o
                                );
                            },
                            pe = function (t, n) {
                                var i;
                                !K && (i = e.picturefill || s.pf)
                                    ? (n && n.src && !t[J]("srcset") && t.setAttribute("srcset", n.src),
                                      i({ reevaluate: !0, elements: [t] }))
                                    : n && n.src && (t.src = n.src);
                            },
                            he = function (e, t) {
                                return (getComputedStyle(e, null) || {})[t];
                            },
                            fe = function (e, t, n) {
                                for (n = n || e.offsetWidth; n < s.minSize && t && !e._lazysizesWidth; )
                                    (n = t.offsetWidth), (t = t.parentNode);
                                return n;
                            },
                            me =
                                ((G = []),
                                (W = V = []),
                                (X = function (e, n) {
                                    H && !n
                                        ? e.apply(this, arguments)
                                        : (W.push(e), R || ((R = !0), (t.hidden ? ee : te)(U)));
                                }),
                                (X._lsFlush = U =
                                    function () {
                                        var e = W;
                                        for (W = V.length ? G : V, H = !0, R = !1; e.length; ) e.shift()();
                                        H = !1;
                                    }),
                                X),
                            ge = function (e, t) {
                                return t
                                    ? function () {
                                          me(e);
                                      }
                                    : function () {
                                          var t = this,
                                              n = arguments;
                                          me(function () {
                                              e.apply(t, n);
                                          });
                                      };
                            },
                            ve = function (e) {
                                var t,
                                    i,
                                    s = function () {
                                        (t = null), e();
                                    },
                                    r = function () {
                                        var e = n.now() - i;
                                        e < 99 ? ee(r, 99 - e) : (ne || s)(s);
                                    };
                                return function () {
                                    (i = n.now()), t || (t = ee(r, 99));
                                };
                            },
                            ye =
                                ((C = /^img$/i),
                                (x = /^iframe$/i),
                                (S = "onscroll" in e && !/(gle|ing)bot/.test(navigator.userAgent)),
                                0,
                                (E = 0),
                                (T = 0),
                                ($ = -1),
                                (k = function (e) {
                                    T--, (!e || T < 0 || !e.target) && (T = 0);
                                }),
                                (M = function (e) {
                                    return (
                                        null == w && (w = "hidden" == he(t.body, "visibility")),
                                        w ||
                                            !(
                                                "hidden" == he(e.parentNode, "visibility") &&
                                                "hidden" == he(e, "visibility")
                                            )
                                    );
                                }),
                                (L = function (e, n) {
                                    var i,
                                        s = e,
                                        r = M(e);
                                    for (
                                        g -= n, b += n, v -= n, y += n;
                                        r && (s = s.offsetParent) && s != t.body && s != Y;

                                    )
                                        (r = (he(s, "opacity") || 1) > 0) &&
                                            "visible" != he(s, "overflow") &&
                                            ((i = s.getBoundingClientRect()),
                                            (r = y > i.left && v < i.right && b > i.top - 1 && g < i.bottom + 1));
                                    return r;
                                }),
                                (I = (function (e) {
                                    var t,
                                        i = 0,
                                        r = s.throttleDelay,
                                        a = s.ricTimeout,
                                        o = function () {
                                            (t = !1), (i = n.now()), e();
                                        },
                                        l =
                                            ne && a > 49
                                                ? function () {
                                                      ne(o, { timeout: a }), a !== s.ricTimeout && (a = s.ricTimeout);
                                                  }
                                                : ge(function () {
                                                      ee(o);
                                                  }, !0);
                                    return function (e) {
                                        var s;
                                        (e = !0 === e) && (a = 33),
                                            t ||
                                                ((t = !0),
                                                (s = r - (n.now() - i)) < 0 && (s = 0),
                                                e || s < 9 ? l() : ee(l, s));
                                    };
                                })(
                                    (A = function () {
                                        var e,
                                            n,
                                            r,
                                            a,
                                            o,
                                            l,
                                            u,
                                            h,
                                            C,
                                            x,
                                            k,
                                            A,
                                            I = i.elements;
                                        if ((p = s.loadMode) && T < 8 && (e = I.length)) {
                                            for (n = 0, $++; n < e; n++)
                                                if (I[n] && !I[n]._lazyRace)
                                                    if (!S || (i.prematureUnveil && i.prematureUnveil(I[n]))) j(I[n]);
                                                    else if (
                                                        (((h = I[n][J]("data-expand")) && (l = 1 * h)) || (l = E),
                                                        x ||
                                                            ((x =
                                                                !s.expand || s.expand < 1
                                                                    ? Y.clientHeight > 500 && Y.clientWidth > 500
                                                                        ? 500
                                                                        : 370
                                                                    : s.expand),
                                                            (i._defEx = x),
                                                            (k = x * s.expFactor),
                                                            (A = s.hFac),
                                                            (w = null),
                                                            E < k && T < 1 && $ > 2 && p > 2 && !t.hidden
                                                                ? ((E = k), ($ = 0))
                                                                : (E = p > 1 && $ > 1 && T < 6 ? x : 0)),
                                                        C !== l &&
                                                            ((f = innerWidth + l * A),
                                                            (m = innerHeight + l),
                                                            (u = -1 * l),
                                                            (C = l)),
                                                        (r = I[n].getBoundingClientRect()),
                                                        (b = r.bottom) >= u &&
                                                            (g = r.top) <= m &&
                                                            (y = r.right) >= u * A &&
                                                            (v = r.left) <= f &&
                                                            (b || y || v || g) &&
                                                            (s.loadHidden || M(I[n])) &&
                                                            ((d && T < 3 && !h && (p < 3 || $ < 4)) || L(I[n], l)))
                                                    ) {
                                                        if ((j(I[n]), (o = !0), T > 9)) break;
                                                    } else
                                                        !o &&
                                                            d &&
                                                            !a &&
                                                            T < 4 &&
                                                            $ < 4 &&
                                                            p > 2 &&
                                                            (c[0] || s.preloadAfterLoad) &&
                                                            (c[0] ||
                                                                (!h &&
                                                                    (b ||
                                                                        y ||
                                                                        v ||
                                                                        g ||
                                                                        "auto" != I[n][J](s.sizesAttr)))) &&
                                                            (a = c[0] || I[n]);
                                            a && !o && j(a);
                                        }
                                    })
                                )),
                                (P = ge(
                                    (_ = function (e) {
                                        var t = e.target;
                                        t._lazyCache
                                            ? delete t._lazyCache
                                            : (k(e),
                                              le(t, s.loadedClass),
                                              ce(t, s.loadingClass),
                                              de(t, D),
                                              ue(t, "lazyloaded"));
                                    })
                                )),
                                (D = function (e) {
                                    P({ target: e.target });
                                }),
                                (O = function (e, t) {
                                    var n = e.getAttribute("data-load-mode") || s.iframeLoadMode;
                                    0 == n ? e.contentWindow.location.replace(t) : 1 == n && (e.src = t);
                                }),
                                (N = function (e) {
                                    var t,
                                        n = e[J](s.srcsetAttr);
                                    (t = s.customMedia[e[J]("data-media") || e[J]("media")]) &&
                                        e.setAttribute("media", t),
                                        n && e.setAttribute("srcset", n);
                                }),
                                (F = ge(function (e, t, n, i, r) {
                                    var a, o, l, c, d, p;
                                    (d = ue(e, "lazybeforeunveil", t)).defaultPrevented ||
                                        (i && (n ? le(e, s.autosizesClass) : e.setAttribute("sizes", i)),
                                        (o = e[J](s.srcsetAttr)),
                                        (a = e[J](s.srcAttr)),
                                        r && (c = (l = e.parentNode) && ie.test(l.nodeName || "")),
                                        (p = t.firesLoad || ("src" in e && (o || a || c))),
                                        (d = { target: e }),
                                        le(e, s.loadingClass),
                                        p && (clearTimeout(u), (u = ee(k, 2500)), de(e, D, !0)),
                                        c && ae.call(l.getElementsByTagName("source"), N),
                                        o
                                            ? e.setAttribute("srcset", o)
                                            : a && !c && (x.test(e.nodeName) ? O(e, a) : (e.src = a)),
                                        r && (o || c) && pe(e, { src: a })),
                                        e._lazyRace && delete e._lazyRace,
                                        ce(e, s.lazyClass),
                                        me(function () {
                                            var t = e.complete && e.naturalWidth > 1;
                                            (p && !t) ||
                                                (t && le(e, s.fastLoadedClass),
                                                _(d),
                                                (e._lazyCache = !0),
                                                ee(function () {
                                                    "_lazyCache" in e && delete e._lazyCache;
                                                }, 9)),
                                                "lazy" == e.loading && T--;
                                        }, !0);
                                })),
                                (j = function (e) {
                                    if (!e._lazyRace) {
                                        var t,
                                            n = C.test(e.nodeName),
                                            i = n && (e[J](s.sizesAttr) || e[J]("sizes")),
                                            r = "auto" == i;
                                        ((!r && d) ||
                                            !n ||
                                            (!e[J]("src") && !e.srcset) ||
                                            e.complete ||
                                            oe(e, s.errorClass) ||
                                            !oe(e, s.lazyClass)) &&
                                            ((t = ue(e, "lazyunveilread").detail),
                                            r && be.updateElem(e, !0, e.offsetWidth),
                                            (e._lazyRace = !0),
                                            T++,
                                            F(e, t, r, i, n));
                                    }
                                }),
                                (z = ve(function () {
                                    (s.loadMode = 3), I();
                                })),
                                (q = function () {
                                    d ||
                                        (n.now() - h < 999
                                            ? ee(q, 999)
                                            : ((d = !0), (s.loadMode = 3), I(), Z("scroll", B, !0)));
                                }),
                                {
                                    _: function () {
                                        (h = n.now()),
                                            (i.elements = t.getElementsByClassName(s.lazyClass)),
                                            (c = t.getElementsByClassName(s.lazyClass + " " + s.preloadClass)),
                                            Z("scroll", I, !0),
                                            Z("resize", I, !0),
                                            Z("pageshow", function (e) {
                                                if (e.persisted) {
                                                    var n = t.querySelectorAll("." + s.loadingClass);
                                                    n.length &&
                                                        n.forEach &&
                                                        te(function () {
                                                            n.forEach(function (e) {
                                                                e.complete && j(e);
                                                            });
                                                        });
                                                }
                                            }),
                                            e.MutationObserver
                                                ? new MutationObserver(I).observe(Y, {
                                                      childList: !0,
                                                      subtree: !0,
                                                      attributes: !0,
                                                  })
                                                : (Y[Q]("DOMNodeInserted", I, !0),
                                                  Y[Q]("DOMAttrModified", I, !0),
                                                  setInterval(I, 999)),
                                            Z("hashchange", I, !0),
                                            [
                                                "focus",
                                                "mouseover",
                                                "click",
                                                "load",
                                                "transitionend",
                                                "animationend",
                                            ].forEach(function (e) {
                                                t[Q](e, I, !0);
                                            }),
                                            /d$|^c/.test(t.readyState)
                                                ? q()
                                                : (Z("load", q), t[Q]("DOMContentLoaded", I), ee(q, 2e4)),
                                            i.elements.length ? (A(), me._lsFlush()) : I();
                                    },
                                    checkElems: I,
                                    unveil: j,
                                    _aLSL: (B = function () {
                                        3 == s.loadMode && (s.loadMode = 2), z();
                                    }),
                                }),
                            be =
                                ((a = ge(function (e, t, n, i) {
                                    var s, r, a;
                                    if (
                                        ((e._lazysizesWidth = i),
                                        (i += "px"),
                                        e.setAttribute("sizes", i),
                                        ie.test(t.nodeName || ""))
                                    )
                                        for (r = 0, a = (s = t.getElementsByTagName("source")).length; r < a; r++)
                                            s[r].setAttribute("sizes", i);
                                    n.detail.dataAttr || pe(e, n.detail);
                                })),
                                (o = function (e, t, n) {
                                    var i,
                                        s = e.parentNode;
                                    s &&
                                        ((n = fe(e, s, n)),
                                        (i = ue(e, "lazybeforesizes", { width: n, dataAttr: !!t })).defaultPrevented ||
                                            ((n = i.detail.width) && n !== e._lazysizesWidth && a(e, s, i, n)));
                                }),
                                {
                                    _: function () {
                                        (r = t.getElementsByClassName(s.autosizesClass)), Z("resize", l);
                                    },
                                    checkElems: (l = ve(function () {
                                        var e,
                                            t = r.length;
                                        if (t) for (e = 0; e < t; e++) o(r[e]);
                                    })),
                                    updateElem: o,
                                }),
                            we = function () {
                                !we.i && t.getElementsByClassName && ((we.i = !0), be._(), ye._());
                            };
                        return (
                            ee(function () {
                                s.init && we();
                            }),
                            (i = {
                                cfg: s,
                                autoSizer: be,
                                loader: ye,
                                init: we,
                                uP: pe,
                                aC: le,
                                rC: ce,
                                hC: oe,
                                fire: ue,
                                gW: fe,
                                rAF: me,
                            })
                        );
                    })(t, t.document, Date);
                    (t.lazySizes = i), e.exports && (e.exports = i);
                })("undefined" != typeof window ? window : {});
            },
            42: function (e) {
                function t(e, t) {
                    (e.onload = function () {
                        (this.onerror = this.onload = null), t(null, e);
                    }),
                        (e.onerror = function () {
                            (this.onerror = this.onload = null), t(new Error("Failed to load " + this.src), e);
                        });
                }
                function n(e, t) {
                    e.onreadystatechange = function () {
                        ("complete" != this.readyState && "loaded" != this.readyState) ||
                            ((this.onreadystatechange = null), t(null, e));
                    };
                }
                e.exports = function (e, i, s) {
                    var r = document.head || document.getElementsByTagName("head")[0],
                        a = document.createElement("script");
                    "function" == typeof i && ((s = i), (i = {})),
                        (i = i || {}),
                        (s = s || function () {}),
                        (a.type = i.type || "text/javascript"),
                        (a.charset = i.charset || "utf8"),
                        (a.async = !("async" in i) || !!i.async),
                        (a.src = e),
                        i.attrs &&
                            (function (e, t) {
                                for (var n in t) e.setAttribute(n, t[n]);
                            })(a, i.attrs),
                        i.text && (a.text = "" + i.text),
                        ("onload" in a ? t : n)(a, s),
                        a.onload || t(a, s),
                        r.appendChild(a);
                };
            },
            824: function (e) {
                var t = 1e3,
                    n = 60 * t,
                    i = 60 * n,
                    s = 24 * i;
                function r(e, t, n, i) {
                    var s = t >= 1.5 * n;
                    return Math.round(e / n) + " " + i + (s ? "s" : "");
                }
                e.exports = function (e, a) {
                    a = a || {};
                    var o,
                        l,
                        c = typeof e;
                    if ("string" === c && e.length > 0)
                        return (function (e) {
                            if (!((e = String(e)).length > 100)) {
                                var r =
                                    /^(-?(?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|weeks?|w|years?|yrs?|y)?$/i.exec(
                                        e
                                    );
                                if (r) {
                                    var a = parseFloat(r[1]);
                                    switch ((r[2] || "ms").toLowerCase()) {
                                        case "years":
                                        case "year":
                                        case "yrs":
                                        case "yr":
                                        case "y":
                                            return 315576e5 * a;
                                        case "weeks":
                                        case "week":
                                        case "w":
                                            return 6048e5 * a;
                                        case "days":
                                        case "day":
                                        case "d":
                                            return a * s;
                                        case "hours":
                                        case "hour":
                                        case "hrs":
                                        case "hr":
                                        case "h":
                                            return a * i;
                                        case "minutes":
                                        case "minute":
                                        case "mins":
                                        case "min":
                                        case "m":
                                            return a * n;
                                        case "seconds":
                                        case "second":
                                        case "secs":
                                        case "sec":
                                        case "s":
                                            return a * t;
                                        case "milliseconds":
                                        case "millisecond":
                                        case "msecs":
                                        case "msec":
                                        case "ms":
                                            return a;
                                        default:
                                            return;
                                    }
                                }
                            }
                        })(e);
                    if ("number" === c && isFinite(e))
                        return a.long
                            ? ((o = e),
                              (l = Math.abs(o)) >= s
                                  ? r(o, l, s, "day")
                                  : l >= i
                                    ? r(o, l, i, "hour")
                                    : l >= n
                                      ? r(o, l, n, "minute")
                                      : l >= t
                                        ? r(o, l, t, "second")
                                        : o + " ms")
                            : (function (e) {
                                  var r = Math.abs(e);
                                  return r >= s
                                      ? Math.round(e / s) + "d"
                                      : r >= i
                                        ? Math.round(e / i) + "h"
                                        : r >= n
                                          ? Math.round(e / n) + "m"
                                          : r >= t
                                            ? Math.round(e / t) + "s"
                                            : e + "ms";
                              })(e);
                    throw new Error("val is not a non-empty string or a valid number. val=" + JSON.stringify(e));
                };
            },
            988: function (e) {
                "use strict";
                var t;
                (t = function () {
                    var e = {},
                        t = {};
                    return (
                        (e.on = function (e, n) {
                            var i = { name: e, handler: n };
                            return (t[e] = t[e] || []), t[e].unshift(i), i;
                        }),
                        (e.off = function (e) {
                            var n = t[e.name].indexOf(e);
                            -1 !== n && t[e.name].splice(n, 1);
                        }),
                        (e.trigger = function (e, n) {
                            var i,
                                s = t[e];
                            if (s) for (i = s.length; i--; ) s[i].handler(n);
                        }),
                        e
                    );
                }),
                    (e.exports = t);
            },
            6: function (e, t, n) {
                "use strict";
                Object.defineProperty(t, "__esModule", { value: !0 });
                var i,
                    s = (i = n(275)) && i.__esModule ? i : { default: i };
                (t.default = {
                    pauseVideo: { acceptableStates: [s.default.ENDED, s.default.PAUSED], stateChangeRequired: !1 },
                    playVideo: { acceptableStates: [s.default.ENDED, s.default.PLAYING], stateChangeRequired: !1 },
                    seekTo: {
                        acceptableStates: [s.default.ENDED, s.default.PLAYING, s.default.PAUSED],
                        stateChangeRequired: !0,
                        timeout: 3e3,
                    },
                }),
                    (e.exports = t.default);
            },
            125: function (e, t, n) {
                "use strict";
                Object.defineProperty(t, "__esModule", { value: !0 });
                var i = o(n(227)),
                    s = o(n(6)),
                    r = o(n(279)),
                    a = o(n(255));
                function o(e) {
                    return e && e.__esModule ? e : { default: e };
                }
                const l = (0, i.default)("youtube-player"),
                    c = {
                        proxyEvents: (e) => {
                            const t = {};
                            for (const n of r.default) {
                                const i = "on" + n.slice(0, 1).toUpperCase() + n.slice(1);
                                t[i] = (t) => {
                                    l('event "%s"', i, t), e.trigger(n, t);
                                };
                            }
                            return t;
                        },
                        promisifyPlayer: (e, t = !1) => {
                            const n = {};
                            for (const i of a.default)
                                t && s.default[i]
                                    ? (n[i] = (...t) =>
                                          e.then((e) => {
                                              const n = s.default[i],
                                                  r = e.getPlayerState(),
                                                  a = e[i].apply(e, t);
                                              return n.stateChangeRequired ||
                                                  (Array.isArray(n.acceptableStates) && !n.acceptableStates.includes(r))
                                                  ? new Promise((t) => {
                                                        const i = () => {
                                                            const s = e.getPlayerState();
                                                            let r;
                                                            "number" == typeof n.timeout &&
                                                                (r = setTimeout(() => {
                                                                    e.removeEventListener("onStateChange", i), t();
                                                                }, n.timeout)),
                                                                Array.isArray(n.acceptableStates) &&
                                                                    n.acceptableStates.includes(s) &&
                                                                    (e.removeEventListener("onStateChange", i),
                                                                    clearTimeout(r),
                                                                    t());
                                                        };
                                                        e.addEventListener("onStateChange", i);
                                                    }).then(() => a)
                                                  : a;
                                          }))
                                    : (n[i] = (...t) => e.then((e) => e[i].apply(e, t)));
                            return n;
                        },
                    };
                (t.default = c), (e.exports = t.default);
            },
            275: function (e, t) {
                "use strict";
                Object.defineProperty(t, "__esModule", { value: !0 }),
                    (t.default = { BUFFERING: 3, ENDED: 0, PAUSED: 2, PLAYING: 1, UNSTARTED: -1, VIDEO_CUED: 5 }),
                    (e.exports = t.default);
            },
            279: function (e, t) {
                "use strict";
                Object.defineProperty(t, "__esModule", { value: !0 }),
                    (t.default = [
                        "ready",
                        "stateChange",
                        "playbackQualityChange",
                        "playbackRateChange",
                        "error",
                        "apiChange",
                        "volumeChange",
                    ]),
                    (e.exports = t.default);
            },
            255: function (e, t) {
                "use strict";
                Object.defineProperty(t, "__esModule", { value: !0 }),
                    (t.default = [
                        "cueVideoById",
                        "loadVideoById",
                        "cueVideoByUrl",
                        "loadVideoByUrl",
                        "playVideo",
                        "pauseVideo",
                        "stopVideo",
                        "getVideoLoadedFraction",
                        "cuePlaylist",
                        "loadPlaylist",
                        "nextVideo",
                        "previousVideo",
                        "playVideoAt",
                        "setShuffle",
                        "setLoop",
                        "getPlaylist",
                        "getPlaylistIndex",
                        "setOption",
                        "mute",
                        "unMute",
                        "isMuted",
                        "setVolume",
                        "getVolume",
                        "seekTo",
                        "getPlayerState",
                        "getPlaybackRate",
                        "setPlaybackRate",
                        "getAvailablePlaybackRates",
                        "getPlaybackQuality",
                        "setPlaybackQuality",
                        "getAvailableQualityLevels",
                        "getCurrentTime",
                        "getDuration",
                        "removeEventListener",
                        "getVideoUrl",
                        "getVideoEmbedCode",
                        "getOptions",
                        "getOption",
                        "addEventListener",
                        "destroy",
                        "setSize",
                        "getIframe",
                        "getSphericalProperties",
                        "setSphericalProperties",
                    ]),
                    (e.exports = t.default);
            },
            62: function (e, t, n) {
                "use strict";
                Object.defineProperty(t, "__esModule", { value: !0 });
                var i = a(n(988)),
                    s = a(n(125)),
                    r = a(n(900));
                function a(e) {
                    return e && e.__esModule ? e : { default: e };
                }
                let o;
                (t.default = (e, t = {}, n = !1) => {
                    const a = (0, i.default)();
                    if ((o || (o = (0, r.default)(a)), t.events))
                        throw new Error("Event handlers cannot be overwritten.");
                    if ("string" == typeof e && !document.getElementById(e))
                        throw new Error('Element "' + e + '" does not exist.');
                    t.events = s.default.proxyEvents(a);
                    const l = new Promise((n) => {
                            "object" == typeof e && e.playVideo instanceof Function
                                ? n(e)
                                : o.then((i) => {
                                      const s = new i.Player(e, t);
                                      return (
                                          a.on("ready", () => {
                                              n(s);
                                          }),
                                          null
                                      );
                                  });
                        }),
                        c = s.default.promisifyPlayer(l, n);
                    return (c.on = a.on), (c.off = a.off), c;
                }),
                    (e.exports = t.default);
            },
            900: function (e, t, n) {
                "use strict";
                Object.defineProperty(t, "__esModule", { value: !0 });
                var i,
                    s = (i = n(42)) && i.__esModule ? i : { default: i };
                (t.default = (e) =>
                    new Promise((t) => {
                        if (window.YT && window.YT.Player && window.YT.Player instanceof Function)
                            return void t(window.YT);
                        {
                            const t = "http:" === window.location.protocol ? "http:" : "https:";
                            (0, s.default)(t + "//www.youtube.com/iframe_api", (t) => {
                                t && e.trigger("error", t);
                            });
                        }
                        const n = window.onYouTubeIframeAPIReady;
                        window.onYouTubeIframeAPIReady = () => {
                            n && n(), t(window.YT);
                        };
                    })),
                    (e.exports = t.default);
            },
        },
        t = {};
    function n(i) {
        var s = t[i];
        if (void 0 !== s) return s.exports;
        var r = (t[i] = { exports: {} });
        return e[i].call(r.exports, r, r.exports, n), r.exports;
    }
    (n.n = function (e) {
        var t =
            e && e.__esModule
                ? function () {
                      return e.default;
                  }
                : function () {
                      return e;
                  };
        return n.d(t, { a: t }), t;
    }),
        (n.d = function (e, t) {
            for (var i in t) n.o(t, i) && !n.o(e, i) && Object.defineProperty(e, i, { enumerable: !0, get: t[i] });
        }),
        (n.o = function (e, t) {
            return Object.prototype.hasOwnProperty.call(e, t);
        }),
        (function () {
            "use strict";
            function e() {
                if (!(this instanceof e)) return new e();
                (this.size = 0),
                    (this.uid = 0),
                    (this.selectors = []),
                    (this.selectorObjects = {}),
                    (this.indexes = Object.create(this.indexes)),
                    (this.activeIndexes = []);
            }
            var t = window.document.documentElement,
                i =
                    t.matches ||
                    t.webkitMatchesSelector ||
                    t.mozMatchesSelector ||
                    t.oMatchesSelector ||
                    t.msMatchesSelector;
            (e.prototype.matchesSelector = function (e, t) {
                return i.call(e, t);
            }),
                (e.prototype.querySelectorAll = function (e, t) {
                    return t.querySelectorAll(e);
                }),
                (e.prototype.indexes = []);
            var s = /^#((?:[\w\u00c0-\uFFFF\-]|\\.)+)/g;
            e.prototype.indexes.push({
                name: "ID",
                selector: function (e) {
                    var t;
                    if ((t = e.match(s))) return t[0].slice(1);
                },
                element: function (e) {
                    if (e.id) return [e.id];
                },
            });
            var r = /^\.((?:[\w\u00c0-\uFFFF\-]|\\.)+)/g;
            e.prototype.indexes.push({
                name: "CLASS",
                selector: function (e) {
                    var t;
                    if ((t = e.match(r))) return t[0].slice(1);
                },
                element: function (e) {
                    var t = e.className;
                    if (t) {
                        if ("string" == typeof t) return t.split(/\s/);
                        if ("object" == typeof t && "baseVal" in t) return t.baseVal.split(/\s/);
                    }
                },
            });
            var a,
                o = /^((?:[\w\u00c0-\uFFFF\-]|\\.)+)/g;
            e.prototype.indexes.push({
                name: "TAG",
                selector: function (e) {
                    var t;
                    if ((t = e.match(o))) return t[0].toUpperCase();
                },
                element: function (e) {
                    return [e.nodeName.toUpperCase()];
                },
            }),
                (e.prototype.indexes.default = {
                    name: "UNIVERSAL",
                    selector: function () {
                        return !0;
                    },
                    element: function () {
                        return [!0];
                    },
                }),
                (a =
                    "function" == typeof window.Map
                        ? window.Map
                        : (function () {
                              function e() {
                                  this.map = {};
                              }
                              return (
                                  (e.prototype.get = function (e) {
                                      return this.map[e + " "];
                                  }),
                                  (e.prototype.set = function (e, t) {
                                      this.map[e + " "] = t;
                                  }),
                                  e
                              );
                          })());
            var l =
                /((?:\((?:\([^()]+\)|[^()]+)+\)|\[(?:\[[^\[\]]*\]|['"][^'"]*['"]|[^\[\]'"]+)+\]|\\.|[^ >+~,(\[\\]+)+|[>+~])(\s*,\s*)?((?:.|\r|\n)*)/g;
            function c(e, t) {
                var n,
                    i,
                    s,
                    r,
                    a,
                    o,
                    c = (e = e.slice(0).concat(e.default)).length,
                    d = t,
                    u = [];
                do {
                    if ((l.exec(""), (s = l.exec(d)) && ((d = s[3]), s[2] || !d)))
                        for (n = 0; n < c; n++)
                            if ((a = (o = e[n]).selector(s[1]))) {
                                for (i = u.length, r = !1; i--; )
                                    if (u[i].index === o && u[i].key === a) {
                                        r = !0;
                                        break;
                                    }
                                r || u.push({ index: o, key: a });
                                break;
                            }
                } while (s);
                return u;
            }
            function d(e, t) {
                var n, i, s;
                for (n = 0, i = e.length; n < i; n++) if (((s = e[n]), t.isPrototypeOf(s))) return s;
            }
            function u(e, t) {
                return e.id - t.id;
            }
            (e.prototype.logDefaultIndexUsed = function () {}),
                (e.prototype.add = function (e, t) {
                    var n,
                        i,
                        s,
                        r,
                        o,
                        l,
                        u,
                        p,
                        h = this.activeIndexes,
                        f = this.selectors,
                        m = this.selectorObjects;
                    if ("string" == typeof e) {
                        for (
                            m[(n = { id: this.uid++, selector: e, data: t }).id] = n, u = c(this.indexes, e), i = 0;
                            i < u.length;
                            i++
                        )
                            (r = (p = u[i]).key),
                                (o = d(h, (s = p.index))) || (((o = Object.create(s)).map = new a()), h.push(o)),
                                s === this.indexes.default && this.logDefaultIndexUsed(n),
                                (l = o.map.get(r)) || ((l = []), o.map.set(r, l)),
                                l.push(n);
                        this.size++, f.push(e);
                    }
                }),
                (e.prototype.remove = function (e, t) {
                    if ("string" == typeof e) {
                        var n,
                            i,
                            s,
                            r,
                            a,
                            o,
                            l,
                            d,
                            u = this.activeIndexes,
                            p = (this.selectors = []),
                            h = this.selectorObjects,
                            f = {},
                            m = 1 === arguments.length;
                        for (n = c(this.indexes, e), s = 0; s < n.length; s++)
                            for (i = n[s], r = u.length; r--; )
                                if (((o = u[r]), i.index.isPrototypeOf(o))) {
                                    if ((l = o.map.get(i.key)))
                                        for (a = l.length; a--; )
                                            (d = l[a]).selector !== e ||
                                                (!m && d.data !== t) ||
                                                (l.splice(a, 1), (f[d.id] = !0));
                                    break;
                                }
                        for (s in f) delete h[s], this.size--;
                        for (s in h) p.push(h[s].selector);
                    }
                }),
                (e.prototype.queryAll = function (e) {
                    if (!this.selectors.length) return [];
                    var t,
                        n,
                        i,
                        s,
                        r,
                        a,
                        o,
                        l,
                        c = {},
                        d = [],
                        p = this.querySelectorAll(this.selectors.join(", "), e);
                    for (t = 0, i = p.length; t < i; t++)
                        for (r = p[t], n = 0, s = (a = this.matches(r)).length; n < s; n++)
                            c[(l = a[n]).id]
                                ? (o = c[l.id])
                                : ((o = { id: l.id, selector: l.selector, data: l.data, elements: [] }),
                                  (c[l.id] = o),
                                  d.push(o)),
                                o.elements.push(r);
                    return d.sort(u);
                }),
                (e.prototype.matches = function (e) {
                    if (!e) return [];
                    var t,
                        n,
                        i,
                        s,
                        r,
                        a,
                        o,
                        l,
                        c,
                        d,
                        p,
                        h = this.activeIndexes,
                        f = {},
                        m = [];
                    for (t = 0, s = h.length; t < s; t++)
                        if ((l = (o = h[t]).element(e)))
                            for (n = 0, r = l.length; n < r; n++)
                                if ((c = o.map.get(l[n])))
                                    for (i = 0, a = c.length; i < a; i++)
                                        !f[(p = (d = c[i]).id)] &&
                                            this.matchesSelector(e, d.selector) &&
                                            ((f[p] = !0), m.push(d));
                    return m.sort(u);
                });
            const p = {},
                h = {},
                f = ["mouseenter", "mouseleave", "pointerenter", "pointerleave", "blur", "focus"];
            function m(e) {
                void 0 === h[e] && (h[e] = []);
            }
            function g(e) {
                return "string" == typeof e ? document.querySelectorAll(e) : e;
            }
            function v(e) {
                let t = (function (e, t) {
                    const n = [];
                    let i = t;
                    do {
                        if (1 !== i.nodeType) break;
                        const t = e.matches(i);
                        t.length && n.push({ delegatedTarget: i, stack: t });
                    } while ((i = i.parentElement));
                    return n;
                })(p[e.type], e.target);
                if (t.length)
                    for (let n = 0; n < t.length; n++)
                        for (let i = 0; i < t[n].stack.length; i++)
                            -1 !== f.indexOf(e.type)
                                ? (y(e, t[n].delegatedTarget),
                                  e.target === t[n].delegatedTarget && t[n].stack[i].data(e))
                                : (y(e, t[n].delegatedTarget), t[n].stack[i].data(e));
            }
            function y(e, t) {
                Object.defineProperty(e, "currentTarget", { configurable: !0, enumerable: !0, get: () => t });
            }
            const b = new (class {
                bindAll(e, t) {
                    t || (t = Object.getOwnPropertyNames(Object.getPrototypeOf(e)));
                    for (let n = 0; n < t.length; n++) e[t[n]] = e[t[n]].bind(e);
                }
                on(e, t, n, i) {
                    const s = e.split(" ");
                    for (let e = 0; e < s.length; e++)
                        if ("function" != typeof t || void 0 !== n)
                            if ((t.nodeType && 1 === t.nodeType) || t === window || t === document)
                                t.addEventListener(s[e], n, i);
                            else {
                                t = g(t);
                                for (let r = 0; r < t.length; r++) t[r].addEventListener(s[e], n, i);
                            }
                        else m(s[e]), h[s[e]].push(t);
                }
                delegate(t, n, i) {
                    const s = t.split(" ");
                    for (let t = 0; t < s.length; t++) {
                        let r = p[s[t]];
                        void 0 === r &&
                            ((r = new e()),
                            (p[s[t]] = r),
                            -1 !== f.indexOf(s[t])
                                ? document.addEventListener(s[t], v, !0)
                                : document.addEventListener(s[t], v)),
                            r.add(n, i);
                    }
                }
                off(e, t, n, i) {
                    const s = e.split(" ");
                    for (let e = 0; e < s.length; e++) {
                        if (void 0 === t) {
                            h[s[e]] = [];
                            continue;
                        }
                        if ("function" == typeof t) {
                            m(s[e]);
                            for (let n = 0; n < h[s[e]].length; n++) h[s[e]][n] === t && h[s[e]].splice(n, 1);
                            continue;
                        }
                        const r = p[s[e]];
                        if (void 0 === r || (r.remove(t, n), 0 !== r.size))
                            if (void 0 === t.removeEventListener) {
                                t = g(t);
                                for (let r = 0; r < t.length; r++) t[r].removeEventListener(s[e], n, i);
                            } else t.removeEventListener(s[e], n, i);
                        else
                            delete p[s[e]],
                                -1 !== f.indexOf(s[e])
                                    ? document.removeEventListener(s[e], v, !0)
                                    : document.removeEventListener(s[e], v);
                    }
                }
                emit(e, ...t) {
                    !(function (e, t) {
                        if (h[e]) for (let n = 0; n < h[e].length; n++) h[e][n](...t);
                    })(e, t);
                }
                debugDelegated() {
                    return JSON.parse(JSON.stringify(p));
                }
                debugBus() {
                    return (function (e) {
                        const t = {};
                        for (const n in e) t[n] = [...e[n]];
                        return t;
                    })(h);
                }
                hasBus(e) {
                    return this.debugBus().hasOwnProperty(e);
                }
            })();
            var w = b;
            const C = new DOMParser();
            function x(e) {
                const t = new URL(e, window.location.origin);
                let n = null;
                return (
                    t.hash.length && (n = e.replace(t.hash, "")),
                    { hasHash: t.hash.length > 0, pathname: t.pathname, host: t.host, raw: e, href: n || t.href }
                );
            }
            function S(e) {
                "HEAD" === e.parentNode.tagName ? document.head.appendChild(E(e)) : document.body.appendChild(E(e));
            }
            function E(e) {
                const t = document.createElement("SCRIPT");
                for (let n = 0; n < e.attributes.length; n++) {
                    const i = e.attributes[n];
                    t.setAttribute(i.nodeName, i.nodeValue);
                }
                return e.innerHTML && (t.innerHTML = e.innerHTML), t;
            }
            class T {
                constructor({ wrapper: e }) {
                    this.wrapper = e;
                }
                leave(e) {
                    return new Promise((t) => {
                        this.onLeave({ ...e, done: t });
                    });
                }
                enter(e) {
                    return new Promise((t) => {
                        this.onEnter({ ...e, done: t });
                    });
                }
                onLeave({ from: e, trigger: t, done: n }) {
                    n();
                }
                onEnter({ to: e, trigger: t, done: n }) {
                    n();
                }
            }
            class k {
                constructor({ content: e, page: t, title: n, wrapper: i }) {
                    (this._contentString = e.outerHTML),
                        (this._DOM = null),
                        (this.page = t),
                        (this.title = n),
                        (this.wrapper = i),
                        (this.content = this.wrapper.lastElementChild);
                }
                onEnter() {}
                onEnterCompleted() {}
                onLeave() {}
                onLeaveCompleted() {}
                initialLoad() {
                    this.onEnter(), this.onEnterCompleted();
                }
                update() {
                    (document.title = this.title),
                        this.wrapper.appendChild(this._DOM.firstElementChild),
                        (this.content = this.wrapper.lastElementChild),
                        (this._DOM = null);
                }
                createDom() {
                    this._DOM ||
                        ((this._DOM = document.createElement("div")), (this._DOM.innerHTML = this._contentString));
                }
                remove() {
                    this.wrapper.firstElementChild.remove();
                }
                enter(e, t) {
                    return new Promise((n) => {
                        this.onEnter(),
                            e.enter({ trigger: t, to: this.content }).then(() => {
                                this.onEnterCompleted(), n();
                            });
                    });
                }
                leave(e, t, n) {
                    return new Promise((i) => {
                        this.onLeave(),
                            e.leave({ trigger: t, from: this.content }).then(() => {
                                n && this.remove(), this.onLeaveCompleted(), i();
                            });
                    });
                }
            }
            class M {
                data = new Map();
                regexCache = new Map();
                add(e, t, n) {
                    this.data.has(e) || (this.data.set(e, new Map()), this.regexCache.set(e, new RegExp(`^${e}$`))),
                        this.data.get(e).set(t, n),
                        this.regexCache.set(t, new RegExp(`^${t}$`));
                }
                findMatch(e, t) {
                    for (const [n, i] of this.data)
                        if (e.pathname.match(this.regexCache.get(n))) {
                            for (const [e, n] of i) if (t.pathname.match(this.regexCache.get(e))) return n;
                            break;
                        }
                    return null;
                }
            }
            const L = "A transition is currently in progress";
            class A {
                isTransitioning = !1;
                currentCacheEntry = null;
                cache = new Map();
                activePromises = new Map();
                constructor(e = {}) {
                    const {
                        links: t = "a:not([target]):not([href^=\\#]):not([data-taxi-ignore])",
                        removeOldContent: n = !0,
                        allowInterruption: i = !1,
                        bypassCache: s = !1,
                        enablePrefetch: r = !0,
                        renderers: a = { default: k },
                        transitions: o = { default: T },
                        reloadJsFilter: l = (e) => void 0 !== e.dataset.taxiReload,
                        reloadCssFilter: c = (e) => !0,
                    } = e;
                    (this.renderers = a),
                        (this.transitions = o),
                        (this.defaultRenderer = this.renderers.default || k),
                        (this.defaultTransition = this.transitions.default || T),
                        (this.wrapper = document.querySelector("[data-taxi]")),
                        (this.reloadJsFilter = l),
                        (this.reloadCssFilter = c),
                        (this.removeOldContent = n),
                        (this.allowInterruption = i),
                        (this.bypassCache = s),
                        (this.enablePrefetch = r),
                        (this.cache = new Map()),
                        (this.isPopping = !1),
                        this.attachEvents(t),
                        (this.currentLocation = x(window.location.href)),
                        this.cache.set(
                            this.currentLocation.href,
                            this.createCacheEntry(document.cloneNode(!0), window.location.href)
                        ),
                        (this.currentCacheEntry = this.cache.get(this.currentLocation.href)),
                        this.currentCacheEntry.renderer.initialLoad();
                }
                setDefaultRenderer(e) {
                    this.defaultRenderer = this.renderers[e];
                }
                setDefaultTransition(e) {
                    this.defaultTransition = this.transitions[e];
                }
                addRoute(e, t, n) {
                    this.router || (this.router = new M()), this.router.add(e, t, n);
                }
                preload(e, t = !1) {
                    return (
                        (e = x(e).href),
                        this.cache.has(e)
                            ? Promise.resolve()
                            : this.fetch(e, !1).then(async (n) => {
                                  this.cache.set(e, this.createCacheEntry(n.html, n.url)),
                                      t && this.cache.get(e).renderer.createDom();
                              })
                    );
                }
                updateCache(e) {
                    const t = x(e || window.location.href).href;
                    this.cache.has(t) && this.cache.delete(t),
                        this.cache.set(t, this.createCacheEntry(document.cloneNode(!0), t));
                }
                clearCache(e) {
                    const t = x(e || window.location.href).href;
                    this.cache.has(t) && this.cache.delete(t);
                }
                navigateTo(e, t = !1, n = !1) {
                    return new Promise((i, s) => {
                        if (!this.allowInterruption && this.isTransitioning) return void s(new Error(L));
                        (this.isTransitioning = !0),
                            (this.isPopping = !0),
                            (this.targetLocation = x(e)),
                            (this.popTarget = window.location.href);
                        const r = new (this.chooseTransition(t))({ wrapper: this.wrapper });
                        let a;
                        if (
                            this.bypassCache ||
                            !this.cache.has(this.targetLocation.href) ||
                            this.cache.get(this.targetLocation.href).skipCache
                        ) {
                            const e = this.fetch(this.targetLocation.href).then((e) => {
                                this.cache.set(this.targetLocation.href, this.createCacheEntry(e.html, e.url)),
                                    this.cache.get(this.targetLocation.href).renderer.createDom();
                            });
                            a = this.beforeFetch(this.targetLocation, r, n).then(async () =>
                                e.then(
                                    async () =>
                                        await this.afterFetch(
                                            this.targetLocation,
                                            r,
                                            this.cache.get(this.targetLocation.href),
                                            n
                                        )
                                )
                            );
                        } else
                            this.cache.get(this.targetLocation.href).renderer.createDom(),
                                (a = this.beforeFetch(this.targetLocation, r, n).then(
                                    async () =>
                                        await this.afterFetch(
                                            this.targetLocation,
                                            r,
                                            this.cache.get(this.targetLocation.href),
                                            n
                                        )
                                ));
                        a.then(() => {
                            i();
                        });
                    });
                }
                on(e, t) {
                    w.on(e, t);
                }
                off(e, t) {
                    w.off(e, t);
                }
                beforeFetch(e, t, n) {
                    return (
                        w.emit("NAVIGATE_OUT", { from: this.currentCacheEntry, trigger: n }),
                        new Promise((i) => {
                            this.currentCacheEntry.renderer.leave(t, n, this.removeOldContent).then(() => {
                                "popstate" !== n && window.history.pushState({}, "", e.raw), i();
                            });
                        })
                    );
                }
                afterFetch(e, t, n, i) {
                    return (
                        (this.currentLocation = e),
                        (this.popTarget = this.currentLocation.href),
                        new Promise((s) => {
                            n.renderer.update(),
                                w.emit("NAVIGATE_IN", { from: this.currentCacheEntry, to: n, trigger: i }),
                                this.reloadJsFilter && this.loadScripts(n.scripts),
                                this.reloadCssFilter && this.loadStyles(n.styles),
                                "popstate" !== i &&
                                    e.href !== n.finalUrl &&
                                    window.history.replaceState({}, "", n.finalUrl),
                                n.renderer.enter(t, i).then(() => {
                                    w.emit("NAVIGATE_END", { from: this.currentCacheEntry, to: n, trigger: i }),
                                        (this.currentCacheEntry = n),
                                        (this.isTransitioning = !1),
                                        (this.isPopping = !1),
                                        s();
                                });
                        })
                    );
                }
                loadScripts(e) {
                    const t = [...e],
                        n = Array.from(document.querySelectorAll("script")).filter(this.reloadJsFilter);
                    for (let e = 0; e < n.length; e++)
                        for (let s = 0; s < t.length; s++)
                            if (n[e].outerHTML === t[s].outerHTML) {
                                (i = n[e]).parentNode.replaceChild(E(i), i), t.splice(s, 1);
                                break;
                            }
                    var i;
                    for (const e of t) S(e);
                }
                loadStyles(e) {
                    const t = Array.from(document.querySelectorAll('link[rel="stylesheet"]')).filter(
                        this.reloadCssFilter
                    );
                    e.forEach((e) => {
                        e.href && !t.find((t) => t.href === e.href) && document.body.append(e);
                    });
                }
                attachEvents(e) {
                    w.delegate("click", e, this.onClick),
                        w.on("popstate", window, this.onPopstate),
                        this.enablePrefetch && w.delegate("mouseenter focus", e, this.onPrefetch);
                }
                onClick = (e) => {
                    if (!e.metaKey && !e.ctrlKey) {
                        const t = x(e.currentTarget.href);
                        if (((this.currentLocation = x(window.location.href)), this.currentLocation.host !== t.host))
                            return;
                        if (this.currentLocation.href !== t.href || (this.currentLocation.hasHash && !t.hasHash))
                            return (
                                e.preventDefault(),
                                void this.navigateTo(
                                    t.raw,
                                    e.currentTarget.dataset.transition || !1,
                                    e.currentTarget
                                ).catch((e) => console.warn(e))
                            );
                        this.currentLocation.hasHash || t.hasHash || e.preventDefault();
                    }
                };
                onPopstate = () =>
                    !(window.location.pathname === this.currentLocation.pathname && !this.isPopping) &&
                    (this.allowInterruption || (!this.isTransitioning && !this.isPopping)
                        ? (this.isPopping || (this.popTarget = window.location.href),
                          (this.isPopping = !0),
                          void this.navigateTo(window.location.href, !1, "popstate"))
                        : (window.history.pushState({}, "", this.popTarget), console.warn(L), !1));
                onPrefetch = (e) => {
                    const t = x(e.currentTarget.href);
                    this.currentLocation.host === t.host && this.preload(e.currentTarget.href, !1);
                };
                fetch(e, t = !0) {
                    if (this.activePromises.has(e)) return this.activePromises.get(e);
                    const n = new Promise((n, i) => {
                        let s;
                        fetch(e, {
                            mode: "same-origin",
                            method: "GET",
                            headers: { "X-Requested-With": "Taxi" },
                            credentials: "same-origin",
                        })
                            .then(
                                (n) => (
                                    n.ok ||
                                        (i("Taxi encountered a non 2xx HTTP status code"),
                                        t && (window.location.href = e)),
                                    (s = n.url),
                                    n.text()
                                )
                            )
                            .then((e) => {
                                var t;
                                n({
                                    html: ((t = e), "string" == typeof t ? C.parseFromString(t, "text/html") : t),
                                    url: s,
                                });
                            })
                            .catch((n) => {
                                i(n), t && (window.location.href = e);
                            })
                            .finally(() => {
                                this.activePromises.delete(e);
                            });
                    });
                    return this.activePromises.set(e, n), n;
                }
                chooseTransition(e) {
                    if (e) return this.transitions[e];
                    const t = this.router?.findMatch(this.currentLocation, this.targetLocation);
                    return t ? this.transitions[t] : this.defaultTransition;
                }
                createCacheEntry(e, t) {
                    const n = e.querySelector("[data-taxi-view]"),
                        i = n.dataset.taxiView.length ? this.renderers[n.dataset.taxiView] : this.defaultRenderer;
                    return (
                        i ||
                            console.warn(
                                `The Renderer "${n.dataset.taxiView}" was set in the data-taxi-view of the requested page, but not registered in Taxi.`
                            ),
                        {
                            page: e,
                            content: n,
                            finalUrl: t,
                            skipCache: n.hasAttribute("data-taxi-nocache"),
                            scripts: this.reloadJsFilter
                                ? Array.from(e.querySelectorAll("script")).filter(this.reloadJsFilter)
                                : [],
                            styles: this.reloadCssFilter
                                ? Array.from(e.querySelectorAll('link[rel="stylesheet"]')).filter(this.reloadCssFilter)
                                : [],
                            title: e.title,
                            renderer: new i({ wrapper: this.wrapper, title: e.title, content: n, page: e }),
                        }
                    );
                }
            }
            function I(e, t, n) {
                var i,
                    s = n || {},
                    r = s.noTrailing,
                    a = void 0 !== r && r,
                    o = s.noLeading,
                    l = void 0 !== o && o,
                    c = s.debounceMode,
                    d = void 0 === c ? void 0 : c,
                    u = !1,
                    p = 0;
                function h() {
                    i && clearTimeout(i);
                }
                function f() {
                    for (var n = arguments.length, s = new Array(n), r = 0; r < n; r++) s[r] = arguments[r];
                    var o = this,
                        c = Date.now() - p;
                    function f() {
                        (p = Date.now()), t.apply(o, s);
                    }
                    function m() {
                        i = void 0;
                    }
                    u ||
                        (l || !d || i || f(),
                        h(),
                        void 0 === d && c > e
                            ? l
                                ? ((p = Date.now()), a || (i = setTimeout(d ? m : f, e)))
                                : f()
                            : !0 !== a && (i = setTimeout(d ? m : f, void 0 === d ? e - c : e)));
                }
                return (
                    (f.cancel = function (e) {
                        var t = (e || {}).upcomingOnly,
                            n = void 0 !== t && t;
                        h(), (u = !n);
                    }),
                    f
                );
            }
            n(90);
            const _ = $(window);
            let P = window.innerWidth;
            const D = { xs: 0, sm: 576, md: 768, lg: 980, xl: 1280, xxl: 1480, xxxl: 1800 },
                O = "breakpointChange";
            function N(e) {
                const t = e || window.innerWidth;
                let n;
                return (
                    $.each(D, (e, i) => {
                        t >= i && (n = e);
                    }),
                    n
                );
            }
            function F() {
                const e = window.innerWidth,
                    t = N(P),
                    n = N(e);
                $.each(D, (i, s) => {
                    if ((e >= s && P < s) || (P >= s && e < s)) {
                        const i = $.Event(O, { bpMinWidthKey: n, newBp: n, oldBp: t, direction: e > P ? 1 : -1 });
                        return _.trigger(i), !1;
                    }
                }),
                    (P = window.innerWidth);
            }
            const j = {
                easeInCubic: function (e, t, n, i, s) {
                    return i * (t /= s) * t * t + n;
                },
                easeOutCubic: function (e, t, n, i, s) {
                    return i * ((t = t / s - 1) * t * t + 1) + n;
                },
                easeInOutCubic: function (e, t, n, i, s) {
                    return (t /= s / 2) < 1 ? (i / 2) * t * t * t + n : (i / 2) * ((t -= 2) * t * t + 2) + n;
                },
                easeOutQuart: function (e, t, n, i, s) {
                    return -i * ((t = t / s - 1) * t * t * t - 1) + n;
                },
            };
            function z() {
                $.extend($.easing, j);
            }
            function B(e) {
                const t = "js-focus-hidden";
                e.first()
                    .attr("tabIndex", "-1")
                    .focus()
                    .addClass(t)
                    .one("blur", function () {
                        e.first().removeClass(t).removeAttr("tabindex");
                    });
            }
            function q() {
                const e = (window.location.search && window.location.search.substr(1)) || "",
                    t = {};
                return (
                    e
                        .split("&")
                        .filter((e) => e.length)
                        .forEach((e) => {
                            const n = e.split("=");
                            n.length > 1 ? (t[n[0]] = n[1]) : (t[n[0]] = !0);
                        }),
                    t
                );
            }
            function H() {
                for (var e = document.getElementsByTagName("a"), t = 0; t < e.length; t++) {
                    var n = e[t];
                    n.getAttribute("href") &&
                        n.hostname !== location.hostname &&
                        ((n.target = "_blank"), n.setAttribute("aria-label", "Link opens in a new window"));
                }
            }
            function R() {
                const e = window.innerWidth <= 1024 ? "".concat(window.innerHeight, "px") : "100vh";
                document.documentElement.style.getPropertyValue("--viewport-height") ||
                    document.documentElement.style.setProperty("--viewport-height", e);
            }
            class V {
                constructor(e, t) {
                    (this.$container = e instanceof $ ? e : $(e)),
                        (this.id = this.$container.data("section-id")),
                        (this.type = this.$container.data("section-type")),
                        (this.name = t),
                        (this.namespace = ".".concat(this.name)),
                        (this.events = {
                            SCROLL: "scroll".concat(this.namespace),
                            CLICK: "click".concat(this.namespace),
                            RESIZE: "resize".concat(this.namespace),
                            MOUSEENTER: "mouseenter".concat(this.namespace),
                            MOUSELEAVE: "mouseleave".concat(this.namespace),
                        });
                }
                onUnload(e) {
                    console.log('Unloading "'.concat(this.name, '"'));
                }
                onSelect(e) {}
                onDeselect(e) {}
                onReorder(e) {}
                onBlockSelect(e) {}
                onBlockDeselect(e) {}
            }
            const G = "data-section-type",
                W = "data-section-id",
                U = $(document);
            class X {
                constructor() {
                    (this.constructors = {}),
                        (this.instances = []),
                        (this.handlers = {
                            sectionLoad: this.onSectionLoad.bind(this),
                            sectionUnload: this.onSectionUnload.bind(this),
                            select: this.onSelect.bind(this),
                            deselect: this.onDeselect.bind(this),
                            reorder: this.onReorder.bind(this),
                            blockSelect: this.onBlockSelect.bind(this),
                            blockDeselect: this.onBlockDeselect.bind(this),
                        }),
                        window.Shopify &&
                            window.Shopify.designMode &&
                            U.on("shopify:section:load", this.handlers.sectionLoad)
                                .on("shopify:section:unload", this.handlers.sectionUnload)
                                .on("shopify:section:select", this.handlers.select)
                                .on("shopify:section:deselect", this.handlers.deselect)
                                .on("shopify:section:reorder", this.handlers.reorder)
                                .on("shopify:block:select", this.handlers.blockSelect)
                                .on("shopify:block:deselect", this.handlers.blockDeselect);
                }
                destroy() {
                    this.instances.forEach((e) => {
                        e.onUnload && e.onUnload();
                    }),
                        U.off("shopify:section:load", this.handlers.sectionLoad)
                            .off("shopify:section:unload", this.handlers.sectionUnload)
                            .off("shopify:section:select", this.handlers.select)
                            .off("shopify:section:deselect", this.handlers.deselect)
                            .off("shopify:section:reorder", this.handlers.reorder)
                            .off("shopify:block:select", this.handlers.blockSelect)
                            .off("shopify:block:deselect", this.handlers.blockDeselect);
                }
                getInstanceById(e) {
                    let t;
                    for (let n = 0; n < this.instances.length; n++)
                        if (this.instances[n].id === e) {
                            t = this.instances[n];
                            break;
                        }
                    return t;
                }
                getSingleInstance(e) {
                    let t;
                    for (let n = 0; n < this.instances.length; n++)
                        if (this.instances[n].type === e) {
                            t = this.instances[n];
                            break;
                        }
                    return t;
                }
                load(e, t) {
                    const n = $(e),
                        i = n.attr(W),
                        s = n.attr(G),
                        r = t || this.constructors[s];
                    if (void 0 === r) return;
                    const a = $.extend(new r(e), { id: i, type: s, container: e });
                    this.instances.push(a);
                }
                unload(e) {
                    let t = this.instances.length;
                    for (; t--; )
                        if (this.instances[t].id === e) {
                            this.instances.splice(t, 1);
                            break;
                        }
                }
                onSectionLoad(e) {
                    const t = $("[".concat(W, "]"), e.target)[0];
                    t && this.load(t);
                }
                onSectionUnload(e) {
                    const t = this.getInstanceById(e.detail.sectionId);
                    t && (t.onUnload(e), this.unload(e.detail.sectionId));
                }
                onGenericEvent(e, t) {
                    const n = this.getInstanceById(e.detail.sectionId);
                    n && "function" == typeof n[t] && n[t].call(n, e);
                }
                onSelect(e) {
                    this.onGenericEvent(e, "onSelect");
                }
                onDeselect(e) {
                    this.onGenericEvent(e, "onDeselect");
                }
                onReorder(e) {
                    this.onGenericEvent(e, "onReorder");
                }
                onBlockSelect(e) {
                    this.onGenericEvent(e, "onBlockSelect");
                }
                onBlockDeselect(e) {
                    this.onGenericEvent(e, "onBlockDeselect");
                }
                register(e, t) {
                    t.prototype instanceof V &&
                        ((this.constructors[e] = t),
                        $("[".concat(G, "=").concat(e, "]")).each((e, n) => {
                            this.load(n, t);
                        }));
                }
            }
            class Y extends k {
                constructor(e) {
                    super(e), (this.sectionManager = new X());
                }
                onEnter() {}
                onEnterCompleted() {}
                onLeave() {
                    this.sectionManager.destroy();
                }
                onLeaveCompleted() {}
            }
            class K {
                constructor(e) {
                    this.$el = $(e);
                }
                destroy() {}
            }
            function Q(e, t) {
                "string" == typeof e && (e = e.replace(".", ""));
                let n = "";
                const i = /\{\{\s*(\w+)\s*\}\}/,
                    s = t || "${{amount}}";
                function r(e) {
                    let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 2,
                        n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : ",",
                        i = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : ".";
                    if (Number.isNaN(e) || null == e) return 0;
                    const s = (e = (e / 100).toFixed(t)).split(".");
                    return s[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1".concat(n)) + (s[1] ? i + s[1] : "");
                }
                switch (s.match(i)[1]) {
                    case "amount":
                        n = r(e, 2);
                        break;
                    case "amount_no_decimals":
                        n = r(e, 0);
                        break;
                    case "amount_with_space_separator":
                        n = r(e, 2, " ", ".");
                        break;
                    case "amount_no_decimals_with_comma_separator":
                        n = r(e, 0, ",", ".");
                        break;
                    case "amount_no_decimals_with_space_separator":
                        n = r(e, 0, " ");
                }
                return s.replace(i, n);
            }
            function J(e) {
                return e.replace(/http(s)?:/, "");
            }
            function Z(e, t) {
                if (null === t || null === e) return e;
                if ("master" === t) return J(e);
                const n = e.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif|webp)(\?v=\d+)?$/i);
                let i = null;
                if (n) {
                    const s = e.split(n[0]),
                        r = n[0];
                    i = J(s[0] + "_" + t + r);
                }
                return i;
            }
            const ee = () => {
                    const e = $.Deferred();
                    return (
                        $.ajax({
                            type: "get",
                            url: "/cart?view=json",
                            success: (t) => {
                                t = t.replace(/<\/?[^>]+>/gi, "");
                                const n = JSON.parse(t);
                                e.resolve(
                                    ((e) => (
                                        (e && e.is_formatted) ||
                                            ((e.total_price = Q(e.total_price, app.moneyFormat)),
                                            e.items.map((e) => {
                                                if (
                                                    ((e.image = Z(e.image, "500x")),
                                                    (e.imageV2.url = Z(e.imageV2.url, "500x")),
                                                    (e.price = Q(e.price, app.moneyFormat)),
                                                    (e.multiple_quantities = e.quantity > 1),
                                                    e.hasOwnProperty("product"))
                                                ) {
                                                    const t = e.product;
                                                    for (let n = e.variant_options.length - 1; n >= 0; n--) {
                                                        const i = t.options[n],
                                                            s = e.variant_options[n];
                                                        (e.variant_options[n] = { name: i, value: s }),
                                                            "Default Title" === s && delete e.variant_options[n];
                                                    }
                                                } else delete e.variant_options;
                                                return (
                                                    "Default Title" === e.variant_title && (e.variant_title = null), e
                                                );
                                            }),
                                            (e.is_formatted = !0)),
                                        e
                                    ))(n)
                                );
                            },
                            error: () => {
                                e.reject({ message: "Could not retrieve cart items" });
                            },
                        }),
                        e
                    );
                },
                te = $(window),
                ne = $(document.body),
                ie = "addStart.ajaxFormManager",
                se = "addDone.ajaxFormManager",
                re = "addSuccess.ajaxFormManager",
                ae = "addFail.ajaxFormManager";
            class oe {
                constructor() {
                    let e = !1;
                    ne.on("submit", 'form[action*="/cart/add"]', (t) => {
                        if ((t.preventDefault(), e)) return;
                        const n = $(t.currentTarget),
                            i = n.find('[type="submit"]'),
                            s = $.Event(ie, { relatedTarget: n });
                        te.trigger(s),
                            i.prop("disabled", !0),
                            (e = !0),
                            ((e) => {
                                const t = $.Deferred();
                                return (
                                    $.ajax({
                                        type: "post",
                                        dataType: "json",
                                        url: "/cart/add.js",
                                        data: e.serialize(),
                                        success: () => {
                                            ee().then((e) => {
                                                t.resolve(e);
                                            });
                                        },
                                        error: () => {
                                            t.reject({ message: "The quantity you entered is not available." });
                                        },
                                    }),
                                    t
                                );
                            })(n)
                                .always(() => {
                                    i.prop("disabled", !1), (e = !1);
                                    const t = $.Event(se, { relatedTarget: n });
                                    te.trigger(t);
                                })
                                .then((e) => {
                                    const t = $.Event(re, { cart: e, relatedTarget: n });
                                    te.trigger(t);
                                })
                                .fail((e) => {
                                    const t = $.Event(ae, {
                                        message: e.message,
                                        description: e.description,
                                        relatedTarget: n,
                                    });
                                    te.trigger(t);
                                });
                    });
                }
            }
            class le {
                constructor(e) {
                    (this.$container = e.$container),
                        (this.product = e.product),
                        (this.singleOptionSelector = e.singleOptionSelector),
                        (this.originalSelectorId = e.originalSelectorId),
                        (this.enableHistoryState = e.enableHistoryState),
                        (this.currentVariant = this._getVariantFromOptions()),
                        $(this.singleOptionSelector, this.$container).on("change", this._onSelectChange.bind(this));
                }
                _getCurrentOptions() {
                    let e = $.map($(this.singleOptionSelector, this.$container), (e) => {
                        const t = $(e),
                            n = t.attr("type"),
                            i = {};
                        return "radio" === n || "checkbox" === n
                            ? !!t[0].checked && ((i.value = t.val()), (i.index = t.data("index")), i)
                            : ((i.value = t.val()), (i.index = t.data("index")), i);
                    });
                    return (
                        (e = (function (e) {
                            let t = -1,
                                n = 0;
                            const i = null == e ? 0 : e.length,
                                s = [];
                            for (; ++t < i; ) {
                                const i = e[t];
                                i && (s[n++] = i);
                            }
                            return s;
                        })(e)),
                        e
                    );
                }
                _getVariantFromOptions() {
                    const e = this._getCurrentOptions(),
                        t = this.product.variants;
                    let n = !1;
                    return (
                        t.forEach((t) => {
                            let i = !0;
                            e.forEach((e) => {
                                i && (i = e.value === t[e.index]);
                            }),
                                i && (n = t);
                        }),
                        n || null
                    );
                }
                _onSelectChange() {
                    const e = this._getVariantFromOptions();
                    this.$container.trigger({ type: "variantChange", variant: e }),
                        e &&
                            (this._updateMasterSelect(e),
                            this._updateImages(e),
                            this._updatePrice(e),
                            (this.currentVariant = e),
                            this.enableHistoryState && this._updateHistoryState(e));
                }
                _updateImages(e) {
                    const t = e.featured_image || {},
                        n = this.currentVariant.featured_image || {};
                    e.featured_image &&
                        t.src !== n.src &&
                        this.$container.trigger({ type: "variantImageChange", variant: e });
                }
                _updatePrice(e) {
                    (e.price === this.currentVariant.price &&
                        e.compare_at_price === this.currentVariant.compare_at_price) ||
                        this.$container.trigger({ type: "variantPriceChange", variant: e });
                }
                _updateHistoryState(e) {
                    if (!window.history.replaceState || !e) return;
                    const t =
                        window.location.protocol +
                        "//" +
                        window.location.host +
                        window.location.pathname +
                        "?variant=" +
                        e.id;
                    window.history.replaceState({ path: t }, "", t);
                }
                _updateMasterSelect(e) {
                    $(this.originalSelectorId, this.$container)[0].value = e.id;
                }
            }
            class ce {
                constructor(e) {
                    (this.$el = $(e)),
                        (this.$price = $("[data-price]", this.$el)),
                        (this.$compareText = $("[data-compare-text]", this.$el)),
                        (this.$comparePrice = $("[data-compare-price]", this.$el)),
                        (this.$compareEls = this.$comparePrice.add(this.$compareText));
                }
                update(e) {
                    e
                        ? (this.$price.html(e.price_formatted),
                          e.compare_at_price > e.price
                              ? (this.$comparePrice.html(e.compare_at_price_formatted), this.$compareEls.show())
                              : (this.$comparePrice.html(""), this.$compareEls.hide()),
                          this.$el.show())
                        : this.$el.hide();
                }
            }
            const de = "[data-single-option-selector]",
                ue = "[data-variant-option-value-list][data-option-position]",
                pe = "is-active",
                he = $(window);
            class fe {
                constructor(e, t) {
                    (this.settings = $.extend({}, { onVariantChange: () => {}, enableHistoryState: !1 }, t)),
                        (this.$el = $(e)),
                        (this.$form = $("form[data-add-to-cart-form]", this.$el)),
                        (this.$singleOptionSelectors = $(de, this.$el)),
                        (this.$variantOptionValueList = $(ue, this.$el)),
                        (this.$productDetailPrice = $("[data-product-detail-price]", this.$el)),
                        (this.$addToCartBtn = $("[data-add-to-cart-btn]", this.$el)),
                        (this.$addToCartBtnText = $("[data-add-to-cart-text]", this.$el)),
                        (this.product = JSON.parse($("[data-product-json]", this.$el).html())),
                        (this.price = new ce(this.$productDetailPrice)),
                        (this.variants = new le({
                            $container: this.$el,
                            enableHistoryState: this.settings.enableHistoryState,
                            singleOptionSelector: de,
                            originalSelectorId: "[data-product-select]",
                            product: this.product,
                        })),
                        (this.onAddStart = this.onAddStart.bind(this)),
                        (this.onAddDone = this.onAddDone.bind(this)),
                        this.$el.on("variantChange", this.onVariantChange.bind(this)),
                        this.$el.on("click", "[data-variant-option-value]", this.onVariantOptionValueClick.bind(this)),
                        he.on(ie, this.onAddStart),
                        he.on(se, this.onAddDone);
                }
                destroy() {
                    he.off(ie, this.onAddStart), he.off(se, this.onAddDone);
                }
                updateVariantOptionValues(e) {
                    if ((console.log("variant", e), e))
                        for (let t = 1; t <= 3; t++) {
                            const n = e["option".concat(t)];
                            if (!n) break;
                            const i = this.$variantOptionValueList
                                .filter('[data-option-position="'.concat(t, '"]'))
                                .find('[data-variant-option-value="' + n + '"]');
                            i.addClass(pe), i.siblings().removeClass(pe);
                        }
                }
                updateAddToCartState(e) {
                    let t = "",
                        n = !1;
                    e
                        ? e.available
                            ? ((n = !1), (t = app.strings.addToCart))
                            : ((n = !0), (t = app.strings.soldOut))
                        : ((n = !0), (t = app.strings.unavailable)),
                        this.$addToCartBtn.prop("disabled", n),
                        this.$addToCartBtnText.text(t);
                }
                onVariantChange(e) {
                    let { variant: t } = e;
                    this.updateVariantOptionValues(t),
                        this.updateAddToCartState(t),
                        this.price.update(t),
                        this.settings.onVariantChange(t);
                }
                onVariantOptionValueClick(e) {
                    const t = $(e.currentTarget);
                    if (t.hasClass(pe) || t.hasClass("is-disabled")) return;
                    const n = t.data("variant-option-value"),
                        i = t.parents(ue).data("option-position");
                    this.$singleOptionSelectors.filter('[data-index="option'.concat(i, '"]')).val(n).trigger("change"),
                        t.addClass(pe),
                        t.siblings().removeClass(pe);
                }
                onAddStart(e) {
                    let { relatedTarget: t } = e;
                    this.$form.is(t) && this.$addToCartBtnText.text("Adding...");
                }
                onAddDone(e) {
                    let { relatedTarget: t } = e;
                    this.$form.is(t) && this.$addToCartBtnText.text("Add to Cart");
                }
            }
            function me() {
                return (
                    (me = Object.assign
                        ? Object.assign.bind()
                        : function (e) {
                              for (var t = 1; t < arguments.length; t++) {
                                  var n = arguments[t];
                                  for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (e[i] = n[i]);
                              }
                              return e;
                          }),
                    me.apply(this, arguments)
                );
            }
            var ge = {
                    strings: [
                        "These are the default values...",
                        "You know what you should do?",
                        "Use your own!",
                        "Have a great day!",
                    ],
                    stringsElement: null,
                    typeSpeed: 0,
                    startDelay: 0,
                    backSpeed: 0,
                    smartBackspace: !0,
                    shuffle: !1,
                    backDelay: 700,
                    fadeOut: !1,
                    fadeOutClass: "typed-fade-out",
                    fadeOutDelay: 500,
                    loop: !1,
                    loopCount: 1 / 0,
                    showCursor: !0,
                    cursorChar: "|",
                    autoInsertCss: !0,
                    attr: null,
                    bindInputFocusEvents: !1,
                    contentType: "html",
                    onBegin: function (e) {},
                    onComplete: function (e) {},
                    preStringTyped: function (e, t) {},
                    onStringTyped: function (e, t) {},
                    onLastStringBackspaced: function (e) {},
                    onTypingPaused: function (e, t) {},
                    onTypingResumed: function (e, t) {},
                    onReset: function (e) {},
                    onStop: function (e, t) {},
                    onStart: function (e, t) {},
                    onDestroy: function (e) {},
                },
                ve = new ((function () {
                    function e() {}
                    var t = e.prototype;
                    return (
                        (t.load = function (e, t, n) {
                            if (
                                ((e.el = "string" == typeof n ? document.querySelector(n) : n),
                                (e.options = me({}, ge, t)),
                                (e.isInput = "input" === e.el.tagName.toLowerCase()),
                                (e.attr = e.options.attr),
                                (e.bindInputFocusEvents = e.options.bindInputFocusEvents),
                                (e.showCursor = !e.isInput && e.options.showCursor),
                                (e.cursorChar = e.options.cursorChar),
                                (e.cursorBlinking = !0),
                                (e.elContent = e.attr ? e.el.getAttribute(e.attr) : e.el.textContent),
                                (e.contentType = e.options.contentType),
                                (e.typeSpeed = e.options.typeSpeed),
                                (e.startDelay = e.options.startDelay),
                                (e.backSpeed = e.options.backSpeed),
                                (e.smartBackspace = e.options.smartBackspace),
                                (e.backDelay = e.options.backDelay),
                                (e.fadeOut = e.options.fadeOut),
                                (e.fadeOutClass = e.options.fadeOutClass),
                                (e.fadeOutDelay = e.options.fadeOutDelay),
                                (e.isPaused = !1),
                                (e.strings = e.options.strings.map(function (e) {
                                    return e.trim();
                                })),
                                (e.stringsElement =
                                    "string" == typeof e.options.stringsElement
                                        ? document.querySelector(e.options.stringsElement)
                                        : e.options.stringsElement),
                                e.stringsElement)
                            ) {
                                (e.strings = []),
                                    (e.stringsElement.style.cssText =
                                        "clip: rect(0 0 0 0);clip-path:inset(50%);height:1px;overflow:hidden;position:absolute;white-space:nowrap;width:1px;");
                                var i = Array.prototype.slice.apply(e.stringsElement.children),
                                    s = i.length;
                                if (s) for (var r = 0; r < s; r += 1) e.strings.push(i[r].innerHTML.trim());
                            }
                            for (var a in ((e.strPos = 0),
                            (e.currentElContent = this.getCurrentElContent(e)),
                            e.currentElContent &&
                                e.currentElContent.length > 0 &&
                                ((e.strPos = e.currentElContent.length - 1), e.strings.unshift(e.currentElContent)),
                            (e.sequence = []),
                            e.strings))
                                e.sequence[a] = a;
                            (e.arrayPos = 0),
                                (e.stopNum = 0),
                                (e.loop = e.options.loop),
                                (e.loopCount = e.options.loopCount),
                                (e.curLoop = 0),
                                (e.shuffle = e.options.shuffle),
                                (e.pause = { status: !1, typewrite: !0, curString: "", curStrPos: 0 }),
                                (e.typingComplete = !1),
                                (e.autoInsertCss = e.options.autoInsertCss),
                                e.autoInsertCss &&
                                    (this.appendCursorAnimationCss(e), this.appendFadeOutAnimationCss(e));
                        }),
                        (t.getCurrentElContent = function (e) {
                            return e.attr
                                ? e.el.getAttribute(e.attr)
                                : e.isInput
                                  ? e.el.value
                                  : "html" === e.contentType
                                    ? e.el.innerHTML
                                    : e.el.textContent;
                        }),
                        (t.appendCursorAnimationCss = function (e) {
                            var t = "data-typed-js-cursor-css";
                            if (e.showCursor && !document.querySelector("[" + t + "]")) {
                                var n = document.createElement("style");
                                n.setAttribute(t, "true"),
                                    (n.innerHTML =
                                        "\n        .typed-cursor{\n          opacity: 1;\n        }\n        .typed-cursor.typed-cursor--blink{\n          animation: typedjsBlink 0.7s infinite;\n          -webkit-animation: typedjsBlink 0.7s infinite;\n                  animation: typedjsBlink 0.7s infinite;\n        }\n        @keyframes typedjsBlink{\n          50% { opacity: 0.0; }\n        }\n        @-webkit-keyframes typedjsBlink{\n          0% { opacity: 1; }\n          50% { opacity: 0.0; }\n          100% { opacity: 1; }\n        }\n      "),
                                    document.body.appendChild(n);
                            }
                        }),
                        (t.appendFadeOutAnimationCss = function (e) {
                            var t = "data-typed-fadeout-js-css";
                            if (e.fadeOut && !document.querySelector("[" + t + "]")) {
                                var n = document.createElement("style");
                                n.setAttribute(t, "true"),
                                    (n.innerHTML =
                                        "\n        .typed-fade-out{\n          opacity: 0;\n          transition: opacity .25s;\n        }\n        .typed-cursor.typed-cursor--blink.typed-fade-out{\n          -webkit-animation: 0;\n          animation: 0;\n        }\n      "),
                                    document.body.appendChild(n);
                            }
                        }),
                        e
                    );
                })())(),
                ye = new ((function () {
                    function e() {}
                    var t = e.prototype;
                    return (
                        (t.typeHtmlChars = function (e, t, n) {
                            if ("html" !== n.contentType) return t;
                            var i = e.substring(t).charAt(0);
                            if ("<" === i || "&" === i) {
                                var s;
                                for (
                                    s = "<" === i ? ">" : ";";
                                    e.substring(t + 1).charAt(0) !== s && !(1 + ++t > e.length);

                                );
                                t++;
                            }
                            return t;
                        }),
                        (t.backSpaceHtmlChars = function (e, t, n) {
                            if ("html" !== n.contentType) return t;
                            var i = e.substring(t).charAt(0);
                            if (">" === i || ";" === i) {
                                var s;
                                for (s = ">" === i ? "<" : "&"; e.substring(t - 1).charAt(0) !== s && !(--t < 0); );
                                t--;
                            }
                            return t;
                        }),
                        e
                    );
                })())(),
                be = (function () {
                    function e(e, t) {
                        ve.load(this, t, e), this.begin();
                    }
                    var t = e.prototype;
                    return (
                        (t.toggle = function () {
                            this.pause.status ? this.start() : this.stop();
                        }),
                        (t.stop = function () {
                            this.typingComplete ||
                                this.pause.status ||
                                (this.toggleBlinking(!0),
                                (this.pause.status = !0),
                                this.options.onStop(this.arrayPos, this));
                        }),
                        (t.start = function () {
                            this.typingComplete ||
                                (this.pause.status &&
                                    ((this.pause.status = !1),
                                    this.pause.typewrite
                                        ? this.typewrite(this.pause.curString, this.pause.curStrPos)
                                        : this.backspace(this.pause.curString, this.pause.curStrPos),
                                    this.options.onStart(this.arrayPos, this)));
                        }),
                        (t.destroy = function () {
                            this.reset(!1), this.options.onDestroy(this);
                        }),
                        (t.reset = function (e) {
                            void 0 === e && (e = !0),
                                clearInterval(this.timeout),
                                this.replaceText(""),
                                this.cursor &&
                                    this.cursor.parentNode &&
                                    (this.cursor.parentNode.removeChild(this.cursor), (this.cursor = null)),
                                (this.strPos = 0),
                                (this.arrayPos = 0),
                                (this.curLoop = 0),
                                e && (this.insertCursor(), this.options.onReset(this), this.begin());
                        }),
                        (t.begin = function () {
                            var e = this;
                            this.options.onBegin(this),
                                (this.typingComplete = !1),
                                this.shuffleStringsIfNeeded(this),
                                this.insertCursor(),
                                this.bindInputFocusEvents && this.bindFocusEvents(),
                                (this.timeout = setTimeout(function () {
                                    0 === e.strPos
                                        ? e.typewrite(e.strings[e.sequence[e.arrayPos]], e.strPos)
                                        : e.backspace(e.strings[e.sequence[e.arrayPos]], e.strPos);
                                }, this.startDelay));
                        }),
                        (t.typewrite = function (e, t) {
                            var n = this;
                            this.fadeOut &&
                                this.el.classList.contains(this.fadeOutClass) &&
                                (this.el.classList.remove(this.fadeOutClass),
                                this.cursor && this.cursor.classList.remove(this.fadeOutClass));
                            var i = this.humanizer(this.typeSpeed),
                                s = 1;
                            !0 !== this.pause.status
                                ? (this.timeout = setTimeout(function () {
                                      t = ye.typeHtmlChars(e, t, n);
                                      var i = 0,
                                          r = e.substring(t);
                                      if ("^" === r.charAt(0) && /^\^\d+/.test(r)) {
                                          var a = 1;
                                          (a += (r = /\d+/.exec(r)[0]).length),
                                              (i = parseInt(r)),
                                              (n.temporaryPause = !0),
                                              n.options.onTypingPaused(n.arrayPos, n),
                                              (e = e.substring(0, t) + e.substring(t + a)),
                                              n.toggleBlinking(!0);
                                      }
                                      if ("`" === r.charAt(0)) {
                                          for (; "`" !== e.substring(t + s).charAt(0) && (s++, !(t + s > e.length)); );
                                          var o = e.substring(0, t),
                                              l = e.substring(o.length + 1, t + s),
                                              c = e.substring(t + s + 1);
                                          (e = o + l + c), s--;
                                      }
                                      n.timeout = setTimeout(function () {
                                          n.toggleBlinking(!1),
                                              t >= e.length ? n.doneTyping(e, t) : n.keepTyping(e, t, s),
                                              n.temporaryPause &&
                                                  ((n.temporaryPause = !1), n.options.onTypingResumed(n.arrayPos, n));
                                      }, i);
                                  }, i))
                                : this.setPauseStatus(e, t, !0);
                        }),
                        (t.keepTyping = function (e, t, n) {
                            0 === t && (this.toggleBlinking(!1), this.options.preStringTyped(this.arrayPos, this));
                            var i = e.substring(0, (t += n));
                            this.replaceText(i), this.typewrite(e, t);
                        }),
                        (t.doneTyping = function (e, t) {
                            var n = this;
                            this.options.onStringTyped(this.arrayPos, this),
                                this.toggleBlinking(!0),
                                (this.arrayPos === this.strings.length - 1 &&
                                    (this.complete(), !1 === this.loop || this.curLoop === this.loopCount)) ||
                                    (this.timeout = setTimeout(function () {
                                        n.backspace(e, t);
                                    }, this.backDelay));
                        }),
                        (t.backspace = function (e, t) {
                            var n = this;
                            if (!0 !== this.pause.status) {
                                if (this.fadeOut) return this.initFadeOut();
                                this.toggleBlinking(!1);
                                var i = this.humanizer(this.backSpeed);
                                this.timeout = setTimeout(function () {
                                    t = ye.backSpaceHtmlChars(e, t, n);
                                    var i = e.substring(0, t);
                                    if ((n.replaceText(i), n.smartBackspace)) {
                                        var s = n.strings[n.arrayPos + 1];
                                        n.stopNum = s && i === s.substring(0, t) ? t : 0;
                                    }
                                    t > n.stopNum
                                        ? (t--, n.backspace(e, t))
                                        : t <= n.stopNum &&
                                          (n.arrayPos++,
                                          n.arrayPos === n.strings.length
                                              ? ((n.arrayPos = 0),
                                                n.options.onLastStringBackspaced(),
                                                n.shuffleStringsIfNeeded(),
                                                n.begin())
                                              : n.typewrite(n.strings[n.sequence[n.arrayPos]], t));
                                }, i);
                            } else this.setPauseStatus(e, t, !1);
                        }),
                        (t.complete = function () {
                            this.options.onComplete(this), this.loop ? this.curLoop++ : (this.typingComplete = !0);
                        }),
                        (t.setPauseStatus = function (e, t, n) {
                            (this.pause.typewrite = n), (this.pause.curString = e), (this.pause.curStrPos = t);
                        }),
                        (t.toggleBlinking = function (e) {
                            this.cursor &&
                                (this.pause.status ||
                                    (this.cursorBlinking !== e &&
                                        ((this.cursorBlinking = e),
                                        e
                                            ? this.cursor.classList.add("typed-cursor--blink")
                                            : this.cursor.classList.remove("typed-cursor--blink"))));
                        }),
                        (t.humanizer = function (e) {
                            return Math.round((Math.random() * e) / 2) + e;
                        }),
                        (t.shuffleStringsIfNeeded = function () {
                            this.shuffle &&
                                (this.sequence = this.sequence.sort(function () {
                                    return Math.random() - 0.5;
                                }));
                        }),
                        (t.initFadeOut = function () {
                            var e = this;
                            return (
                                (this.el.className += " " + this.fadeOutClass),
                                this.cursor && (this.cursor.className += " " + this.fadeOutClass),
                                setTimeout(function () {
                                    e.arrayPos++,
                                        e.replaceText(""),
                                        e.strings.length > e.arrayPos
                                            ? e.typewrite(e.strings[e.sequence[e.arrayPos]], 0)
                                            : (e.typewrite(e.strings[0], 0), (e.arrayPos = 0));
                                }, this.fadeOutDelay)
                            );
                        }),
                        (t.replaceText = function (e) {
                            this.attr
                                ? this.el.setAttribute(this.attr, e)
                                : this.isInput
                                  ? (this.el.value = e)
                                  : "html" === this.contentType
                                    ? (this.el.innerHTML = e)
                                    : (this.el.textContent = e);
                        }),
                        (t.bindFocusEvents = function () {
                            var e = this;
                            this.isInput &&
                                (this.el.addEventListener("focus", function (t) {
                                    e.stop();
                                }),
                                this.el.addEventListener("blur", function (t) {
                                    (e.el.value && 0 !== e.el.value.length) || e.start();
                                }));
                        }),
                        (t.insertCursor = function () {
                            this.showCursor &&
                                (this.cursor ||
                                    ((this.cursor = document.createElement("span")),
                                    (this.cursor.className = "typed-cursor"),
                                    this.cursor.setAttribute("aria-hidden", !0),
                                    (this.cursor.innerHTML = this.cursorChar),
                                    this.el.parentNode &&
                                        this.el.parentNode.insertBefore(this.cursor, this.el.nextSibling)));
                        }),
                        e
                    );
                })();
            class we {
                constructor(e) {
                    (this.$el = $(e)),
                        (this.$typeText = $("[data-type-Text]", this.$el)),
                        this.showMessageWithAnimation("If you can make someones day you should");
                }
                showMessageWithAnimation(e) {
                    this.typed && this.typed.destroy(),
                        (this.typed = new be(this.$typeText.get(0), {
                            strings: ["".concat(e)],
                            typeSpeed: 50,
                            startDelay: 0,
                            backSpeed: 0,
                            smartBackspace: !1,
                            showCursor: !0,
                            cursorChar: "_",
                            loop: !1,
                            onStringTyped: () => {
                                this.typed.stop();
                            },
                            onComplete: () => {},
                        }));
                }
                destroy() {}
            }
            class Ce extends V {
                constructor(e) {
                    super(e, "collection"),
                        (this.productCards = this.$container.find("[data-product-card]").map((e, t) => new K(t))),
                        this.$container.find("[data-quick-add]").map((e, t) => {
                            new fe(t);
                        }),
                        (this.typeText = new we(this.$container.find("[data-type]")));
                }
                onUnload() {
                    console.log("unloading", this.productCards);
                }
            }
            const xe = "is-open",
                Se = $(window);
            class Ee {
                constructor(e) {
                    let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                    (this.$el = $(e)),
                        (this.$header = $(".expander__header", this.$el)),
                        (this.$body = $(".expander__body", this.$el)),
                        (this.$mobileAddStart = $(".mobileAddStart", this.$el));
                    const n = { onClick: $.noop };
                    (this.settings = { ...n, ...t }),
                        (this.isOpen = !1),
                        "open" == this.$el.data("default") && this.open(!0),
                        (this.$quickAddBtnText = $("[data-quick-add-text]", this.$el)),
                        Se.on(ie, this.onQuickAddStart.bind(this)),
                        Se.on(se, this.onQuickAddDone.bind(this)),
                        this.$header.on("click", this.onClick.bind(this));
                }
                destroy() {
                    Se.off(ie, this.onQuickAddStart), Se.off(se, this.onQuickAddDone);
                }
                onClick() {
                    this.settings.onClick(this);
                }
                open() {
                    this.isOpen ||
                        (this.$body.stop(),
                        this.$body.slideDown({
                            duration: 400,
                            easing: "easeOutQuart",
                            start: () => {
                                this.$el.addClass(xe);
                            },
                        }),
                        this.$header.attr("aria-expanded", !0),
                        (this.isOpen = !0));
                }
                close() {
                    this.isOpen &&
                        (this.$body.stop(),
                        this.$body.slideUp({
                            duration: 400,
                            easing: "easeOutQuart",
                            start: () => {
                                this.$el.removeClass(xe);
                            },
                        }),
                        this.$header.attr("aria-expanded", !1),
                        (this.isOpen = !1));
                }
                onQuickAddStart() {
                    this.isOpen &&
                        (this.$body.stop(),
                        this.$body.slideUp({
                            duration: 400,
                            easing: "easeOutQuart",
                            start: () => {
                                this.$el.removeClass(xe);
                            },
                        }),
                        this.$mobileAddStart.addClass("trigger"),
                        this.$quickAddBtnText.text("Adding..."),
                        this.$header.attr("aria-expanded", !1),
                        (this.isOpen = !1));
                }
                onQuickAddDone() {
                    this.$quickAddBtnText.text("Quick add"), this.$mobileAddStart.removeClass("trigger");
                }
            }
            class Te {
                constructor(e) {
                    (this.$el = $(e)),
                        (this.expanders = $.map(
                            $(".expander", this.$el),
                            (e) => new Ee(e, { onClick: this.onClick.bind(this) })
                        )),
                        (this.activeExpander = this.expanders.find((e) => !!e.isOpen));
                }
                onClick(e) {
                    e.isOpen
                        ? e.close()
                        : (this.activeExpander && this.activeExpander.close(), e.open(), (this.activeExpander = e));
                }
            }
            class $e extends V {
                constructor(e) {
                    super(e, "collection"),
                        (this.expanderGroup = new Te(this.$container.find("[data-expander-group]")));
                }
                onUnload() {}
            }
            class ke extends Y {
                onEnter() {
                    this.sectionManager.register("hero", Ce),
                        this.sectionManager.register("collection", Ce),
                        this.sectionManager.register("collection", $e);
                }
            }
            class Me extends Y {
                onEnter() {
                    this.sectionManager.register("collection", Ce), this.sectionManager.register("collection", $e);
                }
            }
            const Le = "is-open",
                Ae = $(window);
            class Ie {
                constructor(e) {
                    let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                    (this.$el = $(e)),
                        (this.$header = $(".expander__header", this.$el)),
                        (this.$body = $(".expander__body", this.$el)),
                        (this.$mobileAddStart = $(".mobileAddStart", this.$el));
                    const n = { onClick: $.noop };
                    (this.settings = { ...n, ...t }),
                        (this.isOpen = !1),
                        "open" == this.$el.data("default") && this.open(!0),
                        (this.$quickAddBtnText = $("[data-quick-add-text]", this.$el)),
                        Ae.on(ie, this.onQuickAddStart.bind(this)),
                        Ae.on(se, this.onQuickAddDone.bind(this)),
                        this.$header.on("click", this.onClick.bind(this));
                }
                destroy() {
                    Ae.off(ie, this.onQuickAddStart), Ae.off(se, this.onQuickAddDone);
                }
                onClick() {
                    this.settings.onClick(this);
                }
                open() {
                    let e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
                    this.isOpen ||
                        (this.$body.stop(),
                        this.$body.slideDown({
                            duration: e ? 50 : 400,
                            easing: "easeOutQuart",
                            start: () => {
                                this.$el.addClass(Le);
                            },
                        }),
                        this.$header.attr("aria-expanded", !0),
                        (this.isOpen = !0));
                }
                close() {
                    this.isOpen &&
                        (this.$body.stop(),
                        this.$body.slideUp({
                            duration: 300,
                            easing: "easeOutQuart",
                            start: () => {
                                this.$el.removeClass(Le);
                            },
                        }),
                        this.$header.attr("aria-expanded", !1),
                        (this.isOpen = !1));
                }
                onQuickAddStart() {
                    this.isOpen &&
                        (this.$body.stop(),
                        this.$body.slideUp({
                            duration: 300,
                            easing: "easeOutQuart",
                            start: () => {
                                this.$el.removeClass(Le);
                            },
                        }),
                        this.$mobileAddStart.addClass("trigger"),
                        this.$quickAddBtnText.text("Adding..."),
                        this.$header.attr("aria-expanded", !1),
                        (this.isOpen = !1));
                }
                onQuickAddDone() {
                    this.$quickAddBtnText.text("Quick add"), this.$mobileAddStart.removeClass("trigger");
                }
            }
            class _e {
                constructor(e) {
                    (this.$el = $(e)),
                        (this.expanders = $.map(
                            $(".expander", this.$el),
                            (e) => new Ie(e, { onClick: this.onClick.bind(this) })
                        )),
                        (this.activeExpander = this.expanders.find((e) => !!e.isOpen));
                }
                onClick(e) {
                    e.isOpen
                        ? e.close()
                        : (this.activeExpander && this.activeExpander.close(), e.open(), (this.activeExpander = e));
                }
            }
            const Pe = "[data-single-option-selector]",
                De = "[data-variant-option-value-list][data-option-position]",
                Oe = ".description-wrapper",
                Ne = "is-active",
                Fe = "is-open",
                je = $(window);
            $(document.body);
            class ze {
                constructor(e, t) {
                    (this.settings = $.extend({}, { onVariantChange: () => {}, enableHistoryState: !0 }, t)),
                        (this.$el = $(e)),
                        (this.$form = $("form[data-add-to-cart-form]", this.$el)),
                        (this.$singleOptionSelectors = $(Pe, this.$el)),
                        (this.$variantOptionValueList = $(De, this.$el)),
                        (this.$productDetailPrice = $("[data-product-detail-price]", this.$el)),
                        (this.$addToCartBtn = $("[data-add-to-cart-btn]", this.$el)),
                        (this.$addToCartBtnText = $("[data-add-to-cart-text]", this.$el)),
                        (this.product = JSON.parse($("[data-product-json]", this.$el).html())),
                        this.$addToCartBtn.on("click", this.onBtnClick.bind(this)),
                        (this.$pulseText = $("[data-pulse-text]", this.$container)),
                        (this.$pulse = $("[data-pulse]", this.$container)),
                        (this.price = new ce(this.$productDetailPrice)),
                        (this.variants = new le({
                            $container: this.$el,
                            enableHistoryState: this.settings.enableHistoryState,
                            singleOptionSelector: Pe,
                            originalSelectorId: "[data-product-select]",
                            product: this.product,
                        })),
                        (this.typed = null),
                        (this.expanderGroup = new _e($("[data-expander-group]", this.$el).first())),
                        (this.onAddStart = this.onAddStart.bind(this)),
                        (this.onAddDone = this.onAddDone.bind(this)),
                        this.$el.on("variantChange", this.onVariantChange.bind(this)),
                        this.$el.on("click", "[data-variant-option-value]", this.onVariantOptionValueClick.bind(this)),
                        this.$el.on("click", "[more-text-trigger]", this.toggleMoreText.bind(this)),
                        $(Oe)[0] && $(Oe)[0].scrollHeight < 200 && $(Oe).addClass(Fe),
                        je.on(ie, this.onAddStart),
                        je.on(se, this.onAddDone);
                }
                destroy() {
                    je.off(ie, this.onAddStart), je.off(se, this.onAddDone);
                }
                updateVariantOptionValues(e) {
                    if (e)
                        for (let t = 1; t <= 3; t++) {
                            const n = e["option".concat(t)];
                            if (!n) break;
                            const i = this.$variantOptionValueList
                                .filter('[data-option-position="'.concat(t, '"]'))
                                .find('[data-variant-option-value="' + n + '"]');
                            i.addClass(Ne), i.siblings().removeClass(Ne);
                        }
                }
                updatePulse(e) {
                    let t = "",
                        n = !1;
                    $.map(e.tags, function (e, t) {
                        "pre-order" === e && (n = !0);
                    }),
                        e &&
                            (e.available && e.inventory_quantity <= 0 && !0 === n
                                ? ((t = "IN PRODUCTION"),
                                  this.$pulse.addClass("pre-order"),
                                  this.$pulse.removeClass("in-stock"),
                                  this.$pulse.removeClass("sold-out"))
                                : e.available
                                  ? ((t = "IN STOCK"),
                                    this.$pulse.addClass("in-stock"),
                                    this.$pulse.removeClass("pre-order"),
                                    this.$pulse.removeClass("sold-out"))
                                  : ((t = "SOLD OUT"),
                                    this.$pulse.addClass("sold-out"),
                                    this.$pulse.removeClass("in-stock"),
                                    this.$pulse.removeClass("pre-order"))),
                        this.$pulse.removeClass("visually-hidden"),
                        this.$pulseText.text(t);
                }
                onBtnClick(e) {
                    (this.selection_required = $("#primary-cta").attr("selection-required")),
                        "true" == this.selection_required &&
                            (e.preventDefault(),
                            $("#data-cta-intersection")
                                .get(0)
                                .scrollIntoView({ behavior: "smooth", block: "center", inline: "center" }));
                }
                updateAddToCartState(e) {
                    let t = "",
                        n = !1,
                        i = !1;
                    $.map(e.tags, function (e, t) {
                        "pre-order" === e && (i = !0);
                    }),
                        e
                            ? e.available && e.inventory_quantity <= 0 && !0 === i
                                ? ((n = !1), (t = app.strings.preOrder))
                                : e.available
                                  ? ((n = !1), (t = app.strings.addToCart))
                                  : ((n = !0), (t = app.strings.soldOut))
                            : ((n = !0), (t = app.strings.unavailable)),
                        this.$addToCartBtn.prop("disabled", n),
                        this.showMessageWithAnimation(t);
                }
                onVariantChange(e) {
                    let { variant: t } = e;
                    this.updateVariantOptionValues(t),
                        this.updateAddToCartState(t),
                        this.price.update(t),
                        this.settings.onVariantChange(t),
                        this.updatePulse(t),
                        this.$addToCartBtn.attr("selection-required", "false"),
                        $("#shop_pay_btn").removeClass("hidden"),
                        $("#shop_pay_btn").prop("href", "/cart/".concat(t.id, ":1?payment=shop_pay"));
                }
                onVariantOptionValueClick(e) {
                    const t = $(e.currentTarget);
                    if (t.hasClass(Ne) || t.hasClass("is-disabled")) return;
                    const n = t.data("variant-option-value"),
                        i = t.parents(De).data("option-position");
                    this.$singleOptionSelectors.filter('[data-index="option'.concat(i, '"]')).val(n).trigger("change"),
                        t.addClass(Ne),
                        t.siblings().removeClass(Ne);
                }
                onAddStart(e) {
                    let { relatedTarget: t } = e;
                    this.$form.is(t) && this.showMessageWithAnimation("adding...");
                }
                showMessageWithAnimation(e) {
                    this.typed && this.typed.destroy(),
                        (this.typed = new be(this.$addToCartBtnText.get(0), {
                            strings: ["".concat(e, " ^2000"), ""],
                            typeSpeed: 25,
                            startDelay: 0,
                            backSpeed: 0,
                            smartBackspace: !1,
                            showCursor: !1,
                            cursorChar: "_",
                            loop: !1,
                            onStringTyped: () => {
                                this.typed.stop();
                            },
                            onComplete: () => {},
                        }));
                }
                onAddDone(e) {
                    let { relatedTarget: t } = e;
                    this.$form.is(t) && this.showMessageWithAnimation("Add to Cart");
                }
                toggleMoreText() {
                    $(Oe).animate(
                        { height: $(Oe)[0].scrollHeight },
                        {
                            duration: 400,
                            easing: "easeInOutCubic",
                            start: function () {
                                $(Oe).addClass(Fe);
                            },
                        }
                    );
                }
            }
            function Be(e) {
                return null !== e && "object" == typeof e && "constructor" in e && e.constructor === Object;
            }
            function qe(e = {}, t = {}) {
                Object.keys(t).forEach((n) => {
                    void 0 === e[n]
                        ? (e[n] = t[n])
                        : Be(t[n]) && Be(e[n]) && Object.keys(t[n]).length > 0 && qe(e[n], t[n]);
                });
            }
            const He = {
                body: {},
                addEventListener() {},
                removeEventListener() {},
                activeElement: { blur() {}, nodeName: "" },
                querySelector() {
                    return null;
                },
                querySelectorAll() {
                    return [];
                },
                getElementById() {
                    return null;
                },
                createEvent() {
                    return { initEvent() {} };
                },
                createElement() {
                    return {
                        children: [],
                        childNodes: [],
                        style: {},
                        setAttribute() {},
                        getElementsByTagName() {
                            return [];
                        },
                    };
                },
                createElementNS() {
                    return {};
                },
                importNode() {
                    return null;
                },
                location: {
                    hash: "",
                    host: "",
                    hostname: "",
                    href: "",
                    origin: "",
                    pathname: "",
                    protocol: "",
                    search: "",
                },
            };
            function Re() {
                const e = "undefined" != typeof document ? document : {};
                return qe(e, He), e;
            }
            const Ve = {
                document: He,
                navigator: { userAgent: "" },
                location: {
                    hash: "",
                    host: "",
                    hostname: "",
                    href: "",
                    origin: "",
                    pathname: "",
                    protocol: "",
                    search: "",
                },
                history: { replaceState() {}, pushState() {}, go() {}, back() {} },
                CustomEvent: function () {
                    return this;
                },
                addEventListener() {},
                removeEventListener() {},
                getComputedStyle() {
                    return {
                        getPropertyValue() {
                            return "";
                        },
                    };
                },
                Image() {},
                Date() {},
                screen: {},
                setTimeout() {},
                clearTimeout() {},
                matchMedia() {
                    return {};
                },
                requestAnimationFrame(e) {
                    return "undefined" == typeof setTimeout ? (e(), null) : setTimeout(e, 0);
                },
                cancelAnimationFrame(e) {
                    "undefined" != typeof setTimeout && clearTimeout(e);
                },
            };
            function Ge() {
                const e = "undefined" != typeof window ? window : {};
                return qe(e, Ve), e;
            }
            function We(e, t = 0) {
                return setTimeout(e, t);
            }
            function Ue() {
                return Date.now();
            }
            function Xe(e, t = "x") {
                const n = Ge();
                let i, s, r;
                const a = (function (e) {
                    const t = Ge();
                    let n;
                    return (
                        t.getComputedStyle && (n = t.getComputedStyle(e, null)),
                        !n && e.currentStyle && (n = e.currentStyle),
                        n || (n = e.style),
                        n
                    );
                })(e);
                return (
                    n.WebKitCSSMatrix
                        ? ((s = a.transform || a.webkitTransform),
                          s.split(",").length > 6 &&
                              (s = s
                                  .split(", ")
                                  .map((e) => e.replace(",", "."))
                                  .join(", ")),
                          (r = new n.WebKitCSSMatrix("none" === s ? "" : s)))
                        : ((r =
                              a.MozTransform ||
                              a.OTransform ||
                              a.MsTransform ||
                              a.msTransform ||
                              a.transform ||
                              a.getPropertyValue("transform").replace("translate(", "matrix(1, 0, 0, 1,")),
                          (i = r.toString().split(","))),
                    "x" === t &&
                        (s = n.WebKitCSSMatrix ? r.m41 : 16 === i.length ? parseFloat(i[12]) : parseFloat(i[4])),
                    "y" === t &&
                        (s = n.WebKitCSSMatrix ? r.m42 : 16 === i.length ? parseFloat(i[13]) : parseFloat(i[5])),
                    s || 0
                );
            }
            function Ye(e) {
                return (
                    "object" == typeof e &&
                    null !== e &&
                    e.constructor &&
                    "Object" === Object.prototype.toString.call(e).slice(8, -1)
                );
            }
            function Ke(...e) {
                const t = Object(e[0]),
                    n = ["__proto__", "constructor", "prototype"];
                for (let s = 1; s < e.length; s += 1) {
                    const r = e[s];
                    if (
                        null != r &&
                        ((i = r),
                        !("undefined" != typeof window && void 0 !== window.HTMLElement
                            ? i instanceof HTMLElement
                            : i && (1 === i.nodeType || 11 === i.nodeType)))
                    ) {
                        const e = Object.keys(Object(r)).filter((e) => n.indexOf(e) < 0);
                        for (let n = 0, i = e.length; n < i; n += 1) {
                            const i = e[n],
                                s = Object.getOwnPropertyDescriptor(r, i);
                            void 0 !== s &&
                                s.enumerable &&
                                (Ye(t[i]) && Ye(r[i])
                                    ? r[i].__swiper__
                                        ? (t[i] = r[i])
                                        : Ke(t[i], r[i])
                                    : !Ye(t[i]) && Ye(r[i])
                                      ? ((t[i] = {}), r[i].__swiper__ ? (t[i] = r[i]) : Ke(t[i], r[i]))
                                      : (t[i] = r[i]));
                        }
                    }
                }
                var i;
                return t;
            }
            function Qe(e, t, n) {
                e.style.setProperty(t, n);
            }
            function Je({ swiper: e, targetPosition: t, side: n }) {
                const i = Ge(),
                    s = -e.translate;
                let r,
                    a = null;
                const o = e.params.speed;
                (e.wrapperEl.style.scrollSnapType = "none"), i.cancelAnimationFrame(e.cssModeFrameID);
                const l = t > s ? "next" : "prev",
                    c = (e, t) => ("next" === l && e >= t) || ("prev" === l && e <= t),
                    d = () => {
                        (r = new Date().getTime()), null === a && (a = r);
                        const l = Math.max(Math.min((r - a) / o, 1), 0),
                            u = 0.5 - Math.cos(l * Math.PI) / 2;
                        let p = s + u * (t - s);
                        if ((c(p, t) && (p = t), e.wrapperEl.scrollTo({ [n]: p }), c(p, t)))
                            return (
                                (e.wrapperEl.style.overflow = "hidden"),
                                (e.wrapperEl.style.scrollSnapType = ""),
                                setTimeout(() => {
                                    (e.wrapperEl.style.overflow = ""), e.wrapperEl.scrollTo({ [n]: p });
                                }),
                                void i.cancelAnimationFrame(e.cssModeFrameID)
                            );
                        e.cssModeFrameID = i.requestAnimationFrame(d);
                    };
                d();
            }
            function Ze(e) {
                return (
                    e.querySelector(".swiper-slide-transform") ||
                    (e.shadowEl && e.shadowEl.querySelector(".swiper-slide-transform")) ||
                    e
                );
            }
            function et(e, t = "") {
                return [...e.children].filter((e) => e.matches(t));
            }
            function tt(e, t = []) {
                const n = document.createElement(e);
                return n.classList.add(...(Array.isArray(t) ? t : [t])), n;
            }
            function nt(e) {
                const t = Ge(),
                    n = Re(),
                    i = e.getBoundingClientRect(),
                    s = n.body,
                    r = e.clientTop || s.clientTop || 0,
                    a = e.clientLeft || s.clientLeft || 0,
                    o = e === t ? t.scrollY : e.scrollTop,
                    l = e === t ? t.scrollX : e.scrollLeft;
                return { top: i.top + o - r, left: i.left + l - a };
            }
            function it(e, t) {
                return Ge().getComputedStyle(e, null).getPropertyValue(t);
            }
            function st(e) {
                let t,
                    n = e;
                if (n) {
                    for (t = 0; null !== (n = n.previousSibling); ) 1 === n.nodeType && (t += 1);
                    return t;
                }
            }
            function rt(e, t) {
                const n = [];
                let i = e.parentElement;
                for (; i; ) t ? i.matches(t) && n.push(i) : n.push(i), (i = i.parentElement);
                return n;
            }
            function at(e, t) {
                t &&
                    e.addEventListener("transitionend", function n(i) {
                        i.target === e && (t.call(e, i), e.removeEventListener("transitionend", n));
                    });
            }
            function ot(e, t, n) {
                const i = Ge();
                return n
                    ? e["width" === t ? "offsetWidth" : "offsetHeight"] +
                          parseFloat(
                              i
                                  .getComputedStyle(e, null)
                                  .getPropertyValue("width" === t ? "margin-right" : "margin-top")
                          ) +
                          parseFloat(
                              i
                                  .getComputedStyle(e, null)
                                  .getPropertyValue("width" === t ? "margin-left" : "margin-bottom")
                          )
                    : e.offsetWidth;
            }
            let lt, ct, dt;
            function ut() {
                return (
                    lt ||
                        (lt = (function () {
                            const e = Ge(),
                                t = Re();
                            return {
                                smoothScroll:
                                    t.documentElement &&
                                    t.documentElement.style &&
                                    "scrollBehavior" in t.documentElement.style,
                                touch: !!("ontouchstart" in e || (e.DocumentTouch && t instanceof e.DocumentTouch)),
                            };
                        })()),
                    lt
                );
            }
            var pt = {
                on(e, t, n) {
                    const i = this;
                    if (!i.eventsListeners || i.destroyed) return i;
                    if ("function" != typeof t) return i;
                    const s = n ? "unshift" : "push";
                    return (
                        e.split(" ").forEach((e) => {
                            i.eventsListeners[e] || (i.eventsListeners[e] = []), i.eventsListeners[e][s](t);
                        }),
                        i
                    );
                },
                once(e, t, n) {
                    const i = this;
                    if (!i.eventsListeners || i.destroyed) return i;
                    if ("function" != typeof t) return i;
                    function s(...n) {
                        i.off(e, s), s.__emitterProxy && delete s.__emitterProxy, t.apply(i, n);
                    }
                    return (s.__emitterProxy = t), i.on(e, s, n);
                },
                onAny(e, t) {
                    const n = this;
                    if (!n.eventsListeners || n.destroyed) return n;
                    if ("function" != typeof e) return n;
                    const i = t ? "unshift" : "push";
                    return n.eventsAnyListeners.indexOf(e) < 0 && n.eventsAnyListeners[i](e), n;
                },
                offAny(e) {
                    const t = this;
                    if (!t.eventsListeners || t.destroyed) return t;
                    if (!t.eventsAnyListeners) return t;
                    const n = t.eventsAnyListeners.indexOf(e);
                    return n >= 0 && t.eventsAnyListeners.splice(n, 1), t;
                },
                off(e, t) {
                    const n = this;
                    return !n.eventsListeners || n.destroyed
                        ? n
                        : n.eventsListeners
                          ? (e.split(" ").forEach((e) => {
                                void 0 === t
                                    ? (n.eventsListeners[e] = [])
                                    : n.eventsListeners[e] &&
                                      n.eventsListeners[e].forEach((i, s) => {
                                          (i === t || (i.__emitterProxy && i.__emitterProxy === t)) &&
                                              n.eventsListeners[e].splice(s, 1);
                                      });
                            }),
                            n)
                          : n;
                },
                emit(...e) {
                    const t = this;
                    if (!t.eventsListeners || t.destroyed) return t;
                    if (!t.eventsListeners) return t;
                    let n, i, s;
                    return (
                        "string" == typeof e[0] || Array.isArray(e[0])
                            ? ((n = e[0]), (i = e.slice(1, e.length)), (s = t))
                            : ((n = e[0].events), (i = e[0].data), (s = e[0].context || t)),
                        i.unshift(s),
                        (Array.isArray(n) ? n : n.split(" ")).forEach((e) => {
                            t.eventsAnyListeners &&
                                t.eventsAnyListeners.length &&
                                t.eventsAnyListeners.forEach((t) => {
                                    t.apply(s, [e, ...i]);
                                }),
                                t.eventsListeners &&
                                    t.eventsListeners[e] &&
                                    t.eventsListeners[e].forEach((e) => {
                                        e.apply(s, i);
                                    });
                        }),
                        t
                    );
                },
            };
            const ht = (e, t) => {
                    if (!e || e.destroyed || !e.params) return;
                    const n = t.closest(e.isElement ? "swiper-slide" : `.${e.params.slideClass}`);
                    if (n) {
                        const t = n.querySelector(`.${e.params.lazyPreloaderClass}`);
                        t && t.remove();
                    }
                },
                ft = (e, t) => {
                    if (!e.slides[t]) return;
                    const n = e.slides[t].querySelector('[loading="lazy"]');
                    n && n.removeAttribute("loading");
                },
                mt = (e) => {
                    if (!e || e.destroyed || !e.params) return;
                    let t = e.params.lazyPreloadPrevNext;
                    const n = e.slides.length;
                    if (!n || !t || t < 0) return;
                    t = Math.min(t, n);
                    const i =
                            "auto" === e.params.slidesPerView
                                ? e.slidesPerViewDynamic()
                                : Math.ceil(e.params.slidesPerView),
                        s = e.activeIndex;
                    if (e.params.grid && e.params.grid.rows > 1) {
                        const n = s,
                            r = [n - t];
                        return (
                            r.push(...Array.from({ length: t }).map((e, t) => n + i + t)),
                            void e.slides.forEach((t, n) => {
                                r.includes(t.column) && ft(e, n);
                            })
                        );
                    }
                    const r = s + i - 1;
                    if (e.params.rewind || e.params.loop)
                        for (let i = s - t; i <= r + t; i += 1) {
                            const t = ((i % n) + n) % n;
                            (t < s || t > r) && ft(e, t);
                        }
                    else
                        for (let i = Math.max(s - t, 0); i <= Math.min(r + t, n - 1); i += 1)
                            i !== s && (i > r || i < s) && ft(e, i);
                };
            var gt = {
                    updateSize: function () {
                        const e = this;
                        let t, n;
                        const i = e.el;
                        (t = void 0 !== e.params.width && null !== e.params.width ? e.params.width : i.clientWidth),
                            (n =
                                void 0 !== e.params.height && null !== e.params.height
                                    ? e.params.height
                                    : i.clientHeight),
                            (0 === t && e.isHorizontal()) ||
                                (0 === n && e.isVertical()) ||
                                ((t =
                                    t -
                                    parseInt(it(i, "padding-left") || 0, 10) -
                                    parseInt(it(i, "padding-right") || 0, 10)),
                                (n =
                                    n -
                                    parseInt(it(i, "padding-top") || 0, 10) -
                                    parseInt(it(i, "padding-bottom") || 0, 10)),
                                Number.isNaN(t) && (t = 0),
                                Number.isNaN(n) && (n = 0),
                                Object.assign(e, { width: t, height: n, size: e.isHorizontal() ? t : n }));
                    },
                    updateSlides: function () {
                        const e = this;
                        function t(t) {
                            return e.isHorizontal()
                                ? t
                                : {
                                      width: "height",
                                      "margin-top": "margin-left",
                                      "margin-bottom ": "margin-right",
                                      "margin-left": "margin-top",
                                      "margin-right": "margin-bottom",
                                      "padding-left": "padding-top",
                                      "padding-right": "padding-bottom",
                                      marginRight: "marginBottom",
                                  }[t];
                        }
                        function n(e, n) {
                            return parseFloat(e.getPropertyValue(t(n)) || 0);
                        }
                        const i = e.params,
                            { wrapperEl: s, slidesEl: r, size: a, rtlTranslate: o, wrongRTL: l } = e,
                            c = e.virtual && i.virtual.enabled,
                            d = c ? e.virtual.slides.length : e.slides.length,
                            u = et(r, `.${e.params.slideClass}, swiper-slide`),
                            p = c ? e.virtual.slides.length : u.length;
                        let h = [];
                        const f = [],
                            m = [];
                        let g = i.slidesOffsetBefore;
                        "function" == typeof g && (g = i.slidesOffsetBefore.call(e));
                        let v = i.slidesOffsetAfter;
                        "function" == typeof v && (v = i.slidesOffsetAfter.call(e));
                        const y = e.snapGrid.length,
                            b = e.slidesGrid.length;
                        let w = i.spaceBetween,
                            C = -g,
                            x = 0,
                            S = 0;
                        if (void 0 === a) return;
                        "string" == typeof w && w.indexOf("%") >= 0
                            ? (w = (parseFloat(w.replace("%", "")) / 100) * a)
                            : "string" == typeof w && (w = parseFloat(w)),
                            (e.virtualSize = -w),
                            u.forEach((e) => {
                                o ? (e.style.marginLeft = "") : (e.style.marginRight = ""),
                                    (e.style.marginBottom = ""),
                                    (e.style.marginTop = "");
                            }),
                            i.centeredSlides &&
                                i.cssMode &&
                                (Qe(s, "--swiper-centered-offset-before", ""),
                                Qe(s, "--swiper-centered-offset-after", ""));
                        const E = i.grid && i.grid.rows > 1 && e.grid;
                        let T;
                        E && e.grid.initSlides(p);
                        const $ =
                            "auto" === i.slidesPerView &&
                            i.breakpoints &&
                            Object.keys(i.breakpoints).filter((e) => void 0 !== i.breakpoints[e].slidesPerView).length >
                                0;
                        for (let s = 0; s < p; s += 1) {
                            let r;
                            if (
                                ((T = 0),
                                u[s] && (r = u[s]),
                                E && e.grid.updateSlide(s, r, p, t),
                                !u[s] || "none" !== it(r, "display"))
                            ) {
                                if ("auto" === i.slidesPerView) {
                                    $ && (u[s].style[t("width")] = "");
                                    const a = getComputedStyle(r),
                                        o = r.style.transform,
                                        l = r.style.webkitTransform;
                                    if (
                                        (o && (r.style.transform = "none"),
                                        l && (r.style.webkitTransform = "none"),
                                        i.roundLengths)
                                    )
                                        T = e.isHorizontal() ? ot(r, "width", !0) : ot(r, "height", !0);
                                    else {
                                        const e = n(a, "width"),
                                            t = n(a, "padding-left"),
                                            i = n(a, "padding-right"),
                                            s = n(a, "margin-left"),
                                            o = n(a, "margin-right"),
                                            l = a.getPropertyValue("box-sizing");
                                        if (l && "border-box" === l) T = e + s + o;
                                        else {
                                            const { clientWidth: n, offsetWidth: a } = r;
                                            T = e + t + i + s + o + (a - n);
                                        }
                                    }
                                    o && (r.style.transform = o),
                                        l && (r.style.webkitTransform = l),
                                        i.roundLengths && (T = Math.floor(T));
                                } else
                                    (T = (a - (i.slidesPerView - 1) * w) / i.slidesPerView),
                                        i.roundLengths && (T = Math.floor(T)),
                                        u[s] && (u[s].style[t("width")] = `${T}px`);
                                u[s] && (u[s].swiperSlideSize = T),
                                    m.push(T),
                                    i.centeredSlides
                                        ? ((C = C + T / 2 + x / 2 + w),
                                          0 === x && 0 !== s && (C = C - a / 2 - w),
                                          0 === s && (C = C - a / 2 - w),
                                          Math.abs(C) < 0.001 && (C = 0),
                                          i.roundLengths && (C = Math.floor(C)),
                                          S % i.slidesPerGroup == 0 && h.push(C),
                                          f.push(C))
                                        : (i.roundLengths && (C = Math.floor(C)),
                                          (S - Math.min(e.params.slidesPerGroupSkip, S)) % e.params.slidesPerGroup ==
                                              0 && h.push(C),
                                          f.push(C),
                                          (C = C + T + w)),
                                    (e.virtualSize += T + w),
                                    (x = T),
                                    (S += 1);
                            }
                        }
                        if (
                            ((e.virtualSize = Math.max(e.virtualSize, a) + v),
                            o &&
                                l &&
                                ("slide" === i.effect || "coverflow" === i.effect) &&
                                (s.style.width = `${e.virtualSize + w}px`),
                            i.setWrapperSize && (s.style[t("width")] = `${e.virtualSize + w}px`),
                            E && e.grid.updateWrapperSize(T, h, t),
                            !i.centeredSlides)
                        ) {
                            const t = [];
                            for (let n = 0; n < h.length; n += 1) {
                                let s = h[n];
                                i.roundLengths && (s = Math.floor(s)), h[n] <= e.virtualSize - a && t.push(s);
                            }
                            (h = t),
                                Math.floor(e.virtualSize - a) - Math.floor(h[h.length - 1]) > 1 &&
                                    h.push(e.virtualSize - a);
                        }
                        if (c && i.loop) {
                            const t = m[0] + w;
                            if (i.slidesPerGroup > 1) {
                                const n = Math.ceil(
                                        (e.virtual.slidesBefore + e.virtual.slidesAfter) / i.slidesPerGroup
                                    ),
                                    s = t * i.slidesPerGroup;
                                for (let e = 0; e < n; e += 1) h.push(h[h.length - 1] + s);
                            }
                            for (let n = 0; n < e.virtual.slidesBefore + e.virtual.slidesAfter; n += 1)
                                1 === i.slidesPerGroup && h.push(h[h.length - 1] + t),
                                    f.push(f[f.length - 1] + t),
                                    (e.virtualSize += t);
                        }
                        if ((0 === h.length && (h = [0]), 0 !== w)) {
                            const n = e.isHorizontal() && o ? "marginLeft" : t("marginRight");
                            u.filter((e, t) => !(i.cssMode && !i.loop) || t !== u.length - 1).forEach((e) => {
                                e.style[n] = `${w}px`;
                            });
                        }
                        if (i.centeredSlides && i.centeredSlidesBounds) {
                            let e = 0;
                            m.forEach((t) => {
                                e += t + (w || 0);
                            }),
                                (e -= w);
                            const t = e - a;
                            h = h.map((e) => (e <= 0 ? -g : e > t ? t + v : e));
                        }
                        if (i.centerInsufficientSlides) {
                            let e = 0;
                            if (
                                (m.forEach((t) => {
                                    e += t + (w || 0);
                                }),
                                (e -= w),
                                e < a)
                            ) {
                                const t = (a - e) / 2;
                                h.forEach((e, n) => {
                                    h[n] = e - t;
                                }),
                                    f.forEach((e, n) => {
                                        f[n] = e + t;
                                    });
                            }
                        }
                        if (
                            (Object.assign(e, { slides: u, snapGrid: h, slidesGrid: f, slidesSizesGrid: m }),
                            i.centeredSlides && i.cssMode && !i.centeredSlidesBounds)
                        ) {
                            Qe(s, "--swiper-centered-offset-before", -h[0] + "px"),
                                Qe(s, "--swiper-centered-offset-after", e.size / 2 - m[m.length - 1] / 2 + "px");
                            const t = -e.snapGrid[0],
                                n = -e.slidesGrid[0];
                            (e.snapGrid = e.snapGrid.map((e) => e + t)),
                                (e.slidesGrid = e.slidesGrid.map((e) => e + n));
                        }
                        if (
                            (p !== d && e.emit("slidesLengthChange"),
                            h.length !== y &&
                                (e.params.watchOverflow && e.checkOverflow(), e.emit("snapGridLengthChange")),
                            f.length !== b && e.emit("slidesGridLengthChange"),
                            i.watchSlidesProgress && e.updateSlidesOffset(),
                            !(c || i.cssMode || ("slide" !== i.effect && "fade" !== i.effect)))
                        ) {
                            const t = `${i.containerModifierClass}backface-hidden`,
                                n = e.el.classList.contains(t);
                            p <= i.maxBackfaceHiddenSlides ? n || e.el.classList.add(t) : n && e.el.classList.remove(t);
                        }
                    },
                    updateAutoHeight: function (e) {
                        const t = this,
                            n = [],
                            i = t.virtual && t.params.virtual.enabled;
                        let s,
                            r = 0;
                        "number" == typeof e ? t.setTransition(e) : !0 === e && t.setTransition(t.params.speed);
                        const a = (e) => (i ? t.slides[t.getSlideIndexByData(e)] : t.slides[e]);
                        if ("auto" !== t.params.slidesPerView && t.params.slidesPerView > 1)
                            if (t.params.centeredSlides)
                                (t.visibleSlides || []).forEach((e) => {
                                    n.push(e);
                                });
                            else
                                for (s = 0; s < Math.ceil(t.params.slidesPerView); s += 1) {
                                    const e = t.activeIndex + s;
                                    if (e > t.slides.length && !i) break;
                                    n.push(a(e));
                                }
                        else n.push(a(t.activeIndex));
                        for (s = 0; s < n.length; s += 1)
                            if (void 0 !== n[s]) {
                                const e = n[s].offsetHeight;
                                r = e > r ? e : r;
                            }
                        (r || 0 === r) && (t.wrapperEl.style.height = `${r}px`);
                    },
                    updateSlidesOffset: function () {
                        const e = this,
                            t = e.slides,
                            n = e.isElement ? (e.isHorizontal() ? e.wrapperEl.offsetLeft : e.wrapperEl.offsetTop) : 0;
                        for (let i = 0; i < t.length; i += 1)
                            t[i].swiperSlideOffset =
                                (e.isHorizontal() ? t[i].offsetLeft : t[i].offsetTop) - n - e.cssOverflowAdjustment();
                    },
                    updateSlidesProgress: function (e = (this && this.translate) || 0) {
                        const t = this,
                            n = t.params,
                            { slides: i, rtlTranslate: s, snapGrid: r } = t;
                        if (0 === i.length) return;
                        void 0 === i[0].swiperSlideOffset && t.updateSlidesOffset();
                        let a = -e;
                        s && (a = e),
                            i.forEach((e) => {
                                e.classList.remove(n.slideVisibleClass);
                            }),
                            (t.visibleSlidesIndexes = []),
                            (t.visibleSlides = []);
                        let o = n.spaceBetween;
                        "string" == typeof o && o.indexOf("%") >= 0
                            ? (o = (parseFloat(o.replace("%", "")) / 100) * t.size)
                            : "string" == typeof o && (o = parseFloat(o));
                        for (let e = 0; e < i.length; e += 1) {
                            const l = i[e];
                            let c = l.swiperSlideOffset;
                            n.cssMode && n.centeredSlides && (c -= i[0].swiperSlideOffset);
                            const d = (a + (n.centeredSlides ? t.minTranslate() : 0) - c) / (l.swiperSlideSize + o),
                                u =
                                    (a - r[0] + (n.centeredSlides ? t.minTranslate() : 0) - c) /
                                    (l.swiperSlideSize + o),
                                p = -(a - c),
                                h = p + t.slidesSizesGrid[e];
                            ((p >= 0 && p < t.size - 1) || (h > 1 && h <= t.size) || (p <= 0 && h >= t.size)) &&
                                (t.visibleSlides.push(l),
                                t.visibleSlidesIndexes.push(e),
                                i[e].classList.add(n.slideVisibleClass)),
                                (l.progress = s ? -d : d),
                                (l.originalProgress = s ? -u : u);
                        }
                    },
                    updateProgress: function (e) {
                        const t = this;
                        if (void 0 === e) {
                            const n = t.rtlTranslate ? -1 : 1;
                            e = (t && t.translate && t.translate * n) || 0;
                        }
                        const n = t.params,
                            i = t.maxTranslate() - t.minTranslate();
                        let { progress: s, isBeginning: r, isEnd: a, progressLoop: o } = t;
                        const l = r,
                            c = a;
                        if (0 === i) (s = 0), (r = !0), (a = !0);
                        else {
                            s = (e - t.minTranslate()) / i;
                            const n = Math.abs(e - t.minTranslate()) < 1,
                                o = Math.abs(e - t.maxTranslate()) < 1;
                            (r = n || s <= 0), (a = o || s >= 1), n && (s = 0), o && (s = 1);
                        }
                        if (n.loop) {
                            const n = t.getSlideIndexByData(0),
                                i = t.getSlideIndexByData(t.slides.length - 1),
                                s = t.slidesGrid[n],
                                r = t.slidesGrid[i],
                                a = t.slidesGrid[t.slidesGrid.length - 1],
                                l = Math.abs(e);
                            (o = l >= s ? (l - s) / a : (l + a - r) / a), o > 1 && (o -= 1);
                        }
                        Object.assign(t, { progress: s, progressLoop: o, isBeginning: r, isEnd: a }),
                            (n.watchSlidesProgress || (n.centeredSlides && n.autoHeight)) && t.updateSlidesProgress(e),
                            r && !l && t.emit("reachBeginning toEdge"),
                            a && !c && t.emit("reachEnd toEdge"),
                            ((l && !r) || (c && !a)) && t.emit("fromEdge"),
                            t.emit("progress", s);
                    },
                    updateSlidesClasses: function () {
                        const e = this,
                            { slides: t, params: n, slidesEl: i, activeIndex: s } = e,
                            r = e.virtual && n.virtual.enabled,
                            a = (e) => et(i, `.${n.slideClass}${e}, swiper-slide${e}`)[0];
                        let o;
                        if (
                            (t.forEach((e) => {
                                e.classList.remove(n.slideActiveClass, n.slideNextClass, n.slidePrevClass);
                            }),
                            r)
                        )
                            if (n.loop) {
                                let t = s - e.virtual.slidesBefore;
                                t < 0 && (t = e.virtual.slides.length + t),
                                    t >= e.virtual.slides.length && (t -= e.virtual.slides.length),
                                    (o = a(`[data-swiper-slide-index="${t}"]`));
                            } else o = a(`[data-swiper-slide-index="${s}"]`);
                        else o = t[s];
                        if (o) {
                            o.classList.add(n.slideActiveClass);
                            let e = (function (e, t) {
                                const n = [];
                                for (; e.nextElementSibling; ) {
                                    const i = e.nextElementSibling;
                                    t ? i.matches(t) && n.push(i) : n.push(i), (e = i);
                                }
                                return n;
                            })(o, `.${n.slideClass}, swiper-slide`)[0];
                            n.loop && !e && (e = t[0]), e && e.classList.add(n.slideNextClass);
                            let i = (function (e, t) {
                                const n = [];
                                for (; e.previousElementSibling; ) {
                                    const i = e.previousElementSibling;
                                    t ? i.matches(t) && n.push(i) : n.push(i), (e = i);
                                }
                                return n;
                            })(o, `.${n.slideClass}, swiper-slide`)[0];
                            n.loop && 0 === !i && (i = t[t.length - 1]), i && i.classList.add(n.slidePrevClass);
                        }
                        e.emitSlidesClasses();
                    },
                    updateActiveIndex: function (e) {
                        const t = this,
                            n = t.rtlTranslate ? t.translate : -t.translate,
                            { snapGrid: i, params: s, activeIndex: r, realIndex: a, snapIndex: o } = t;
                        let l,
                            c = e;
                        const d = (e) => {
                            let n = e - t.virtual.slidesBefore;
                            return (
                                n < 0 && (n = t.virtual.slides.length + n),
                                n >= t.virtual.slides.length && (n -= t.virtual.slides.length),
                                n
                            );
                        };
                        if (
                            (void 0 === c &&
                                (c = (function (e) {
                                    const { slidesGrid: t, params: n } = e,
                                        i = e.rtlTranslate ? e.translate : -e.translate;
                                    let s;
                                    for (let e = 0; e < t.length; e += 1)
                                        void 0 !== t[e + 1]
                                            ? i >= t[e] && i < t[e + 1] - (t[e + 1] - t[e]) / 2
                                                ? (s = e)
                                                : i >= t[e] && i < t[e + 1] && (s = e + 1)
                                            : i >= t[e] && (s = e);
                                    return n.normalizeSlideIndex && (s < 0 || void 0 === s) && (s = 0), s;
                                })(t)),
                            i.indexOf(n) >= 0)
                        )
                            l = i.indexOf(n);
                        else {
                            const e = Math.min(s.slidesPerGroupSkip, c);
                            l = e + Math.floor((c - e) / s.slidesPerGroup);
                        }
                        if ((l >= i.length && (l = i.length - 1), c === r))
                            return (
                                l !== o && ((t.snapIndex = l), t.emit("snapIndexChange")),
                                void (t.params.loop && t.virtual && t.params.virtual.enabled && (t.realIndex = d(c)))
                            );
                        let u;
                        (u =
                            t.virtual && s.virtual.enabled && s.loop
                                ? d(c)
                                : t.slides[c]
                                  ? parseInt(t.slides[c].getAttribute("data-swiper-slide-index") || c, 10)
                                  : c),
                            Object.assign(t, {
                                previousSnapIndex: o,
                                snapIndex: l,
                                previousRealIndex: a,
                                realIndex: u,
                                previousIndex: r,
                                activeIndex: c,
                            }),
                            t.initialized && mt(t),
                            t.emit("activeIndexChange"),
                            t.emit("snapIndexChange"),
                            a !== u && t.emit("realIndexChange"),
                            (t.initialized || t.params.runCallbacksOnInit) && t.emit("slideChange");
                    },
                    updateClickedSlide: function (e) {
                        const t = this,
                            n = t.params,
                            i = e.closest(`.${n.slideClass}, swiper-slide`);
                        let s,
                            r = !1;
                        if (i)
                            for (let e = 0; e < t.slides.length; e += 1)
                                if (t.slides[e] === i) {
                                    (r = !0), (s = e);
                                    break;
                                }
                        if (!i || !r) return (t.clickedSlide = void 0), void (t.clickedIndex = void 0);
                        (t.clickedSlide = i),
                            t.virtual && t.params.virtual.enabled
                                ? (t.clickedIndex = parseInt(i.getAttribute("data-swiper-slide-index"), 10))
                                : (t.clickedIndex = s),
                            n.slideToClickedSlide &&
                                void 0 !== t.clickedIndex &&
                                t.clickedIndex !== t.activeIndex &&
                                t.slideToClickedSlide();
                    },
                },
                vt = {
                    getTranslate: function (e = this.isHorizontal() ? "x" : "y") {
                        const { params: t, rtlTranslate: n, translate: i, wrapperEl: s } = this;
                        if (t.virtualTranslate) return n ? -i : i;
                        if (t.cssMode) return i;
                        let r = Xe(s, e);
                        return (r += this.cssOverflowAdjustment()), n && (r = -r), r || 0;
                    },
                    setTranslate: function (e, t) {
                        const n = this,
                            { rtlTranslate: i, params: s, wrapperEl: r, progress: a } = n;
                        let o,
                            l = 0,
                            c = 0;
                        n.isHorizontal() ? (l = i ? -e : e) : (c = e),
                            s.roundLengths && ((l = Math.floor(l)), (c = Math.floor(c))),
                            (n.previousTranslate = n.translate),
                            (n.translate = n.isHorizontal() ? l : c),
                            s.cssMode
                                ? (r[n.isHorizontal() ? "scrollLeft" : "scrollTop"] = n.isHorizontal() ? -l : -c)
                                : s.virtualTranslate ||
                                  (n.isHorizontal()
                                      ? (l -= n.cssOverflowAdjustment())
                                      : (c -= n.cssOverflowAdjustment()),
                                  (r.style.transform = `translate3d(${l}px, ${c}px, 0px)`));
                        const d = n.maxTranslate() - n.minTranslate();
                        (o = 0 === d ? 0 : (e - n.minTranslate()) / d),
                            o !== a && n.updateProgress(e),
                            n.emit("setTranslate", n.translate, t);
                    },
                    minTranslate: function () {
                        return -this.snapGrid[0];
                    },
                    maxTranslate: function () {
                        return -this.snapGrid[this.snapGrid.length - 1];
                    },
                    translateTo: function (e = 0, t = this.params.speed, n = !0, i = !0, s) {
                        const r = this,
                            { params: a, wrapperEl: o } = r;
                        if (r.animating && a.preventInteractionOnTransition) return !1;
                        const l = r.minTranslate(),
                            c = r.maxTranslate();
                        let d;
                        if (((d = i && e > l ? l : i && e < c ? c : e), r.updateProgress(d), a.cssMode)) {
                            const e = r.isHorizontal();
                            if (0 === t) o[e ? "scrollLeft" : "scrollTop"] = -d;
                            else {
                                if (!r.support.smoothScroll)
                                    return Je({ swiper: r, targetPosition: -d, side: e ? "left" : "top" }), !0;
                                o.scrollTo({ [e ? "left" : "top"]: -d, behavior: "smooth" });
                            }
                            return !0;
                        }
                        return (
                            0 === t
                                ? (r.setTransition(0),
                                  r.setTranslate(d),
                                  n && (r.emit("beforeTransitionStart", t, s), r.emit("transitionEnd")))
                                : (r.setTransition(t),
                                  r.setTranslate(d),
                                  n && (r.emit("beforeTransitionStart", t, s), r.emit("transitionStart")),
                                  r.animating ||
                                      ((r.animating = !0),
                                      r.onTranslateToWrapperTransitionEnd ||
                                          (r.onTranslateToWrapperTransitionEnd = function (e) {
                                              r &&
                                                  !r.destroyed &&
                                                  e.target === this &&
                                                  (r.wrapperEl.removeEventListener(
                                                      "transitionend",
                                                      r.onTranslateToWrapperTransitionEnd
                                                  ),
                                                  (r.onTranslateToWrapperTransitionEnd = null),
                                                  delete r.onTranslateToWrapperTransitionEnd,
                                                  n && r.emit("transitionEnd"));
                                          }),
                                      r.wrapperEl.addEventListener(
                                          "transitionend",
                                          r.onTranslateToWrapperTransitionEnd
                                      ))),
                            !0
                        );
                    },
                };
            function yt({ swiper: e, runCallbacks: t, direction: n, step: i }) {
                const { activeIndex: s, previousIndex: r } = e;
                let a = n;
                if ((a || (a = s > r ? "next" : s < r ? "prev" : "reset"), e.emit(`transition${i}`), t && s !== r)) {
                    if ("reset" === a) return void e.emit(`slideResetTransition${i}`);
                    e.emit(`slideChangeTransition${i}`),
                        "next" === a ? e.emit(`slideNextTransition${i}`) : e.emit(`slidePrevTransition${i}`);
                }
            }
            var bt = {
                    slideTo: function (e = 0, t = this.params.speed, n = !0, i, s) {
                        "string" == typeof e && (e = parseInt(e, 10));
                        const r = this;
                        let a = e;
                        a < 0 && (a = 0);
                        const {
                            params: o,
                            snapGrid: l,
                            slidesGrid: c,
                            previousIndex: d,
                            activeIndex: u,
                            rtlTranslate: p,
                            wrapperEl: h,
                            enabled: f,
                        } = r;
                        if ((r.animating && o.preventInteractionOnTransition) || (!f && !i && !s)) return !1;
                        const m = Math.min(r.params.slidesPerGroupSkip, a);
                        let g = m + Math.floor((a - m) / r.params.slidesPerGroup);
                        g >= l.length && (g = l.length - 1);
                        const v = -l[g];
                        if (o.normalizeSlideIndex)
                            for (let e = 0; e < c.length; e += 1) {
                                const t = -Math.floor(100 * v),
                                    n = Math.floor(100 * c[e]),
                                    i = Math.floor(100 * c[e + 1]);
                                void 0 !== c[e + 1]
                                    ? t >= n && t < i - (i - n) / 2
                                        ? (a = e)
                                        : t >= n && t < i && (a = e + 1)
                                    : t >= n && (a = e);
                            }
                        if (r.initialized && a !== u) {
                            if (
                                !r.allowSlideNext &&
                                (p ? v > r.translate && v > r.minTranslate() : v < r.translate && v < r.minTranslate())
                            )
                                return !1;
                            if (!r.allowSlidePrev && v > r.translate && v > r.maxTranslate() && (u || 0) !== a)
                                return !1;
                        }
                        let y;
                        if (
                            (a !== (d || 0) && n && r.emit("beforeSlideChangeStart"),
                            r.updateProgress(v),
                            (y = a > u ? "next" : a < u ? "prev" : "reset"),
                            (p && -v === r.translate) || (!p && v === r.translate))
                        )
                            return (
                                r.updateActiveIndex(a),
                                o.autoHeight && r.updateAutoHeight(),
                                r.updateSlidesClasses(),
                                "slide" !== o.effect && r.setTranslate(v),
                                "reset" !== y && (r.transitionStart(n, y), r.transitionEnd(n, y)),
                                !1
                            );
                        if (o.cssMode) {
                            const e = r.isHorizontal(),
                                n = p ? v : -v;
                            if (0 === t) {
                                const t = r.virtual && r.params.virtual.enabled;
                                t && ((r.wrapperEl.style.scrollSnapType = "none"), (r._immediateVirtual = !0)),
                                    t && !r._cssModeVirtualInitialSet && r.params.initialSlide > 0
                                        ? ((r._cssModeVirtualInitialSet = !0),
                                          requestAnimationFrame(() => {
                                              h[e ? "scrollLeft" : "scrollTop"] = n;
                                          }))
                                        : (h[e ? "scrollLeft" : "scrollTop"] = n),
                                    t &&
                                        requestAnimationFrame(() => {
                                            (r.wrapperEl.style.scrollSnapType = ""), (r._immediateVirtual = !1);
                                        });
                            } else {
                                if (!r.support.smoothScroll)
                                    return Je({ swiper: r, targetPosition: n, side: e ? "left" : "top" }), !0;
                                h.scrollTo({ [e ? "left" : "top"]: n, behavior: "smooth" });
                            }
                            return !0;
                        }
                        return (
                            r.setTransition(t),
                            r.setTranslate(v),
                            r.updateActiveIndex(a),
                            r.updateSlidesClasses(),
                            r.emit("beforeTransitionStart", t, i),
                            r.transitionStart(n, y),
                            0 === t
                                ? r.transitionEnd(n, y)
                                : r.animating ||
                                  ((r.animating = !0),
                                  r.onSlideToWrapperTransitionEnd ||
                                      (r.onSlideToWrapperTransitionEnd = function (e) {
                                          r &&
                                              !r.destroyed &&
                                              e.target === this &&
                                              (r.wrapperEl.removeEventListener(
                                                  "transitionend",
                                                  r.onSlideToWrapperTransitionEnd
                                              ),
                                              (r.onSlideToWrapperTransitionEnd = null),
                                              delete r.onSlideToWrapperTransitionEnd,
                                              r.transitionEnd(n, y));
                                      }),
                                  r.wrapperEl.addEventListener("transitionend", r.onSlideToWrapperTransitionEnd)),
                            !0
                        );
                    },
                    slideToLoop: function (e = 0, t = this.params.speed, n = !0, i) {
                        "string" == typeof e && (e = parseInt(e, 10));
                        const s = this;
                        let r = e;
                        return (
                            s.params.loop &&
                                (s.virtual && s.params.virtual.enabled
                                    ? (r += s.virtual.slidesBefore)
                                    : (r = s.getSlideIndexByData(r))),
                            s.slideTo(r, t, n, i)
                        );
                    },
                    slideNext: function (e = this.params.speed, t = !0, n) {
                        const i = this,
                            { enabled: s, params: r, animating: a } = i;
                        if (!s) return i;
                        let o = r.slidesPerGroup;
                        "auto" === r.slidesPerView &&
                            1 === r.slidesPerGroup &&
                            r.slidesPerGroupAuto &&
                            (o = Math.max(i.slidesPerViewDynamic("current", !0), 1));
                        const l = i.activeIndex < r.slidesPerGroupSkip ? 1 : o,
                            c = i.virtual && r.virtual.enabled;
                        if (r.loop) {
                            if (a && !c && r.loopPreventsSliding) return !1;
                            i.loopFix({ direction: "next" }), (i._clientLeft = i.wrapperEl.clientLeft);
                        }
                        return r.rewind && i.isEnd ? i.slideTo(0, e, t, n) : i.slideTo(i.activeIndex + l, e, t, n);
                    },
                    slidePrev: function (e = this.params.speed, t = !0, n) {
                        const i = this,
                            { params: s, snapGrid: r, slidesGrid: a, rtlTranslate: o, enabled: l, animating: c } = i;
                        if (!l) return i;
                        const d = i.virtual && s.virtual.enabled;
                        if (s.loop) {
                            if (c && !d && s.loopPreventsSliding) return !1;
                            i.loopFix({ direction: "prev" }), (i._clientLeft = i.wrapperEl.clientLeft);
                        }
                        function u(e) {
                            return e < 0 ? -Math.floor(Math.abs(e)) : Math.floor(e);
                        }
                        const p = u(o ? i.translate : -i.translate),
                            h = r.map((e) => u(e));
                        let f = r[h.indexOf(p) - 1];
                        if (void 0 === f && s.cssMode) {
                            let e;
                            r.forEach((t, n) => {
                                p >= t && (e = n);
                            }),
                                void 0 !== e && (f = r[e > 0 ? e - 1 : e]);
                        }
                        let m = 0;
                        if (
                            (void 0 !== f &&
                                ((m = a.indexOf(f)),
                                m < 0 && (m = i.activeIndex - 1),
                                "auto" === s.slidesPerView &&
                                    1 === s.slidesPerGroup &&
                                    s.slidesPerGroupAuto &&
                                    ((m = m - i.slidesPerViewDynamic("previous", !0) + 1), (m = Math.max(m, 0)))),
                            s.rewind && i.isBeginning)
                        ) {
                            const s =
                                i.params.virtual && i.params.virtual.enabled && i.virtual
                                    ? i.virtual.slides.length - 1
                                    : i.slides.length - 1;
                            return i.slideTo(s, e, t, n);
                        }
                        return i.slideTo(m, e, t, n);
                    },
                    slideReset: function (e = this.params.speed, t = !0, n) {
                        return this.slideTo(this.activeIndex, e, t, n);
                    },
                    slideToClosest: function (e = this.params.speed, t = !0, n, i = 0.5) {
                        const s = this;
                        let r = s.activeIndex;
                        const a = Math.min(s.params.slidesPerGroupSkip, r),
                            o = a + Math.floor((r - a) / s.params.slidesPerGroup),
                            l = s.rtlTranslate ? s.translate : -s.translate;
                        if (l >= s.snapGrid[o]) {
                            const e = s.snapGrid[o];
                            l - e > (s.snapGrid[o + 1] - e) * i && (r += s.params.slidesPerGroup);
                        } else {
                            const e = s.snapGrid[o - 1];
                            l - e <= (s.snapGrid[o] - e) * i && (r -= s.params.slidesPerGroup);
                        }
                        return (r = Math.max(r, 0)), (r = Math.min(r, s.slidesGrid.length - 1)), s.slideTo(r, e, t, n);
                    },
                    slideToClickedSlide: function () {
                        const e = this,
                            { params: t, slidesEl: n } = e,
                            i = "auto" === t.slidesPerView ? e.slidesPerViewDynamic() : t.slidesPerView;
                        let s,
                            r = e.clickedIndex;
                        const a = e.isElement ? "swiper-slide" : `.${t.slideClass}`;
                        if (t.loop) {
                            if (e.animating) return;
                            (s = parseInt(e.clickedSlide.getAttribute("data-swiper-slide-index"), 10)),
                                t.centeredSlides
                                    ? r < e.loopedSlides - i / 2 || r > e.slides.length - e.loopedSlides + i / 2
                                        ? (e.loopFix(),
                                          (r = e.getSlideIndex(et(n, `${a}[data-swiper-slide-index="${s}"]`)[0])),
                                          We(() => {
                                              e.slideTo(r);
                                          }))
                                        : e.slideTo(r)
                                    : r > e.slides.length - i
                                      ? (e.loopFix(),
                                        (r = e.getSlideIndex(et(n, `${a}[data-swiper-slide-index="${s}"]`)[0])),
                                        We(() => {
                                            e.slideTo(r);
                                        }))
                                      : e.slideTo(r);
                        } else e.slideTo(r);
                    },
                },
                wt = {
                    loopCreate: function (e) {
                        const t = this,
                            { params: n, slidesEl: i } = t;
                        !n.loop ||
                            (t.virtual && t.params.virtual.enabled) ||
                            (et(i, `.${n.slideClass}, swiper-slide`).forEach((e, t) => {
                                e.setAttribute("data-swiper-slide-index", t);
                            }),
                            t.loopFix({ slideRealIndex: e, direction: n.centeredSlides ? void 0 : "next" }));
                    },
                    loopFix: function ({
                        slideRealIndex: e,
                        slideTo: t = !0,
                        direction: n,
                        setTranslate: i,
                        activeSlideIndex: s,
                        byController: r,
                        byMousewheel: a,
                    } = {}) {
                        const o = this;
                        if (!o.params.loop) return;
                        o.emit("beforeLoopFix");
                        const { slides: l, allowSlidePrev: c, allowSlideNext: d, slidesEl: u, params: p } = o;
                        if (((o.allowSlidePrev = !0), (o.allowSlideNext = !0), o.virtual && p.virtual.enabled))
                            return (
                                t &&
                                    (p.centeredSlides || 0 !== o.snapIndex
                                        ? p.centeredSlides && o.snapIndex < p.slidesPerView
                                            ? o.slideTo(o.virtual.slides.length + o.snapIndex, 0, !1, !0)
                                            : o.snapIndex === o.snapGrid.length - 1 &&
                                              o.slideTo(o.virtual.slidesBefore, 0, !1, !0)
                                        : o.slideTo(o.virtual.slides.length, 0, !1, !0)),
                                (o.allowSlidePrev = c),
                                (o.allowSlideNext = d),
                                void o.emit("loopFix")
                            );
                        const h =
                            "auto" === p.slidesPerView
                                ? o.slidesPerViewDynamic()
                                : Math.ceil(parseFloat(p.slidesPerView, 10));
                        let f = p.loopedSlides || h;
                        f % p.slidesPerGroup != 0 && (f += p.slidesPerGroup - (f % p.slidesPerGroup)),
                            (o.loopedSlides = f);
                        const m = [],
                            g = [];
                        let v = o.activeIndex;
                        void 0 === s
                            ? (s = o.getSlideIndex(o.slides.filter((e) => e.classList.contains(p.slideActiveClass))[0]))
                            : (v = s);
                        const y = "next" === n || !n,
                            b = "prev" === n || !n;
                        let w = 0,
                            C = 0;
                        if (s < f) {
                            w = Math.max(f - s, p.slidesPerGroup);
                            for (let e = 0; e < f - s; e += 1) {
                                const t = e - Math.floor(e / l.length) * l.length;
                                m.push(l.length - t - 1);
                            }
                        } else if (s > o.slides.length - 2 * f) {
                            C = Math.max(s - (o.slides.length - 2 * f), p.slidesPerGroup);
                            for (let e = 0; e < C; e += 1) {
                                const t = e - Math.floor(e / l.length) * l.length;
                                g.push(t);
                            }
                        }
                        if (
                            (b &&
                                m.forEach((e) => {
                                    (o.slides[e].swiperLoopMoveDOM = !0),
                                        u.prepend(o.slides[e]),
                                        (o.slides[e].swiperLoopMoveDOM = !1);
                                }),
                            y &&
                                g.forEach((e) => {
                                    (o.slides[e].swiperLoopMoveDOM = !0),
                                        u.append(o.slides[e]),
                                        (o.slides[e].swiperLoopMoveDOM = !1);
                                }),
                            o.recalcSlides(),
                            "auto" === p.slidesPerView && o.updateSlides(),
                            p.watchSlidesProgress && o.updateSlidesOffset(),
                            t)
                        )
                            if (m.length > 0 && b)
                                if (void 0 === e) {
                                    const e = o.slidesGrid[v],
                                        t = o.slidesGrid[v + w] - e;
                                    a
                                        ? o.setTranslate(o.translate - t)
                                        : (o.slideTo(v + w, 0, !1, !0),
                                          i && (o.touches[o.isHorizontal() ? "startX" : "startY"] += t));
                                } else i && o.slideToLoop(e, 0, !1, !0);
                            else if (g.length > 0 && y)
                                if (void 0 === e) {
                                    const e = o.slidesGrid[v],
                                        t = o.slidesGrid[v - C] - e;
                                    a
                                        ? o.setTranslate(o.translate - t)
                                        : (o.slideTo(v - C, 0, !1, !0),
                                          i && (o.touches[o.isHorizontal() ? "startX" : "startY"] += t));
                                } else o.slideToLoop(e, 0, !1, !0);
                        if (
                            ((o.allowSlidePrev = c), (o.allowSlideNext = d), o.controller && o.controller.control && !r)
                        ) {
                            const t = {
                                slideRealIndex: e,
                                slideTo: !1,
                                direction: n,
                                setTranslate: i,
                                activeSlideIndex: s,
                                byController: !0,
                            };
                            Array.isArray(o.controller.control)
                                ? o.controller.control.forEach((e) => {
                                      !e.destroyed && e.params.loop && e.loopFix(t);
                                  })
                                : o.controller.control instanceof o.constructor &&
                                  o.controller.control.params.loop &&
                                  o.controller.control.loopFix(t);
                        }
                        o.emit("loopFix");
                    },
                    loopDestroy: function () {
                        const e = this,
                            { params: t, slidesEl: n } = e;
                        if (!t.loop || (e.virtual && e.params.virtual.enabled)) return;
                        e.recalcSlides();
                        const i = [];
                        e.slides.forEach((e) => {
                            const t =
                                void 0 === e.swiperSlideIndex
                                    ? 1 * e.getAttribute("data-swiper-slide-index")
                                    : e.swiperSlideIndex;
                            i[t] = e;
                        }),
                            e.slides.forEach((e) => {
                                e.removeAttribute("data-swiper-slide-index");
                            }),
                            i.forEach((e) => {
                                n.append(e);
                            }),
                            e.recalcSlides(),
                            e.slideTo(e.realIndex, 0);
                    },
                };
            function Ct(e) {
                const t = this,
                    n = Re(),
                    i = Ge(),
                    s = t.touchEventsData;
                s.evCache.push(e);
                const { params: r, touches: a, enabled: o } = t;
                if (!o) return;
                if (!r.simulateTouch && "mouse" === e.pointerType) return;
                if (t.animating && r.preventInteractionOnTransition) return;
                !t.animating && r.cssMode && r.loop && t.loopFix();
                let l = e;
                l.originalEvent && (l = l.originalEvent);
                let c = l.target;
                if ("wrapper" === r.touchEventsTarget && !t.wrapperEl.contains(c)) return;
                if ("which" in l && 3 === l.which) return;
                if ("button" in l && l.button > 0) return;
                if (s.isTouched && s.isMoved) return;
                const d = !!r.noSwipingClass && "" !== r.noSwipingClass,
                    u = e.composedPath ? e.composedPath() : e.path;
                d && l.target && l.target.shadowRoot && u && (c = u[0]);
                const p = r.noSwipingSelector ? r.noSwipingSelector : `.${r.noSwipingClass}`,
                    h = !(!l.target || !l.target.shadowRoot);
                if (
                    r.noSwiping &&
                    (h
                        ? (function (e, t = this) {
                              return (function t(n) {
                                  if (!n || n === Re() || n === Ge()) return null;
                                  n.assignedSlot && (n = n.assignedSlot);
                                  const i = n.closest(e);
                                  return i || n.getRootNode ? i || t(n.getRootNode().host) : null;
                              })(t);
                          })(p, c)
                        : c.closest(p))
                )
                    return void (t.allowClick = !0);
                if (r.swipeHandler && !c.closest(r.swipeHandler)) return;
                (a.currentX = l.pageX), (a.currentY = l.pageY);
                const f = a.currentX,
                    m = a.currentY,
                    g = r.edgeSwipeDetection || r.iOSEdgeSwipeDetection,
                    v = r.edgeSwipeThreshold || r.iOSEdgeSwipeThreshold;
                if (g && (f <= v || f >= i.innerWidth - v)) {
                    if ("prevent" !== g) return;
                    e.preventDefault();
                }
                Object.assign(s, {
                    isTouched: !0,
                    isMoved: !1,
                    allowTouchCallbacks: !0,
                    isScrolling: void 0,
                    startMoving: void 0,
                }),
                    (a.startX = f),
                    (a.startY = m),
                    (s.touchStartTime = Ue()),
                    (t.allowClick = !0),
                    t.updateSize(),
                    (t.swipeDirection = void 0),
                    r.threshold > 0 && (s.allowThresholdMove = !1);
                let y = !0;
                c.matches(s.focusableElements) && ((y = !1), "SELECT" === c.nodeName && (s.isTouched = !1)),
                    n.activeElement &&
                        n.activeElement.matches(s.focusableElements) &&
                        n.activeElement !== c &&
                        n.activeElement.blur();
                const b = y && t.allowTouchMove && r.touchStartPreventDefault;
                (!r.touchStartForcePreventDefault && !b) || c.isContentEditable || l.preventDefault(),
                    r.freeMode &&
                        r.freeMode.enabled &&
                        t.freeMode &&
                        t.animating &&
                        !r.cssMode &&
                        t.freeMode.onTouchStart(),
                    t.emit("touchStart", l);
            }
            function xt(e) {
                const t = Re(),
                    n = this,
                    i = n.touchEventsData,
                    { params: s, touches: r, rtlTranslate: a, enabled: o } = n;
                if (!o) return;
                if (!s.simulateTouch && "mouse" === e.pointerType) return;
                let l = e;
                if ((l.originalEvent && (l = l.originalEvent), !i.isTouched))
                    return void (i.startMoving && i.isScrolling && n.emit("touchMoveOpposite", l));
                const c = i.evCache.findIndex((e) => e.pointerId === l.pointerId);
                c >= 0 && (i.evCache[c] = l);
                const d = i.evCache.length > 1 ? i.evCache[0] : l,
                    u = d.pageX,
                    p = d.pageY;
                if (l.preventedByNestedSwiper) return (r.startX = u), void (r.startY = p);
                if (!n.allowTouchMove)
                    return (
                        l.target.matches(i.focusableElements) || (n.allowClick = !1),
                        void (
                            i.isTouched &&
                            (Object.assign(r, {
                                startX: u,
                                startY: p,
                                prevX: n.touches.currentX,
                                prevY: n.touches.currentY,
                                currentX: u,
                                currentY: p,
                            }),
                            (i.touchStartTime = Ue()))
                        )
                    );
                if (s.touchReleaseOnEdges && !s.loop)
                    if (n.isVertical()) {
                        if (
                            (p < r.startY && n.translate <= n.maxTranslate()) ||
                            (p > r.startY && n.translate >= n.minTranslate())
                        )
                            return (i.isTouched = !1), void (i.isMoved = !1);
                    } else if (
                        (u < r.startX && n.translate <= n.maxTranslate()) ||
                        (u > r.startX && n.translate >= n.minTranslate())
                    )
                        return;
                if (t.activeElement && l.target === t.activeElement && l.target.matches(i.focusableElements))
                    return (i.isMoved = !0), void (n.allowClick = !1);
                if ((i.allowTouchCallbacks && n.emit("touchMove", l), l.targetTouches && l.targetTouches.length > 1))
                    return;
                (r.currentX = u), (r.currentY = p);
                const h = r.currentX - r.startX,
                    f = r.currentY - r.startY;
                if (n.params.threshold && Math.sqrt(h ** 2 + f ** 2) < n.params.threshold) return;
                if (void 0 === i.isScrolling) {
                    let e;
                    (n.isHorizontal() && r.currentY === r.startY) || (n.isVertical() && r.currentX === r.startX)
                        ? (i.isScrolling = !1)
                        : h * h + f * f >= 25 &&
                          ((e = (180 * Math.atan2(Math.abs(f), Math.abs(h))) / Math.PI),
                          (i.isScrolling = n.isHorizontal() ? e > s.touchAngle : 90 - e > s.touchAngle));
                }
                if (
                    (i.isScrolling && n.emit("touchMoveOpposite", l),
                    void 0 === i.startMoving &&
                        ((r.currentX === r.startX && r.currentY === r.startY) || (i.startMoving = !0)),
                    i.isScrolling || (n.zoom && n.params.zoom && n.params.zoom.enabled && i.evCache.length > 1))
                )
                    return void (i.isTouched = !1);
                if (!i.startMoving) return;
                (n.allowClick = !1),
                    !s.cssMode && l.cancelable && l.preventDefault(),
                    s.touchMoveStopPropagation && !s.nested && l.stopPropagation();
                let m = n.isHorizontal() ? h : f,
                    g = n.isHorizontal() ? r.currentX - r.previousX : r.currentY - r.previousY;
                s.oneWayMovement && ((m = Math.abs(m) * (a ? 1 : -1)), (g = Math.abs(g) * (a ? 1 : -1))),
                    (r.diff = m),
                    (m *= s.touchRatio),
                    a && ((m = -m), (g = -g));
                const v = n.touchesDirection;
                (n.swipeDirection = m > 0 ? "prev" : "next"), (n.touchesDirection = g > 0 ? "prev" : "next");
                const y = n.params.loop && !s.cssMode;
                if (!i.isMoved) {
                    if (
                        (y && n.loopFix({ direction: n.swipeDirection }),
                        (i.startTranslate = n.getTranslate()),
                        n.setTransition(0),
                        n.animating)
                    ) {
                        const e = new window.CustomEvent("transitionend", { bubbles: !0, cancelable: !0 });
                        n.wrapperEl.dispatchEvent(e);
                    }
                    (i.allowMomentumBounce = !1),
                        !s.grabCursor || (!0 !== n.allowSlideNext && !0 !== n.allowSlidePrev) || n.setGrabCursor(!0),
                        n.emit("sliderFirstMove", l);
                }
                let b;
                i.isMoved &&
                    v !== n.touchesDirection &&
                    y &&
                    Math.abs(m) >= 1 &&
                    (n.loopFix({ direction: n.swipeDirection, setTranslate: !0 }), (b = !0)),
                    n.emit("sliderMove", l),
                    (i.isMoved = !0),
                    (i.currentTranslate = m + i.startTranslate);
                let w = !0,
                    C = s.resistanceRatio;
                if (
                    (s.touchReleaseOnEdges && (C = 0),
                    m > 0
                        ? (y &&
                              !b &&
                              i.currentTranslate >
                                  (s.centeredSlides ? n.minTranslate() - n.size / 2 : n.minTranslate()) &&
                              n.loopFix({ direction: "prev", setTranslate: !0, activeSlideIndex: 0 }),
                          i.currentTranslate > n.minTranslate() &&
                              ((w = !1),
                              s.resistance &&
                                  (i.currentTranslate =
                                      n.minTranslate() - 1 + (-n.minTranslate() + i.startTranslate + m) ** C)))
                        : m < 0 &&
                          (y &&
                              !b &&
                              i.currentTranslate <
                                  (s.centeredSlides ? n.maxTranslate() + n.size / 2 : n.maxTranslate()) &&
                              n.loopFix({
                                  direction: "next",
                                  setTranslate: !0,
                                  activeSlideIndex:
                                      n.slides.length -
                                      ("auto" === s.slidesPerView
                                          ? n.slidesPerViewDynamic()
                                          : Math.ceil(parseFloat(s.slidesPerView, 10))),
                              }),
                          i.currentTranslate < n.maxTranslate() &&
                              ((w = !1),
                              s.resistance &&
                                  (i.currentTranslate =
                                      n.maxTranslate() + 1 - (n.maxTranslate() - i.startTranslate - m) ** C))),
                    w && (l.preventedByNestedSwiper = !0),
                    !n.allowSlideNext &&
                        "next" === n.swipeDirection &&
                        i.currentTranslate < i.startTranslate &&
                        (i.currentTranslate = i.startTranslate),
                    !n.allowSlidePrev &&
                        "prev" === n.swipeDirection &&
                        i.currentTranslate > i.startTranslate &&
                        (i.currentTranslate = i.startTranslate),
                    n.allowSlidePrev || n.allowSlideNext || (i.currentTranslate = i.startTranslate),
                    s.threshold > 0)
                ) {
                    if (!(Math.abs(m) > s.threshold || i.allowThresholdMove))
                        return void (i.currentTranslate = i.startTranslate);
                    if (!i.allowThresholdMove)
                        return (
                            (i.allowThresholdMove = !0),
                            (r.startX = r.currentX),
                            (r.startY = r.currentY),
                            (i.currentTranslate = i.startTranslate),
                            void (r.diff = n.isHorizontal() ? r.currentX - r.startX : r.currentY - r.startY)
                        );
                }
                s.followFinger &&
                    !s.cssMode &&
                    (((s.freeMode && s.freeMode.enabled && n.freeMode) || s.watchSlidesProgress) &&
                        (n.updateActiveIndex(), n.updateSlidesClasses()),
                    s.freeMode && s.freeMode.enabled && n.freeMode && n.freeMode.onTouchMove(),
                    n.updateProgress(i.currentTranslate),
                    n.setTranslate(i.currentTranslate));
            }
            function St(e) {
                const t = this,
                    n = t.touchEventsData,
                    i = n.evCache.findIndex((t) => t.pointerId === e.pointerId);
                if (
                    (i >= 0 && n.evCache.splice(i, 1),
                    ["pointercancel", "pointerout", "pointerleave"].includes(e.type) &&
                        ("pointercancel" !== e.type || (!t.browser.isSafari && !t.browser.isWebView)))
                )
                    return;
                const { params: s, touches: r, rtlTranslate: a, slidesGrid: o, enabled: l } = t;
                if (!l) return;
                if (!s.simulateTouch && "mouse" === e.pointerType) return;
                let c = e;
                if (
                    (c.originalEvent && (c = c.originalEvent),
                    n.allowTouchCallbacks && t.emit("touchEnd", c),
                    (n.allowTouchCallbacks = !1),
                    !n.isTouched)
                )
                    return (
                        n.isMoved && s.grabCursor && t.setGrabCursor(!1), (n.isMoved = !1), void (n.startMoving = !1)
                    );
                s.grabCursor &&
                    n.isMoved &&
                    n.isTouched &&
                    (!0 === t.allowSlideNext || !0 === t.allowSlidePrev) &&
                    t.setGrabCursor(!1);
                const d = Ue(),
                    u = d - n.touchStartTime;
                if (t.allowClick) {
                    const e = c.path || (c.composedPath && c.composedPath());
                    t.updateClickedSlide((e && e[0]) || c.target),
                        t.emit("tap click", c),
                        u < 300 && d - n.lastClickTime < 300 && t.emit("doubleTap doubleClick", c);
                }
                if (
                    ((n.lastClickTime = Ue()),
                    We(() => {
                        t.destroyed || (t.allowClick = !0);
                    }),
                    !n.isTouched ||
                        !n.isMoved ||
                        !t.swipeDirection ||
                        0 === r.diff ||
                        n.currentTranslate === n.startTranslate)
                )
                    return (n.isTouched = !1), (n.isMoved = !1), void (n.startMoving = !1);
                let p;
                if (
                    ((n.isTouched = !1),
                    (n.isMoved = !1),
                    (n.startMoving = !1),
                    (p = s.followFinger ? (a ? t.translate : -t.translate) : -n.currentTranslate),
                    s.cssMode)
                )
                    return;
                if (s.freeMode && s.freeMode.enabled) return void t.freeMode.onTouchEnd({ currentPos: p });
                let h = 0,
                    f = t.slidesSizesGrid[0];
                for (let e = 0; e < o.length; e += e < s.slidesPerGroupSkip ? 1 : s.slidesPerGroup) {
                    const t = e < s.slidesPerGroupSkip - 1 ? 1 : s.slidesPerGroup;
                    void 0 !== o[e + t]
                        ? p >= o[e] && p < o[e + t] && ((h = e), (f = o[e + t] - o[e]))
                        : p >= o[e] && ((h = e), (f = o[o.length - 1] - o[o.length - 2]));
                }
                let m = null,
                    g = null;
                s.rewind &&
                    (t.isBeginning
                        ? (g =
                              s.virtual && s.virtual.enabled && t.virtual
                                  ? t.virtual.slides.length - 1
                                  : t.slides.length - 1)
                        : t.isEnd && (m = 0));
                const v = (p - o[h]) / f,
                    y = h < s.slidesPerGroupSkip - 1 ? 1 : s.slidesPerGroup;
                if (u > s.longSwipesMs) {
                    if (!s.longSwipes) return void t.slideTo(t.activeIndex);
                    "next" === t.swipeDirection &&
                        (v >= s.longSwipesRatio ? t.slideTo(s.rewind && t.isEnd ? m : h + y) : t.slideTo(h)),
                        "prev" === t.swipeDirection &&
                            (v > 1 - s.longSwipesRatio
                                ? t.slideTo(h + y)
                                : null !== g && v < 0 && Math.abs(v) > s.longSwipesRatio
                                  ? t.slideTo(g)
                                  : t.slideTo(h));
                } else {
                    if (!s.shortSwipes) return void t.slideTo(t.activeIndex);
                    !t.navigation || (c.target !== t.navigation.nextEl && c.target !== t.navigation.prevEl)
                        ? ("next" === t.swipeDirection && t.slideTo(null !== m ? m : h + y),
                          "prev" === t.swipeDirection && t.slideTo(null !== g ? g : h))
                        : c.target === t.navigation.nextEl
                          ? t.slideTo(h + y)
                          : t.slideTo(h);
                }
            }
            function Et() {
                const e = this,
                    { params: t, el: n } = e;
                if (n && 0 === n.offsetWidth) return;
                t.breakpoints && e.setBreakpoint();
                const { allowSlideNext: i, allowSlidePrev: s, snapGrid: r } = e,
                    a = e.virtual && e.params.virtual.enabled;
                (e.allowSlideNext = !0),
                    (e.allowSlidePrev = !0),
                    e.updateSize(),
                    e.updateSlides(),
                    e.updateSlidesClasses();
                const o = a && t.loop;
                !("auto" === t.slidesPerView || t.slidesPerView > 1) ||
                !e.isEnd ||
                e.isBeginning ||
                e.params.centeredSlides ||
                o
                    ? e.params.loop && !a
                        ? e.slideToLoop(e.realIndex, 0, !1, !0)
                        : e.slideTo(e.activeIndex, 0, !1, !0)
                    : e.slideTo(e.slides.length - 1, 0, !1, !0),
                    e.autoplay &&
                        e.autoplay.running &&
                        e.autoplay.paused &&
                        (clearTimeout(e.autoplay.resizeTimeout),
                        (e.autoplay.resizeTimeout = setTimeout(() => {
                            e.autoplay && e.autoplay.running && e.autoplay.paused && e.autoplay.resume();
                        }, 500))),
                    (e.allowSlidePrev = s),
                    (e.allowSlideNext = i),
                    e.params.watchOverflow && r !== e.snapGrid && e.checkOverflow();
            }
            function Tt(e) {
                const t = this;
                t.enabled &&
                    (t.allowClick ||
                        (t.params.preventClicks && e.preventDefault(),
                        t.params.preventClicksPropagation &&
                            t.animating &&
                            (e.stopPropagation(), e.stopImmediatePropagation())));
            }
            function $t() {
                const e = this,
                    { wrapperEl: t, rtlTranslate: n, enabled: i } = e;
                if (!i) return;
                let s;
                (e.previousTranslate = e.translate),
                    e.isHorizontal() ? (e.translate = -t.scrollLeft) : (e.translate = -t.scrollTop),
                    0 === e.translate && (e.translate = 0),
                    e.updateActiveIndex(),
                    e.updateSlidesClasses();
                const r = e.maxTranslate() - e.minTranslate();
                (s = 0 === r ? 0 : (e.translate - e.minTranslate()) / r),
                    s !== e.progress && e.updateProgress(n ? -e.translate : e.translate),
                    e.emit("setTranslate", e.translate, !1);
            }
            function kt(e) {
                const t = this;
                ht(t, e.target),
                    t.params.cssMode || ("auto" !== t.params.slidesPerView && !t.params.autoHeight) || t.update();
            }
            let Mt = !1;
            function Lt() {}
            const At = (e, t) => {
                    const n = Re(),
                        { params: i, el: s, wrapperEl: r, device: a } = e,
                        o = !!i.nested,
                        l = "on" === t ? "addEventListener" : "removeEventListener",
                        c = t;
                    s[l]("pointerdown", e.onTouchStart, { passive: !1 }),
                        n[l]("pointermove", e.onTouchMove, { passive: !1, capture: o }),
                        n[l]("pointerup", e.onTouchEnd, { passive: !0 }),
                        n[l]("pointercancel", e.onTouchEnd, { passive: !0 }),
                        n[l]("pointerout", e.onTouchEnd, { passive: !0 }),
                        n[l]("pointerleave", e.onTouchEnd, { passive: !0 }),
                        (i.preventClicks || i.preventClicksPropagation) && s[l]("click", e.onClick, !0),
                        i.cssMode && r[l]("scroll", e.onScroll),
                        i.updateOnWindowResize
                            ? e[c](
                                  a.ios || a.android
                                      ? "resize orientationchange observerUpdate"
                                      : "resize observerUpdate",
                                  Et,
                                  !0
                              )
                            : e[c]("observerUpdate", Et, !0),
                        s[l]("load", e.onLoad, { capture: !0 });
                },
                It = (e, t) => e.grid && t.grid && t.grid.rows > 1;
            var _t = {
                    setBreakpoint: function () {
                        const e = this,
                            { realIndex: t, initialized: n, params: i, el: s } = e,
                            r = i.breakpoints;
                        if (!r || (r && 0 === Object.keys(r).length)) return;
                        const a = e.getBreakpoint(r, e.params.breakpointsBase, e.el);
                        if (!a || e.currentBreakpoint === a) return;
                        const o = (a in r ? r[a] : void 0) || e.originalParams,
                            l = It(e, i),
                            c = It(e, o),
                            d = i.enabled;
                        l && !c
                            ? (s.classList.remove(
                                  `${i.containerModifierClass}grid`,
                                  `${i.containerModifierClass}grid-column`
                              ),
                              e.emitContainerClasses())
                            : !l &&
                              c &&
                              (s.classList.add(`${i.containerModifierClass}grid`),
                              ((o.grid.fill && "column" === o.grid.fill) ||
                                  (!o.grid.fill && "column" === i.grid.fill)) &&
                                  s.classList.add(`${i.containerModifierClass}grid-column`),
                              e.emitContainerClasses()),
                            ["navigation", "pagination", "scrollbar"].forEach((t) => {
                                if (void 0 === o[t]) return;
                                const n = i[t] && i[t].enabled,
                                    s = o[t] && o[t].enabled;
                                n && !s && e[t].disable(), !n && s && e[t].enable();
                            });
                        const u = o.direction && o.direction !== i.direction,
                            p = i.loop && (o.slidesPerView !== i.slidesPerView || u);
                        u && n && e.changeDirection(), Ke(e.params, o);
                        const h = e.params.enabled;
                        Object.assign(e, {
                            allowTouchMove: e.params.allowTouchMove,
                            allowSlideNext: e.params.allowSlideNext,
                            allowSlidePrev: e.params.allowSlidePrev,
                        }),
                            d && !h ? e.disable() : !d && h && e.enable(),
                            (e.currentBreakpoint = a),
                            e.emit("_beforeBreakpoint", o),
                            p && n && (e.loopDestroy(), e.loopCreate(t), e.updateSlides()),
                            e.emit("breakpoint", o);
                    },
                    getBreakpoint: function (e, t = "window", n) {
                        if (!e || ("container" === t && !n)) return;
                        let i = !1;
                        const s = Ge(),
                            r = "window" === t ? s.innerHeight : n.clientHeight,
                            a = Object.keys(e).map((e) => {
                                if ("string" == typeof e && 0 === e.indexOf("@")) {
                                    const t = parseFloat(e.substr(1));
                                    return { value: r * t, point: e };
                                }
                                return { value: e, point: e };
                            });
                        a.sort((e, t) => parseInt(e.value, 10) - parseInt(t.value, 10));
                        for (let e = 0; e < a.length; e += 1) {
                            const { point: r, value: o } = a[e];
                            "window" === t
                                ? s.matchMedia(`(min-width: ${o}px)`).matches && (i = r)
                                : o <= n.clientWidth && (i = r);
                        }
                        return i || "max";
                    },
                },
                Pt = {
                    init: !0,
                    direction: "horizontal",
                    oneWayMovement: !1,
                    touchEventsTarget: "wrapper",
                    initialSlide: 0,
                    speed: 300,
                    cssMode: !1,
                    updateOnWindowResize: !0,
                    resizeObserver: !0,
                    nested: !1,
                    createElements: !1,
                    enabled: !0,
                    focusableElements: "input, select, option, textarea, button, video, label",
                    width: null,
                    height: null,
                    preventInteractionOnTransition: !1,
                    userAgent: null,
                    url: null,
                    edgeSwipeDetection: !1,
                    edgeSwipeThreshold: 20,
                    autoHeight: !1,
                    setWrapperSize: !1,
                    virtualTranslate: !1,
                    effect: "slide",
                    breakpoints: void 0,
                    breakpointsBase: "window",
                    spaceBetween: 0,
                    slidesPerView: 1,
                    slidesPerGroup: 1,
                    slidesPerGroupSkip: 0,
                    slidesPerGroupAuto: !1,
                    centeredSlides: !1,
                    centeredSlidesBounds: !1,
                    slidesOffsetBefore: 0,
                    slidesOffsetAfter: 0,
                    normalizeSlideIndex: !0,
                    centerInsufficientSlides: !1,
                    watchOverflow: !0,
                    roundLengths: !1,
                    touchRatio: 1,
                    touchAngle: 45,
                    simulateTouch: !0,
                    shortSwipes: !0,
                    longSwipes: !0,
                    longSwipesRatio: 0.5,
                    longSwipesMs: 300,
                    followFinger: !0,
                    allowTouchMove: !0,
                    threshold: 5,
                    touchMoveStopPropagation: !1,
                    touchStartPreventDefault: !0,
                    touchStartForcePreventDefault: !1,
                    touchReleaseOnEdges: !1,
                    uniqueNavElements: !0,
                    resistance: !0,
                    resistanceRatio: 0.85,
                    watchSlidesProgress: !1,
                    grabCursor: !1,
                    preventClicks: !0,
                    preventClicksPropagation: !0,
                    slideToClickedSlide: !1,
                    loop: !1,
                    loopedSlides: null,
                    loopPreventsSliding: !0,
                    rewind: !1,
                    allowSlidePrev: !0,
                    allowSlideNext: !0,
                    swipeHandler: null,
                    noSwiping: !0,
                    noSwipingClass: "swiper-no-swiping",
                    noSwipingSelector: null,
                    passiveListeners: !0,
                    maxBackfaceHiddenSlides: 10,
                    containerModifierClass: "swiper-",
                    slideClass: "swiper-slide",
                    slideActiveClass: "swiper-slide-active",
                    slideVisibleClass: "swiper-slide-visible",
                    slideNextClass: "swiper-slide-next",
                    slidePrevClass: "swiper-slide-prev",
                    wrapperClass: "swiper-wrapper",
                    lazyPreloaderClass: "swiper-lazy-preloader",
                    lazyPreloadPrevNext: 0,
                    runCallbacksOnInit: !0,
                    _emitClasses: !1,
                };
            function Dt(e, t) {
                return function (n = {}) {
                    const i = Object.keys(n)[0],
                        s = n[i];
                    "object" == typeof s && null !== s
                        ? (["navigation", "pagination", "scrollbar"].indexOf(i) >= 0 &&
                              !0 === e[i] &&
                              (e[i] = { auto: !0 }),
                          i in e && "enabled" in s
                              ? (!0 === e[i] && (e[i] = { enabled: !0 }),
                                "object" != typeof e[i] || "enabled" in e[i] || (e[i].enabled = !0),
                                e[i] || (e[i] = { enabled: !1 }),
                                Ke(t, n))
                              : Ke(t, n))
                        : Ke(t, n);
                };
            }
            const Ot = {
                    eventsEmitter: pt,
                    update: gt,
                    translate: vt,
                    transition: {
                        setTransition: function (e, t) {
                            const n = this;
                            n.params.cssMode || (n.wrapperEl.style.transitionDuration = `${e}ms`),
                                n.emit("setTransition", e, t);
                        },
                        transitionStart: function (e = !0, t) {
                            const n = this,
                                { params: i } = n;
                            i.cssMode ||
                                (i.autoHeight && n.updateAutoHeight(),
                                yt({ swiper: n, runCallbacks: e, direction: t, step: "Start" }));
                        },
                        transitionEnd: function (e = !0, t) {
                            const n = this,
                                { params: i } = n;
                            (n.animating = !1),
                                i.cssMode ||
                                    (n.setTransition(0), yt({ swiper: n, runCallbacks: e, direction: t, step: "End" }));
                        },
                    },
                    slide: bt,
                    loop: wt,
                    grabCursor: {
                        setGrabCursor: function (e) {
                            const t = this;
                            if (!t.params.simulateTouch || (t.params.watchOverflow && t.isLocked) || t.params.cssMode)
                                return;
                            const n = "container" === t.params.touchEventsTarget ? t.el : t.wrapperEl;
                            t.isElement && (t.__preventObserver__ = !0),
                                (n.style.cursor = "move"),
                                (n.style.cursor = e ? "grabbing" : "grab"),
                                t.isElement &&
                                    requestAnimationFrame(() => {
                                        t.__preventObserver__ = !1;
                                    });
                        },
                        unsetGrabCursor: function () {
                            const e = this;
                            (e.params.watchOverflow && e.isLocked) ||
                                e.params.cssMode ||
                                (e.isElement && (e.__preventObserver__ = !0),
                                (e["container" === e.params.touchEventsTarget ? "el" : "wrapperEl"].style.cursor = ""),
                                e.isElement &&
                                    requestAnimationFrame(() => {
                                        e.__preventObserver__ = !1;
                                    }));
                        },
                    },
                    events: {
                        attachEvents: function () {
                            const e = this,
                                t = Re(),
                                { params: n } = e;
                            (e.onTouchStart = Ct.bind(e)),
                                (e.onTouchMove = xt.bind(e)),
                                (e.onTouchEnd = St.bind(e)),
                                n.cssMode && (e.onScroll = $t.bind(e)),
                                (e.onClick = Tt.bind(e)),
                                (e.onLoad = kt.bind(e)),
                                Mt || (t.addEventListener("touchstart", Lt), (Mt = !0)),
                                At(e, "on");
                        },
                        detachEvents: function () {
                            At(this, "off");
                        },
                    },
                    breakpoints: _t,
                    checkOverflow: {
                        checkOverflow: function () {
                            const e = this,
                                { isLocked: t, params: n } = e,
                                { slidesOffsetBefore: i } = n;
                            if (i) {
                                const t = e.slides.length - 1,
                                    n = e.slidesGrid[t] + e.slidesSizesGrid[t] + 2 * i;
                                e.isLocked = e.size > n;
                            } else e.isLocked = 1 === e.snapGrid.length;
                            !0 === n.allowSlideNext && (e.allowSlideNext = !e.isLocked),
                                !0 === n.allowSlidePrev && (e.allowSlidePrev = !e.isLocked),
                                t && t !== e.isLocked && (e.isEnd = !1),
                                t !== e.isLocked && e.emit(e.isLocked ? "lock" : "unlock");
                        },
                    },
                    classes: {
                        addClasses: function () {
                            const e = this,
                                { classNames: t, params: n, rtl: i, el: s, device: r } = e,
                                a = (function (e, t) {
                                    const n = [];
                                    return (
                                        e.forEach((e) => {
                                            "object" == typeof e
                                                ? Object.keys(e).forEach((i) => {
                                                      e[i] && n.push(t + i);
                                                  })
                                                : "string" == typeof e && n.push(t + e);
                                        }),
                                        n
                                    );
                                })(
                                    [
                                        "initialized",
                                        n.direction,
                                        { "free-mode": e.params.freeMode && n.freeMode.enabled },
                                        { autoheight: n.autoHeight },
                                        { rtl: i },
                                        { grid: n.grid && n.grid.rows > 1 },
                                        { "grid-column": n.grid && n.grid.rows > 1 && "column" === n.grid.fill },
                                        { android: r.android },
                                        { ios: r.ios },
                                        { "css-mode": n.cssMode },
                                        { centered: n.cssMode && n.centeredSlides },
                                        { "watch-progress": n.watchSlidesProgress },
                                    ],
                                    n.containerModifierClass
                                );
                            t.push(...a), s.classList.add(...t), e.emitContainerClasses();
                        },
                        removeClasses: function () {
                            const { el: e, classNames: t } = this;
                            e.classList.remove(...t), this.emitContainerClasses();
                        },
                    },
                },
                Nt = {};
            class Ft {
                constructor(...e) {
                    let t, n;
                    1 === e.length && e[0].constructor && "Object" === Object.prototype.toString.call(e[0]).slice(8, -1)
                        ? (n = e[0])
                        : ([t, n] = e),
                        n || (n = {}),
                        (n = Ke({}, n)),
                        t && !n.el && (n.el = t);
                    const i = Re();
                    if (n.el && "string" == typeof n.el && i.querySelectorAll(n.el).length > 1) {
                        const e = [];
                        return (
                            i.querySelectorAll(n.el).forEach((t) => {
                                const i = Ke({}, n, { el: t });
                                e.push(new Ft(i));
                            }),
                            e
                        );
                    }
                    const s = this;
                    (s.__swiper__ = !0),
                        (s.support = ut()),
                        (s.device = (function (e = {}) {
                            return (
                                ct ||
                                    (ct = (function ({ userAgent: e } = {}) {
                                        const t = ut(),
                                            n = Ge(),
                                            i = n.navigator.platform,
                                            s = e || n.navigator.userAgent,
                                            r = { ios: !1, android: !1 },
                                            a = n.screen.width,
                                            o = n.screen.height,
                                            l = s.match(/(Android);?[\s\/]+([\d.]+)?/);
                                        let c = s.match(/(iPad).*OS\s([\d_]+)/);
                                        const d = s.match(/(iPod)(.*OS\s([\d_]+))?/),
                                            u = !c && s.match(/(iPhone\sOS|iOS)\s([\d_]+)/),
                                            p = "Win32" === i;
                                        let h = "MacIntel" === i;
                                        return (
                                            !c &&
                                                h &&
                                                t.touch &&
                                                [
                                                    "1024x1366",
                                                    "1366x1024",
                                                    "834x1194",
                                                    "1194x834",
                                                    "834x1112",
                                                    "1112x834",
                                                    "768x1024",
                                                    "1024x768",
                                                    "820x1180",
                                                    "1180x820",
                                                    "810x1080",
                                                    "1080x810",
                                                ].indexOf(`${a}x${o}`) >= 0 &&
                                                ((c = s.match(/(Version)\/([\d.]+)/)),
                                                c || (c = [0, 1, "13_0_0"]),
                                                (h = !1)),
                                            l && !p && ((r.os = "android"), (r.android = !0)),
                                            (c || u || d) && ((r.os = "ios"), (r.ios = !0)),
                                            r
                                        );
                                    })(e)),
                                ct
                            );
                        })({ userAgent: n.userAgent })),
                        (s.browser =
                            (dt ||
                                (dt = (function () {
                                    const e = Ge();
                                    let t = !1;
                                    function n() {
                                        const t = e.navigator.userAgent.toLowerCase();
                                        return (
                                            t.indexOf("safari") >= 0 &&
                                            t.indexOf("chrome") < 0 &&
                                            t.indexOf("android") < 0
                                        );
                                    }
                                    if (n()) {
                                        const n = String(e.navigator.userAgent);
                                        if (n.includes("Version/")) {
                                            const [e, i] = n
                                                .split("Version/")[1]
                                                .split(" ")[0]
                                                .split(".")
                                                .map((e) => Number(e));
                                            t = e < 16 || (16 === e && i < 2);
                                        }
                                    }
                                    return {
                                        isSafari: t || n(),
                                        needPerspectiveFix: t,
                                        isWebView: /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(
                                            e.navigator.userAgent
                                        ),
                                    };
                                })()),
                            dt)),
                        (s.eventsListeners = {}),
                        (s.eventsAnyListeners = []),
                        (s.modules = [...s.__modules__]),
                        n.modules && Array.isArray(n.modules) && s.modules.push(...n.modules);
                    const r = {};
                    s.modules.forEach((e) => {
                        e({
                            params: n,
                            swiper: s,
                            extendParams: Dt(n, r),
                            on: s.on.bind(s),
                            once: s.once.bind(s),
                            off: s.off.bind(s),
                            emit: s.emit.bind(s),
                        });
                    });
                    const a = Ke({}, Pt, r);
                    return (
                        (s.params = Ke({}, a, Nt, n)),
                        (s.originalParams = Ke({}, s.params)),
                        (s.passedParams = Ke({}, n)),
                        s.params &&
                            s.params.on &&
                            Object.keys(s.params.on).forEach((e) => {
                                s.on(e, s.params.on[e]);
                            }),
                        s.params && s.params.onAny && s.onAny(s.params.onAny),
                        Object.assign(s, {
                            enabled: s.params.enabled,
                            el: t,
                            classNames: [],
                            slides: [],
                            slidesGrid: [],
                            snapGrid: [],
                            slidesSizesGrid: [],
                            isHorizontal() {
                                return "horizontal" === s.params.direction;
                            },
                            isVertical() {
                                return "vertical" === s.params.direction;
                            },
                            activeIndex: 0,
                            realIndex: 0,
                            isBeginning: !0,
                            isEnd: !1,
                            translate: 0,
                            previousTranslate: 0,
                            progress: 0,
                            velocity: 0,
                            animating: !1,
                            cssOverflowAdjustment() {
                                return Math.trunc(this.translate / 2 ** 23) * 2 ** 23;
                            },
                            allowSlideNext: s.params.allowSlideNext,
                            allowSlidePrev: s.params.allowSlidePrev,
                            touchEventsData: {
                                isTouched: void 0,
                                isMoved: void 0,
                                allowTouchCallbacks: void 0,
                                touchStartTime: void 0,
                                isScrolling: void 0,
                                currentTranslate: void 0,
                                startTranslate: void 0,
                                allowThresholdMove: void 0,
                                focusableElements: s.params.focusableElements,
                                lastClickTime: 0,
                                clickTimeout: void 0,
                                velocities: [],
                                allowMomentumBounce: void 0,
                                startMoving: void 0,
                                evCache: [],
                            },
                            allowClick: !0,
                            allowTouchMove: s.params.allowTouchMove,
                            touches: { startX: 0, startY: 0, currentX: 0, currentY: 0, diff: 0 },
                            imagesToLoad: [],
                            imagesLoaded: 0,
                        }),
                        s.emit("_swiper"),
                        s.params.init && s.init(),
                        s
                    );
                }
                getSlideIndex(e) {
                    const { slidesEl: t, params: n } = this,
                        i = st(et(t, `.${n.slideClass}, swiper-slide`)[0]);
                    return st(e) - i;
                }
                getSlideIndexByData(e) {
                    return this.getSlideIndex(
                        this.slides.filter((t) => 1 * t.getAttribute("data-swiper-slide-index") === e)[0]
                    );
                }
                recalcSlides() {
                    const { slidesEl: e, params: t } = this;
                    this.slides = et(e, `.${t.slideClass}, swiper-slide`);
                }
                enable() {
                    const e = this;
                    e.enabled || ((e.enabled = !0), e.params.grabCursor && e.setGrabCursor(), e.emit("enable"));
                }
                disable() {
                    const e = this;
                    e.enabled && ((e.enabled = !1), e.params.grabCursor && e.unsetGrabCursor(), e.emit("disable"));
                }
                setProgress(e, t) {
                    const n = this;
                    e = Math.min(Math.max(e, 0), 1);
                    const i = n.minTranslate(),
                        s = (n.maxTranslate() - i) * e + i;
                    n.translateTo(s, void 0 === t ? 0 : t), n.updateActiveIndex(), n.updateSlidesClasses();
                }
                emitContainerClasses() {
                    const e = this;
                    if (!e.params._emitClasses || !e.el) return;
                    const t = e.el.className
                        .split(" ")
                        .filter((t) => 0 === t.indexOf("swiper") || 0 === t.indexOf(e.params.containerModifierClass));
                    e.emit("_containerClasses", t.join(" "));
                }
                getSlideClasses(e) {
                    const t = this;
                    return t.destroyed
                        ? ""
                        : e.className
                              .split(" ")
                              .filter((e) => 0 === e.indexOf("swiper-slide") || 0 === e.indexOf(t.params.slideClass))
                              .join(" ");
                }
                emitSlidesClasses() {
                    const e = this;
                    if (!e.params._emitClasses || !e.el) return;
                    const t = [];
                    e.slides.forEach((n) => {
                        const i = e.getSlideClasses(n);
                        t.push({ slideEl: n, classNames: i }), e.emit("_slideClass", n, i);
                    }),
                        e.emit("_slideClasses", t);
                }
                slidesPerViewDynamic(e = "current", t = !1) {
                    const { params: n, slides: i, slidesGrid: s, slidesSizesGrid: r, size: a, activeIndex: o } = this;
                    let l = 1;
                    if (n.centeredSlides) {
                        let e,
                            t = i[o] ? i[o].swiperSlideSize : 0;
                        for (let n = o + 1; n < i.length; n += 1)
                            i[n] && !e && ((t += i[n].swiperSlideSize), (l += 1), t > a && (e = !0));
                        for (let n = o - 1; n >= 0; n -= 1)
                            i[n] && !e && ((t += i[n].swiperSlideSize), (l += 1), t > a && (e = !0));
                    } else if ("current" === e)
                        for (let e = o + 1; e < i.length; e += 1)
                            (t ? s[e] + r[e] - s[o] < a : s[e] - s[o] < a) && (l += 1);
                    else for (let e = o - 1; e >= 0; e -= 1) s[o] - s[e] < a && (l += 1);
                    return l;
                }
                update() {
                    const e = this;
                    if (!e || e.destroyed) return;
                    const { snapGrid: t, params: n } = e;
                    function i() {
                        const t = e.rtlTranslate ? -1 * e.translate : e.translate,
                            n = Math.min(Math.max(t, e.maxTranslate()), e.minTranslate());
                        e.setTranslate(n), e.updateActiveIndex(), e.updateSlidesClasses();
                    }
                    let s;
                    if (
                        (n.breakpoints && e.setBreakpoint(),
                        [...e.el.querySelectorAll('[loading="lazy"]')].forEach((t) => {
                            t.complete && ht(e, t);
                        }),
                        e.updateSize(),
                        e.updateSlides(),
                        e.updateProgress(),
                        e.updateSlidesClasses(),
                        n.freeMode && n.freeMode.enabled && !n.cssMode)
                    )
                        i(), n.autoHeight && e.updateAutoHeight();
                    else {
                        if (("auto" === n.slidesPerView || n.slidesPerView > 1) && e.isEnd && !n.centeredSlides) {
                            const t = e.virtual && n.virtual.enabled ? e.virtual.slides : e.slides;
                            s = e.slideTo(t.length - 1, 0, !1, !0);
                        } else s = e.slideTo(e.activeIndex, 0, !1, !0);
                        s || i();
                    }
                    n.watchOverflow && t !== e.snapGrid && e.checkOverflow(), e.emit("update");
                }
                changeDirection(e, t = !0) {
                    const n = this,
                        i = n.params.direction;
                    return (
                        e || (e = "horizontal" === i ? "vertical" : "horizontal"),
                        e === i ||
                            ("horizontal" !== e && "vertical" !== e) ||
                            (n.el.classList.remove(`${n.params.containerModifierClass}${i}`),
                            n.el.classList.add(`${n.params.containerModifierClass}${e}`),
                            n.emitContainerClasses(),
                            (n.params.direction = e),
                            n.slides.forEach((t) => {
                                "vertical" === e ? (t.style.width = "") : (t.style.height = "");
                            }),
                            n.emit("changeDirection"),
                            t && n.update()),
                        n
                    );
                }
                changeLanguageDirection(e) {
                    const t = this;
                    (t.rtl && "rtl" === e) ||
                        (!t.rtl && "ltr" === e) ||
                        ((t.rtl = "rtl" === e),
                        (t.rtlTranslate = "horizontal" === t.params.direction && t.rtl),
                        t.rtl
                            ? (t.el.classList.add(`${t.params.containerModifierClass}rtl`), (t.el.dir = "rtl"))
                            : (t.el.classList.remove(`${t.params.containerModifierClass}rtl`), (t.el.dir = "ltr")),
                        t.update());
                }
                mount(e) {
                    const t = this;
                    if (t.mounted) return !0;
                    let n = e || t.params.el;
                    if (("string" == typeof n && (n = document.querySelector(n)), !n)) return !1;
                    (n.swiper = t), n.shadowEl && (t.isElement = !0);
                    const i = () => `.${(t.params.wrapperClass || "").trim().split(" ").join(".")}`;
                    let s =
                        n && n.shadowRoot && n.shadowRoot.querySelector
                            ? n.shadowRoot.querySelector(i())
                            : et(n, i())[0];
                    return (
                        !s &&
                            t.params.createElements &&
                            ((s = tt("div", t.params.wrapperClass)),
                            n.append(s),
                            et(n, `.${t.params.slideClass}`).forEach((e) => {
                                s.append(e);
                            })),
                        Object.assign(t, {
                            el: n,
                            wrapperEl: s,
                            slidesEl: t.isElement ? n : s,
                            mounted: !0,
                            rtl: "rtl" === n.dir.toLowerCase() || "rtl" === it(n, "direction"),
                            rtlTranslate:
                                "horizontal" === t.params.direction &&
                                ("rtl" === n.dir.toLowerCase() || "rtl" === it(n, "direction")),
                            wrongRTL: "-webkit-box" === it(s, "display"),
                        }),
                        !0
                    );
                }
                init(e) {
                    const t = this;
                    return (
                        t.initialized ||
                            !1 === t.mount(e) ||
                            (t.emit("beforeInit"),
                            t.params.breakpoints && t.setBreakpoint(),
                            t.addClasses(),
                            t.updateSize(),
                            t.updateSlides(),
                            t.params.watchOverflow && t.checkOverflow(),
                            t.params.grabCursor && t.enabled && t.setGrabCursor(),
                            t.params.loop && t.virtual && t.params.virtual.enabled
                                ? t.slideTo(
                                      t.params.initialSlide + t.virtual.slidesBefore,
                                      0,
                                      t.params.runCallbacksOnInit,
                                      !1,
                                      !0
                                  )
                                : t.slideTo(t.params.initialSlide, 0, t.params.runCallbacksOnInit, !1, !0),
                            t.params.loop && t.loopCreate(),
                            t.attachEvents(),
                            [...t.el.querySelectorAll('[loading="lazy"]')].forEach((e) => {
                                e.complete
                                    ? ht(t, e)
                                    : e.addEventListener("load", (e) => {
                                          ht(t, e.target);
                                      });
                            }),
                            mt(t),
                            (t.initialized = !0),
                            mt(t),
                            t.emit("init"),
                            t.emit("afterInit")),
                        t
                    );
                }
                destroy(e = !0, t = !0) {
                    const n = this,
                        { params: i, el: s, wrapperEl: r, slides: a } = n;
                    return (
                        void 0 === n.params ||
                            n.destroyed ||
                            (n.emit("beforeDestroy"),
                            (n.initialized = !1),
                            n.detachEvents(),
                            i.loop && n.loopDestroy(),
                            t &&
                                (n.removeClasses(),
                                s.removeAttribute("style"),
                                r.removeAttribute("style"),
                                a &&
                                    a.length &&
                                    a.forEach((e) => {
                                        e.classList.remove(
                                            i.slideVisibleClass,
                                            i.slideActiveClass,
                                            i.slideNextClass,
                                            i.slidePrevClass
                                        ),
                                            e.removeAttribute("style"),
                                            e.removeAttribute("data-swiper-slide-index");
                                    })),
                            n.emit("destroy"),
                            Object.keys(n.eventsListeners).forEach((e) => {
                                n.off(e);
                            }),
                            !1 !== e &&
                                ((n.el.swiper = null),
                                (function (e) {
                                    const t = e;
                                    Object.keys(t).forEach((e) => {
                                        try {
                                            t[e] = null;
                                        } catch (e) {}
                                        try {
                                            delete t[e];
                                        } catch (e) {}
                                    });
                                })(n)),
                            (n.destroyed = !0)),
                        null
                    );
                }
                static extendDefaults(e) {
                    Ke(Nt, e);
                }
                static get extendedDefaults() {
                    return Nt;
                }
                static get defaults() {
                    return Pt;
                }
                static installModule(e) {
                    Ft.prototype.__modules__ || (Ft.prototype.__modules__ = []);
                    const t = Ft.prototype.__modules__;
                    "function" == typeof e && t.indexOf(e) < 0 && t.push(e);
                }
                static use(e) {
                    return Array.isArray(e) ? (e.forEach((e) => Ft.installModule(e)), Ft) : (Ft.installModule(e), Ft);
                }
            }
            Object.keys(Ot).forEach((e) => {
                Object.keys(Ot[e]).forEach((t) => {
                    Ft.prototype[t] = Ot[e][t];
                });
            }),
                Ft.use([
                    function ({ swiper: e, on: t, emit: n }) {
                        const i = Ge();
                        let s = null,
                            r = null;
                        const a = () => {
                                e && !e.destroyed && e.initialized && (n("beforeResize"), n("resize"));
                            },
                            o = () => {
                                e && !e.destroyed && e.initialized && n("orientationchange");
                            };
                        t("init", () => {
                            e.params.resizeObserver && void 0 !== i.ResizeObserver
                                ? e &&
                                  !e.destroyed &&
                                  e.initialized &&
                                  ((s = new ResizeObserver((t) => {
                                      r = i.requestAnimationFrame(() => {
                                          const { width: n, height: i } = e;
                                          let s = n,
                                              r = i;
                                          t.forEach(({ contentBoxSize: t, contentRect: n, target: i }) => {
                                              (i && i !== e.el) ||
                                                  ((s = n ? n.width : (t[0] || t).inlineSize),
                                                  (r = n ? n.height : (t[0] || t).blockSize));
                                          }),
                                              (s === n && r === i) || a();
                                      });
                                  })),
                                  s.observe(e.el))
                                : (i.addEventListener("resize", a), i.addEventListener("orientationchange", o));
                        }),
                            t("destroy", () => {
                                r && i.cancelAnimationFrame(r),
                                    s && s.unobserve && e.el && (s.unobserve(e.el), (s = null)),
                                    i.removeEventListener("resize", a),
                                    i.removeEventListener("orientationchange", o);
                            });
                    },
                    function ({ swiper: e, extendParams: t, on: n, emit: i }) {
                        const s = [],
                            r = Ge(),
                            a = (t, n = {}) => {
                                const a = new (r.MutationObserver || r.WebkitMutationObserver)((t) => {
                                    if (e.__preventObserver__) return;
                                    if (1 === t.length) return void i("observerUpdate", t[0]);
                                    const n = function () {
                                        i("observerUpdate", t[0]);
                                    };
                                    r.requestAnimationFrame ? r.requestAnimationFrame(n) : r.setTimeout(n, 0);
                                });
                                a.observe(t, {
                                    attributes: void 0 === n.attributes || n.attributes,
                                    childList: void 0 === n.childList || n.childList,
                                    characterData: void 0 === n.characterData || n.characterData,
                                }),
                                    s.push(a);
                            };
                        t({ observer: !1, observeParents: !1, observeSlideChildren: !1 }),
                            n("init", () => {
                                if (e.params.observer) {
                                    if (e.params.observeParents) {
                                        const t = rt(e.el);
                                        for (let e = 0; e < t.length; e += 1) a(t[e]);
                                    }
                                    a(e.el, { childList: e.params.observeSlideChildren }),
                                        a(e.wrapperEl, { attributes: !1 });
                                }
                            }),
                            n("destroy", () => {
                                s.forEach((e) => {
                                    e.disconnect();
                                }),
                                    s.splice(0, s.length);
                            });
                    },
                ]);
            var jt = Ft;
            function zt(e, t, n, i) {
                return (
                    e.params.createElements &&
                        Object.keys(i).forEach((s) => {
                            if (!n[s] && !0 === n.auto) {
                                let r = et(e.el, `.${i[s]}`)[0];
                                r || ((r = tt("div", i[s])), (r.className = i[s]), e.el.append(r)),
                                    (n[s] = r),
                                    (t[s] = r);
                            }
                        }),
                    n
                );
            }
            function Bt(e = "") {
                return `.${e
                    .trim()
                    .replace(/([\.:!+\/])/g, "\\$1")
                    .replace(/ /g, ".")}`;
            }
            function qt(e) {
                const t = this,
                    { params: n, slidesEl: i } = t;
                n.loop && t.loopDestroy();
                const s = (e) => {
                    if ("string" == typeof e) {
                        const t = document.createElement("div");
                        (t.innerHTML = e), i.append(t.children[0]), (t.innerHTML = "");
                    } else i.append(e);
                };
                if ("object" == typeof e && "length" in e) for (let t = 0; t < e.length; t += 1) e[t] && s(e[t]);
                else s(e);
                t.recalcSlides(), n.loop && t.loopCreate(), (n.observer && !t.isElement) || t.update();
            }
            function Ht(e) {
                const t = this,
                    { params: n, activeIndex: i, slidesEl: s } = t;
                n.loop && t.loopDestroy();
                let r = i + 1;
                const a = (e) => {
                    if ("string" == typeof e) {
                        const t = document.createElement("div");
                        (t.innerHTML = e), s.prepend(t.children[0]), (t.innerHTML = "");
                    } else s.prepend(e);
                };
                if ("object" == typeof e && "length" in e) {
                    for (let t = 0; t < e.length; t += 1) e[t] && a(e[t]);
                    r = i + e.length;
                } else a(e);
                t.recalcSlides(),
                    n.loop && t.loopCreate(),
                    (n.observer && !t.isElement) || t.update(),
                    t.slideTo(r, 0, !1);
            }
            function Rt(e, t) {
                const n = this,
                    { params: i, activeIndex: s, slidesEl: r } = n;
                let a = s;
                i.loop && ((a -= n.loopedSlides), n.loopDestroy(), n.recalcSlides());
                const o = n.slides.length;
                if (e <= 0) return void n.prependSlide(t);
                if (e >= o) return void n.appendSlide(t);
                let l = a > e ? a + 1 : a;
                const c = [];
                for (let t = o - 1; t >= e; t -= 1) {
                    const e = n.slides[t];
                    e.remove(), c.unshift(e);
                }
                if ("object" == typeof t && "length" in t) {
                    for (let e = 0; e < t.length; e += 1) t[e] && r.append(t[e]);
                    l = a > e ? a + t.length : a;
                } else r.append(t);
                for (let e = 0; e < c.length; e += 1) r.append(c[e]);
                n.recalcSlides(),
                    i.loop && n.loopCreate(),
                    (i.observer && !n.isElement) || n.update(),
                    i.loop ? n.slideTo(l + n.loopedSlides, 0, !1) : n.slideTo(l, 0, !1);
            }
            function Vt(e) {
                const t = this,
                    { params: n, activeIndex: i } = t;
                let s = i;
                n.loop && ((s -= t.loopedSlides), t.loopDestroy());
                let r,
                    a = s;
                if ("object" == typeof e && "length" in e) {
                    for (let n = 0; n < e.length; n += 1)
                        (r = e[n]), t.slides[r] && t.slides[r].remove(), r < a && (a -= 1);
                    a = Math.max(a, 0);
                } else (r = e), t.slides[r] && t.slides[r].remove(), r < a && (a -= 1), (a = Math.max(a, 0));
                t.recalcSlides(),
                    n.loop && t.loopCreate(),
                    (n.observer && !t.isElement) || t.update(),
                    n.loop ? t.slideTo(a + t.loopedSlides, 0, !1) : t.slideTo(a, 0, !1);
            }
            function Gt() {
                const e = this,
                    t = [];
                for (let n = 0; n < e.slides.length; n += 1) t.push(n);
                e.removeSlide(t);
            }
            function Wt(e) {
                const {
                    effect: t,
                    swiper: n,
                    on: i,
                    setTranslate: s,
                    setTransition: r,
                    overwriteParams: a,
                    perspective: o,
                    recreateShadows: l,
                    getEffectParams: c,
                } = e;
                let d;
                i("beforeInit", () => {
                    if (n.params.effect !== t) return;
                    n.classNames.push(`${n.params.containerModifierClass}${t}`),
                        o && o() && n.classNames.push(`${n.params.containerModifierClass}3d`);
                    const e = a ? a() : {};
                    Object.assign(n.params, e), Object.assign(n.originalParams, e);
                }),
                    i("setTranslate", () => {
                        n.params.effect === t && s();
                    }),
                    i("setTransition", (e, i) => {
                        n.params.effect === t && r(i);
                    }),
                    i("transitionEnd", () => {
                        if (n.params.effect === t && l) {
                            if (!c || !c().slideShadows) return;
                            n.slides.forEach((e) => {
                                e.querySelectorAll(
                                    ".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left"
                                ).forEach((e) => e.remove());
                            }),
                                l();
                        }
                    }),
                    i("virtualUpdate", () => {
                        n.params.effect === t &&
                            (n.slides.length || (d = !0),
                            requestAnimationFrame(() => {
                                d && n.slides && n.slides.length && (s(), (d = !1));
                            }));
                    });
            }
            function Ut(e, t) {
                const n = Ze(t);
                return (
                    n !== t &&
                        ((n.style.backfaceVisibility = "hidden"), (n.style["-webkit-backface-visibility"] = "hidden")),
                    n
                );
            }
            function Xt({ swiper: e, duration: t, transformElements: n, allSlides: i }) {
                const { activeIndex: s } = e;
                if (e.params.virtualTranslate && 0 !== t) {
                    let t,
                        r = !1;
                    (t = i
                        ? n
                        : n.filter((t) => {
                              const n = t.classList.contains("swiper-slide-transform")
                                  ? ((t) =>
                                        t.parentElement
                                            ? t.parentElement
                                            : e.slides.filter((e) => e.shadowEl && e.shadowEl === t.parentNode)[0])(t)
                                  : t;
                              return e.getSlideIndex(n) === s;
                          })),
                        t.forEach((t) => {
                            at(t, () => {
                                if (r) return;
                                if (!e || e.destroyed) return;
                                (r = !0), (e.animating = !1);
                                const t = new window.CustomEvent("transitionend", { bubbles: !0, cancelable: !0 });
                                e.wrapperEl.dispatchEvent(t);
                            });
                        });
                }
            }
            function Yt(e, t, n) {
                const i = "swiper-slide-shadow" + (n ? `-${n}` : ""),
                    s = Ze(t);
                let r = s.querySelector(`.${i}`);
                return r || ((r = tt("div", "swiper-slide-shadow" + (n ? `-${n}` : ""))), s.append(r)), r;
            }
            const Kt = [
                function ({ swiper: e, extendParams: t, on: n, emit: i }) {
                    let s;
                    t({
                        virtual: {
                            enabled: !1,
                            slides: [],
                            cache: !0,
                            renderSlide: null,
                            renderExternal: null,
                            renderExternalUpdate: !0,
                            addSlidesBefore: 0,
                            addSlidesAfter: 0,
                        },
                    });
                    const r = Re();
                    e.virtual = { cache: {}, from: void 0, to: void 0, slides: [], offset: 0, slidesGrid: [] };
                    const a = r.createElement("div");
                    function o(t, n) {
                        const i = e.params.virtual;
                        if (i.cache && e.virtual.cache[n]) return e.virtual.cache[n];
                        let s;
                        return (
                            i.renderSlide
                                ? ((s = i.renderSlide.call(e, t, n)),
                                  "string" == typeof s && ((a.innerHTML = s), (s = a.children[0])))
                                : (s = e.isElement ? tt("swiper-slide") : tt("div", e.params.slideClass)),
                            s.setAttribute("data-swiper-slide-index", n),
                            i.renderSlide || (s.innerHTML = t),
                            i.cache && (e.virtual.cache[n] = s),
                            s
                        );
                    }
                    function l(t) {
                        const { slidesPerView: n, slidesPerGroup: s, centeredSlides: r, loop: a } = e.params,
                            { addSlidesBefore: l, addSlidesAfter: c } = e.params.virtual,
                            { from: d, to: u, slides: p, slidesGrid: h, offset: f } = e.virtual;
                        e.params.cssMode || e.updateActiveIndex();
                        const m = e.activeIndex || 0;
                        let g, v, y;
                        (g = e.rtlTranslate ? "right" : e.isHorizontal() ? "left" : "top"),
                            r
                                ? ((v = Math.floor(n / 2) + s + c), (y = Math.floor(n / 2) + s + l))
                                : ((v = n + (s - 1) + c), (y = (a ? n : s) + l));
                        let b = m - y,
                            w = m + v;
                        a || ((b = Math.max(b, 0)), (w = Math.min(w, p.length - 1)));
                        let C = (e.slidesGrid[b] || 0) - (e.slidesGrid[0] || 0);
                        function x() {
                            e.updateSlides(), e.updateProgress(), e.updateSlidesClasses(), i("virtualUpdate");
                        }
                        if (
                            (a && m >= y
                                ? ((b -= y), r || (C += e.slidesGrid[0]))
                                : a && m < y && ((b = -y), r && (C += e.slidesGrid[0])),
                            Object.assign(e.virtual, {
                                from: b,
                                to: w,
                                offset: C,
                                slidesGrid: e.slidesGrid,
                                slidesBefore: y,
                                slidesAfter: v,
                            }),
                            d === b && u === w && !t)
                        )
                            return (
                                e.slidesGrid !== h &&
                                    C !== f &&
                                    e.slides.forEach((t) => {
                                        t.style[g] = C - Math.abs(e.cssOverflowAdjustment()) + "px";
                                    }),
                                e.updateProgress(),
                                void i("virtualUpdate")
                            );
                        if (e.params.virtual.renderExternal)
                            return (
                                e.params.virtual.renderExternal.call(e, {
                                    offset: C,
                                    from: b,
                                    to: w,
                                    slides: (function () {
                                        const e = [];
                                        for (let t = b; t <= w; t += 1) e.push(p[t]);
                                        return e;
                                    })(),
                                }),
                                void (e.params.virtual.renderExternalUpdate ? x() : i("virtualUpdate"))
                            );
                        const S = [],
                            E = [],
                            T = (e) => {
                                let t = e;
                                return e < 0 ? (t = p.length + e) : t >= p.length && (t -= p.length), t;
                            };
                        if (t)
                            e.slidesEl.querySelectorAll(`.${e.params.slideClass}, swiper-slide`).forEach((e) => {
                                e.remove();
                            });
                        else
                            for (let t = d; t <= u; t += 1)
                                if (t < b || t > w) {
                                    const n = T(t);
                                    e.slidesEl
                                        .querySelectorAll(
                                            `.${e.params.slideClass}[data-swiper-slide-index="${n}"], swiper-slide[data-swiper-slide-index="${n}"]`
                                        )
                                        .forEach((e) => {
                                            e.remove();
                                        });
                                }
                        const $ = a ? -p.length : 0,
                            k = a ? 2 * p.length : p.length;
                        for (let e = $; e < k; e += 1)
                            if (e >= b && e <= w) {
                                const n = T(e);
                                void 0 === u || t ? E.push(n) : (e > u && E.push(n), e < d && S.push(n));
                            }
                        if (
                            (E.forEach((t) => {
                                e.slidesEl.append(o(p[t], t));
                            }),
                            a)
                        )
                            for (let t = S.length - 1; t >= 0; t -= 1) {
                                const n = S[t];
                                e.slidesEl.prepend(o(p[n], n));
                            }
                        else
                            S.sort((e, t) => t - e),
                                S.forEach((t) => {
                                    e.slidesEl.prepend(o(p[t], t));
                                });
                        et(e.slidesEl, ".swiper-slide, swiper-slide").forEach((t) => {
                            t.style[g] = C - Math.abs(e.cssOverflowAdjustment()) + "px";
                        }),
                            x();
                    }
                    n("beforeInit", () => {
                        if (!e.params.virtual.enabled) return;
                        let t;
                        if (void 0 === e.passedParams.virtual.slides) {
                            const n = [...e.slidesEl.children].filter((t) =>
                                t.matches(`.${e.params.slideClass}, swiper-slide`)
                            );
                            n &&
                                n.length &&
                                ((e.virtual.slides = [...n]),
                                (t = !0),
                                n.forEach((t, n) => {
                                    t.setAttribute("data-swiper-slide-index", n), (e.virtual.cache[n] = t), t.remove();
                                }));
                        }
                        t || (e.virtual.slides = e.params.virtual.slides),
                            e.classNames.push(`${e.params.containerModifierClass}virtual`),
                            (e.params.watchSlidesProgress = !0),
                            (e.originalParams.watchSlidesProgress = !0),
                            e.params.initialSlide || l();
                    }),
                        n("setTranslate", () => {
                            e.params.virtual.enabled &&
                                (e.params.cssMode && !e._immediateVirtual
                                    ? (clearTimeout(s),
                                      (s = setTimeout(() => {
                                          l();
                                      }, 100)))
                                    : l());
                        }),
                        n("init update resize", () => {
                            e.params.virtual.enabled &&
                                e.params.cssMode &&
                                Qe(e.wrapperEl, "--swiper-virtual-size", `${e.virtualSize}px`);
                        }),
                        Object.assign(e.virtual, {
                            appendSlide: function (t) {
                                if ("object" == typeof t && "length" in t)
                                    for (let n = 0; n < t.length; n += 1) t[n] && e.virtual.slides.push(t[n]);
                                else e.virtual.slides.push(t);
                                l(!0);
                            },
                            prependSlide: function (t) {
                                const n = e.activeIndex;
                                let i = n + 1,
                                    s = 1;
                                if (Array.isArray(t)) {
                                    for (let n = 0; n < t.length; n += 1) t[n] && e.virtual.slides.unshift(t[n]);
                                    (i = n + t.length), (s = t.length);
                                } else e.virtual.slides.unshift(t);
                                if (e.params.virtual.cache) {
                                    const t = e.virtual.cache,
                                        n = {};
                                    Object.keys(t).forEach((e) => {
                                        const i = t[e],
                                            r = i.getAttribute("data-swiper-slide-index");
                                        r && i.setAttribute("data-swiper-slide-index", parseInt(r, 10) + s),
                                            (n[parseInt(e, 10) + s] = i);
                                    }),
                                        (e.virtual.cache = n);
                                }
                                l(!0), e.slideTo(i, 0);
                            },
                            removeSlide: function (t) {
                                if (null == t) return;
                                let n = e.activeIndex;
                                if (Array.isArray(t))
                                    for (let i = t.length - 1; i >= 0; i -= 1)
                                        e.virtual.slides.splice(t[i], 1),
                                            e.params.virtual.cache && delete e.virtual.cache[t[i]],
                                            t[i] < n && (n -= 1),
                                            (n = Math.max(n, 0));
                                else
                                    e.virtual.slides.splice(t, 1),
                                        e.params.virtual.cache && delete e.virtual.cache[t],
                                        t < n && (n -= 1),
                                        (n = Math.max(n, 0));
                                l(!0), e.slideTo(n, 0);
                            },
                            removeAllSlides: function () {
                                (e.virtual.slides = []),
                                    e.params.virtual.cache && (e.virtual.cache = {}),
                                    l(!0),
                                    e.slideTo(0, 0);
                            },
                            update: l,
                        });
                },
                function ({ swiper: e, extendParams: t, on: n, emit: i }) {
                    const s = Re(),
                        r = Ge();
                    function a(t) {
                        if (!e.enabled) return;
                        const { rtlTranslate: n } = e;
                        let a = t;
                        a.originalEvent && (a = a.originalEvent);
                        const o = a.keyCode || a.charCode,
                            l = e.params.keyboard.pageUpDown,
                            c = l && 33 === o,
                            d = l && 34 === o,
                            u = 37 === o,
                            p = 39 === o,
                            h = 38 === o,
                            f = 40 === o;
                        if (!e.allowSlideNext && ((e.isHorizontal() && p) || (e.isVertical() && f) || d)) return !1;
                        if (!e.allowSlidePrev && ((e.isHorizontal() && u) || (e.isVertical() && h) || c)) return !1;
                        if (
                            !(
                                a.shiftKey ||
                                a.altKey ||
                                a.ctrlKey ||
                                a.metaKey ||
                                (s.activeElement &&
                                    s.activeElement.nodeName &&
                                    ("input" === s.activeElement.nodeName.toLowerCase() ||
                                        "textarea" === s.activeElement.nodeName.toLowerCase()))
                            )
                        ) {
                            if (e.params.keyboard.onlyInViewport && (c || d || u || p || h || f)) {
                                let t = !1;
                                if (
                                    rt(e.el, `.${e.params.slideClass}, swiper-slide`).length > 0 &&
                                    0 === rt(e.el, `.${e.params.slideActiveClass}`).length
                                )
                                    return;
                                const i = e.el,
                                    s = i.clientWidth,
                                    a = i.clientHeight,
                                    o = r.innerWidth,
                                    l = r.innerHeight,
                                    c = nt(i);
                                n && (c.left -= i.scrollLeft);
                                const d = [
                                    [c.left, c.top],
                                    [c.left + s, c.top],
                                    [c.left, c.top + a],
                                    [c.left + s, c.top + a],
                                ];
                                for (let e = 0; e < d.length; e += 1) {
                                    const n = d[e];
                                    if (n[0] >= 0 && n[0] <= o && n[1] >= 0 && n[1] <= l) {
                                        if (0 === n[0] && 0 === n[1]) continue;
                                        t = !0;
                                    }
                                }
                                if (!t) return;
                            }
                            e.isHorizontal()
                                ? ((c || d || u || p) && (a.preventDefault ? a.preventDefault() : (a.returnValue = !1)),
                                  (((d || p) && !n) || ((c || u) && n)) && e.slideNext(),
                                  (((c || u) && !n) || ((d || p) && n)) && e.slidePrev())
                                : ((c || d || h || f) && (a.preventDefault ? a.preventDefault() : (a.returnValue = !1)),
                                  (d || f) && e.slideNext(),
                                  (c || h) && e.slidePrev()),
                                i("keyPress", o);
                        }
                    }
                    function o() {
                        e.keyboard.enabled || (s.addEventListener("keydown", a), (e.keyboard.enabled = !0));
                    }
                    function l() {
                        e.keyboard.enabled && (s.removeEventListener("keydown", a), (e.keyboard.enabled = !1));
                    }
                    (e.keyboard = { enabled: !1 }),
                        t({ keyboard: { enabled: !1, onlyInViewport: !0, pageUpDown: !0 } }),
                        n("init", () => {
                            e.params.keyboard.enabled && o();
                        }),
                        n("destroy", () => {
                            e.keyboard.enabled && l();
                        }),
                        Object.assign(e.keyboard, { enable: o, disable: l });
                },
                function ({ swiper: e, extendParams: t, on: n, emit: i }) {
                    const s = Ge();
                    let r;
                    t({
                        mousewheel: {
                            enabled: !1,
                            releaseOnEdges: !1,
                            invert: !1,
                            forceToAxis: !1,
                            sensitivity: 1,
                            eventsTarget: "container",
                            thresholdDelta: null,
                            thresholdTime: null,
                            noMousewheelClass: "swiper-no-mousewheel",
                        },
                    }),
                        (e.mousewheel = { enabled: !1 });
                    let a,
                        o = Ue();
                    const l = [];
                    function c() {
                        e.enabled && (e.mouseEntered = !0);
                    }
                    function d() {
                        e.enabled && (e.mouseEntered = !1);
                    }
                    function u(t) {
                        return !(
                            (e.params.mousewheel.thresholdDelta && t.delta < e.params.mousewheel.thresholdDelta) ||
                            (e.params.mousewheel.thresholdTime && Ue() - o < e.params.mousewheel.thresholdTime) ||
                            (!(t.delta >= 6 && Ue() - o < 60) &&
                                (t.direction < 0
                                    ? (e.isEnd && !e.params.loop) || e.animating || (e.slideNext(), i("scroll", t.raw))
                                    : (e.isBeginning && !e.params.loop) ||
                                      e.animating ||
                                      (e.slidePrev(), i("scroll", t.raw)),
                                (o = new s.Date().getTime()),
                                1))
                        );
                    }
                    function p(t) {
                        let n = t,
                            s = !0;
                        if (!e.enabled) return;
                        if (t.target.closest(`.${e.params.mousewheel.noMousewheelClass}`)) return;
                        const o = e.params.mousewheel;
                        e.params.cssMode && n.preventDefault();
                        let c = e.el;
                        "container" !== e.params.mousewheel.eventsTarget &&
                            (c = document.querySelector(e.params.mousewheel.eventsTarget));
                        const d = c && c.contains(n.target);
                        if (!e.mouseEntered && !d && !o.releaseOnEdges) return !0;
                        n.originalEvent && (n = n.originalEvent);
                        let p = 0;
                        const h = e.rtlTranslate ? -1 : 1,
                            f = (function (e) {
                                let t = 0,
                                    n = 0,
                                    i = 0,
                                    s = 0;
                                return (
                                    "detail" in e && (n = e.detail),
                                    "wheelDelta" in e && (n = -e.wheelDelta / 120),
                                    "wheelDeltaY" in e && (n = -e.wheelDeltaY / 120),
                                    "wheelDeltaX" in e && (t = -e.wheelDeltaX / 120),
                                    "axis" in e && e.axis === e.HORIZONTAL_AXIS && ((t = n), (n = 0)),
                                    (i = 10 * t),
                                    (s = 10 * n),
                                    "deltaY" in e && (s = e.deltaY),
                                    "deltaX" in e && (i = e.deltaX),
                                    e.shiftKey && !i && ((i = s), (s = 0)),
                                    (i || s) &&
                                        e.deltaMode &&
                                        (1 === e.deltaMode ? ((i *= 40), (s *= 40)) : ((i *= 800), (s *= 800))),
                                    i && !t && (t = i < 1 ? -1 : 1),
                                    s && !n && (n = s < 1 ? -1 : 1),
                                    { spinX: t, spinY: n, pixelX: i, pixelY: s }
                                );
                            })(n);
                        if (o.forceToAxis)
                            if (e.isHorizontal()) {
                                if (!(Math.abs(f.pixelX) > Math.abs(f.pixelY))) return !0;
                                p = -f.pixelX * h;
                            } else {
                                if (!(Math.abs(f.pixelY) > Math.abs(f.pixelX))) return !0;
                                p = -f.pixelY;
                            }
                        else p = Math.abs(f.pixelX) > Math.abs(f.pixelY) ? -f.pixelX * h : -f.pixelY;
                        if (0 === p) return !0;
                        o.invert && (p = -p);
                        let m = e.getTranslate() + p * o.sensitivity;
                        if (
                            (m >= e.minTranslate() && (m = e.minTranslate()),
                            m <= e.maxTranslate() && (m = e.maxTranslate()),
                            (s = !!e.params.loop || !(m === e.minTranslate() || m === e.maxTranslate())),
                            s && e.params.nested && n.stopPropagation(),
                            e.params.freeMode && e.params.freeMode.enabled)
                        ) {
                            const t = { time: Ue(), delta: Math.abs(p), direction: Math.sign(p) },
                                s = a && t.time < a.time + 500 && t.delta <= a.delta && t.direction === a.direction;
                            if (!s) {
                                a = void 0;
                                let c = e.getTranslate() + p * o.sensitivity;
                                const d = e.isBeginning,
                                    u = e.isEnd;
                                if (
                                    (c >= e.minTranslate() && (c = e.minTranslate()),
                                    c <= e.maxTranslate() && (c = e.maxTranslate()),
                                    e.setTransition(0),
                                    e.setTranslate(c),
                                    e.updateProgress(),
                                    e.updateActiveIndex(),
                                    e.updateSlidesClasses(),
                                    ((!d && e.isBeginning) || (!u && e.isEnd)) && e.updateSlidesClasses(),
                                    e.params.loop &&
                                        e.loopFix({ direction: t.direction < 0 ? "next" : "prev", byMousewheel: !0 }),
                                    e.params.freeMode.sticky)
                                ) {
                                    clearTimeout(r), (r = void 0), l.length >= 15 && l.shift();
                                    const n = l.length ? l[l.length - 1] : void 0,
                                        i = l[0];
                                    if ((l.push(t), n && (t.delta > n.delta || t.direction !== n.direction)))
                                        l.splice(0);
                                    else if (
                                        l.length >= 15 &&
                                        t.time - i.time < 500 &&
                                        i.delta - t.delta >= 1 &&
                                        t.delta <= 6
                                    ) {
                                        const n = p > 0 ? 0.8 : 0.2;
                                        (a = t),
                                            l.splice(0),
                                            (r = We(() => {
                                                e.slideToClosest(e.params.speed, !0, void 0, n);
                                            }, 0));
                                    }
                                    r ||
                                        (r = We(() => {
                                            (a = t), l.splice(0), e.slideToClosest(e.params.speed, !0, void 0, 0.5);
                                        }, 500));
                                }
                                if (
                                    (s || i("scroll", n),
                                    e.params.autoplay && e.params.autoplayDisableOnInteraction && e.autoplay.stop(),
                                    c === e.minTranslate() || c === e.maxTranslate())
                                )
                                    return !0;
                            }
                        } else {
                            const n = { time: Ue(), delta: Math.abs(p), direction: Math.sign(p), raw: t };
                            l.length >= 2 && l.shift();
                            const i = l.length ? l[l.length - 1] : void 0;
                            if (
                                (l.push(n),
                                i
                                    ? (n.direction !== i.direction || n.delta > i.delta || n.time > i.time + 150) &&
                                      u(n)
                                    : u(n),
                                (function (t) {
                                    const n = e.params.mousewheel;
                                    if (t.direction < 0) {
                                        if (e.isEnd && !e.params.loop && n.releaseOnEdges) return !0;
                                    } else if (e.isBeginning && !e.params.loop && n.releaseOnEdges) return !0;
                                    return !1;
                                })(n))
                            )
                                return !0;
                        }
                        return n.preventDefault ? n.preventDefault() : (n.returnValue = !1), !1;
                    }
                    function h(t) {
                        let n = e.el;
                        "container" !== e.params.mousewheel.eventsTarget &&
                            (n = document.querySelector(e.params.mousewheel.eventsTarget)),
                            n[t]("mouseenter", c),
                            n[t]("mouseleave", d),
                            n[t]("wheel", p);
                    }
                    function f() {
                        return e.params.cssMode
                            ? (e.wrapperEl.removeEventListener("wheel", p), !0)
                            : !e.mousewheel.enabled && (h("addEventListener"), (e.mousewheel.enabled = !0), !0);
                    }
                    function m() {
                        return e.params.cssMode
                            ? (e.wrapperEl.addEventListener(event, p), !0)
                            : !!e.mousewheel.enabled && (h("removeEventListener"), (e.mousewheel.enabled = !1), !0);
                    }
                    n("init", () => {
                        !e.params.mousewheel.enabled && e.params.cssMode && m(), e.params.mousewheel.enabled && f();
                    }),
                        n("destroy", () => {
                            e.params.cssMode && f(), e.mousewheel.enabled && m();
                        }),
                        Object.assign(e.mousewheel, { enable: f, disable: m });
                },
                function ({ swiper: e, extendParams: t, on: n, emit: i }) {
                    t({
                        navigation: {
                            nextEl: null,
                            prevEl: null,
                            hideOnClick: !1,
                            disabledClass: "swiper-button-disabled",
                            hiddenClass: "swiper-button-hidden",
                            lockClass: "swiper-button-lock",
                            navigationDisabledClass: "swiper-navigation-disabled",
                        },
                    }),
                        (e.navigation = { nextEl: null, prevEl: null });
                    const s = (e) => (Array.isArray(e) || (e = [e].filter((e) => !!e)), e);
                    function r(t) {
                        let n;
                        return t && "string" == typeof t && e.isElement && ((n = e.el.shadowRoot.querySelector(t)), n)
                            ? n
                            : (t &&
                                  ("string" == typeof t && (n = [...document.querySelectorAll(t)]),
                                  e.params.uniqueNavElements &&
                                      "string" == typeof t &&
                                      n.length > 1 &&
                                      1 === e.el.querySelectorAll(t).length &&
                                      (n = e.el.querySelector(t))),
                              t && !n ? t : n);
                    }
                    function a(t, n) {
                        const i = e.params.navigation;
                        (t = s(t)).forEach((t) => {
                            t &&
                                (t.classList[n ? "add" : "remove"](...i.disabledClass.split(" ")),
                                "BUTTON" === t.tagName && (t.disabled = n),
                                e.params.watchOverflow &&
                                    e.enabled &&
                                    t.classList[e.isLocked ? "add" : "remove"](i.lockClass));
                        });
                    }
                    function o() {
                        const { nextEl: t, prevEl: n } = e.navigation;
                        if (e.params.loop) return a(n, !1), void a(t, !1);
                        a(n, e.isBeginning && !e.params.rewind), a(t, e.isEnd && !e.params.rewind);
                    }
                    function l(t) {
                        t.preventDefault(),
                            (!e.isBeginning || e.params.loop || e.params.rewind) &&
                                (e.slidePrev(), i("navigationPrev"));
                    }
                    function c(t) {
                        t.preventDefault(),
                            (!e.isEnd || e.params.loop || e.params.rewind) && (e.slideNext(), i("navigationNext"));
                    }
                    function d() {
                        const t = e.params.navigation;
                        if (
                            ((e.params.navigation = zt(e, e.originalParams.navigation, e.params.navigation, {
                                nextEl: "swiper-button-next",
                                prevEl: "swiper-button-prev",
                            })),
                            !t.nextEl && !t.prevEl)
                        )
                            return;
                        let n = r(t.nextEl),
                            i = r(t.prevEl);
                        Object.assign(e.navigation, { nextEl: n, prevEl: i }), (n = s(n)), (i = s(i));
                        const a = (n, i) => {
                            n && n.addEventListener("click", "next" === i ? c : l),
                                !e.enabled && n && n.classList.add(...t.lockClass.split(" "));
                        };
                        n.forEach((e) => a(e, "next")), i.forEach((e) => a(e, "prev"));
                    }
                    function u() {
                        let { nextEl: t, prevEl: n } = e.navigation;
                        (t = s(t)), (n = s(n));
                        const i = (t, n) => {
                            t.removeEventListener("click", "next" === n ? c : l),
                                t.classList.remove(...e.params.navigation.disabledClass.split(" "));
                        };
                        t.forEach((e) => i(e, "next")), n.forEach((e) => i(e, "prev"));
                    }
                    n("init", () => {
                        !1 === e.params.navigation.enabled ? p() : (d(), o());
                    }),
                        n("toEdge fromEdge lock unlock", () => {
                            o();
                        }),
                        n("destroy", () => {
                            u();
                        }),
                        n("enable disable", () => {
                            let { nextEl: t, prevEl: n } = e.navigation;
                            (t = s(t)),
                                (n = s(n)),
                                [...t, ...n]
                                    .filter((e) => !!e)
                                    .forEach((t) =>
                                        t.classList[e.enabled ? "remove" : "add"](e.params.navigation.lockClass)
                                    );
                        }),
                        n("click", (t, n) => {
                            let { nextEl: r, prevEl: a } = e.navigation;
                            (r = s(r)), (a = s(a));
                            const o = n.target;
                            if (e.params.navigation.hideOnClick && !a.includes(o) && !r.includes(o)) {
                                if (
                                    e.pagination &&
                                    e.params.pagination &&
                                    e.params.pagination.clickable &&
                                    (e.pagination.el === o || e.pagination.el.contains(o))
                                )
                                    return;
                                let t;
                                r.length
                                    ? (t = r[0].classList.contains(e.params.navigation.hiddenClass))
                                    : a.length && (t = a[0].classList.contains(e.params.navigation.hiddenClass)),
                                    i(!0 === t ? "navigationShow" : "navigationHide"),
                                    [...r, ...a]
                                        .filter((e) => !!e)
                                        .forEach((t) => t.classList.toggle(e.params.navigation.hiddenClass));
                            }
                        });
                    const p = () => {
                        e.el.classList.add(...e.params.navigation.navigationDisabledClass.split(" ")), u();
                    };
                    Object.assign(e.navigation, {
                        enable: () => {
                            e.el.classList.remove(...e.params.navigation.navigationDisabledClass.split(" ")), d(), o();
                        },
                        disable: p,
                        update: o,
                        init: d,
                        destroy: u,
                    });
                },
                function ({ swiper: e, extendParams: t, on: n, emit: i }) {
                    const s = "swiper-pagination";
                    let r;
                    t({
                        pagination: {
                            el: null,
                            bulletElement: "span",
                            clickable: !1,
                            hideOnClick: !1,
                            renderBullet: null,
                            renderProgressbar: null,
                            renderFraction: null,
                            renderCustom: null,
                            progressbarOpposite: !1,
                            type: "bullets",
                            dynamicBullets: !1,
                            dynamicMainBullets: 1,
                            formatFractionCurrent: (e) => e,
                            formatFractionTotal: (e) => e,
                            bulletClass: `${s}-bullet`,
                            bulletActiveClass: `${s}-bullet-active`,
                            modifierClass: `${s}-`,
                            currentClass: `${s}-current`,
                            totalClass: `${s}-total`,
                            hiddenClass: `${s}-hidden`,
                            progressbarFillClass: `${s}-progressbar-fill`,
                            progressbarOppositeClass: `${s}-progressbar-opposite`,
                            clickableClass: `${s}-clickable`,
                            lockClass: `${s}-lock`,
                            horizontalClass: `${s}-horizontal`,
                            verticalClass: `${s}-vertical`,
                            paginationDisabledClass: `${s}-disabled`,
                        },
                    }),
                        (e.pagination = { el: null, bullets: [] });
                    let a = 0;
                    const o = (e) => (Array.isArray(e) || (e = [e].filter((e) => !!e)), e);
                    function l() {
                        return (
                            !e.params.pagination.el ||
                            !e.pagination.el ||
                            (Array.isArray(e.pagination.el) && 0 === e.pagination.el.length)
                        );
                    }
                    function c(t, n) {
                        const { bulletActiveClass: i } = e.params.pagination;
                        t &&
                            (t = t[("prev" === n ? "previous" : "next") + "ElementSibling"]) &&
                            (t.classList.add(`${i}-${n}`),
                            (t = t[("prev" === n ? "previous" : "next") + "ElementSibling"]) &&
                                t.classList.add(`${i}-${n}-${n}`));
                    }
                    function d(t) {
                        const n = t.target.closest(Bt(e.params.pagination.bulletClass));
                        if (!n) return;
                        t.preventDefault();
                        const i = st(n) * e.params.slidesPerGroup;
                        if (e.params.loop) {
                            if (e.realIndex === i) return;
                            const t = e.getSlideIndexByData(i),
                                n = e.getSlideIndexByData(e.realIndex);
                            t > e.slides.length - e.loopedSlides &&
                                e.loopFix({ direction: t > n ? "next" : "prev", activeSlideIndex: t, slideTo: !1 }),
                                e.slideToLoop(i);
                        } else e.slideTo(i);
                    }
                    function u() {
                        const t = e.rtl,
                            n = e.params.pagination;
                        if (l()) return;
                        let s,
                            d,
                            u = e.pagination.el;
                        u = o(u);
                        const p = e.virtual && e.params.virtual.enabled ? e.virtual.slides.length : e.slides.length,
                            h = e.params.loop ? Math.ceil(p / e.params.slidesPerGroup) : e.snapGrid.length;
                        if (
                            (e.params.loop
                                ? ((d = e.previousRealIndex || 0),
                                  (s =
                                      e.params.slidesPerGroup > 1
                                          ? Math.floor(e.realIndex / e.params.slidesPerGroup)
                                          : e.realIndex))
                                : void 0 !== e.snapIndex
                                  ? ((s = e.snapIndex), (d = e.previousSnapIndex))
                                  : ((d = e.previousIndex || 0), (s = e.activeIndex || 0)),
                            "bullets" === n.type && e.pagination.bullets && e.pagination.bullets.length > 0)
                        ) {
                            const i = e.pagination.bullets;
                            let o, l, p;
                            if (
                                (n.dynamicBullets &&
                                    ((r = ot(i[0], e.isHorizontal() ? "width" : "height", !0)),
                                    u.forEach((t) => {
                                        t.style[e.isHorizontal() ? "width" : "height"] =
                                            r * (n.dynamicMainBullets + 4) + "px";
                                    }),
                                    n.dynamicMainBullets > 1 &&
                                        void 0 !== d &&
                                        ((a += s - (d || 0)),
                                        a > n.dynamicMainBullets - 1
                                            ? (a = n.dynamicMainBullets - 1)
                                            : a < 0 && (a = 0)),
                                    (o = Math.max(s - a, 0)),
                                    (l = o + (Math.min(i.length, n.dynamicMainBullets) - 1)),
                                    (p = (l + o) / 2)),
                                i.forEach((e) => {
                                    const t = [
                                        ...["", "-next", "-next-next", "-prev", "-prev-prev", "-main"].map(
                                            (e) => `${n.bulletActiveClass}${e}`
                                        ),
                                    ]
                                        .map((e) => ("string" == typeof e && e.includes(" ") ? e.split(" ") : e))
                                        .flat();
                                    e.classList.remove(...t);
                                }),
                                u.length > 1)
                            )
                                i.forEach((t) => {
                                    const i = st(t);
                                    i === s
                                        ? t.classList.add(...n.bulletActiveClass.split(" "))
                                        : e.isElement && t.setAttribute("part", "bullet"),
                                        n.dynamicBullets &&
                                            (i >= o &&
                                                i <= l &&
                                                t.classList.add(...`${n.bulletActiveClass}-main`.split(" ")),
                                            i === o && c(t, "prev"),
                                            i === l && c(t, "next"));
                                });
                            else {
                                const t = i[s];
                                if (
                                    (t && t.classList.add(...n.bulletActiveClass.split(" ")),
                                    e.isElement &&
                                        i.forEach((e, t) => {
                                            e.setAttribute("part", t === s ? "bullet-active" : "bullet");
                                        }),
                                    n.dynamicBullets)
                                ) {
                                    const e = i[o],
                                        t = i[l];
                                    for (let e = o; e <= l; e += 1)
                                        i[e] && i[e].classList.add(...`${n.bulletActiveClass}-main`.split(" "));
                                    c(e, "prev"), c(t, "next");
                                }
                            }
                            if (n.dynamicBullets) {
                                const s = Math.min(i.length, n.dynamicMainBullets + 4),
                                    a = (r * s - r) / 2 - p * r,
                                    o = t ? "right" : "left";
                                i.forEach((t) => {
                                    t.style[e.isHorizontal() ? o : "top"] = `${a}px`;
                                });
                            }
                        }
                        u.forEach((t, r) => {
                            if (
                                ("fraction" === n.type &&
                                    (t.querySelectorAll(Bt(n.currentClass)).forEach((e) => {
                                        e.textContent = n.formatFractionCurrent(s + 1);
                                    }),
                                    t.querySelectorAll(Bt(n.totalClass)).forEach((e) => {
                                        e.textContent = n.formatFractionTotal(h);
                                    })),
                                "progressbar" === n.type)
                            ) {
                                let i;
                                i = n.progressbarOpposite
                                    ? e.isHorizontal()
                                        ? "vertical"
                                        : "horizontal"
                                    : e.isHorizontal()
                                      ? "horizontal"
                                      : "vertical";
                                const r = (s + 1) / h;
                                let a = 1,
                                    o = 1;
                                "horizontal" === i ? (a = r) : (o = r),
                                    t.querySelectorAll(Bt(n.progressbarFillClass)).forEach((t) => {
                                        (t.style.transform = `translate3d(0,0,0) scaleX(${a}) scaleY(${o})`),
                                            (t.style.transitionDuration = `${e.params.speed}ms`);
                                    });
                            }
                            "custom" === n.type && n.renderCustom
                                ? ((t.innerHTML = n.renderCustom(e, s + 1, h)), 0 === r && i("paginationRender", t))
                                : (0 === r && i("paginationRender", t), i("paginationUpdate", t)),
                                e.params.watchOverflow &&
                                    e.enabled &&
                                    t.classList[e.isLocked ? "add" : "remove"](n.lockClass);
                        });
                    }
                    function p() {
                        const t = e.params.pagination;
                        if (l()) return;
                        const n = e.virtual && e.params.virtual.enabled ? e.virtual.slides.length : e.slides.length;
                        let s = e.pagination.el;
                        s = o(s);
                        let r = "";
                        if ("bullets" === t.type) {
                            let i = e.params.loop ? Math.ceil(n / e.params.slidesPerGroup) : e.snapGrid.length;
                            e.params.freeMode && e.params.freeMode.enabled && i > n && (i = n);
                            for (let n = 0; n < i; n += 1)
                                t.renderBullet
                                    ? (r += t.renderBullet.call(e, n, t.bulletClass))
                                    : (r += `<${t.bulletElement} ${e.isElement ? 'part="bullet"' : ""} class="${t.bulletClass}"></${t.bulletElement}>`);
                        }
                        "fraction" === t.type &&
                            (r = t.renderFraction
                                ? t.renderFraction.call(e, t.currentClass, t.totalClass)
                                : `<span class="${t.currentClass}"></span> / <span class="${t.totalClass}"></span>`),
                            "progressbar" === t.type &&
                                (r = t.renderProgressbar
                                    ? t.renderProgressbar.call(e, t.progressbarFillClass)
                                    : `<span class="${t.progressbarFillClass}"></span>`),
                            (e.pagination.bullets = []),
                            s.forEach((n) => {
                                "custom" !== t.type && (n.innerHTML = r || ""),
                                    "bullets" === t.type &&
                                        e.pagination.bullets.push(...n.querySelectorAll(Bt(t.bulletClass)));
                            }),
                            "custom" !== t.type && i("paginationRender", s[0]);
                    }
                    function h() {
                        e.params.pagination = zt(e, e.originalParams.pagination, e.params.pagination, {
                            el: "swiper-pagination",
                        });
                        const t = e.params.pagination;
                        if (!t.el) return;
                        let n;
                        "string" == typeof t.el && e.isElement && (n = e.el.shadowRoot.querySelector(t.el)),
                            n || "string" != typeof t.el || (n = [...document.querySelectorAll(t.el)]),
                            n || (n = t.el),
                            n &&
                                0 !== n.length &&
                                (e.params.uniqueNavElements &&
                                    "string" == typeof t.el &&
                                    Array.isArray(n) &&
                                    n.length > 1 &&
                                    ((n = [...e.el.querySelectorAll(t.el)]),
                                    n.length > 1 && (n = n.filter((t) => rt(t, ".swiper")[0] === e.el)[0])),
                                Array.isArray(n) && 1 === n.length && (n = n[0]),
                                Object.assign(e.pagination, { el: n }),
                                (n = o(n)),
                                n.forEach((n) => {
                                    "bullets" === t.type && t.clickable && n.classList.add(t.clickableClass),
                                        n.classList.add(t.modifierClass + t.type),
                                        n.classList.add(e.isHorizontal() ? t.horizontalClass : t.verticalClass),
                                        "bullets" === t.type &&
                                            t.dynamicBullets &&
                                            (n.classList.add(`${t.modifierClass}${t.type}-dynamic`),
                                            (a = 0),
                                            t.dynamicMainBullets < 1 && (t.dynamicMainBullets = 1)),
                                        "progressbar" === t.type &&
                                            t.progressbarOpposite &&
                                            n.classList.add(t.progressbarOppositeClass),
                                        t.clickable && n.addEventListener("click", d),
                                        e.enabled || n.classList.add(t.lockClass);
                                }));
                    }
                    function f() {
                        const t = e.params.pagination;
                        if (l()) return;
                        let n = e.pagination.el;
                        n &&
                            ((n = o(n)),
                            n.forEach((n) => {
                                n.classList.remove(t.hiddenClass),
                                    n.classList.remove(t.modifierClass + t.type),
                                    n.classList.remove(e.isHorizontal() ? t.horizontalClass : t.verticalClass),
                                    t.clickable && n.removeEventListener("click", d);
                            })),
                            e.pagination.bullets &&
                                e.pagination.bullets.forEach((e) =>
                                    e.classList.remove(...t.bulletActiveClass.split(" "))
                                );
                    }
                    n("changeDirection", () => {
                        if (!e.pagination || !e.pagination.el) return;
                        const t = e.params.pagination;
                        let { el: n } = e.pagination;
                        (n = o(n)),
                            n.forEach((n) => {
                                n.classList.remove(t.horizontalClass, t.verticalClass),
                                    n.classList.add(e.isHorizontal() ? t.horizontalClass : t.verticalClass);
                            });
                    }),
                        n("init", () => {
                            !1 === e.params.pagination.enabled ? m() : (h(), p(), u());
                        }),
                        n("activeIndexChange", () => {
                            void 0 === e.snapIndex && u();
                        }),
                        n("snapIndexChange", () => {
                            u();
                        }),
                        n("snapGridLengthChange", () => {
                            p(), u();
                        }),
                        n("destroy", () => {
                            f();
                        }),
                        n("enable disable", () => {
                            let { el: t } = e.pagination;
                            t &&
                                ((t = o(t)),
                                t.forEach((t) =>
                                    t.classList[e.enabled ? "remove" : "add"](e.params.pagination.lockClass)
                                ));
                        }),
                        n("lock unlock", () => {
                            u();
                        }),
                        n("click", (t, n) => {
                            const s = n.target;
                            let { el: r } = e.pagination;
                            if (
                                (Array.isArray(r) || (r = [r].filter((e) => !!e)),
                                e.params.pagination.el &&
                                    e.params.pagination.hideOnClick &&
                                    r &&
                                    r.length > 0 &&
                                    !s.classList.contains(e.params.pagination.bulletClass))
                            ) {
                                if (
                                    e.navigation &&
                                    ((e.navigation.nextEl && s === e.navigation.nextEl) ||
                                        (e.navigation.prevEl && s === e.navigation.prevEl))
                                )
                                    return;
                                const t = r[0].classList.contains(e.params.pagination.hiddenClass);
                                i(!0 === t ? "paginationShow" : "paginationHide"),
                                    r.forEach((t) => t.classList.toggle(e.params.pagination.hiddenClass));
                            }
                        });
                    const m = () => {
                        e.el.classList.add(e.params.pagination.paginationDisabledClass);
                        let { el: t } = e.pagination;
                        t &&
                            ((t = o(t)),
                            t.forEach((t) => t.classList.add(e.params.pagination.paginationDisabledClass))),
                            f();
                    };
                    Object.assign(e.pagination, {
                        enable: () => {
                            e.el.classList.remove(e.params.pagination.paginationDisabledClass);
                            let { el: t } = e.pagination;
                            t &&
                                ((t = o(t)),
                                t.forEach((t) => t.classList.remove(e.params.pagination.paginationDisabledClass))),
                                h(),
                                p(),
                                u();
                        },
                        disable: m,
                        render: p,
                        update: u,
                        init: h,
                        destroy: f,
                    });
                },
                function ({ swiper: e, extendParams: t, on: n, emit: i }) {
                    const s = Re();
                    let r,
                        a,
                        o,
                        l,
                        c = !1,
                        d = null,
                        u = null;
                    function p() {
                        if (!e.params.scrollbar.el || !e.scrollbar.el) return;
                        const { scrollbar: t, rtlTranslate: n } = e,
                            { dragEl: i, el: s } = t,
                            r = e.params.scrollbar,
                            l = e.params.loop ? e.progressLoop : e.progress;
                        let c = a,
                            u = (o - a) * l;
                        n
                            ? ((u = -u), u > 0 ? ((c = a - u), (u = 0)) : -u + a > o && (c = o + u))
                            : u < 0
                              ? ((c = a + u), (u = 0))
                              : u + a > o && (c = o - u),
                            e.isHorizontal()
                                ? ((i.style.transform = `translate3d(${u}px, 0, 0)`), (i.style.width = `${c}px`))
                                : ((i.style.transform = `translate3d(0px, ${u}px, 0)`), (i.style.height = `${c}px`)),
                            r.hide &&
                                (clearTimeout(d),
                                (s.style.opacity = 1),
                                (d = setTimeout(() => {
                                    (s.style.opacity = 0), (s.style.transitionDuration = "400ms");
                                }, 1e3)));
                    }
                    function h() {
                        if (!e.params.scrollbar.el || !e.scrollbar.el) return;
                        const { scrollbar: t } = e,
                            { dragEl: n, el: i } = t;
                        (n.style.width = ""),
                            (n.style.height = ""),
                            (o = e.isHorizontal() ? i.offsetWidth : i.offsetHeight),
                            (l =
                                e.size /
                                (e.virtualSize +
                                    e.params.slidesOffsetBefore -
                                    (e.params.centeredSlides ? e.snapGrid[0] : 0))),
                            (a =
                                "auto" === e.params.scrollbar.dragSize
                                    ? o * l
                                    : parseInt(e.params.scrollbar.dragSize, 10)),
                            e.isHorizontal() ? (n.style.width = `${a}px`) : (n.style.height = `${a}px`),
                            (i.style.display = l >= 1 ? "none" : ""),
                            e.params.scrollbar.hide && (i.style.opacity = 0),
                            e.params.watchOverflow &&
                                e.enabled &&
                                t.el.classList[e.isLocked ? "add" : "remove"](e.params.scrollbar.lockClass);
                    }
                    function f(t) {
                        return e.isHorizontal() ? t.clientX : t.clientY;
                    }
                    function m(t) {
                        const { scrollbar: n, rtlTranslate: i } = e,
                            { el: s } = n;
                        let l;
                        (l = (f(t) - nt(s)[e.isHorizontal() ? "left" : "top"] - (null !== r ? r : a / 2)) / (o - a)),
                            (l = Math.max(Math.min(l, 1), 0)),
                            i && (l = 1 - l);
                        const c = e.minTranslate() + (e.maxTranslate() - e.minTranslate()) * l;
                        e.updateProgress(c), e.setTranslate(c), e.updateActiveIndex(), e.updateSlidesClasses();
                    }
                    function g(t) {
                        const n = e.params.scrollbar,
                            { scrollbar: s, wrapperEl: a } = e,
                            { el: o, dragEl: l } = s;
                        (c = !0),
                            (r =
                                t.target === l
                                    ? f(t) - t.target.getBoundingClientRect()[e.isHorizontal() ? "left" : "top"]
                                    : null),
                            t.preventDefault(),
                            t.stopPropagation(),
                            (a.style.transitionDuration = "100ms"),
                            (l.style.transitionDuration = "100ms"),
                            m(t),
                            clearTimeout(u),
                            (o.style.transitionDuration = "0ms"),
                            n.hide && (o.style.opacity = 1),
                            e.params.cssMode && (e.wrapperEl.style["scroll-snap-type"] = "none"),
                            i("scrollbarDragStart", t);
                    }
                    function v(t) {
                        const { scrollbar: n, wrapperEl: s } = e,
                            { el: r, dragEl: a } = n;
                        c &&
                            (t.preventDefault ? t.preventDefault() : (t.returnValue = !1),
                            m(t),
                            (s.style.transitionDuration = "0ms"),
                            (r.style.transitionDuration = "0ms"),
                            (a.style.transitionDuration = "0ms"),
                            i("scrollbarDragMove", t));
                    }
                    function y(t) {
                        const n = e.params.scrollbar,
                            { scrollbar: s, wrapperEl: r } = e,
                            { el: a } = s;
                        c &&
                            ((c = !1),
                            e.params.cssMode &&
                                ((e.wrapperEl.style["scroll-snap-type"] = ""), (r.style.transitionDuration = "")),
                            n.hide &&
                                (clearTimeout(u),
                                (u = We(() => {
                                    (a.style.opacity = 0), (a.style.transitionDuration = "400ms");
                                }, 1e3))),
                            i("scrollbarDragEnd", t),
                            n.snapOnRelease && e.slideToClosest());
                    }
                    function b(t) {
                        const { scrollbar: n, params: i } = e,
                            r = n.el;
                        if (!r) return;
                        const a = r,
                            o = !!i.passiveListeners && { passive: !1, capture: !1 },
                            l = !!i.passiveListeners && { passive: !0, capture: !1 };
                        if (!a) return;
                        const c = "on" === t ? "addEventListener" : "removeEventListener";
                        a[c]("pointerdown", g, o), s[c]("pointermove", v, o), s[c]("pointerup", y, l);
                    }
                    function w() {
                        const { scrollbar: t, el: n } = e;
                        e.params.scrollbar = zt(e, e.originalParams.scrollbar, e.params.scrollbar, {
                            el: "swiper-scrollbar",
                        });
                        const i = e.params.scrollbar;
                        if (!i.el) return;
                        let r, a;
                        "string" == typeof i.el && e.isElement && (r = e.el.shadowRoot.querySelector(i.el)),
                            r || "string" != typeof i.el ? r || (r = i.el) : (r = s.querySelectorAll(i.el)),
                            e.params.uniqueNavElements &&
                                "string" == typeof i.el &&
                                r.length > 1 &&
                                1 === n.querySelectorAll(i.el).length &&
                                (r = n.querySelector(i.el)),
                            r.length > 0 && (r = r[0]),
                            r.classList.add(e.isHorizontal() ? i.horizontalClass : i.verticalClass),
                            r &&
                                ((a = r.querySelector(`.${e.params.scrollbar.dragClass}`)),
                                a || ((a = tt("div", e.params.scrollbar.dragClass)), r.append(a))),
                            Object.assign(t, { el: r, dragEl: a }),
                            i.draggable && e.params.scrollbar.el && e.scrollbar.el && b("on"),
                            r && r.classList[e.enabled ? "remove" : "add"](e.params.scrollbar.lockClass);
                    }
                    function C() {
                        const t = e.params.scrollbar,
                            n = e.scrollbar.el;
                        n && n.classList.remove(e.isHorizontal() ? t.horizontalClass : t.verticalClass),
                            e.params.scrollbar.el && e.scrollbar.el && b("off");
                    }
                    t({
                        scrollbar: {
                            el: null,
                            dragSize: "auto",
                            hide: !1,
                            draggable: !1,
                            snapOnRelease: !0,
                            lockClass: "swiper-scrollbar-lock",
                            dragClass: "swiper-scrollbar-drag",
                            scrollbarDisabledClass: "swiper-scrollbar-disabled",
                            horizontalClass: "swiper-scrollbar-horizontal",
                            verticalClass: "swiper-scrollbar-vertical",
                        },
                    }),
                        (e.scrollbar = { el: null, dragEl: null }),
                        n("init", () => {
                            !1 === e.params.scrollbar.enabled ? x() : (w(), h(), p());
                        }),
                        n("update resize observerUpdate lock unlock", () => {
                            h();
                        }),
                        n("setTranslate", () => {
                            p();
                        }),
                        n("setTransition", (t, n) => {
                            !(function (t) {
                                e.params.scrollbar.el &&
                                    e.scrollbar.el &&
                                    (e.scrollbar.dragEl.style.transitionDuration = `${t}ms`);
                            })(n);
                        }),
                        n("enable disable", () => {
                            const { el: t } = e.scrollbar;
                            t && t.classList[e.enabled ? "remove" : "add"](e.params.scrollbar.lockClass);
                        }),
                        n("destroy", () => {
                            C();
                        });
                    const x = () => {
                        e.el.classList.add(e.params.scrollbar.scrollbarDisabledClass),
                            e.scrollbar.el && e.scrollbar.el.classList.add(e.params.scrollbar.scrollbarDisabledClass),
                            C();
                    };
                    Object.assign(e.scrollbar, {
                        enable: () => {
                            e.el.classList.remove(e.params.scrollbar.scrollbarDisabledClass),
                                e.scrollbar.el &&
                                    e.scrollbar.el.classList.remove(e.params.scrollbar.scrollbarDisabledClass),
                                w(),
                                h(),
                                p();
                        },
                        disable: x,
                        updateSize: h,
                        setTranslate: p,
                        init: w,
                        destroy: C,
                    });
                },
                function ({ swiper: e, extendParams: t, on: n }) {
                    t({ parallax: { enabled: !1 } });
                    const i = (t, n) => {
                            const { rtl: i } = e,
                                s = i ? -1 : 1,
                                r = t.getAttribute("data-swiper-parallax") || "0";
                            let a = t.getAttribute("data-swiper-parallax-x"),
                                o = t.getAttribute("data-swiper-parallax-y");
                            const l = t.getAttribute("data-swiper-parallax-scale"),
                                c = t.getAttribute("data-swiper-parallax-opacity"),
                                d = t.getAttribute("data-swiper-parallax-rotate");
                            if (
                                (a || o
                                    ? ((a = a || "0"), (o = o || "0"))
                                    : e.isHorizontal()
                                      ? ((a = r), (o = "0"))
                                      : ((o = r), (a = "0")),
                                (a = a.indexOf("%") >= 0 ? parseInt(a, 10) * n * s + "%" : a * n * s + "px"),
                                (o = o.indexOf("%") >= 0 ? parseInt(o, 10) * n + "%" : o * n + "px"),
                                null != c)
                            ) {
                                const e = c - (c - 1) * (1 - Math.abs(n));
                                t.style.opacity = e;
                            }
                            let u = `translate3d(${a}, ${o}, 0px)`;
                            null != l && (u += ` scale(${l - (l - 1) * (1 - Math.abs(n))})`),
                                d && null != d && (u += ` rotate(${d * n * -1}deg)`),
                                (t.style.transform = u);
                        },
                        s = () => {
                            const { el: t, slides: n, progress: s, snapGrid: r } = e;
                            et(
                                t,
                                "[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]"
                            ).forEach((e) => {
                                i(e, s);
                            }),
                                n.forEach((t, n) => {
                                    let a = t.progress;
                                    e.params.slidesPerGroup > 1 &&
                                        "auto" !== e.params.slidesPerView &&
                                        (a += Math.ceil(n / 2) - s * (r.length - 1)),
                                        (a = Math.min(Math.max(a, -1), 1)),
                                        t
                                            .querySelectorAll(
                                                "[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale], [data-swiper-parallax-rotate]"
                                            )
                                            .forEach((e) => {
                                                i(e, a);
                                            });
                                });
                        };
                    n("beforeInit", () => {
                        e.params.parallax.enabled &&
                            ((e.params.watchSlidesProgress = !0), (e.originalParams.watchSlidesProgress = !0));
                    }),
                        n("init", () => {
                            e.params.parallax.enabled && s();
                        }),
                        n("setTranslate", () => {
                            e.params.parallax.enabled && s();
                        }),
                        n("setTransition", (t, n) => {
                            e.params.parallax.enabled &&
                                ((t = e.params.speed) => {
                                    const { el: n } = e;
                                    n.querySelectorAll(
                                        "[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]"
                                    ).forEach((e) => {
                                        let n = parseInt(e.getAttribute("data-swiper-parallax-duration"), 10) || t;
                                        0 === t && (n = 0), (e.style.transitionDuration = `${n}ms`);
                                    });
                                })(n);
                        });
                },
                function ({ swiper: e, extendParams: t, on: n, emit: i }) {
                    const s = Ge();
                    t({
                        zoom: {
                            enabled: !1,
                            maxRatio: 3,
                            minRatio: 1,
                            toggle: !0,
                            containerClass: "swiper-zoom-container",
                            zoomedSlideClass: "swiper-slide-zoomed",
                        },
                    }),
                        (e.zoom = { enabled: !1 });
                    let r,
                        a,
                        o = 1,
                        l = !1;
                    const c = [],
                        d = {
                            originX: 0,
                            originY: 0,
                            slideEl: void 0,
                            slideWidth: void 0,
                            slideHeight: void 0,
                            imageEl: void 0,
                            imageWrapEl: void 0,
                            maxRatio: 3,
                        },
                        u = {
                            isTouched: void 0,
                            isMoved: void 0,
                            currentX: void 0,
                            currentY: void 0,
                            minX: void 0,
                            minY: void 0,
                            maxX: void 0,
                            maxY: void 0,
                            width: void 0,
                            height: void 0,
                            startX: void 0,
                            startY: void 0,
                            touchesStart: {},
                            touchesCurrent: {},
                        },
                        p = { x: void 0, y: void 0, prevPositionX: void 0, prevPositionY: void 0, prevTime: void 0 };
                    let h = 1;
                    function f() {
                        if (c.length < 2) return 1;
                        const e = c[0].pageX,
                            t = c[0].pageY,
                            n = c[1].pageX,
                            i = c[1].pageY;
                        return Math.sqrt((n - e) ** 2 + (i - t) ** 2);
                    }
                    function m(t) {
                        const n = e.isElement ? "swiper-slide" : `.${e.params.slideClass}`;
                        return !!t.target.matches(n) || e.slides.filter((e) => e.contains(t.target)).length > 0;
                    }
                    function g(t) {
                        if (("mouse" === t.pointerType && c.splice(0, c.length), !m(t))) return;
                        const n = e.params.zoom;
                        if (((r = !1), (a = !1), c.push(t), !(c.length < 2))) {
                            if (((r = !0), (d.scaleStart = f()), !d.slideEl)) {
                                (d.slideEl = t.target.closest(`.${e.params.slideClass}, swiper-slide`)),
                                    d.slideEl || (d.slideEl = e.slides[e.activeIndex]);
                                let i = d.slideEl.querySelector(`.${n.containerClass}`);
                                if (
                                    (i && (i = i.querySelectorAll("picture, img, svg, canvas, .swiper-zoom-target")[0]),
                                    (d.imageEl = i),
                                    (d.imageWrapEl = i ? rt(d.imageEl, `.${n.containerClass}`)[0] : void 0),
                                    !d.imageWrapEl)
                                )
                                    return void (d.imageEl = void 0);
                                d.maxRatio = d.imageWrapEl.getAttribute("data-swiper-zoom") || n.maxRatio;
                            }
                            if (d.imageEl) {
                                const [e, t] = (function () {
                                    if (c.length < 2) return { x: null, y: null };
                                    const e = d.imageEl.getBoundingClientRect();
                                    return [
                                        (c[0].pageX + (c[1].pageX - c[0].pageX) / 2 - e.x) / o,
                                        (c[0].pageY + (c[1].pageY - c[0].pageY) / 2 - e.y) / o,
                                    ];
                                })();
                                (d.originX = e), (d.originY = t), (d.imageEl.style.transitionDuration = "0ms");
                            }
                            l = !0;
                        }
                    }
                    function v(t) {
                        if (!m(t)) return;
                        const n = e.params.zoom,
                            i = e.zoom,
                            s = c.findIndex((e) => e.pointerId === t.pointerId);
                        s >= 0 && (c[s] = t),
                            c.length < 2 ||
                                ((a = !0),
                                (d.scaleMove = f()),
                                d.imageEl &&
                                    ((i.scale = (d.scaleMove / d.scaleStart) * o),
                                    i.scale > d.maxRatio &&
                                        (i.scale = d.maxRatio - 1 + (i.scale - d.maxRatio + 1) ** 0.5),
                                    i.scale < n.minRatio &&
                                        (i.scale = n.minRatio + 1 - (n.minRatio - i.scale + 1) ** 0.5),
                                    (d.imageEl.style.transform = `translate3d(0,0,0) scale(${i.scale})`)));
                    }
                    function y(t) {
                        if (!m(t)) return;
                        if ("mouse" === t.pointerType && "pointerout" === t.type) return;
                        const n = e.params.zoom,
                            i = e.zoom,
                            s = c.findIndex((e) => e.pointerId === t.pointerId);
                        s >= 0 && c.splice(s, 1),
                            r &&
                                a &&
                                ((r = !1),
                                (a = !1),
                                d.imageEl &&
                                    ((i.scale = Math.max(Math.min(i.scale, d.maxRatio), n.minRatio)),
                                    (d.imageEl.style.transitionDuration = `${e.params.speed}ms`),
                                    (d.imageEl.style.transform = `translate3d(0,0,0) scale(${i.scale})`),
                                    (o = i.scale),
                                    (l = !1),
                                    i.scale > 1 && d.slideEl
                                        ? d.slideEl.classList.add(`${n.zoomedSlideClass}`)
                                        : i.scale <= 1 &&
                                          d.slideEl &&
                                          d.slideEl.classList.remove(`${n.zoomedSlideClass}`),
                                    1 === i.scale && ((d.originX = 0), (d.originY = 0), (d.slideEl = void 0))));
                    }
                    function b(t) {
                        if (
                            !m(t) ||
                            !(function (t) {
                                const n = `.${e.params.zoom.containerClass}`;
                                return (
                                    !!t.target.matches(n) ||
                                    [...e.el.querySelectorAll(n)].filter((e) => e.contains(t.target)).length > 0
                                );
                            })(t)
                        )
                            return;
                        const n = e.zoom;
                        if (!d.imageEl) return;
                        if (!u.isTouched || !d.slideEl) return;
                        u.isMoved ||
                            ((u.width = d.imageEl.offsetWidth),
                            (u.height = d.imageEl.offsetHeight),
                            (u.startX = Xe(d.imageWrapEl, "x") || 0),
                            (u.startY = Xe(d.imageWrapEl, "y") || 0),
                            (d.slideWidth = d.slideEl.offsetWidth),
                            (d.slideHeight = d.slideEl.offsetHeight),
                            (d.imageWrapEl.style.transitionDuration = "0ms"));
                        const i = u.width * n.scale,
                            s = u.height * n.scale;
                        if (i < d.slideWidth && s < d.slideHeight) return;
                        if (
                            ((u.minX = Math.min(d.slideWidth / 2 - i / 2, 0)),
                            (u.maxX = -u.minX),
                            (u.minY = Math.min(d.slideHeight / 2 - s / 2, 0)),
                            (u.maxY = -u.minY),
                            (u.touchesCurrent.x = c.length > 0 ? c[0].pageX : t.pageX),
                            (u.touchesCurrent.y = c.length > 0 ? c[0].pageY : t.pageY),
                            Math.max(
                                Math.abs(u.touchesCurrent.x - u.touchesStart.x),
                                Math.abs(u.touchesCurrent.y - u.touchesStart.y)
                            ) > 5 && (e.allowClick = !1),
                            !u.isMoved && !l)
                        ) {
                            if (
                                e.isHorizontal() &&
                                ((Math.floor(u.minX) === Math.floor(u.startX) &&
                                    u.touchesCurrent.x < u.touchesStart.x) ||
                                    (Math.floor(u.maxX) === Math.floor(u.startX) &&
                                        u.touchesCurrent.x > u.touchesStart.x))
                            )
                                return void (u.isTouched = !1);
                            if (
                                !e.isHorizontal() &&
                                ((Math.floor(u.minY) === Math.floor(u.startY) &&
                                    u.touchesCurrent.y < u.touchesStart.y) ||
                                    (Math.floor(u.maxY) === Math.floor(u.startY) &&
                                        u.touchesCurrent.y > u.touchesStart.y))
                            )
                                return void (u.isTouched = !1);
                        }
                        t.cancelable && t.preventDefault(), t.stopPropagation(), (u.isMoved = !0);
                        const r = (n.scale - o) / (d.maxRatio - e.params.zoom.minRatio),
                            { originX: a, originY: h } = d;
                        (u.currentX = u.touchesCurrent.x - u.touchesStart.x + u.startX + r * (u.width - 2 * a)),
                            (u.currentY = u.touchesCurrent.y - u.touchesStart.y + u.startY + r * (u.height - 2 * h)),
                            u.currentX < u.minX && (u.currentX = u.minX + 1 - (u.minX - u.currentX + 1) ** 0.8),
                            u.currentX > u.maxX && (u.currentX = u.maxX - 1 + (u.currentX - u.maxX + 1) ** 0.8),
                            u.currentY < u.minY && (u.currentY = u.minY + 1 - (u.minY - u.currentY + 1) ** 0.8),
                            u.currentY > u.maxY && (u.currentY = u.maxY - 1 + (u.currentY - u.maxY + 1) ** 0.8),
                            p.prevPositionX || (p.prevPositionX = u.touchesCurrent.x),
                            p.prevPositionY || (p.prevPositionY = u.touchesCurrent.y),
                            p.prevTime || (p.prevTime = Date.now()),
                            (p.x = (u.touchesCurrent.x - p.prevPositionX) / (Date.now() - p.prevTime) / 2),
                            (p.y = (u.touchesCurrent.y - p.prevPositionY) / (Date.now() - p.prevTime) / 2),
                            Math.abs(u.touchesCurrent.x - p.prevPositionX) < 2 && (p.x = 0),
                            Math.abs(u.touchesCurrent.y - p.prevPositionY) < 2 && (p.y = 0),
                            (p.prevPositionX = u.touchesCurrent.x),
                            (p.prevPositionY = u.touchesCurrent.y),
                            (p.prevTime = Date.now()),
                            (d.imageWrapEl.style.transform = `translate3d(${u.currentX}px, ${u.currentY}px,0)`);
                    }
                    function w() {
                        const t = e.zoom;
                        d.slideEl &&
                            e.activeIndex !== e.slides.indexOf(d.slideEl) &&
                            (d.imageEl && (d.imageEl.style.transform = "translate3d(0,0,0) scale(1)"),
                            d.imageWrapEl && (d.imageWrapEl.style.transform = "translate3d(0,0,0)"),
                            d.slideEl.classList.remove(`${e.params.zoom.zoomedSlideClass}`),
                            (t.scale = 1),
                            (o = 1),
                            (d.slideEl = void 0),
                            (d.imageEl = void 0),
                            (d.imageWrapEl = void 0),
                            (d.originX = 0),
                            (d.originY = 0));
                    }
                    function C(t) {
                        const n = e.zoom,
                            i = e.params.zoom;
                        if (!d.slideEl) {
                            t && t.target && (d.slideEl = t.target.closest(`.${e.params.slideClass}, swiper-slide`)),
                                d.slideEl ||
                                    (e.params.virtual && e.params.virtual.enabled && e.virtual
                                        ? (d.slideEl = et(e.slidesEl, `.${e.params.slideActiveClass}`)[0])
                                        : (d.slideEl = e.slides[e.activeIndex]));
                            let n = d.slideEl.querySelector(`.${i.containerClass}`);
                            n && (n = n.querySelectorAll("picture, img, svg, canvas, .swiper-zoom-target")[0]),
                                (d.imageEl = n),
                                (d.imageWrapEl = n ? rt(d.imageEl, `.${i.containerClass}`)[0] : void 0);
                        }
                        if (!d.imageEl || !d.imageWrapEl) return;
                        let r, a, l, c, p, h, f, m, g, v, y, b, w, C, x, S, E, T;
                        e.params.cssMode &&
                            ((e.wrapperEl.style.overflow = "hidden"), (e.wrapperEl.style.touchAction = "none")),
                            d.slideEl.classList.add(`${i.zoomedSlideClass}`),
                            void 0 === u.touchesStart.x && t
                                ? ((r = t.pageX), (a = t.pageY))
                                : ((r = u.touchesStart.x), (a = u.touchesStart.y));
                        const $ = "number" == typeof t ? t : null;
                        1 === o && $ && ((r = void 0), (a = void 0)),
                            (n.scale = $ || d.imageWrapEl.getAttribute("data-swiper-zoom") || i.maxRatio),
                            (o = $ || d.imageWrapEl.getAttribute("data-swiper-zoom") || i.maxRatio),
                            !t || (1 === o && $)
                                ? ((f = 0), (m = 0))
                                : ((E = d.slideEl.offsetWidth),
                                  (T = d.slideEl.offsetHeight),
                                  (l = nt(d.slideEl).left + s.scrollX),
                                  (c = nt(d.slideEl).top + s.scrollY),
                                  (p = l + E / 2 - r),
                                  (h = c + T / 2 - a),
                                  (g = d.imageEl.offsetWidth),
                                  (v = d.imageEl.offsetHeight),
                                  (y = g * n.scale),
                                  (b = v * n.scale),
                                  (w = Math.min(E / 2 - y / 2, 0)),
                                  (C = Math.min(T / 2 - b / 2, 0)),
                                  (x = -w),
                                  (S = -C),
                                  (f = p * n.scale),
                                  (m = h * n.scale),
                                  f < w && (f = w),
                                  f > x && (f = x),
                                  m < C && (m = C),
                                  m > S && (m = S)),
                            $ && 1 === n.scale && ((d.originX = 0), (d.originY = 0)),
                            (d.imageWrapEl.style.transitionDuration = "300ms"),
                            (d.imageWrapEl.style.transform = `translate3d(${f}px, ${m}px,0)`),
                            (d.imageEl.style.transitionDuration = "300ms"),
                            (d.imageEl.style.transform = `translate3d(0,0,0) scale(${n.scale})`);
                    }
                    function x() {
                        const t = e.zoom,
                            n = e.params.zoom;
                        if (!d.slideEl) {
                            e.params.virtual && e.params.virtual.enabled && e.virtual
                                ? (d.slideEl = et(e.slidesEl, `.${e.params.slideActiveClass}`)[0])
                                : (d.slideEl = e.slides[e.activeIndex]);
                            let t = d.slideEl.querySelector(`.${n.containerClass}`);
                            t && (t = t.querySelectorAll("picture, img, svg, canvas, .swiper-zoom-target")[0]),
                                (d.imageEl = t),
                                (d.imageWrapEl = t ? rt(d.imageEl, `.${n.containerClass}`)[0] : void 0);
                        }
                        d.imageEl &&
                            d.imageWrapEl &&
                            (e.params.cssMode &&
                                ((e.wrapperEl.style.overflow = ""), (e.wrapperEl.style.touchAction = "")),
                            (t.scale = 1),
                            (o = 1),
                            (d.imageWrapEl.style.transitionDuration = "300ms"),
                            (d.imageWrapEl.style.transform = "translate3d(0,0,0)"),
                            (d.imageEl.style.transitionDuration = "300ms"),
                            (d.imageEl.style.transform = "translate3d(0,0,0) scale(1)"),
                            d.slideEl.classList.remove(`${n.zoomedSlideClass}`),
                            (d.slideEl = void 0),
                            (d.originX = 0),
                            (d.originY = 0));
                    }
                    function S(t) {
                        const n = e.zoom;
                        n.scale && 1 !== n.scale ? x() : C(t);
                    }
                    function E() {
                        return {
                            passiveListener: !!e.params.passiveListeners && { passive: !0, capture: !1 },
                            activeListenerWithCapture: !e.params.passiveListeners || { passive: !1, capture: !0 },
                        };
                    }
                    function T() {
                        const t = e.zoom;
                        if (t.enabled) return;
                        t.enabled = !0;
                        const { passiveListener: n, activeListenerWithCapture: i } = E();
                        e.wrapperEl.addEventListener("pointerdown", g, n),
                            e.wrapperEl.addEventListener("pointermove", v, i),
                            ["pointerup", "pointercancel", "pointerout"].forEach((t) => {
                                e.wrapperEl.addEventListener(t, y, n);
                            }),
                            e.wrapperEl.addEventListener("pointermove", b, i);
                    }
                    function $() {
                        const t = e.zoom;
                        if (!t.enabled) return;
                        t.enabled = !1;
                        const { passiveListener: n, activeListenerWithCapture: i } = E();
                        e.wrapperEl.removeEventListener("pointerdown", g, n),
                            e.wrapperEl.removeEventListener("pointermove", v, i),
                            ["pointerup", "pointercancel", "pointerout"].forEach((t) => {
                                e.wrapperEl.removeEventListener(t, y, n);
                            }),
                            e.wrapperEl.removeEventListener("pointermove", b, i);
                    }
                    Object.defineProperty(e.zoom, "scale", {
                        get() {
                            return h;
                        },
                        set(e) {
                            if (h !== e) {
                                const t = d.imageEl,
                                    n = d.slideEl;
                                i("zoomChange", e, t, n);
                            }
                            h = e;
                        },
                    }),
                        n("init", () => {
                            e.params.zoom.enabled && T();
                        }),
                        n("destroy", () => {
                            $();
                        }),
                        n("touchStart", (t, n) => {
                            e.zoom.enabled &&
                                (function (t) {
                                    const n = e.device;
                                    if (!d.imageEl) return;
                                    if (u.isTouched) return;
                                    n.android && t.cancelable && t.preventDefault(), (u.isTouched = !0);
                                    const i = c.length > 0 ? c[0] : t;
                                    (u.touchesStart.x = i.pageX), (u.touchesStart.y = i.pageY);
                                })(n);
                        }),
                        n("touchEnd", (t, n) => {
                            e.zoom.enabled &&
                                (function () {
                                    const t = e.zoom;
                                    if (!d.imageEl) return;
                                    if (!u.isTouched || !u.isMoved) return (u.isTouched = !1), void (u.isMoved = !1);
                                    (u.isTouched = !1), (u.isMoved = !1);
                                    let n = 300,
                                        i = 300;
                                    const s = p.x * n,
                                        r = u.currentX + s,
                                        a = p.y * i,
                                        o = u.currentY + a;
                                    0 !== p.x && (n = Math.abs((r - u.currentX) / p.x)),
                                        0 !== p.y && (i = Math.abs((o - u.currentY) / p.y));
                                    const l = Math.max(n, i);
                                    (u.currentX = r), (u.currentY = o);
                                    const c = u.width * t.scale,
                                        h = u.height * t.scale;
                                    (u.minX = Math.min(d.slideWidth / 2 - c / 2, 0)),
                                        (u.maxX = -u.minX),
                                        (u.minY = Math.min(d.slideHeight / 2 - h / 2, 0)),
                                        (u.maxY = -u.minY),
                                        (u.currentX = Math.max(Math.min(u.currentX, u.maxX), u.minX)),
                                        (u.currentY = Math.max(Math.min(u.currentY, u.maxY), u.minY)),
                                        (d.imageWrapEl.style.transitionDuration = `${l}ms`),
                                        (d.imageWrapEl.style.transform = `translate3d(${u.currentX}px, ${u.currentY}px,0)`);
                                })();
                        }),
                        n("doubleTap", (t, n) => {
                            !e.animating && e.params.zoom.enabled && e.zoom.enabled && e.params.zoom.toggle && S(n);
                        }),
                        n("transitionEnd", () => {
                            e.zoom.enabled && e.params.zoom.enabled && w();
                        }),
                        n("slideChange", () => {
                            e.zoom.enabled && e.params.zoom.enabled && e.params.cssMode && w();
                        }),
                        Object.assign(e.zoom, { enable: T, disable: $, in: C, out: x, toggle: S });
                },
                function ({ swiper: e, extendParams: t, on: n }) {
                    function i(e, t) {
                        const n = (function () {
                            let e, t, n;
                            return (i, s) => {
                                for (t = -1, e = i.length; e - t > 1; )
                                    (n = (e + t) >> 1), i[n] <= s ? (t = n) : (e = n);
                                return e;
                            };
                        })();
                        let i, s;
                        return (
                            (this.x = e),
                            (this.y = t),
                            (this.lastIndex = e.length - 1),
                            (this.interpolate = function (e) {
                                return e
                                    ? ((s = n(this.x, e)),
                                      (i = s - 1),
                                      ((e - this.x[i]) * (this.y[s] - this.y[i])) / (this.x[s] - this.x[i]) + this.y[i])
                                    : 0;
                            }),
                            this
                        );
                    }
                    function s() {
                        e.controller.control &&
                            e.controller.spline &&
                            ((e.controller.spline = void 0), delete e.controller.spline);
                    }
                    t({ controller: { control: void 0, inverse: !1, by: "slide" } }),
                        (e.controller = { control: void 0 }),
                        n("beforeInit", () => {
                            if (
                                "undefined" != typeof window &&
                                ("string" == typeof e.params.controller.control ||
                                    e.params.controller.control instanceof HTMLElement)
                            ) {
                                const t = document.querySelector(e.params.controller.control);
                                if (t && t.swiper) e.controller.control = t.swiper;
                                else if (t) {
                                    const n = (i) => {
                                        (e.controller.control = i.detail[0]),
                                            e.update(),
                                            t.removeEventListener("init", n);
                                    };
                                    t.addEventListener("init", n);
                                }
                            } else e.controller.control = e.params.controller.control;
                        }),
                        n("update", () => {
                            s();
                        }),
                        n("resize", () => {
                            s();
                        }),
                        n("observerUpdate", () => {
                            s();
                        }),
                        n("setTranslate", (t, n, i) => {
                            e.controller.control && !e.controller.control.destroyed && e.controller.setTranslate(n, i);
                        }),
                        n("setTransition", (t, n, i) => {
                            e.controller.control && !e.controller.control.destroyed && e.controller.setTransition(n, i);
                        }),
                        Object.assign(e.controller, {
                            setTranslate: function (t, n) {
                                const s = e.controller.control;
                                let r, a;
                                const o = e.constructor;
                                function l(t) {
                                    if (t.destroyed) return;
                                    const n = e.rtlTranslate ? -e.translate : e.translate;
                                    "slide" === e.params.controller.by &&
                                        ((function (t) {
                                            e.controller.spline = e.params.loop
                                                ? new i(e.slidesGrid, t.slidesGrid)
                                                : new i(e.snapGrid, t.snapGrid);
                                        })(t),
                                        (a = -e.controller.spline.interpolate(-n))),
                                        (a && "container" !== e.params.controller.by) ||
                                            ((r =
                                                (t.maxTranslate() - t.minTranslate()) /
                                                (e.maxTranslate() - e.minTranslate())),
                                            (!Number.isNaN(r) && Number.isFinite(r)) || (r = 1),
                                            (a = (n - e.minTranslate()) * r + t.minTranslate())),
                                        e.params.controller.inverse && (a = t.maxTranslate() - a),
                                        t.updateProgress(a),
                                        t.setTranslate(a, e),
                                        t.updateActiveIndex(),
                                        t.updateSlidesClasses();
                                }
                                if (Array.isArray(s))
                                    for (let e = 0; e < s.length; e += 1) s[e] !== n && s[e] instanceof o && l(s[e]);
                                else s instanceof o && n !== s && l(s);
                            },
                            setTransition: function (t, n) {
                                const i = e.constructor,
                                    s = e.controller.control;
                                let r;
                                function a(n) {
                                    n.destroyed ||
                                        (n.setTransition(t, e),
                                        0 !== t &&
                                            (n.transitionStart(),
                                            n.params.autoHeight &&
                                                We(() => {
                                                    n.updateAutoHeight();
                                                }),
                                            at(n.wrapperEl, () => {
                                                s && n.transitionEnd();
                                            })));
                                }
                                if (Array.isArray(s))
                                    for (r = 0; r < s.length; r += 1) s[r] !== n && s[r] instanceof i && a(s[r]);
                                else s instanceof i && n !== s && a(s);
                            },
                        });
                },
                function ({ swiper: e, extendParams: t, on: n }) {
                    t({
                        a11y: {
                            enabled: !0,
                            notificationClass: "swiper-notification",
                            prevSlideMessage: "Previous slide",
                            nextSlideMessage: "Next slide",
                            firstSlideMessage: "This is the first slide",
                            lastSlideMessage: "This is the last slide",
                            paginationBulletMessage: "Go to slide {{index}}",
                            slideLabelMessage: "{{index}} / {{slidesLength}}",
                            containerMessage: null,
                            containerRoleDescriptionMessage: null,
                            itemRoleDescriptionMessage: null,
                            slideRole: "group",
                            id: null,
                        },
                    }),
                        (e.a11y = { clicked: !1 });
                    let i = null;
                    function s(e) {
                        const t = i;
                        0 !== t.length && ((t.innerHTML = ""), (t.innerHTML = e));
                    }
                    const r = (e) => (Array.isArray(e) || (e = [e].filter((e) => !!e)), e);
                    function a(e) {
                        (e = r(e)).forEach((e) => {
                            e.setAttribute("tabIndex", "0");
                        });
                    }
                    function o(e) {
                        (e = r(e)).forEach((e) => {
                            e.setAttribute("tabIndex", "-1");
                        });
                    }
                    function l(e, t) {
                        (e = r(e)).forEach((e) => {
                            e.setAttribute("role", t);
                        });
                    }
                    function c(e, t) {
                        (e = r(e)).forEach((e) => {
                            e.setAttribute("aria-roledescription", t);
                        });
                    }
                    function d(e, t) {
                        (e = r(e)).forEach((e) => {
                            e.setAttribute("aria-label", t);
                        });
                    }
                    function u(e) {
                        (e = r(e)).forEach((e) => {
                            e.setAttribute("aria-disabled", !0);
                        });
                    }
                    function p(e) {
                        (e = r(e)).forEach((e) => {
                            e.setAttribute("aria-disabled", !1);
                        });
                    }
                    function h(t) {
                        if (13 !== t.keyCode && 32 !== t.keyCode) return;
                        const n = e.params.a11y,
                            i = t.target;
                        (e.pagination &&
                            e.pagination.el &&
                            (i === e.pagination.el || e.pagination.el.contains(t.target)) &&
                            !t.target.matches(Bt(e.params.pagination.bulletClass))) ||
                            (e.navigation &&
                                e.navigation.nextEl &&
                                i === e.navigation.nextEl &&
                                ((e.isEnd && !e.params.loop) || e.slideNext(),
                                e.isEnd ? s(n.lastSlideMessage) : s(n.nextSlideMessage)),
                            e.navigation &&
                                e.navigation.prevEl &&
                                i === e.navigation.prevEl &&
                                ((e.isBeginning && !e.params.loop) || e.slidePrev(),
                                e.isBeginning ? s(n.firstSlideMessage) : s(n.prevSlideMessage)),
                            e.pagination && i.matches(Bt(e.params.pagination.bulletClass)) && i.click());
                    }
                    function f() {
                        return e.pagination && e.pagination.bullets && e.pagination.bullets.length;
                    }
                    function m() {
                        return f() && e.params.pagination.clickable;
                    }
                    const g = (e, t, n) => {
                            a(e),
                                "BUTTON" !== e.tagName && (l(e, "button"), e.addEventListener("keydown", h)),
                                d(e, n),
                                (function (e, t) {
                                    (e = r(e)).forEach((e) => {
                                        e.setAttribute("aria-controls", t);
                                    });
                                })(e, t);
                        },
                        v = () => {
                            e.a11y.clicked = !0;
                        },
                        y = () => {
                            requestAnimationFrame(() => {
                                requestAnimationFrame(() => {
                                    e.destroyed || (e.a11y.clicked = !1);
                                });
                            });
                        },
                        b = (t) => {
                            if (e.a11y.clicked) return;
                            const n = t.target.closest(`.${e.params.slideClass}, swiper-slide`);
                            if (!n || !e.slides.includes(n)) return;
                            const i = e.slides.indexOf(n) === e.activeIndex,
                                s = e.params.watchSlidesProgress && e.visibleSlides && e.visibleSlides.includes(n);
                            i ||
                                s ||
                                (t.sourceCapabilities && t.sourceCapabilities.firesTouchEvents) ||
                                (e.isHorizontal() ? (e.el.scrollLeft = 0) : (e.el.scrollTop = 0),
                                e.slideTo(e.slides.indexOf(n), 0));
                        },
                        w = () => {
                            const t = e.params.a11y;
                            t.itemRoleDescriptionMessage && c(e.slides, t.itemRoleDescriptionMessage),
                                t.slideRole && l(e.slides, t.slideRole);
                            const n = e.slides.length;
                            t.slideLabelMessage &&
                                e.slides.forEach((i, s) => {
                                    const r = e.params.loop
                                        ? parseInt(i.getAttribute("data-swiper-slide-index"), 10)
                                        : s;
                                    d(
                                        i,
                                        t.slideLabelMessage
                                            .replace(/\{\{index\}\}/, r + 1)
                                            .replace(/\{\{slidesLength\}\}/, n)
                                    );
                                });
                        };
                    n("beforeInit", () => {
                        (i = tt("span", e.params.a11y.notificationClass)),
                            i.setAttribute("aria-live", "assertive"),
                            i.setAttribute("aria-atomic", "true");
                    }),
                        n("afterInit", () => {
                            e.params.a11y.enabled &&
                                (() => {
                                    const t = e.params.a11y;
                                    e.isElement ? e.el.shadowEl.append(i) : e.el.append(i);
                                    const n = e.el;
                                    t.containerRoleDescriptionMessage && c(n, t.containerRoleDescriptionMessage),
                                        t.containerMessage && d(n, t.containerMessage);
                                    const s = e.wrapperEl,
                                        a =
                                            t.id ||
                                            s.getAttribute("id") ||
                                            `swiper-wrapper-${(function (e = 16) {
                                                return "x"
                                                    .repeat(e)
                                                    .replace(/x/g, () => Math.round(16 * Math.random()).toString(16));
                                            })(16)}`,
                                        o = e.params.autoplay && e.params.autoplay.enabled ? "off" : "polite";
                                    var l;
                                    (l = a),
                                        r(s).forEach((e) => {
                                            e.setAttribute("id", l);
                                        }),
                                        (function (e, t) {
                                            (e = r(e)).forEach((e) => {
                                                e.setAttribute("aria-live", t);
                                            });
                                        })(s, o),
                                        w();
                                    let { nextEl: u, prevEl: p } = e.navigation ? e.navigation : {};
                                    (u = r(u)),
                                        (p = r(p)),
                                        u && u.forEach((e) => g(e, a, t.nextSlideMessage)),
                                        p && p.forEach((e) => g(e, a, t.prevSlideMessage)),
                                        m() &&
                                            (Array.isArray(e.pagination.el)
                                                ? e.pagination.el
                                                : [e.pagination.el]
                                            ).forEach((e) => {
                                                e.addEventListener("keydown", h);
                                            }),
                                        e.el.addEventListener("focus", b, !0),
                                        e.el.addEventListener("pointerdown", v, !0),
                                        e.el.addEventListener("pointerup", y, !0);
                                })();
                        }),
                        n("slidesLengthChange snapGridLengthChange slidesGridLengthChange", () => {
                            e.params.a11y.enabled && w();
                        }),
                        n("fromEdge toEdge afterInit lock unlock", () => {
                            e.params.a11y.enabled &&
                                (function () {
                                    if (e.params.loop || e.params.rewind || !e.navigation) return;
                                    const { nextEl: t, prevEl: n } = e.navigation;
                                    n && (e.isBeginning ? (u(n), o(n)) : (p(n), a(n))),
                                        t && (e.isEnd ? (u(t), o(t)) : (p(t), a(t)));
                                })();
                        }),
                        n("paginationUpdate", () => {
                            e.params.a11y.enabled &&
                                (function () {
                                    const t = e.params.a11y;
                                    f() &&
                                        e.pagination.bullets.forEach((n) => {
                                            e.params.pagination.clickable &&
                                                (a(n),
                                                e.params.pagination.renderBullet ||
                                                    (l(n, "button"),
                                                    d(
                                                        n,
                                                        t.paginationBulletMessage.replace(/\{\{index\}\}/, st(n) + 1)
                                                    ))),
                                                n.matches(Bt(e.params.pagination.bulletActiveClass))
                                                    ? n.setAttribute("aria-current", "true")
                                                    : n.removeAttribute("aria-current");
                                        });
                                })();
                        }),
                        n("destroy", () => {
                            e.params.a11y.enabled &&
                                (function () {
                                    i && i.remove();
                                    let { nextEl: t, prevEl: n } = e.navigation ? e.navigation : {};
                                    (t = r(t)),
                                        (n = r(n)),
                                        t && t.forEach((e) => e.removeEventListener("keydown", h)),
                                        n && n.forEach((e) => e.removeEventListener("keydown", h)),
                                        m() &&
                                            (Array.isArray(e.pagination.el)
                                                ? e.pagination.el
                                                : [e.pagination.el]
                                            ).forEach((e) => {
                                                e.removeEventListener("keydown", h);
                                            }),
                                        e.el.removeEventListener("focus", b, !0),
                                        e.el.removeEventListener("pointerdown", v, !0),
                                        e.el.removeEventListener("pointerup", y, !0);
                                })();
                        });
                },
                function ({ swiper: e, extendParams: t, on: n }) {
                    t({ history: { enabled: !1, root: "", replaceState: !1, key: "slides", keepQuery: !1 } });
                    let i = !1,
                        s = {};
                    const r = (e) =>
                            e
                                .toString()
                                .replace(/\s+/g, "-")
                                .replace(/[^\w-]+/g, "")
                                .replace(/--+/g, "-")
                                .replace(/^-+/, "")
                                .replace(/-+$/, ""),
                        a = (e) => {
                            const t = Ge();
                            let n;
                            n = e ? new URL(e) : t.location;
                            const i = n.pathname
                                    .slice(1)
                                    .split("/")
                                    .filter((e) => "" !== e),
                                s = i.length;
                            return { key: i[s - 2], value: i[s - 1] };
                        },
                        o = (t, n) => {
                            const s = Ge();
                            if (!i || !e.params.history.enabled) return;
                            let a;
                            a = e.params.url ? new URL(e.params.url) : s.location;
                            const o = e.slides[n];
                            let l = r(o.getAttribute("data-history"));
                            if (e.params.history.root.length > 0) {
                                let n = e.params.history.root;
                                "/" === n[n.length - 1] && (n = n.slice(0, n.length - 1)),
                                    (l = `${n}/${t ? `${t}/` : ""}${l}`);
                            } else a.pathname.includes(t) || (l = `${t ? `${t}/` : ""}${l}`);
                            e.params.history.keepQuery && (l += a.search);
                            const c = s.history.state;
                            (c && c.value === l) ||
                                (e.params.history.replaceState
                                    ? s.history.replaceState({ value: l }, null, l)
                                    : s.history.pushState({ value: l }, null, l));
                        },
                        l = (t, n, i) => {
                            if (n)
                                for (let s = 0, a = e.slides.length; s < a; s += 1) {
                                    const a = e.slides[s];
                                    if (r(a.getAttribute("data-history")) === n) {
                                        const n = e.getSlideIndex(a);
                                        e.slideTo(n, t, i);
                                    }
                                }
                            else e.slideTo(0, t, i);
                        },
                        c = () => {
                            (s = a(e.params.url)), l(e.params.speed, s.value, !1);
                        };
                    n("init", () => {
                        e.params.history.enabled &&
                            (() => {
                                const t = Ge();
                                if (e.params.history) {
                                    if (!t.history || !t.history.pushState)
                                        return (
                                            (e.params.history.enabled = !1), void (e.params.hashNavigation.enabled = !0)
                                        );
                                    (i = !0),
                                        (s = a(e.params.url)),
                                        s.key || s.value
                                            ? (l(0, s.value, e.params.runCallbacksOnInit),
                                              e.params.history.replaceState || t.addEventListener("popstate", c))
                                            : e.params.history.replaceState || t.addEventListener("popstate", c);
                                }
                            })();
                    }),
                        n("destroy", () => {
                            e.params.history.enabled &&
                                (() => {
                                    const t = Ge();
                                    e.params.history.replaceState || t.removeEventListener("popstate", c);
                                })();
                        }),
                        n("transitionEnd _freeModeNoMomentumRelease", () => {
                            i && o(e.params.history.key, e.activeIndex);
                        }),
                        n("slideChange", () => {
                            i && e.params.cssMode && o(e.params.history.key, e.activeIndex);
                        });
                },
                function ({ swiper: e, extendParams: t, emit: n, on: i }) {
                    let s = !1;
                    const r = Re(),
                        a = Ge();
                    t({
                        hashNavigation: {
                            enabled: !1,
                            replaceState: !1,
                            watchState: !1,
                            getSlideIndex(t, n) {
                                if (e.virtual && e.params.virtual.enabled) {
                                    const t = e.slides.filter((e) => e.getAttribute("data-hash") === n)[0];
                                    return t ? parseInt(t.getAttribute("data-swiper-slide-index"), 10) : 0;
                                }
                                return e.getSlideIndex(
                                    et(
                                        e.slidesEl,
                                        `.${e.params.slideClass}[data-hash="${n}"], swiper-slide[data-hash="${n}"]`
                                    )[0]
                                );
                            },
                        },
                    });
                    const o = () => {
                            n("hashChange");
                            const t = r.location.hash.replace("#", ""),
                                i =
                                    e.virtual && e.params.virtual.enabled
                                        ? e.slidesEl.querySelector(`[data-swiper-slide-index="${e.activeIndex}"]`)
                                        : e.slides[e.activeIndex];
                            if (t !== (i ? i.getAttribute("data-hash") : "")) {
                                const n = e.params.hashNavigation.getSlideIndex(e, t);
                                if (void 0 === n || Number.isNaN(n)) return;
                                e.slideTo(n);
                            }
                        },
                        l = () => {
                            if (!s || !e.params.hashNavigation.enabled) return;
                            const t =
                                    e.virtual && e.params.virtual.enabled
                                        ? e.slidesEl.querySelector(`[data-swiper-slide-index="${e.activeIndex}"]`)
                                        : e.slides[e.activeIndex],
                                i = t ? t.getAttribute("data-hash") || t.getAttribute("data-history") : "";
                            e.params.hashNavigation.replaceState && a.history && a.history.replaceState
                                ? (a.history.replaceState(null, null, `#${i}` || ""), n("hashSet"))
                                : ((r.location.hash = i || ""), n("hashSet"));
                        };
                    i("init", () => {
                        e.params.hashNavigation.enabled &&
                            (() => {
                                if (!e.params.hashNavigation.enabled || (e.params.history && e.params.history.enabled))
                                    return;
                                s = !0;
                                const t = r.location.hash.replace("#", "");
                                if (t) {
                                    const n = 0,
                                        i = e.params.hashNavigation.getSlideIndex(e, t);
                                    e.slideTo(i || 0, n, e.params.runCallbacksOnInit, !0);
                                }
                                e.params.hashNavigation.watchState && a.addEventListener("hashchange", o);
                            })();
                    }),
                        i("destroy", () => {
                            e.params.hashNavigation.enabled &&
                                e.params.hashNavigation.watchState &&
                                a.removeEventListener("hashchange", o);
                        }),
                        i("transitionEnd _freeModeNoMomentumRelease", () => {
                            s && l();
                        }),
                        i("slideChange", () => {
                            s && e.params.cssMode && l();
                        });
                },
                function ({ swiper: e, extendParams: t, on: n, emit: i, params: s }) {
                    let r, a;
                    (e.autoplay = { running: !1, paused: !1, timeLeft: 0 }),
                        t({
                            autoplay: {
                                enabled: !1,
                                delay: 3e3,
                                waitForTransition: !0,
                                disableOnInteraction: !0,
                                stopOnLastSlide: !1,
                                reverseDirection: !1,
                                pauseOnMouseEnter: !1,
                            },
                        });
                    let o,
                        l,
                        c,
                        d,
                        u,
                        p,
                        h,
                        f = s && s.autoplay ? s.autoplay.delay : 3e3,
                        m = s && s.autoplay ? s.autoplay.delay : 3e3,
                        g = new Date().getTime;
                    function v(t) {
                        e &&
                            !e.destroyed &&
                            e.wrapperEl &&
                            t.target === e.wrapperEl &&
                            (e.wrapperEl.removeEventListener("transitionend", v), S());
                    }
                    const y = () => {
                            if (e.destroyed || !e.autoplay.running) return;
                            e.autoplay.paused ? (l = !0) : l && ((m = o), (l = !1));
                            const t = e.autoplay.paused ? o : g + m - new Date().getTime();
                            (e.autoplay.timeLeft = t),
                                i("autoplayTimeLeft", t, t / f),
                                (a = requestAnimationFrame(() => {
                                    y();
                                }));
                        },
                        b = (t) => {
                            if (e.destroyed || !e.autoplay.running) return;
                            cancelAnimationFrame(a), y();
                            let n = void 0 === t ? e.params.autoplay.delay : t;
                            (f = e.params.autoplay.delay), (m = e.params.autoplay.delay);
                            const s = (() => {
                                let t;
                                if (
                                    ((t =
                                        e.virtual && e.params.virtual.enabled
                                            ? e.slides.filter((e) => e.classList.contains("swiper-slide-active"))[0]
                                            : e.slides[e.activeIndex]),
                                    t)
                                )
                                    return parseInt(t.getAttribute("data-swiper-autoplay"), 10);
                            })();
                            !Number.isNaN(s) && s > 0 && void 0 === t && ((n = s), (f = s), (m = s)), (o = n);
                            const l = e.params.speed,
                                c = () => {
                                    e &&
                                        !e.destroyed &&
                                        (e.params.autoplay.reverseDirection
                                            ? !e.isBeginning || e.params.loop || e.params.rewind
                                                ? (e.slidePrev(l, !0, !0), i("autoplay"))
                                                : e.params.autoplay.stopOnLastSlide ||
                                                  (e.slideTo(e.slides.length - 1, l, !0, !0), i("autoplay"))
                                            : !e.isEnd || e.params.loop || e.params.rewind
                                              ? (e.slideNext(l, !0, !0), i("autoplay"))
                                              : e.params.autoplay.stopOnLastSlide ||
                                                (e.slideTo(0, l, !0, !0), i("autoplay")),
                                        e.params.cssMode &&
                                            ((g = new Date().getTime()),
                                            requestAnimationFrame(() => {
                                                b();
                                            })));
                                };
                            return (
                                n > 0
                                    ? (clearTimeout(r),
                                      (r = setTimeout(() => {
                                          c();
                                      }, n)))
                                    : requestAnimationFrame(() => {
                                          c();
                                      }),
                                n
                            );
                        },
                        w = () => {
                            (e.autoplay.running = !0), b(), i("autoplayStart");
                        },
                        C = () => {
                            (e.autoplay.running = !1), clearTimeout(r), cancelAnimationFrame(a), i("autoplayStop");
                        },
                        x = (t, n) => {
                            if (e.destroyed || !e.autoplay.running) return;
                            clearTimeout(r), t || (h = !0);
                            const s = () => {
                                i("autoplayPause"),
                                    e.params.autoplay.waitForTransition
                                        ? e.wrapperEl.addEventListener("transitionend", v)
                                        : S();
                            };
                            if (((e.autoplay.paused = !0), n))
                                return p && (o = e.params.autoplay.delay), (p = !1), void s();
                            const a = o || e.params.autoplay.delay;
                            (o = a - (new Date().getTime() - g)),
                                (e.isEnd && o < 0 && !e.params.loop) || (o < 0 && (o = 0), s());
                        },
                        S = () => {
                            (e.isEnd && o < 0 && !e.params.loop) ||
                                e.destroyed ||
                                !e.autoplay.running ||
                                ((g = new Date().getTime()),
                                h ? ((h = !1), b(o)) : b(),
                                (e.autoplay.paused = !1),
                                i("autoplayResume"));
                        },
                        E = () => {
                            if (e.destroyed || !e.autoplay.running) return;
                            const t = Re();
                            "hidden" === t.visibilityState && ((h = !0), x(!0)), "visible" === t.visibilityState && S();
                        },
                        T = (e) => {
                            "mouse" === e.pointerType && ((h = !0), x(!0));
                        },
                        $ = (t) => {
                            "mouse" === t.pointerType && e.autoplay.paused && S();
                        };
                    n("init", () => {
                        e.params.autoplay.enabled &&
                            (e.params.autoplay.pauseOnMouseEnter &&
                                (e.el.addEventListener("pointerenter", T), e.el.addEventListener("pointerleave", $)),
                            Re().addEventListener("visibilitychange", E),
                            (g = new Date().getTime()),
                            w());
                    }),
                        n("destroy", () => {
                            e.el.removeEventListener("pointerenter", T),
                                e.el.removeEventListener("pointerleave", $),
                                Re().removeEventListener("visibilitychange", E),
                                e.autoplay.running && C();
                        }),
                        n("beforeTransitionStart", (t, n, i) => {
                            !e.destroyed &&
                                e.autoplay.running &&
                                (i || !e.params.autoplay.disableOnInteraction ? x(!0, !0) : C());
                        }),
                        n("sliderFirstMove", () => {
                            !e.destroyed &&
                                e.autoplay.running &&
                                (e.params.autoplay.disableOnInteraction
                                    ? C()
                                    : ((c = !0),
                                      (d = !1),
                                      (h = !1),
                                      (u = setTimeout(() => {
                                          (h = !0), (d = !0), x(!0);
                                      }, 200))));
                        }),
                        n("touchEnd", () => {
                            if (!e.destroyed && e.autoplay.running && c) {
                                if ((clearTimeout(u), clearTimeout(r), e.params.autoplay.disableOnInteraction))
                                    return (d = !1), void (c = !1);
                                d && e.params.cssMode && S(), (d = !1), (c = !1);
                            }
                        }),
                        n("slideChange", () => {
                            !e.destroyed && e.autoplay.running && (p = !0);
                        }),
                        Object.assign(e.autoplay, { start: w, stop: C, pause: x, resume: S });
                },
                function ({ swiper: e, extendParams: t, on: n }) {
                    t({
                        thumbs: {
                            swiper: null,
                            multipleActiveThumbs: !0,
                            autoScrollOffset: 0,
                            slideThumbActiveClass: "swiper-slide-thumb-active",
                            thumbsContainerClass: "swiper-thumbs",
                        },
                    });
                    let i = !1,
                        s = !1;
                    function r() {
                        const t = e.thumbs.swiper;
                        if (!t || t.destroyed) return;
                        const n = t.clickedIndex,
                            i = t.clickedSlide;
                        if (i && i.classList.contains(e.params.thumbs.slideThumbActiveClass)) return;
                        if (null == n) return;
                        let s;
                        (s = t.params.loop ? parseInt(t.clickedSlide.getAttribute("data-swiper-slide-index"), 10) : n),
                            e.params.loop ? e.slideToLoop(s) : e.slideTo(s);
                    }
                    function a() {
                        const { thumbs: t } = e.params;
                        if (i) return !1;
                        i = !0;
                        const n = e.constructor;
                        if (t.swiper instanceof n)
                            (e.thumbs.swiper = t.swiper),
                                Object.assign(e.thumbs.swiper.originalParams, {
                                    watchSlidesProgress: !0,
                                    slideToClickedSlide: !1,
                                }),
                                Object.assign(e.thumbs.swiper.params, {
                                    watchSlidesProgress: !0,
                                    slideToClickedSlide: !1,
                                }),
                                e.thumbs.swiper.update();
                        else if (Ye(t.swiper)) {
                            const i = Object.assign({}, t.swiper);
                            Object.assign(i, { watchSlidesProgress: !0, slideToClickedSlide: !1 }),
                                (e.thumbs.swiper = new n(i)),
                                (s = !0);
                        }
                        return (
                            e.thumbs.swiper.el.classList.add(e.params.thumbs.thumbsContainerClass),
                            e.thumbs.swiper.on("tap", r),
                            !0
                        );
                    }
                    function o(t) {
                        const n = e.thumbs.swiper;
                        if (!n || n.destroyed) return;
                        const i = "auto" === n.params.slidesPerView ? n.slidesPerViewDynamic() : n.params.slidesPerView;
                        let s = 1;
                        const r = e.params.thumbs.slideThumbActiveClass;
                        if (
                            (e.params.slidesPerView > 1 && !e.params.centeredSlides && (s = e.params.slidesPerView),
                            e.params.thumbs.multipleActiveThumbs || (s = 1),
                            (s = Math.floor(s)),
                            n.slides.forEach((e) => e.classList.remove(r)),
                            n.params.loop || (n.params.virtual && n.params.virtual.enabled))
                        )
                            for (let t = 0; t < s; t += 1)
                                et(n.slidesEl, `[data-swiper-slide-index="${e.realIndex + t}"]`).forEach((e) => {
                                    e.classList.add(r);
                                });
                        else
                            for (let t = 0; t < s; t += 1)
                                n.slides[e.realIndex + t] && n.slides[e.realIndex + t].classList.add(r);
                        const a = e.params.thumbs.autoScrollOffset,
                            o = a && !n.params.loop;
                        if (e.realIndex !== n.realIndex || o) {
                            const s = n.activeIndex;
                            let r, l;
                            if (n.params.loop) {
                                const t = n.slides.filter(
                                    (t) => t.getAttribute("data-swiper-slide-index") === `${e.realIndex}`
                                )[0];
                                (r = n.slides.indexOf(t)), (l = e.activeIndex > e.previousIndex ? "next" : "prev");
                            } else (r = e.realIndex), (l = r > e.previousIndex ? "next" : "prev");
                            o && (r += "next" === l ? a : -1 * a),
                                n.visibleSlidesIndexes &&
                                    n.visibleSlidesIndexes.indexOf(r) < 0 &&
                                    (n.params.centeredSlides
                                        ? (r = r > s ? r - Math.floor(i / 2) + 1 : r + Math.floor(i / 2) - 1)
                                        : r > s && n.params.slidesPerGroup,
                                    n.slideTo(r, t ? 0 : void 0));
                        }
                    }
                    (e.thumbs = { swiper: null }),
                        n("beforeInit", () => {
                            const { thumbs: t } = e.params;
                            if (t && t.swiper)
                                if ("string" == typeof t.swiper || t.swiper instanceof HTMLElement) {
                                    const n = Re(),
                                        i = () => {
                                            const i =
                                                "string" == typeof t.swiper ? n.querySelector(t.swiper) : t.swiper;
                                            if (i && i.swiper) (t.swiper = i.swiper), a(), o(!0);
                                            else if (i) {
                                                const n = (s) => {
                                                    (t.swiper = s.detail[0]),
                                                        i.removeEventListener("init", n),
                                                        a(),
                                                        o(!0),
                                                        t.swiper.update(),
                                                        e.update();
                                                };
                                                i.addEventListener("init", n);
                                            }
                                            return i;
                                        },
                                        s = () => {
                                            e.destroyed || i() || requestAnimationFrame(s);
                                        };
                                    requestAnimationFrame(s);
                                } else a(), o(!0);
                        }),
                        n("slideChange update resize observerUpdate", () => {
                            o();
                        }),
                        n("setTransition", (t, n) => {
                            const i = e.thumbs.swiper;
                            i && !i.destroyed && i.setTransition(n);
                        }),
                        n("beforeDestroy", () => {
                            const t = e.thumbs.swiper;
                            t && !t.destroyed && s && t.destroy();
                        }),
                        Object.assign(e.thumbs, { init: a, update: o });
                },
                function ({ swiper: e, extendParams: t, emit: n, once: i }) {
                    t({
                        freeMode: {
                            enabled: !1,
                            momentum: !0,
                            momentumRatio: 1,
                            momentumBounce: !0,
                            momentumBounceRatio: 1,
                            momentumVelocityRatio: 1,
                            sticky: !1,
                            minimumVelocity: 0.02,
                        },
                    }),
                        Object.assign(e, {
                            freeMode: {
                                onTouchStart: function () {
                                    if (e.params.cssMode) return;
                                    const t = e.getTranslate();
                                    e.setTranslate(t),
                                        e.setTransition(0),
                                        (e.touchEventsData.velocities.length = 0),
                                        e.freeMode.onTouchEnd({ currentPos: e.rtl ? e.translate : -e.translate });
                                },
                                onTouchMove: function () {
                                    if (e.params.cssMode) return;
                                    const { touchEventsData: t, touches: n } = e;
                                    0 === t.velocities.length &&
                                        t.velocities.push({
                                            position: n[e.isHorizontal() ? "startX" : "startY"],
                                            time: t.touchStartTime,
                                        }),
                                        t.velocities.push({
                                            position: n[e.isHorizontal() ? "currentX" : "currentY"],
                                            time: Ue(),
                                        });
                                },
                                onTouchEnd: function ({ currentPos: t }) {
                                    if (e.params.cssMode) return;
                                    const {
                                            params: s,
                                            wrapperEl: r,
                                            rtlTranslate: a,
                                            snapGrid: o,
                                            touchEventsData: l,
                                        } = e,
                                        c = Ue() - l.touchStartTime;
                                    if (t < -e.minTranslate()) e.slideTo(e.activeIndex);
                                    else if (t > -e.maxTranslate())
                                        e.slides.length < o.length
                                            ? e.slideTo(o.length - 1)
                                            : e.slideTo(e.slides.length - 1);
                                    else {
                                        if (s.freeMode.momentum) {
                                            if (l.velocities.length > 1) {
                                                const t = l.velocities.pop(),
                                                    n = l.velocities.pop(),
                                                    i = t.position - n.position,
                                                    r = t.time - n.time;
                                                (e.velocity = i / r),
                                                    (e.velocity /= 2),
                                                    Math.abs(e.velocity) < s.freeMode.minimumVelocity &&
                                                        (e.velocity = 0),
                                                    (r > 150 || Ue() - t.time > 300) && (e.velocity = 0);
                                            } else e.velocity = 0;
                                            (e.velocity *= s.freeMode.momentumVelocityRatio), (l.velocities.length = 0);
                                            let t = 1e3 * s.freeMode.momentumRatio;
                                            const c = e.velocity * t;
                                            let d = e.translate + c;
                                            a && (d = -d);
                                            let u,
                                                p = !1;
                                            const h = 20 * Math.abs(e.velocity) * s.freeMode.momentumBounceRatio;
                                            let f;
                                            if (d < e.maxTranslate())
                                                s.freeMode.momentumBounce
                                                    ? (d + e.maxTranslate() < -h && (d = e.maxTranslate() - h),
                                                      (u = e.maxTranslate()),
                                                      (p = !0),
                                                      (l.allowMomentumBounce = !0))
                                                    : (d = e.maxTranslate()),
                                                    s.loop && s.centeredSlides && (f = !0);
                                            else if (d > e.minTranslate())
                                                s.freeMode.momentumBounce
                                                    ? (d - e.minTranslate() > h && (d = e.minTranslate() + h),
                                                      (u = e.minTranslate()),
                                                      (p = !0),
                                                      (l.allowMomentumBounce = !0))
                                                    : (d = e.minTranslate()),
                                                    s.loop && s.centeredSlides && (f = !0);
                                            else if (s.freeMode.sticky) {
                                                let t;
                                                for (let e = 0; e < o.length; e += 1)
                                                    if (o[e] > -d) {
                                                        t = e;
                                                        break;
                                                    }
                                                (d =
                                                    Math.abs(o[t] - d) < Math.abs(o[t - 1] - d) ||
                                                    "next" === e.swipeDirection
                                                        ? o[t]
                                                        : o[t - 1]),
                                                    (d = -d);
                                            }
                                            if (
                                                (f &&
                                                    i("transitionEnd", () => {
                                                        e.loopFix();
                                                    }),
                                                0 !== e.velocity)
                                            ) {
                                                if (
                                                    ((t = a
                                                        ? Math.abs((-d - e.translate) / e.velocity)
                                                        : Math.abs((d - e.translate) / e.velocity)),
                                                    s.freeMode.sticky)
                                                ) {
                                                    const n = Math.abs((a ? -d : d) - e.translate),
                                                        i = e.slidesSizesGrid[e.activeIndex];
                                                    t = n < i ? s.speed : n < 2 * i ? 1.5 * s.speed : 2.5 * s.speed;
                                                }
                                            } else if (s.freeMode.sticky) return void e.slideToClosest();
                                            s.freeMode.momentumBounce && p
                                                ? (e.updateProgress(u),
                                                  e.setTransition(t),
                                                  e.setTranslate(d),
                                                  e.transitionStart(!0, e.swipeDirection),
                                                  (e.animating = !0),
                                                  at(r, () => {
                                                      e &&
                                                          !e.destroyed &&
                                                          l.allowMomentumBounce &&
                                                          (n("momentumBounce"),
                                                          e.setTransition(s.speed),
                                                          setTimeout(() => {
                                                              e.setTranslate(u),
                                                                  at(r, () => {
                                                                      e && !e.destroyed && e.transitionEnd();
                                                                  });
                                                          }, 0));
                                                  }))
                                                : e.velocity
                                                  ? (n("_freeModeNoMomentumRelease"),
                                                    e.updateProgress(d),
                                                    e.setTransition(t),
                                                    e.setTranslate(d),
                                                    e.transitionStart(!0, e.swipeDirection),
                                                    e.animating ||
                                                        ((e.animating = !0),
                                                        at(r, () => {
                                                            e && !e.destroyed && e.transitionEnd();
                                                        })))
                                                  : e.updateProgress(d),
                                                e.updateActiveIndex(),
                                                e.updateSlidesClasses();
                                        } else {
                                            if (s.freeMode.sticky) return void e.slideToClosest();
                                            s.freeMode && n("_freeModeNoMomentumRelease");
                                        }
                                        (!s.freeMode.momentum || c >= s.longSwipesMs) &&
                                            (e.updateProgress(), e.updateActiveIndex(), e.updateSlidesClasses());
                                    }
                                },
                            },
                        });
                },
                function ({ swiper: e, extendParams: t }) {
                    let n, i, s;
                    t({ grid: { rows: 1, fill: "column" } });
                    const r = () => {
                        let t = e.params.spaceBetween;
                        return (
                            "string" == typeof t && t.indexOf("%") >= 0
                                ? (t = (parseFloat(t.replace("%", "")) / 100) * e.size)
                                : "string" == typeof t && (t = parseFloat(t)),
                            t
                        );
                    };
                    e.grid = {
                        initSlides: (t) => {
                            const { slidesPerView: r } = e.params,
                                { rows: a, fill: o } = e.params.grid;
                            (s = Math.floor(t / a)),
                                (n = Math.floor(t / a) === t / a ? t : Math.ceil(t / a) * a),
                                "auto" !== r && "row" === o && (n = Math.max(n, r * a)),
                                (i = n / a);
                        },
                        updateSlide: (t, a, o, l) => {
                            const { slidesPerGroup: c } = e.params,
                                d = r(),
                                { rows: u, fill: p } = e.params.grid;
                            let h, f, m;
                            if ("row" === p && c > 1) {
                                const e = Math.floor(t / (c * u)),
                                    i = t - u * c * e,
                                    s = 0 === e ? c : Math.min(Math.ceil((o - e * u * c) / u), c);
                                (m = Math.floor(i / s)),
                                    (f = i - m * s + e * c),
                                    (h = f + (m * n) / u),
                                    (a.style.order = h);
                            } else
                                "column" === p
                                    ? ((f = Math.floor(t / u)),
                                      (m = t - f * u),
                                      (f > s || (f === s && m === u - 1)) && ((m += 1), m >= u && ((m = 0), (f += 1))))
                                    : ((m = Math.floor(t / i)), (f = t - m * i));
                            (a.row = m), (a.column = f), (a.style[l("margin-top")] = 0 !== m ? d && `${d}px` : "");
                        },
                        updateWrapperSize: (t, i, s) => {
                            const { centeredSlides: a, roundLengths: o } = e.params,
                                l = r(),
                                { rows: c } = e.params.grid;
                            if (
                                ((e.virtualSize = (t + l) * n),
                                (e.virtualSize = Math.ceil(e.virtualSize / c) - l),
                                (e.wrapperEl.style[s("width")] = `${e.virtualSize + l}px`),
                                a)
                            ) {
                                const t = [];
                                for (let n = 0; n < i.length; n += 1) {
                                    let s = i[n];
                                    o && (s = Math.floor(s)), i[n] < e.virtualSize + i[0] && t.push(s);
                                }
                                i.splice(0, i.length), i.push(...t);
                            }
                        },
                    };
                },
                function ({ swiper: e }) {
                    Object.assign(e, {
                        appendSlide: qt.bind(e),
                        prependSlide: Ht.bind(e),
                        addSlide: Rt.bind(e),
                        removeSlide: Vt.bind(e),
                        removeAllSlides: Gt.bind(e),
                    });
                },
                function ({ swiper: e, extendParams: t, on: n }) {
                    t({ fadeEffect: { crossFade: !1 } }),
                        Wt({
                            effect: "fade",
                            swiper: e,
                            on: n,
                            setTranslate: () => {
                                const { slides: t } = e;
                                e.params.fadeEffect;
                                for (let n = 0; n < t.length; n += 1) {
                                    const t = e.slides[n];
                                    let i = -t.swiperSlideOffset;
                                    e.params.virtualTranslate || (i -= e.translate);
                                    let s = 0;
                                    e.isHorizontal() || ((s = i), (i = 0));
                                    const r = e.params.fadeEffect.crossFade
                                            ? Math.max(1 - Math.abs(t.progress), 0)
                                            : 1 + Math.min(Math.max(t.progress, -1), 0),
                                        a = Ut(0, t);
                                    (a.style.opacity = r), (a.style.transform = `translate3d(${i}px, ${s}px, 0px)`);
                                }
                            },
                            setTransition: (t) => {
                                const n = e.slides.map((e) => Ze(e));
                                n.forEach((e) => {
                                    e.style.transitionDuration = `${t}ms`;
                                }),
                                    Xt({ swiper: e, duration: t, transformElements: n, allSlides: !0 });
                            },
                            overwriteParams: () => ({
                                slidesPerView: 1,
                                slidesPerGroup: 1,
                                watchSlidesProgress: !0,
                                spaceBetween: 0,
                                virtualTranslate: !e.params.cssMode,
                            }),
                        });
                },
                function ({ swiper: e, extendParams: t, on: n }) {
                    t({ cubeEffect: { slideShadows: !0, shadow: !0, shadowOffset: 20, shadowScale: 0.94 } });
                    const i = (e, t, n) => {
                        let i = n
                                ? e.querySelector(".swiper-slide-shadow-left")
                                : e.querySelector(".swiper-slide-shadow-top"),
                            s = n
                                ? e.querySelector(".swiper-slide-shadow-right")
                                : e.querySelector(".swiper-slide-shadow-bottom");
                        i || ((i = tt("div", "swiper-slide-shadow-" + (n ? "left" : "top"))), e.append(i)),
                            s || ((s = tt("div", "swiper-slide-shadow-" + (n ? "right" : "bottom"))), e.append(s)),
                            i && (i.style.opacity = Math.max(-t, 0)),
                            s && (s.style.opacity = Math.max(t, 0));
                    };
                    Wt({
                        effect: "cube",
                        swiper: e,
                        on: n,
                        setTranslate: () => {
                            const {
                                    el: t,
                                    wrapperEl: n,
                                    slides: s,
                                    width: r,
                                    height: a,
                                    rtlTranslate: o,
                                    size: l,
                                    browser: c,
                                } = e,
                                d = e.params.cubeEffect,
                                u = e.isHorizontal(),
                                p = e.virtual && e.params.virtual.enabled;
                            let h,
                                f = 0;
                            d.shadow &&
                                (u
                                    ? ((h = e.slidesEl.querySelector(".swiper-cube-shadow")),
                                      h || ((h = tt("div", "swiper-cube-shadow")), e.slidesEl.append(h)),
                                      (h.style.height = `${r}px`))
                                    : ((h = t.querySelector(".swiper-cube-shadow")),
                                      h || ((h = tt("div", "swiper-cube-shadow")), t.append(h))));
                            for (let e = 0; e < s.length; e += 1) {
                                const t = s[e];
                                let n = e;
                                p && (n = parseInt(t.getAttribute("data-swiper-slide-index"), 10));
                                let r = 90 * n,
                                    a = Math.floor(r / 360);
                                o && ((r = -r), (a = Math.floor(-r / 360)));
                                const c = Math.max(Math.min(t.progress, 1), -1);
                                let h = 0,
                                    m = 0,
                                    g = 0;
                                n % 4 == 0
                                    ? ((h = 4 * -a * l), (g = 0))
                                    : (n - 1) % 4 == 0
                                      ? ((h = 0), (g = 4 * -a * l))
                                      : (n - 2) % 4 == 0
                                        ? ((h = l + 4 * a * l), (g = l))
                                        : (n - 3) % 4 == 0 && ((h = -l), (g = 3 * l + 4 * l * a)),
                                    o && (h = -h),
                                    u || ((m = h), (h = 0));
                                const v = `rotateX(${u ? 0 : -r}deg) rotateY(${u ? r : 0}deg) translate3d(${h}px, ${m}px, ${g}px)`;
                                c <= 1 && c > -1 && ((f = 90 * n + 90 * c), o && (f = 90 * -n - 90 * c)),
                                    (t.style.transform = v),
                                    d.slideShadows && i(t, c, u);
                            }
                            if (
                                ((n.style.transformOrigin = `50% 50% -${l / 2}px`),
                                (n.style["-webkit-transform-origin"] = `50% 50% -${l / 2}px`),
                                d.shadow)
                            )
                                if (u)
                                    h.style.transform = `translate3d(0px, ${r / 2 + d.shadowOffset}px, ${-r / 2}px) rotateX(90deg) rotateZ(0deg) scale(${d.shadowScale})`;
                                else {
                                    const e = Math.abs(f) - 90 * Math.floor(Math.abs(f) / 90),
                                        t =
                                            1.5 -
                                            (Math.sin((2 * e * Math.PI) / 360) / 2 +
                                                Math.cos((2 * e * Math.PI) / 360) / 2),
                                        n = d.shadowScale,
                                        i = d.shadowScale / t,
                                        s = d.shadowOffset;
                                    h.style.transform = `scale3d(${n}, 1, ${i}) translate3d(0px, ${a / 2 + s}px, ${-a / 2 / i}px) rotateX(-90deg)`;
                                }
                            const m = (c.isSafari || c.isWebView) && c.needPerspectiveFix ? -l / 2 : 0;
                            (n.style.transform = `translate3d(0px,0,${m}px) rotateX(${e.isHorizontal() ? 0 : f}deg) rotateY(${e.isHorizontal() ? -f : 0}deg)`),
                                n.style.setProperty("--swiper-cube-translate-z", `${m}px`);
                        },
                        setTransition: (t) => {
                            const { el: n, slides: i } = e;
                            if (
                                (i.forEach((e) => {
                                    (e.style.transitionDuration = `${t}ms`),
                                        e
                                            .querySelectorAll(
                                                ".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left"
                                            )
                                            .forEach((e) => {
                                                e.style.transitionDuration = `${t}ms`;
                                            });
                                }),
                                e.params.cubeEffect.shadow && !e.isHorizontal())
                            ) {
                                const e = n.querySelector(".swiper-cube-shadow");
                                e && (e.style.transitionDuration = `${t}ms`);
                            }
                        },
                        recreateShadows: () => {
                            const t = e.isHorizontal();
                            e.slides.forEach((e) => {
                                const n = Math.max(Math.min(e.progress, 1), -1);
                                i(e, n, t);
                            });
                        },
                        getEffectParams: () => e.params.cubeEffect,
                        perspective: () => !0,
                        overwriteParams: () => ({
                            slidesPerView: 1,
                            slidesPerGroup: 1,
                            watchSlidesProgress: !0,
                            resistanceRatio: 0,
                            spaceBetween: 0,
                            centeredSlides: !1,
                            virtualTranslate: !0,
                        }),
                    });
                },
                function ({ swiper: e, extendParams: t, on: n }) {
                    t({ flipEffect: { slideShadows: !0, limitRotation: !0 } });
                    const i = (t, n, i) => {
                        let s = e.isHorizontal()
                                ? t.querySelector(".swiper-slide-shadow-left")
                                : t.querySelector(".swiper-slide-shadow-top"),
                            r = e.isHorizontal()
                                ? t.querySelector(".swiper-slide-shadow-right")
                                : t.querySelector(".swiper-slide-shadow-bottom");
                        s || (s = Yt(0, t, e.isHorizontal() ? "left" : "top")),
                            r || (r = Yt(0, t, e.isHorizontal() ? "right" : "bottom")),
                            s && (s.style.opacity = Math.max(-n, 0)),
                            r && (r.style.opacity = Math.max(n, 0));
                    };
                    Wt({
                        effect: "flip",
                        swiper: e,
                        on: n,
                        setTranslate: () => {
                            const { slides: t, rtlTranslate: n } = e,
                                s = e.params.flipEffect;
                            for (let r = 0; r < t.length; r += 1) {
                                const a = t[r];
                                let o = a.progress;
                                e.params.flipEffect.limitRotation && (o = Math.max(Math.min(a.progress, 1), -1));
                                const l = a.swiperSlideOffset;
                                let c = -180 * o,
                                    d = 0,
                                    u = e.params.cssMode ? -l - e.translate : -l,
                                    p = 0;
                                e.isHorizontal() ? n && (c = -c) : ((p = u), (u = 0), (d = -c), (c = 0)),
                                    (a.style.zIndex = -Math.abs(Math.round(o)) + t.length),
                                    s.slideShadows && i(a, o);
                                const h = `translate3d(${u}px, ${p}px, 0px) rotateX(${d}deg) rotateY(${c}deg)`;
                                Ut(0, a).style.transform = h;
                            }
                        },
                        setTransition: (t) => {
                            const n = e.slides.map((e) => Ze(e));
                            n.forEach((e) => {
                                (e.style.transitionDuration = `${t}ms`),
                                    e
                                        .querySelectorAll(
                                            ".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left"
                                        )
                                        .forEach((e) => {
                                            e.style.transitionDuration = `${t}ms`;
                                        });
                            }),
                                Xt({ swiper: e, duration: t, transformElements: n });
                        },
                        recreateShadows: () => {
                            e.params.flipEffect,
                                e.slides.forEach((t) => {
                                    let n = t.progress;
                                    e.params.flipEffect.limitRotation && (n = Math.max(Math.min(t.progress, 1), -1)),
                                        i(t, n);
                                });
                        },
                        getEffectParams: () => e.params.flipEffect,
                        perspective: () => !0,
                        overwriteParams: () => ({
                            slidesPerView: 1,
                            slidesPerGroup: 1,
                            watchSlidesProgress: !0,
                            spaceBetween: 0,
                            virtualTranslate: !e.params.cssMode,
                        }),
                    });
                },
                function ({ swiper: e, extendParams: t, on: n }) {
                    t({
                        coverflowEffect: {
                            rotate: 50,
                            stretch: 0,
                            depth: 100,
                            scale: 1,
                            modifier: 1,
                            slideShadows: !0,
                        },
                    }),
                        Wt({
                            effect: "coverflow",
                            swiper: e,
                            on: n,
                            setTranslate: () => {
                                const { width: t, height: n, slides: i, slidesSizesGrid: s } = e,
                                    r = e.params.coverflowEffect,
                                    a = e.isHorizontal(),
                                    o = e.translate,
                                    l = a ? t / 2 - o : n / 2 - o,
                                    c = a ? r.rotate : -r.rotate,
                                    d = r.depth;
                                for (let e = 0, t = i.length; e < t; e += 1) {
                                    const t = i[e],
                                        n = s[e],
                                        o = (l - t.swiperSlideOffset - n / 2) / n,
                                        u = "function" == typeof r.modifier ? r.modifier(o) : o * r.modifier;
                                    let p = a ? c * u : 0,
                                        h = a ? 0 : c * u,
                                        f = -d * Math.abs(u),
                                        m = r.stretch;
                                    "string" == typeof m &&
                                        -1 !== m.indexOf("%") &&
                                        (m = (parseFloat(r.stretch) / 100) * n);
                                    let g = a ? 0 : m * u,
                                        v = a ? m * u : 0,
                                        y = 1 - (1 - r.scale) * Math.abs(u);
                                    Math.abs(v) < 0.001 && (v = 0),
                                        Math.abs(g) < 0.001 && (g = 0),
                                        Math.abs(f) < 0.001 && (f = 0),
                                        Math.abs(p) < 0.001 && (p = 0),
                                        Math.abs(h) < 0.001 && (h = 0),
                                        Math.abs(y) < 0.001 && (y = 0);
                                    const b = `translate3d(${v}px,${g}px,${f}px)  rotateX(${h}deg) rotateY(${p}deg) scale(${y})`;
                                    if (
                                        ((Ut(0, t).style.transform = b),
                                        (t.style.zIndex = 1 - Math.abs(Math.round(u))),
                                        r.slideShadows)
                                    ) {
                                        let e = a
                                                ? t.querySelector(".swiper-slide-shadow-left")
                                                : t.querySelector(".swiper-slide-shadow-top"),
                                            n = a
                                                ? t.querySelector(".swiper-slide-shadow-right")
                                                : t.querySelector(".swiper-slide-shadow-bottom");
                                        e || (e = Yt(0, t, a ? "left" : "top")),
                                            n || (n = Yt(0, t, a ? "right" : "bottom")),
                                            e && (e.style.opacity = u > 0 ? u : 0),
                                            n && (n.style.opacity = -u > 0 ? -u : 0);
                                    }
                                }
                            },
                            setTransition: (t) => {
                                e.slides
                                    .map((e) => Ze(e))
                                    .forEach((e) => {
                                        (e.style.transitionDuration = `${t}ms`),
                                            e
                                                .querySelectorAll(
                                                    ".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left"
                                                )
                                                .forEach((e) => {
                                                    e.style.transitionDuration = `${t}ms`;
                                                });
                                    });
                            },
                            perspective: () => !0,
                            overwriteParams: () => ({ watchSlidesProgress: !0 }),
                        });
                },
                function ({ swiper: e, extendParams: t, on: n }) {
                    t({
                        creativeEffect: {
                            limitProgress: 1,
                            shadowPerProgress: !1,
                            progressMultiplier: 1,
                            perspective: !0,
                            prev: { translate: [0, 0, 0], rotate: [0, 0, 0], opacity: 1, scale: 1 },
                            next: { translate: [0, 0, 0], rotate: [0, 0, 0], opacity: 1, scale: 1 },
                        },
                    });
                    const i = (e) => ("string" == typeof e ? e : `${e}px`);
                    Wt({
                        effect: "creative",
                        swiper: e,
                        on: n,
                        setTranslate: () => {
                            const { slides: t, wrapperEl: n, slidesSizesGrid: s } = e,
                                r = e.params.creativeEffect,
                                { progressMultiplier: a } = r,
                                o = e.params.centeredSlides;
                            if (o) {
                                const t = s[0] / 2 - e.params.slidesOffsetBefore || 0;
                                n.style.transform = `translateX(calc(50% - ${t}px))`;
                            }
                            for (let n = 0; n < t.length; n += 1) {
                                const s = t[n],
                                    l = s.progress,
                                    c = Math.min(Math.max(s.progress, -r.limitProgress), r.limitProgress);
                                let d = c;
                                o || (d = Math.min(Math.max(s.originalProgress, -r.limitProgress), r.limitProgress));
                                const u = s.swiperSlideOffset,
                                    p = [e.params.cssMode ? -u - e.translate : -u, 0, 0],
                                    h = [0, 0, 0];
                                let f = !1;
                                e.isHorizontal() || ((p[1] = p[0]), (p[0] = 0));
                                let m = { translate: [0, 0, 0], rotate: [0, 0, 0], scale: 1, opacity: 1 };
                                c < 0 ? ((m = r.next), (f = !0)) : c > 0 && ((m = r.prev), (f = !0)),
                                    p.forEach((e, t) => {
                                        p[t] = `calc(${e}px + (${i(m.translate[t])} * ${Math.abs(c * a)}))`;
                                    }),
                                    h.forEach((e, t) => {
                                        h[t] = m.rotate[t] * Math.abs(c * a);
                                    }),
                                    (s.style.zIndex = -Math.abs(Math.round(l)) + t.length);
                                const g = p.join(", "),
                                    v = `rotateX(${h[0]}deg) rotateY(${h[1]}deg) rotateZ(${h[2]}deg)`,
                                    y =
                                        d < 0
                                            ? `scale(${1 + (1 - m.scale) * d * a})`
                                            : `scale(${1 - (1 - m.scale) * d * a})`,
                                    b = d < 0 ? 1 + (1 - m.opacity) * d * a : 1 - (1 - m.opacity) * d * a,
                                    w = `translate3d(${g}) ${v} ${y}`;
                                if ((f && m.shadow) || !f) {
                                    let e = s.querySelector(".swiper-slide-shadow");
                                    if ((!e && m.shadow && (e = Yt(0, s)), e)) {
                                        const t = r.shadowPerProgress ? c * (1 / r.limitProgress) : c;
                                        e.style.opacity = Math.min(Math.max(Math.abs(t), 0), 1);
                                    }
                                }
                                const C = Ut(0, s);
                                (C.style.transform = w),
                                    (C.style.opacity = b),
                                    m.origin && (C.style.transformOrigin = m.origin);
                            }
                        },
                        setTransition: (t) => {
                            const n = e.slides.map((e) => Ze(e));
                            n.forEach((e) => {
                                (e.style.transitionDuration = `${t}ms`),
                                    e.querySelectorAll(".swiper-slide-shadow").forEach((e) => {
                                        e.style.transitionDuration = `${t}ms`;
                                    });
                            }),
                                Xt({ swiper: e, duration: t, transformElements: n, allSlides: !0 });
                        },
                        perspective: () => e.params.creativeEffect.perspective,
                        overwriteParams: () => ({ watchSlidesProgress: !0, virtualTranslate: !e.params.cssMode }),
                    });
                },
                function ({ swiper: e, extendParams: t, on: n }) {
                    t({ cardsEffect: { slideShadows: !0, rotate: !0, perSlideRotate: 2, perSlideOffset: 8 } }),
                        Wt({
                            effect: "cards",
                            swiper: e,
                            on: n,
                            setTranslate: () => {
                                const { slides: t, activeIndex: n, rtlTranslate: i } = e,
                                    s = e.params.cardsEffect,
                                    { startTranslate: r, isTouched: a } = e.touchEventsData,
                                    o = i ? -e.translate : e.translate;
                                for (let l = 0; l < t.length; l += 1) {
                                    const c = t[l],
                                        d = c.progress,
                                        u = Math.min(Math.max(d, -4), 4);
                                    let p = c.swiperSlideOffset;
                                    e.params.centeredSlides &&
                                        !e.params.cssMode &&
                                        (e.wrapperEl.style.transform = `translateX(${e.minTranslate()}px)`),
                                        e.params.centeredSlides && e.params.cssMode && (p -= t[0].swiperSlideOffset);
                                    let h = e.params.cssMode ? -p - e.translate : -p,
                                        f = 0;
                                    const m = -100 * Math.abs(u);
                                    let g = 1,
                                        v = -s.perSlideRotate * u,
                                        y = s.perSlideOffset - 0.75 * Math.abs(u);
                                    const b = e.virtual && e.params.virtual.enabled ? e.virtual.from + l : l,
                                        w =
                                            (b === n || b === n - 1) &&
                                            u > 0 &&
                                            u < 1 &&
                                            (a || e.params.cssMode) &&
                                            o < r,
                                        C =
                                            (b === n || b === n + 1) &&
                                            u < 0 &&
                                            u > -1 &&
                                            (a || e.params.cssMode) &&
                                            o > r;
                                    if (w || C) {
                                        const e = (1 - Math.abs((Math.abs(u) - 0.5) / 0.5)) ** 0.5;
                                        (v += -28 * u * e),
                                            (g += -0.5 * e),
                                            (y += 96 * e),
                                            (f = -25 * e * Math.abs(u) + "%");
                                    }
                                    if (
                                        ((h =
                                            u < 0
                                                ? `calc(${h}px ${i ? "-" : "+"} (${y * Math.abs(u)}%))`
                                                : u > 0
                                                  ? `calc(${h}px ${i ? "-" : "+"} (-${y * Math.abs(u)}%))`
                                                  : `${h}px`),
                                        !e.isHorizontal())
                                    ) {
                                        const e = f;
                                        (f = h), (h = e);
                                    }
                                    const x = u < 0 ? "" + (1 + (1 - g) * u) : "" + (1 - (1 - g) * u),
                                        S = `\n        translate3d(${h}, ${f}, ${m}px)\n        rotateZ(${s.rotate ? (i ? -v : v) : 0}deg)\n        scale(${x})\n      `;
                                    if (s.slideShadows) {
                                        let e = c.querySelector(".swiper-slide-shadow");
                                        e || (e = Yt(0, c)),
                                            e &&
                                                (e.style.opacity = Math.min(Math.max((Math.abs(u) - 0.5) / 0.5, 0), 1));
                                    }
                                    (c.style.zIndex = -Math.abs(Math.round(d)) + t.length),
                                        (Ut(0, c).style.transform = S);
                                }
                            },
                            setTransition: (t) => {
                                const n = e.slides.map((e) => Ze(e));
                                n.forEach((e) => {
                                    (e.style.transitionDuration = `${t}ms`),
                                        e.querySelectorAll(".swiper-slide-shadow").forEach((e) => {
                                            e.style.transitionDuration = `${t}ms`;
                                        });
                                }),
                                    Xt({ swiper: e, duration: t, transformElements: n });
                            },
                            perspective: () => !0,
                            overwriteParams: () => ({ watchSlidesProgress: !0, virtualTranslate: !e.params.cssMode }),
                        });
                },
            ];
            jt.use(Kt);
            const Qt = { slideshow: "[data-slideshow]", slide: ".swiper-slide" },
                Jt = "is-active";
            class Zt {
                constructor(e) {
                    (this.$el = $(e)),
                        (this.$images = $("img", this.$el)),
                        (this.$slideshow = $(Qt.slideshow, this.$el)),
                        (this.$slides = $(Qt.slide, this.$el)),
                        (this.$galleryThumbs = $(Qt.galleryThumbs, this.$el)),
                        (this.slideCount = this.$slides.length),
                        (this.isActive = this.$el.hasClass(Jt)),
                        (this.swiper = new jt(this.$slideshow.get(0), {
                            loop: this.slideCount > 1,
                            effect: "slide",
                            speed: 600,
                            simulateTouch: !0,
							navigation: {
							nextEl: '.swiper-button-next',
							prevEl: '.swiper-button-prev',
							},
                            pagination: { el: ".swiper-pagination", clickable: !0 },
                        })),
                        1 === this.slideCount && this.$slideshow.addClass("is-disabled");
                }
                activate() {
                    this.isActive ||
                        (this.$el.addClass(Jt), this.$images.attr("loading", "eager"), (this.isActive = !0));
                }
                deactivate() {
                    this.$el.removeClass(Jt), (this.isActive = !1);
                }
                findImageById(e) {
                    return this.$images.filter('[data-image-id="'.concat(e, '"]')).get(0);
                }
                destroy() {}
            }
            const en = "sg-open",
                tn = ($(window), $(document.body)),
                nn = $("#view-container");
            class sn {
                constructor(e) {
                    (this.$el = $(e)),
                        (this.isOpen = !1),
                        (this.callbacks = { bodyToggleClick: this.onToggleClick.bind(this) }),
                        (this.$backdrop = $(document.createElement("div")).addClass("sg-backdrop")),
                        this.$backdrop.attr("title", "Close Size Guide"),
                        this.$backdrop.appendTo(nn),
                        this.$backdrop.on("click", this.callbacks.bodyToggleClick),
                        tn.on("click", "[data-size-guide]", this.callbacks.bodyToggleClick),
                        tn.on("click", "[sg-close]", this.callbacks.bodyToggleClick);
                }
                open() {
                    this.isOpen || ($(".sg").addClass("is-open"), tn.addClass(en), (this.isOpen = !0));
                }
                close() {
                    this.isOpen && ($(".sg").removeClass("is-open"), tn.removeClass(en), (this.isOpen = !1));
                }
                toggle() {
                    this.isOpen ? this.close() : this.open();
                }
                onToggleClick(e) {
                    e.preventDefault(), this.toggle();
                }
                destroy() {
                    this.$backdrop.remove();
                }
            }
            class rn {
                constructor(e) {
                    if (((this.$el = $(e)), null != document.getElementById("data-cta-intersection"))) {
                        const e = document.getElementById("data-cta-intersection");
                        new IntersectionObserver(
                            (e) => {
                                e[0].isIntersecting
                                    ? ($("#primary-cta").removeClass("cta-sticky"),
                                      $("#data-cta-intersection").css("height", "0px"))
                                    : (console.log("is not visible"),
                                      $("#primary-cta").addClass("cta-sticky"),
                                      $("#data-cta-intersection").css("height", "52px"));
                            },
                            { rootMargin: "50px 0px -50px 0px", threshold: 1 }
                        ).observe(e);
                    }
                }
            }
            var an = n(699),
                on = n.n(an);
            const ln = "[data-sms]";
            class cn {
                constructor() {
                    this.attentive();
                }
                attentive() {
                    var e = $("#error-msg"),
                        t = $("#valid-msg");
                    const n = document.querySelector("#phone");
                    var i = on()(n, {
                        utilsScript: "https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/18.3.3/js/utils.min.js",
                        allowExtensions: !0,
                        formatOnDisplay: !0,
                        autoFormat: !0,
                        autoHideDialCode: !1,
                        autoPlaceholder: !0,
                        numberType: "MOBILE",
                        localizedCountries: {
                            us: "United States",
                            gb: "United Kingdom",
                            au: "Australia",
                            ca: "Canada",
                        },
                        onlyCountries: ["us", "gb", "au", "ca"],
                        preferredCountries: [""],
                        preventInvalidNumbers: !0,
                        separateDialCode: !0,
                        initialCountry: "".concat("US"),
                        geoIpLookup: (e) => {
                            fetch("https://ipapi.co/json")
                                .then((e) => e.json())
                                .then((t) => e(t.country_code))
                                .catch(() => e("us"));
                        },
                    });
                    n.blur(function () {
                        n.removeClass("error"),
                            e.addClass("hide"),
                            t.addClass("hide"),
                            $.trim(n.val()) &&
                                (n.intlTelInput("isValidNumber")
                                    ? t.removeClass("hide")
                                    : (n.addClass("error"), e.removeClass("hide")));
                    }),
                        $("#sub2").click(function () {
                            if ($("input").hasClass("tel1")) {
                                var e = $("#email").val(),
                                    t = $("#phone").val(),
                                    n = $(".iti__selected-dial-code").text() + t,
                                    s = i.getSelectedCountryData().iso2;
                                $("#sub2").attr("disabled", !0);
                                var r = {
                                    url:
                                        "https://pythiaclothing-001-site1.ftempurl.com/SubscriberAPi?phoneNumber=" +
                                        n +
                                        "&email=" +
                                        e +
                                        "&country=" +
                                        s,
                                    method: "GET",
                                    timeout: 0,
                                };
                                $.ajax(r).done(function (e) {
                                    $("#sub2").attr("disabled", !1),
                                        "You are already Subscribed!" == e
                                            ? ($(".pt23").hide(),
                                              $(".mainDiv").hide(),
                                              $("#already-img").show(),
                                              $("#attentive-valid__show").addClass("hide"))
                                            : "Welcome to the family!" == e
                                              ? ($(".pt23").hide(),
                                                $(".mainDiv").hide(),
                                                $("#success-img").show(),
                                                $("#attentive-valid__show").addClass("hide"),
                                                $("#attentive-valid__show").addClass("hide"))
                                              : ($(".text").text(e),
                                                $("#attentive-valid__show").removeClass("hide"),
                                                $("#attentive-valid__show").text(
                                                    "please enter a valid phone number and email"
                                                ));
                                });
                            }
                        });
                }
                destroy() {}
            }
            class dn extends V {
                constructor(e) {
                    super(e, "product"),
                        (this.productDetailForm = new ze($("[data-product-detail-form]", this.$container).first())),
                        (this.ctaIntersection = new rn(this.$container.find("[cta-intersection]"))),
                        (this.productDetailGallery = new Zt(
                            $("[data-product-detail-gallery]", this.$container).first()
                        )),
                        (this.productSG = new sn($("[data-product-sg]", this.$container).first())),
                        (this.$newsletterForm = $(ln, this.$container)),
                        this.$newsletterForm.length && (this.newsletterForm = new cn(this.$newsletterForm));
                }
                onUnload() {
                    this.productDetailForm.destroy(), this.productDetailGallery.destroy(), this.productSG.destroy();
                }
            }
            const un = "[data-product-card-set]";
            class pn {
                constructor(e) {
                    (this.$el = $(e)),
                        (this.productCards = $.map(this.$el.find("[data-product-card]"), (e) => new K(e)));
                }
                destroy() {
                    this.productCards.forEach((e) => e.destroy());
                }
            }
            class hn extends V {
                constructor(e) {
                    super(e, "product-related"),
                        (this.$productCardSet = $(un, this.$container)),
                        (this.$content = $("[data-content]", this.$container)),
                        $.ajax({
                            type: "get",
                            url: this.$container.data("url"),
                            success: (e) => {
                                const t = $(e).children();
                                0 !== t.length
                                    ? (this.$content.html(t), (this.productCardSet = new pn(this.$productCardSet)))
                                    : this.$container.hide();
                            },
                            error: () => {
                                this.$container.hide();
                            },
                        });
                }
                onUnload() {
                    this.productCardSet && this.productCardSet.destroy();
                }
            }
            class fn extends Y {
                onEnter() {
                    this.sectionManager.register("product", dn), this.sectionManager.register("product-related", hn);
                }
            }
            class mn extends Y {
                initialLoad() {
                    this.redirect();
                }
                onEnterCompleted() {
                    this.redirect();
                }
                redirect() {
                    const e = "/?cart";
                    setTimeout(() => {
                        var t;
                        null !== (t = window.app) && void 0 !== t && t.taxi
                            ? app.taxi.navigateTo(e)
                            : (window.location = e);
                    }, 50);
                }
            }
            var gn = n(829),
                vn = n.n(gn),
                yn = n(62),
                bn = n.n(yn),
                wn = n(564),
                Cn = n.n(wn);
            const xn = "is-hidden";
            class Sn {
                constructor(e) {
                    (this.$el = vn()(e)),
                        (this.$cover = vn()("[data-embed-cover]", this.$el)),
                        (this.$player = vn()("[data-embed-player]", this.$el)),
                        (this.$exit = vn()("[data-embed-exit]", this.$el)),
                        (this.player = bn()(this.$player.get(0), {
                            videoId: this.$el.data("id"),
                            playerVars: { modestBranding: 1, rel: 0 },
                        })),
                        Cn()(this.$cover.get(0), () => {
                            this.$cover.addClass("img-loaded");
                        }),
                        this.player.on("stateChange", this.onPlayerStateChange.bind(this)),
                        this.$cover.on("click", this.onCoverClick.bind(this)),
                        this.$exit.on("click", this.onExitClick.bind(this));
                }
                onCoverClick() {
                    this.player.seekTo(0),
                        this.player.playVideo().then(() => {
                            this.$cover.addClass(xn);
                        });
                }
                onExitClick() {
                    this.player.seekTo(0),
                        this.player.pauseVideo().then(() => {
                            this.$cover.removeClass(xn);
                        });
                }
                onPlayerStateChange(e) {
                    let { data: t } = e;
                    0 === t && this.$cover.removeClass(xn);
                }
            }
            class En extends V {
                constructor(e) {
                    super(e, "video-embed"),
                        (this.embeds = vn().map(vn()("[data-embed][data-id]", this.$container), (e) => new Sn(e)));
                }
            }
            class Tn extends Y {
                onEnter() {
                    this.sectionManager.register("video-embed", En);
                }
            }
            class $n extends V {
                constructor(e) {
                    super(e, "article");
                }
                onUnload() {}
            }
            class kn extends Y {
                onEnter() {
                    super.onEnter(), this.sectionManager.register("article", $n);
                }
            }
            const Mn = "[data-next-page]",
                Ln = $(window);
            class An {
                constructor(e) {
                    let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                    if (
                        ((this.isLoading = !1),
                        (this.settings = { threshold: 500, selector: null, onFetchComplete: (e) => {}, ...t }),
                        null === this.settings.selector)
                    )
                        return console.log("[InfiniteScroll] - Selector required!");
                    (this.$el = $(e)),
                        (this.$nextPageLink = $(Mn, this.$el)),
                        0 !== this.$nextPageLink.length &&
                            ((this.measurements = {}),
                            (this.throttledOnScroll = I(150, this.onScroll.bind(this))),
                            (this.throttledResize = I(150, this.onResize.bind(this))),
                            this.addEventListeners(),
                            this.setMeasurements(),
                            this.onScroll());
                }
                addEventListeners() {
                    window.addEventListener("scroll", this.throttledOnScroll),
                        window.addEventListener("resize", this.throttledResize);
                }
                removeEventListeners() {
                    window.removeEventListener("scroll", this.throttledOnScroll),
                        window.removeEventListener("resize", this.throttledResize);
                }
                destroy() {
                    this.removeEventListeners();
                }
                setMeasurements() {
                    this.measurements = {
                        windowHeight: Ln.height(),
                        elTop: this.$el.offset().top,
                        elHeight: this.$el.outerHeight(),
                    };
                }
                onResize() {
                    this.setMeasurements();
                }
                onScroll() {
                    this.isLoading ||
                        ((window.scrollY || window.pageYOffset) +
                            this.measurements.windowHeight +
                            this.settings.threshold >
                            this.measurements.elTop + this.measurements.elHeight &&
                            (this.removeEventListeners(),
                            this.fetchNextPage((e) => {
                                var t;
                                e && this.addEventListeners(),
                                    null === (t = window.app.taxi) || void 0 === t || t.updateCache();
                            })));
                }
                fetchNextPage(e) {
                    const t = this.$nextPageLink.attr("href");
                    if (!t) return console.log("[InfiniteScroll] - no URL found");
                    $.ajax({ url: t, beforeSend: () => (this.isLoading = !0) }).done((t) => {
                        const n = $(t),
                            i = n.find(this.settings.selector),
                            s = $(Mn, n),
                            r = s.length > 0;
                        r ? (this.$nextPageLink.replaceWith(s), (this.$nextPageLink = s)) : this.$nextPageLink.remove(),
                            e(r),
                            this.settings.onFetchComplete(i),
                            (this.isLoading = !1);
                    });
                }
            }
            class In extends V {
                constructor(e) {
                    super(e, "blog"),
                        (this.$grid = $("[data-grid]", this.$container)),
                        (this.infiniteScroll = new An(this.$container, {
                            selector: "[data-grid-item]",
                            onFetchComplete: this.onFetchComplete.bind(this),
                        }));
                }
                onUnload() {
                    this.infiniteScroll.destroy();
                }
                onFetchComplete(e) {
                    this.$grid.append(e);
                }
            }
            class _n extends Y {
                onEnter() {
                    super.onEnter(), this.sectionManager.register("blog", In);
                }
            }
            class Pn extends V {
                constructor(e) {
                    super(e, "search"), (this.productCardSet = new pn($(un, this.$container).first()));
                }
                onUnload() {
                    this.productCardSet.destroy();
                }
            }
            class Dn extends Y {
                onEnter() {
                    super.onEnter(), this.sectionManager.register("search", Pn);
                }
            }
            class On extends Y {
                initialLoad() {
                    this.redirect();
                }
                onEnterCompleted() {
                    this.redirect();
                }
                redirect() {
                    const e = "/account/?addresses";
                    setTimeout(() => {
                        var t;
                        null !== (t = window.app) && void 0 !== t && t.taxi
                            ? app.taxi.navigateTo(e)
                            : (window.location = e);
                    }, 50);
                }
            }
            class Nn extends V {
                constructor(e) {
                    super(e, "addresses"),
                        (this.$toggleNew = $("[data-toggle-new]", this.$container)),
                        (this.$newForm = $("[data-new]", this.$container)),
                        (this.$toggleForm = $("[data-toggle-form]", this.$container)),
                        (this.$deleteAddress = $("[data-delete-address]", this.$container)),
                        this.$toggleNew.on("click", (e) => {
                            e.preventDefault(), this.$newForm.toggle();
                        }),
                        this.$toggleForm.on("click", (e) => {
                            e.preventDefault();
                            const t = $(e.currentTarget).data("id");
                            $("#edit-address-".concat(t)).toggle();
                        }),
                        this.$deleteAddress.on("click", (e) => {
                            e.preventDefault();
                            const t = $(e.currentTarget).data("id");
                            confirm("Are you sure you wish to delete this address?") &&
                                (function (e, t) {
                                    const n = (t = t || {}).method || "post",
                                        i = t.parameters || {},
                                        s = document.createElement("form");
                                    for (const t in (s.setAttribute("method", n), s.setAttribute("action", e), i)) {
                                        const e = document.createElement("input");
                                        e.setAttribute("type", "hidden"),
                                            e.setAttribute("name", t),
                                            e.setAttribute("value", i[t]),
                                            s.appendChild(e);
                                    }
                                    document.body.appendChild(s), s.submit(), document.body.removeChild(s);
                                })("/account/addresses/" + t, { parameters: { _method: "delete" } });
                        });
                }
            }
            class Fn extends Y {
                onEnter() {
                    super.onEnter(), console.log("account"), this.sectionManager.register("addresses", Nn);
                }
            }
            class jn extends V {
                constructor(e) {
                    super(e, "login"),
                        (this.resetSuccess = this.$container.data("reset-success")),
                        (this.$loginForm = $("#customer-login-form", this.$container)),
                        (this.$recoverForm = $("#recover-password-form", this.$container)),
                        this.$container.on("click", "[data-hide-recover]", (e) => {
                            e.preventDefault(), this.hideRecoverForm();
                        }),
                        this.$container.on("click", "[data-show-recover]", (e) => {
                            e.preventDefault(), this.showRecoverForm();
                        }),
                        "#recover" == window.location.hash && this.showRecoverForm(),
                        this.resetSuccess && (document.getElementById("reset-success").style.display = "block");
                }
                showRecoverForm() {
                    this.$loginForm.hide(), this.$recoverForm.show();
                }
                hideRecoverForm() {
                    this.$loginForm.show(), this.$recoverForm.hide();
                }
            }
            class zn extends Y {
                onEnter() {
                    super.onEnter(), this.sectionManager.register("login", jn);
                }
            }
            class Bn extends V {
                constructor(e) {
                    super(e, "page-faq"), (this.expanderGroup = new _e(this.$container.find("[data-expander-group]")));
                }
                onUnload() {}
            }
            class qn extends Y {
                onEnter() {
                    this.sectionManager.register("page-faq", Bn);
                }
            }
            const Hn = "password-open",
                Rn = ($(window), $(document.body)),
                Vn = $("#view-container");
            class Gn extends V {
                constructor(e) {
                    super(e, "password-popup"),
                        (this.isOpen = !1),
                        (this.callbacks = { bodyToggleClick: this.onToggleClick.bind(this) }),
                        Rn.on("click", "[data-password-toggle]", this.callbacks.bodyToggleClick),
                        (this.$backdrop = $(document.createElement("div")).addClass("password-backdrop")),
                        this.$backdrop.attr("title", "Close pop-up"),
                        this.$backdrop.appendTo(Vn),
                        this.$backdrop.on("click", this.onToggleClick.bind(this));
                }
                open() {
                    this.isOpen || (Rn.addClass(Hn), (this.isOpen = !0));
                }
                close() {
                    this.isOpen && (Rn.removeClass(Hn), (this.isOpen = !1));
                }
                toggle() {
                    this.isOpen ? this.close() : this.open();
                }
                onToggleClick(e) {
                    e.preventDefault(), this.toggle();
                }
                onUnload() {}
            }
            class Wn extends Y {
                onEnter() {
                    super.onEnter(), this.sectionManager.register("password-popup", Gn);
                }
            }
            class Un extends Y {
                onEnter() {
                    this.sectionManager.register("page-rewards", Bn);
                }
            }
            const Xn = "[data-close]",
                Yn = "[data-item]",
                Kn = "[data-ajax-cart-toggle]",
                Qn = "#cart-total__saved-banner",
                Jn = ".ajax-cart__footer-row",
                Zn = ".ajax-cart__header",
                ei = ".ajax-cart__body",
                ti = ".ajax-cart__footer",
                ni = {
                    open: "is-open",
                    empty: "is-empty",
                    itemRequestInProgress: "is-in-progress",
                    itemIsBeingRemoved: "is-being-removed",
                    adjusterButtonDisabled: "is-disabled",
                    bodyCartOpen: "ajax-cart-open",
                    backdrop: "ajax-cart-backdrop",
                    isVisible: "is-visible",
                    onSale: "on-sale",
                },
                ii = ".ajaxCart",
                si = { CLICK: "click".concat(ii), RENDER: "render".concat(ii) },
                ri = $(window),
                ai = $(document.body);
            class oi {
                constructor(e) {
                    (this.isOpen = !1),
                        (this.hasBeenRendered = !1),
                        (this.requestInProgress = !1),
                        (this.upsellSuccessMessage = $("[data-upsell-text]").attr("success_message")),
                        (this.upsellProgressMessage = $("[data-upsell-text]").attr("progress_message")),
                        (this.callbacks = {
                            bodyToggleClick: this.onToggleClick.bind(this),
                            bodyCloseClick: this.onCloseClick.bind(this),
                            itemRemoveClick: this.onItemRemoveClick.bind(this),
                            itemIncrementClick: this.onItemIncrementClick.bind(this),
                            itemDecrementClick: this.onItemDecrementClick.bind(this),
                        }),
                        (this.$el = $(e)),
                        (this.$body = $("[data-body]", this.$el)),
                        (this.$totalPrice = $("[data-total-price]", this.$el)),
                        (this.$totalSaved = $("[total-saved-price]", this.$el)),
                        (this.$originalPrice = $("[total-original-price]", this.$el)),
                        (this.upsellText = $("[data-upsell-text]", this.$el)),
                        (this.$cartCount = $("[data-cart-count]", this.$el)),
                        this.$el.on(si.CLICK, "[data-item-increment]", this.onItemIncrementClick.bind(this)),
                        this.$el.on(si.CLICK, "[data-item-decrement]", this.onItemDecrementClick.bind(this)),
                        (this.$backdrop = $(document.createElement("div")).addClass(ni.backdrop)),
                        this.$backdrop.attr("title", "Close Cart"),
                        this.$backdrop.appendTo(ai),
                        this.$backdrop.on("click", this.close.bind(this)),
                        this.$el.on(si.CLICK, "[data-item-remove]", this.callbacks.itemRemoveClick),
                        ai.on(si.CLICK, Kn, this.callbacks.bodyToggleClick),
                        ai.on(si.CLICK, Xn, this.callbacks.bodyCloseClick);
                }
                destroy() {
                    this.$backdrop.remove(),
                        ai.off(si.CLICK, Kn, this.callbacks.bodyToggleClick),
                        ai.off(si.CLICK, Xn, this.callbacks.bodyCloseClick);
                }
                bodyTemplate(e) {
                    let t = "";
                    return (
                        e.items &&
                            (t = $.map(e.items, (e) => {
                                let {
                                    key: t,
                                    quantity: n,
                                    image: i,
                                    product_title: s,
                                    price: r,
                                    price_formatted: a,
                                    variant_title: o,
                                    is_addable: l,
                                    variant_quantity: c,
                                    compare_at_price: d,
                                    compare_at_price_formatted: u,
                                    original_price: p,
                                    pre_order: h,
                                } = e;
                                return '\n          <div class="ajax-cart__item" data-key="'
                                    .concat(t, '" data-qty="')
                                    .concat(
                                        n,
                                        '" data-item>\n          <div class="ajax-cart__item-inner">\n          <div class="ajax-cart__item-image-frame">\n            <div class="ajax-cart__item-image">\n              <img src="'
                                    )
                                    .concat(i, '" alt="')
                                    .concat(
                                        s,
                                        '" height="100" width="100" />\n            </div>\n          </div>\n          <div class="ajax-cart__item-info">\n\n            <div class="item-info_main">\n            \n            <h4 class="ajax-cart__item-title">'
                                    )
                                    .concat(
                                        s,
                                        '  <span class="remove-btn" data-item-remove><svg width="16" height="16" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">\n            <path d="M10.5535 13.2222H3.44458C3.29494 13.2187 3.14745 13.1857 3.01056 13.1252C2.87366 13.0646 2.75004 12.9777 2.64675 12.8693C2.54346 12.761 2.46253 12.6334 2.40859 12.4937C2.35465 12.3541 2.32874 12.2052 2.33236 12.0556V4.36719H3.11014V12.0556C3.10643 12.1031 3.11214 12.1509 3.12696 12.1962C3.14179 12.2415 3.16542 12.2834 3.1965 12.3195C3.22758 12.3557 3.2655 12.3853 3.30807 12.4068C3.35065 12.4282 3.39704 12.441 3.44458 12.4444H10.5535C10.601 12.441 10.6474 12.4282 10.69 12.4068C10.7325 12.3853 10.7705 12.3557 10.8015 12.3195C10.8326 12.2834 10.8562 12.2415 10.8711 12.1962C10.8859 12.1509 10.8916 12.1031 10.8879 12.0556V4.36719H11.6657V12.0556C11.6693 12.2052 11.6434 12.3541 11.5894 12.4937C11.5355 12.6334 11.4546 12.761 11.3513 12.8693C11.248 12.9777 11.1244 13.0646 10.9875 13.1252C10.8506 13.1857 10.7031 13.2187 10.5535 13.2222Z" fill="white"/>\n            <path d="M11.9691 3.50043H1.94358C1.84044 3.50043 1.74153 3.45946 1.6686 3.38653C1.59567 3.3136 1.55469 3.21468 1.55469 3.11155C1.55469 3.00841 1.59567 2.90949 1.6686 2.83656C1.74153 2.76363 1.84044 2.72266 1.94358 2.72266H11.9691C12.0722 2.72266 12.1712 2.76363 12.2441 2.83656C12.317 2.90949 12.358 3.00841 12.358 3.11155C12.358 3.21468 12.317 3.3136 12.2441 3.38653C12.1712 3.45946 12.0722 3.50043 11.9691 3.50043Z" fill="white"/>\n            <path d="M8.16797 5.05469H8.94575V10.888H8.16797V5.05469Z" fill="white"/>\n            <path d="M5.05469 5.05469H5.83247V10.888H5.05469V5.05469Z" fill="white"/>\n            <path d="M8.94358 2.27846H8.2047V1.55512H5.79358V2.27846H5.05469V1.55512C5.05444 1.35541 5.13103 1.16325 5.26858 1.01845C5.40614 0.873661 5.59412 0.787329 5.79358 0.777344H8.2047C8.40416 0.787329 8.59214 0.873661 8.7297 1.01845C8.86725 1.16325 8.94383 1.35541 8.94358 1.55512V2.27846Z" fill="white"/>\n            </svg>\n            </span></h4>\n\n            '
                                    )
                                    .concat(
                                        null != o
                                            ? '<p class="ajax-cart__item-variant">'
                                                  .concat(o, " ")
                                                  .concat(
                                                      l && c && h
                                                          ? '<span class="ajax-cart__item-preorder">- PRE-ORDER</span>'
                                                          : "",
                                                      "</p>"
                                                  )
                                            : "",
                                        '\n\n            </div>\n     \n            \n            <div class="item-info_footer">\n            <div class="quantity-adjuster">\n              <a href="#" class="quantity-adjuster__button" aria-label="Decrement Quantity" data-item-decrement>\n                <i class="quantity-adjuster__icon minus"></i>\n              </a>\n    \n              <div class="quantity-adjuster__value">\n                '
                                    )
                                    .concat(
                                        n,
                                        '\n              </div>\n    \n              <a href="#" class="quantity-adjuster__button'
                                    )
                                    .concat(
                                        l ? "" : " is-disabled",
                                        '" aria-label="Increment Quantity" data-item-increment>\n                <i class="quantity-adjuster__icon plus"></i>\n              </a>\n            </div>\n\n            '
                                    )
                                    .concat(
                                        d > p
                                            ? '<div class="ajax-cart__price"><span class="original-price">'
                                                  .concat(a, '</span> <span class="compare-at__price">')
                                                  .concat(u, "</span></div>")
                                            : '<div class="ajax-cart__price"><span>'.concat(a, "</span></div>"),
                                        "\n\n            </div>\n\n \n  \n          </div>\n\n          </div> \n   \n        </div>\n        "
                                    );
                            }).join("")),
                        t
                    );
                }
                validateQty(e) {
                    return parseFloat(e) !== parseInt(e) || Number.isNaN(e) ? 1 : e;
                }
                getItemAttributes(e) {
                    const t = $(e),
                        n = t.is(Yn) ? t : t.parents(Yn);
                    return { $el: n, key: n.data("key"), qty: this.validateQty(n.data("qty")) };
                }
                render(e, t) {
                    if (e)
                        return (
                            "body" === t
                                ? (this.$body.html(this.bodyTemplate(e)),
                                  this.ToggleUpsell(e),
                                  this.ToggleTotalSaved(e),
                                  this.$cartCount.text(e.item_count))
                                : "price" === t
                                  ? (this.$totalPrice.html(e.total_price_formatted),
                                    this.ToggleUpsell(e),
                                    this.ToggleTotalSaved(e),
                                    this.$cartCount.text(e.item_count))
                                  : (this.$body.html(this.bodyTemplate(e)),
                                    this.$totalPrice.html(e.total_price_formatted),
                                    this.ToggleUpsell(e),
                                    this.ToggleTotalSaved(e),
                                    this.$cartCount.text(e.item_count)),
                            this.$el.toggleClass(ni.empty, 0 === e.item_count),
                            ri.trigger($.Event(si.RENDER, { cart: e })),
                            (this.hasBeenRendered = !0),
                            this
                        );
                }
                toggle() {
                    return this.isOpen ? this.close() : this.open();
                }
                open() {
                    this.isOpen || (this.$el.addClass(ni.open), ai.addClass(ni.bodyCartOpen), (this.isOpen = !0));
                }
                close() {
                    this.isOpen && (this.$el.removeClass(ni.open), ai.removeClass(ni.bodyCartOpen), (this.isOpen = !1));
                }
                onChangeSuccess(e) {
                    this.render(e), this.render(e).open();
                }
                onChangeFail() {}
                onItemRemoveClick(e) {
                    e.preventDefault();
                    const { key: t, $el: n } = this.getItemAttributes(e.target);
                    this.adjustQuantity(t, 0, n);
                }
                onItemIncrementClick(e) {
                    if ((e.preventDefault(), $(e.currentTarget).hasClass(ni.adjusterButtonDisabled))) return;
                    const { key: t, qty: n, $el: i } = this.getItemAttributes(e.target);
                    this.adjustQuantity(t, n + 1, i);
                }
                onItemDecrementClick(e) {
                    if ((e.preventDefault(), $(e.currentTarget).hasClass(ni.adjusterButtonDisabled))) return;
                    const { key: t, qty: n, $el: i } = this.getItemAttributes(e.target);
                    this.adjustQuantity(t, n - 1, i);
                }
                adjustQuantity(e, t, n) {
                    if (this.requestInProgress) return;
                    this.requestInProgress = !0;
                    const i = ni[0 === t ? "itemIsBeingRemoved" : "itemRequestInProgress"];
                    n.addClass(i),
                        t < 0 && (t = 0),
                        ((e, t) => {
                            const n = $.Deferred();
                            return (
                                $.ajax({
                                    type: "post",
                                    dataType: "json",
                                    url: "/cart/change.js",
                                    data: "quantity=".concat(t, "&id=").concat(e),
                                    success: () => {
                                        ee().then((e) => {
                                            n.resolve(e);
                                        });
                                    },
                                    error: () => {
                                        n.reject({ message: "Something went wrong." });
                                    },
                                }),
                                n
                            );
                        })(e, t)
                            .then((e) => {
                                e.item_count > 0 && 0 === t ? this.render(e) : (this.render(e), n.removeClass(i));
                            })
                            .fail(() => {
                                console.warn("something went wrong...");
                            })
                            .always(() => {
                                this.requestInProgress = !1;
                            });
                }
                ToggleUpsell(e) {
                    var t = $(".cart-shipping__bar-progress").attr("threshold"),
                        n = (e.original_total_price / t) * 100,
                        i = Q(t - e.original_total_price, app.moneyFormat).replace(/\.00$/, "");
                    e.original_total_price > t
                        ? (this.upsellText.html(this.upsellSuccessMessage),
                          $(".cart-shipping__bar-progress").attr("style", "width: ".concat(n, "%")))
                        : (this.upsellText.html(this.upsellProgressMessage),
                          this.upsellText.children("span").html(i),
                          $(".cart-shipping__bar-progress").attr("style", "width: ".concat(n, "%")));
                }
                ToggleTotalSaved(e) {
                    var t = 0,
                        n = e.original_total_price;
                    $.map(e.items, function (e, n) {
                        if (e.compare_at_price > e.original_price) {
                            var i = (e.compare_at_price - e.original_price) * e.quantity;
                            t = i + t;
                        }
                    }),
                        (n += t),
                        t > 0
                            ? ($(Qn).addClass(ni.isVisible),
                              $(Jn).addClass(ni.onSale),
                              this.$totalSaved.html(Q(t)),
                              n > e.original_total_price && this.$originalPrice.html(Q(n)),
                              $(Zn).css("--ajax-cart-header-height", "85px"),
                              $(ei).css("--ajax-cart-header-height", "85px"),
                              $(ti).css("--ajax-cart-header-height", "85px"))
                            : ($(Qn).removeClass(ni.isVisible),
                              $(Jn).removeClass(ni.onSale),
                              $(Zn).css("--ajax-cart-header-height", "58px"),
                              $(ei).css("--ajax-cart-header-height", "58px"),
                              $(ti).css("--ajax-cart-header-height", "58px"));
                }
                onToggleClick(e) {
                    e.preventDefault(), this.hasBeenRendered && this.toggle();
                }
                onCloseClick(e) {
                    e.preventDefault(), this.close();
                }
            }
            const li = ".expander__header",
                ci = ".expander__body",
                di = ".header",
                ui = ".navigation-backdrop-desktop",
                pi = "is-open",
                hi = "desktop-navigation-open",
                fi = $(window),
                mi = $(document.body);
            class gi {
                constructor(e) {
                    let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                    (this.$el = $(e)), (this.$header = $(li, this.$el)), (this.$body = $(ci, this.$el));
                    const n = { onClick: $.noop };
                    (this.settings = { ...n, ...t }),
                        (this.isOpen = !1),
                        "open" == this.$el.data("default") && this.open(!0),
                        this.$header.on("click", this.onClick.bind(this)),
                        $(ui).on("click", this.onClick.bind(this)),
                        $(ui).on("click", function () {
                            mi.removeClass(hi);
                        }),
                        fi.on(O, this.onBreakpointChange.bind(this));
                }
                onClick() {
                    this.settings.onClick(this);
                }
                open() {
                    let e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
                    this.isOpen ||
                        (this.$body.stop(),
                        this.$body.slideDown({
                            duration: e ? 50 : 400,
                            easing: "easeOutQuart",
                            start: () => {
                                this.$el.addClass(pi), mi.addClass(hi), $(di).addClass("invert");
                            },
                        }),
                        this.$header.attr("aria-expanded", !0),
                        (this.isOpen = !0));
                }
                close() {
                    this.isOpen &&
                        (this.$body.stop(),
                        this.$body.slideUp({
                            duration: 400,
                            easing: "easeOutQuart",
                            start: () => {
                                this.$el.removeClass(pi), mi.removeClass(hi);
                            },
                        }),
                        $(di).removeClass("invert"),
                        this.$header.attr("aria-expanded", !1),
                        (this.isOpen = !1));
                }
                close2() {
                    this.isOpen &&
                        (this.$body.stop(),
                        this.$body.slideUp({
                            duration: 400,
                            easing: "easeOutQuart",
                            start: () => {
                                this.$el.removeClass(pi);
                            },
                        }),
                        $(di).removeClass("invert"),
                        this.$header.attr("aria-expanded", !1),
                        (this.isOpen = !1));
                }
                onBreakpointChange(e) {
                    this.isOpen && ["xs", "sm", "md"].includes(e.bpMinWidthKey) && this.close();
                }
            }
            class vi {
                constructor(e) {
                    (this.$el = $(e)),
                        (this.expanders = $.map(
                            $(".expander", this.$el),
                            (e) => new gi(e, { onClick: this.onClick.bind(this) })
                        )),
                        (this.activeExpander = this.expanders.find((e) => !!e.isOpen));
                }
                onClick(e) {
                    e.isOpen
                        ? e.close()
                        : (this.activeExpander && this.activeExpander.close2(), e.open(), (this.activeExpander = e));
                }
                close() {
                    var e = $(".expander.is-open");
                    (this.$header = $(li, e)),
                        (this.$body = $(ci, e)),
                        this.$body.stop(),
                        this.$body.slideUp({
                            duration: 400,
                            easing: "easeOutQuart",
                            start: () => {
                                e.removeClass(pi), mi.removeClass(hi);
                            },
                        }),
                        $(di).removeClass("invert"),
                        this.$header.attr("aria-expanded", !1),
                        (this.isOpen = !1);
                }
            }
            class yi extends V {
                constructor(e) {
                    super(e, "header"),
                        (this.$cartCount = $("[data-cart-count]", this.$container)),
                        (this.$cartToggle = $("[data-ajax-cart-toggle]", this.$container)),
                        (this.$announcementBar = $("[data-announcement-bar]", this.$container)),
                        this.$announcementBar.find(".announcement-bar__message").map((e) => $(e).attr("[index]"));
                    var t = $.map($(".announcement-bar__message"), function (e) {
                        return $(e).attr("index");
                    });
                    if (t.length > 1) {
                        var n = -1;
                        setInterval(() => {
                            n++,
                                t[n] == n &&
                                    ($(".announcement-bar__message").removeClass("show"),
                                    $("#message-".concat(n)).addClass("show")),
                                n >= t.length - 1 && (n = -1);
                        }, 4e3);
                    }
                    (this.expanderGroup = new vi(this.$container.find("[data-expander-group]"))),
                        $(window).on(si.RENDER, this.onAJAXCartRender.bind(this));
                }
                onAJAXCartRender(e) {
                    let { cart: t } = e;
                    this.$cartCount.text(t.item_count), this.$cartToggle.toggleClass("has-items", t.item_count > 0);
                }
                onNavigateOut() {
                    this.expanderGroup.close();
                }
                onNavigateIn(e) {
                    let { page: t } = e;
                }
            }
            const bi = () => {};
            class wi {
                constructor(e, t) {
                    (this.name = "ajaxKlaviyoForm"),
                        (this.namespace = ".".concat(this.name)),
                        (this.events = { SUBMIT: "submit" + this.namespace });
                    const n = {
                        source: "Shopify Form",
                        countryCode: "default",
                        onInit: bi,
                        onBeforeSend: bi,
                        onSubmitStart: bi,
                        onSubmitFail: bi,
                        onSubscribeSuccess: bi,
                        onSubscribeFail: bi,
                    };
                    return (
                        0 !== e.length &&
                        ((this.$form = e instanceof $ ? e : $(e)),
                        (this.$input = this.$form.find('input[type="email"]')),
                        (this.$submit = this.$form.find('[type="submit"]')),
                        (this.settings = $.extend({}, n, t)),
                        (this.isSubmitting = !1),
                        this.settings.listId
                            ? (this.$form.on(this.events.SUBMIT, this.onFormSubmit.bind(this)),
                              void this.settings.onInit())
                            : (console.warn("[".concat(this.name, "] - Valid Klaviyo List ID required to initialize")),
                              !1))
                    );
                }
                logErrors(e) {
                    if (Array.isArray(e) && e.length)
                        for (let t = e.length - 1; t >= 0; t--)
                            console.warn("[".concat(this.name, "] - onSubmitFail error: ").concat(e[t]));
                }
                onBeforeSend() {
                    return (
                        !1 !== this.settings.onBeforeSend() &&
                        (this.$input.val() && this.$input.val().length
                            ? (this.$submit.prop("disabled", !0),
                              (this.isSubmitting = !0),
                              this.settings.onSubmitStart(),
                              !0)
                            : (this.$input.parents(".form-group").addClass("alert-info"), !1))
                    );
                }
                onSubmitDone(e) {
                    this.$submit.prop("disabled", !1),
                        e.success
                            ? this.settings.onSubscribeSuccess(e)
                            : (this.logErrors(e.errors), this.settings.onSubscribeFail(e));
                }
                onSubmitFail(e) {
                    this.$submit.prop("disabled", !1), this.logErrors(e), this.settings.onSubmitFail(e);
                }
                onFormSubmit(e) {
                    return (
                        e.preventDefault(),
                        $.ajax({
                            async: !0,
                            crossDomain: !0,
                            url: "//manage.kmail-lists.com/ajax/subscriptions/subscribe",
                            method: "POST",
                            headers: {
                                "content-type": "application/x-www-form-urlencoded",
                                "cache-control": "no-cache",
                            },
                            data: {
                                g: this.settings.listId,
                                $fields: "$source",
                                email: this.$input.val(),
                                $source: this.settings.source,
                            },
                            beforeSend: this.onBeforeSend.bind(this),
                        })
                            .done((e) => {
                                this.onSubmitDone(e),
                                    "US" === this.settings.countryCode &&
                                        (window.location.href = "https://pythia.attn.tv/p/8gv/landing-page");
                            })
                            .fail((e, t) => {
                                let n = [];
                                e &&
                                    e.responseJSON &&
                                    e.responseJSON.hasOwnProperty("errors") &&
                                    (n = e.responseJSON.errors),
                                    this.onSubmitFail(n);
                            })
                            .always(() => {
                                this.isSubmitting = !1;
                            }),
                        !1
                    );
                }
            }
            const Ci = "form",
                xi = "show-contents",
                Si = "show-message";
            class Ei {
                constructor(e) {
                    let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                    (this.name = "newsletterForm"),
                        (this.settings = vn().extend({}, { forceSuccess: !1 }, t)),
                        (this.typed = null),
                        (this.$el = vn()(e)),
                        (this.$form = this.$el.is(Ci) ? this.$el : this.$el.find(Ci)),
                        this.$form.length
                            ? ((this.$formContents = vn()("[data-form-contents]", this.$el)),
                              (this.$formMessage = vn()("[data-form-message]", this.$el)),
                              (this.$formInput = vn()('input[type="email"]', this.$el)),
                              this.$form.on(
                                  "click",
                                  "[data-form-contents-trigger]",
                                  this.onFormContentsTriggerClick.bind(this)
                              ),
                              this.$formInput.on("keydown", this.onFormInputKeyDown.bind(this)))
                            : console.warn("[".concat(this.name, "] - Form element required to initialize"));
                }
                showMessageWithAnimation(e) {
                    let t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1],
                        n = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
                    this.typed && this.typed.destroy(),
                        this.$formMessage.html(""),
                        this.$formContents.addClass(Si),
                        n && this.$formMessage.addClass("error"),
                        (this.typed = new be(this.$formMessage.get(0), {
                            strings: ["".concat(e, " ^2000"), ""],
                            typeSpeed: 10,
                            backSpeed: 10,
                            showCursor: !1,
                            onComplete: () => {
                                this.$formContents.removeClass(Si),
                                    this.$formMessage.removeClass("error"),
                                    this.hideFormContents(),
                                    t && this.reset();
                            },
                        }));
                }
                showFormContents() {
                    this.$form.addClass(xi), this.$formInput.focus();
                }
                hideFormContents() {
                    this.$form.removeClass(xi);
                }
                reset() {
                    this.$formInput.val(""), this.$formMessage.html("");
                }
                onSubscribeSuccess(e) {
                    const t = e && e.data && e.data.is_subscribed;
                    let n = "success";
                    t && (n = "already-subscribed"), this.settings.forceSuccess && (n = "success");
                    const i = !!this.settings.forceSuccess || !t,
                        s = !this.settings.forceSuccess && t;
                    this.showMessageWithAnimation(this.$formMessage.data(n), i, s);
                }
                onSubmitStart() {
                    this.showMessageWithAnimation("Submitting", !1);
                }
                onSubmitFail(e) {
                    const t = Array.isArray(e) ? e.join("  ") : e;
                    this.showMessageWithAnimation(t, !1, !0);
                }
                onSubscribeFail() {
                    this.showMessageWithAnimation(this.$formMessage.data("fail"), !1, !0);
                }
                onFormContentsTriggerClick(e) {
                    e.preventDefault(), this.showFormContents();
                }
                onFormInputKeyDown(e) {
                    e && 27 === e.which && this.hideFormContents();
                }
            }
            class Ti extends V {
                constructor(e) {
                    super(e, "footer"),
                        (this.$form = $("[data-newsletter-form]", this.$container)),
                        this.$form.length &&
                            ((this.newsletterForm = new Ei(this.$form)),
                            (this.ajaxForm = new wi(this.$form, {
                                listId: this.$form.data("klaviyo-list-id"),
                                source: this.$form.data("klaviyo-source"),
                                countryCode: this.$form.data("country-code"),
                                onSubmitStart: () => this.newsletterForm.onSubmitStart(),
                                onSubmitFail: (e) => this.newsletterForm.onSubmitFail(e),
                                onSubscribeSuccess: (e) => this.newsletterForm.onSubscribeSuccess(e),
                                onSubscribeFail: (e) => this.newsletterForm.onSubscribeFail(e),
                            })));
                }
            }
            const $i = ".header",
                ki = "is-open",
                Mi = "mobile-navigation-open",
                Li = $(window),
                Ai = $(document.body);
            class Ii extends V {
                constructor(e) {
                    super(e, "mobile-menu"),
                        (this.isOpen = !1),
                        (this.drawerOpen = !1),
                        (this.callbacks = {
                            bodyToggleClick: this.onToggleClick.bind(this),
                            drawerToggleOpen: this.onDrawerOpen.bind(this),
                            drawerToggleClose: this.onDrawerClose.bind(this),
                            breakpointChange: this.onBreakpointChange.bind(this),
                        }),
                        Ai.on("click", "[data-mobile-menu-toggle]", this.callbacks.bodyToggleClick),
                        Ai.on("click", ".has-child", this.callbacks.drawerToggleOpen),
                        Ai.on("click", ".drawer-back", this.callbacks.drawerToggleClose),
                        Ai.on("click", ".navigation-backdrop-mobile", this.callbacks.bodyToggleClick),
                        Li.on(O, this.callbacks.breakpointChange);
                }
                open() {
                    let e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
                    this.isOpen ||
                        (this.$container.stop(),
                        this.$container.slideDown({
                            duration: e ? 50 : 400,
                            easing: "easeOutQuart",
                            start: () => {
                                this.$container.addClass(ki),
                                    $($i).addClass("invert"),
                                    Ai.addClass(Mi),
                                    $("#dotted-menu").prop("checked", !0);
                            },
                            complete: () => {
                                this.$container.css("height", "");
                            },
                        }),
                        (this.isOpen = !0));
                }
                close() {
                    this.isOpen &&
                        (this.$container.stop(),
                        this.$container.slideUp({
                            duration: 400,
                            easing: "easeOutQuart",
                            start: () => {
                                this.$container.removeClass(ki),
                                    Ai.removeClass(Mi),
                                    this.onDrawerClose(),
                                    $("#dotted-menu").prop("checked", !1);
                            },
                            complete: () => {
                                this.$container.css("height", "");
                            },
                        }),
                        $($i).removeClass("invert"),
                        (this.isOpen = !1));
                }
                onDrawerOpen(e) {
                    const t = $(e.currentTarget);
                    $(".mobile-nav").addClass("child-visible"),
                        $(t).closest(".drawer-menu__item").addClass("active-drawer"),
                        $(this.$container).animate(
                            {
                                height:
                                    $(".active-drawer").children(".drawer-menu__list--sub").prop("scrollHeight") + 50,
                            },
                            { duration: 400, easing: "easeInOutCubic", start: function () {} }
                        );
                }
                onDrawerClose(e) {
                    $(".mobile-nav").removeClass("child-visible"),
                        $(".drawer-menu__item").removeClass("active-drawer"),
                        $(this.$container).animate(
                            { height: $(".mainnav").prop("scrollHeight") + 50 },
                            { duration: 400, easing: "easeInOutCubic" }
                        );
                }
                toggle() {
                    this.isOpen ? this.close() : this.open();
                }
                onToggleClick(e) {
                    e.preventDefault(), this.toggle();
                }
                onBreakpointChange(e) {
                    this.isOpen && (["xs", "sm", "md"].includes(e.bpMinWidthKey) || this.close());
                }
                onSelect() {
                    this.open();
                }
                onDeselect() {
                    this.close();
                }
                onUnload() {
                    this.destroy();
                }
            }
            function _i(e) {
                return "number" == typeof e;
            }
            function Pi(e) {
                return "string" == typeof e;
            }
            function Di(e) {
                return "[object Object]" === Object.prototype.toString.call(e);
            }
            function Oi(e) {
                return (
                    Di(e) ||
                    (function (e) {
                        return Array.isArray(e);
                    })(e)
                );
            }
            function Ni(e) {
                return Math.abs(e);
            }
            function Fi(e) {
                return e ? e / Ni(e) : 0;
            }
            function ji(e, t) {
                return Ni(e - t);
            }
            function zi(e) {
                return Hi(e).map(Number);
            }
            function Bi(e) {
                return e[qi(e)];
            }
            function qi(e) {
                return Math.max(0, e.length - 1);
            }
            function Hi(e) {
                return Object.keys(e);
            }
            function Ri(e, t) {
                return [e, t].reduce(function (e, t) {
                    return (
                        Hi(t).forEach(function (n) {
                            var i = e[n],
                                s = t[n],
                                r = Di(i) && Di(s);
                            e[n] = r ? Ri(i, s) : s;
                        }),
                        e
                    );
                }, {});
            }
            function Vi(e, t) {
                var n = Hi(e),
                    i = Hi(t);
                return (
                    n.length === i.length &&
                    n.every(function (n) {
                        var i = e[n],
                            s = t[n];
                        return "function" == typeof i
                            ? "".concat(i) === "".concat(s)
                            : Oi(i) && Oi(s)
                              ? Vi(i, s)
                              : i === s;
                    })
                );
            }
            function Gi(e, t) {
                var n = Ni(e - t);
                function i(t) {
                    return t < e;
                }
                function s(e) {
                    return e > t;
                }
                function r(e) {
                    return i(e) || s(e);
                }
                var a = {
                    length: n,
                    max: t,
                    min: e,
                    constrain: function (n) {
                        return r(n) ? (i(n) ? e : t) : n;
                    },
                    reachedAny: r,
                    reachedMax: s,
                    reachedMin: i,
                    removeOffset: function (e) {
                        return n ? e - n * Math.ceil((e - t) / n) : e;
                    },
                };
                return a;
            }
            function Wi(e, t, n) {
                var i = Gi(0, e),
                    s = i.min,
                    r = i.constrain,
                    a = e + 1,
                    o = l(t);
                function l(e) {
                    return n ? Ni((a + e) % a) : r(e);
                }
                function c() {
                    return o;
                }
                function d(e) {
                    return (o = l(e)), u;
                }
                var u = {
                    add: function (e) {
                        return d(c() + e);
                    },
                    clone: function () {
                        return Wi(e, c(), n);
                    },
                    get: c,
                    set: d,
                    min: s,
                    max: e,
                };
                return u;
            }
            function Ui() {
                var e = [],
                    t = {
                        add: function (n, i, s, r) {
                            return (
                                void 0 === r && (r = { passive: !0 }),
                                n.addEventListener(i, s, r),
                                e.push(function () {
                                    return n.removeEventListener(i, s, r);
                                }),
                                t
                            );
                        },
                        removeAll: function () {
                            return (
                                (e = e.filter(function (e) {
                                    return e();
                                })),
                                t
                            );
                        },
                    };
                return t;
            }
            function Xi(e) {
                var t = e;
                function n(e) {
                    return (t /= e), s;
                }
                function i(e) {
                    return _i(e) ? e : e.get();
                }
                var s = {
                    add: function (e) {
                        return (t += i(e)), s;
                    },
                    divide: n,
                    get: function () {
                        return t;
                    },
                    multiply: function (e) {
                        return (t *= e), s;
                    },
                    normalize: function () {
                        return 0 !== t && n(t), s;
                    },
                    set: function (e) {
                        return (t = i(e)), s;
                    },
                    subtract: function (e) {
                        return (t -= i(e)), s;
                    },
                };
                return s;
            }
            function Yi(e, t, n, i, s) {
                var r = s.measure(10),
                    a = s.measure(50),
                    o = !1;
                return {
                    constrain: function (s) {
                        if (!o && e.reachedAny(n.get()) && e.reachedAny(t.get())) {
                            var l = e.reachedMin(t.get()) ? "min" : "max",
                                c = Ni(e[l] - t.get()),
                                d = n.get() - t.get(),
                                u = Math.min(c / a, 0.85);
                            n.subtract(d * u),
                                !s && Ni(d) < r && (n.set(e.constrain(n.get())), i.useSpeed(10).useMass(3));
                        }
                    },
                    toggleActive: function (e) {
                        o = !e;
                    },
                };
            }
            function Ki(e, t, n, i) {
                var s = Gi(t.min + 0.1, t.max + 0.1),
                    r = s.reachedMin,
                    a = s.reachedMax;
                return {
                    loop: function (t) {
                        if (
                            (function (e) {
                                return 1 === e ? a(n.get()) : -1 === e && r(n.get());
                            })(t)
                        ) {
                            var s = e * (-1 * t);
                            i.forEach(function (e) {
                                return e.add(s);
                            });
                        }
                    },
                };
            }
            function Qi(e) {
                var t = e.max,
                    n = e.length,
                    i = {
                        get: function (e) {
                            return (e - t) / -n;
                        },
                    };
                return i;
            }
            function Ji(e, t, n) {
                var i =
                        "x" === e.scroll
                            ? function (e) {
                                  return "translate3d(".concat(e, "px,0px,0px)");
                              }
                            : function (e) {
                                  return "translate3d(0px,".concat(e, "px,0px)");
                              },
                    s = n.style,
                    r = !1;
                return {
                    clear: function () {
                        r || ((s.transform = ""), n.getAttribute("style") || n.removeAttribute("style"));
                    },
                    to: function (e) {
                        r || (s.transform = i(t.apply(e.get())));
                    },
                    toggleActive: function (e) {
                        r = !e;
                    },
                };
            }
            function Zi(e, t, n, i, s, r, a, o, l) {
                var c,
                    d = zi(s),
                    u = zi(s).reverse(),
                    p = ((c = r[0] - 1), m(f(u, c), "end")).concat(
                        (function () {
                            var e = n - r[0] - 1;
                            return m(f(d, e), "start");
                        })()
                    );
                function h(e, t) {
                    return e.reduce(function (e, t) {
                        return e - s[t];
                    }, t);
                }
                function f(e, t) {
                    return e.reduce(function (e, n) {
                        return h(e, t) > 0 ? e.concat([n]) : e;
                    }, []);
                }
                function m(n, s) {
                    var r = "start" === s,
                        c = r ? -i : i,
                        d = a.findSlideBounds([c]);
                    return n.map(function (n) {
                        var s = r ? 0 : -i,
                            a = r ? i : 0,
                            c = d.filter(function (e) {
                                return e.index === n;
                            })[0][r ? "end" : "start"],
                            u = Xi(-1),
                            p = Xi(-1),
                            h = Ji(e, t, l[n]);
                        return {
                            index: n,
                            location: p,
                            translate: h,
                            target: function () {
                                return u.set(o.get() > c ? s : a);
                            },
                        };
                    });
                }
                var g = {
                    canLoop: function () {
                        return p.every(function (e) {
                            var t = e.index,
                                i = d.filter(function (e) {
                                    return e !== t;
                                });
                            return h(i, n) <= 0.1;
                        });
                    },
                    clear: function () {
                        p.forEach(function (e) {
                            return e.translate.clear();
                        });
                    },
                    loop: function () {
                        p.forEach(function (e) {
                            var t = e.target,
                                n = e.translate,
                                i = e.location,
                                s = t();
                            s.get() !== i.get() && (0 === s.get() ? n.clear() : n.to(s), i.set(s));
                        });
                    },
                    loopPoints: p,
                };
                return g;
            }
            function es(e, t, n, i, s) {
                var r = i.align,
                    a = i.axis,
                    o = i.direction,
                    l = i.startIndex,
                    c = i.inViewThreshold,
                    d = i.loop,
                    u = i.speed,
                    p = i.dragFree,
                    h = i.slidesToScroll,
                    f = i.skipSnaps,
                    m = i.containScroll,
                    g = t.getBoundingClientRect(),
                    v = n.map(function (e) {
                        return e.getBoundingClientRect();
                    }),
                    y = (function (e) {
                        var t = "rtl" === e ? -1 : 1,
                            n = {
                                apply: function (e) {
                                    return e * t;
                                },
                            };
                        return n;
                    })(o),
                    b = (function (e, t) {
                        var n = "y" === e ? "y" : "x";
                        return {
                            scroll: n,
                            cross: "y" === e ? "x" : "y",
                            startEdge: "y" === n ? "top" : "rtl" === t ? "right" : "left",
                            endEdge: "y" === n ? "bottom" : "rtl" === t ? "left" : "right",
                            measureSize: function (e) {
                                var t = e.width,
                                    i = e.height;
                                return "x" === n ? t : i;
                            },
                        };
                    })(a, o),
                    w = b.measureSize(g),
                    C = (function (e) {
                        var t = {
                            measure: function (t) {
                                return e * (t / 100);
                            },
                        };
                        return t;
                    })(w),
                    x = (function (e, t) {
                        var n = {
                            start: function () {
                                return 0;
                            },
                            center: function (e) {
                                return i(e) / 2;
                            },
                            end: i,
                        };
                        function i(e) {
                            return t - e;
                        }
                        var s = {
                            measure: function (i) {
                                return _i(e) ? t * Number(e) : n[e](i);
                            },
                        };
                        return s;
                    })(r, w),
                    S = !d && "" !== m,
                    E = (function (e, t, n, i, s) {
                        var r = e.measureSize,
                            a = e.startEdge,
                            o = e.endEdge,
                            l = n[0] && s,
                            c = (function () {
                                if (!l) return 0;
                                var e = n[0];
                                return Ni(t[a] - e[a]);
                            })(),
                            d = (function () {
                                if (!l) return 0;
                                var e = window.getComputedStyle(Bi(i));
                                return parseFloat(e.getPropertyValue("margin-".concat(o)));
                            })(),
                            u = n.map(r),
                            p = n
                                .map(function (e, t, n) {
                                    var i = !t,
                                        s = t === qi(n);
                                    return i ? u[t] + c : s ? u[t] + d : n[t + 1][a] - e[a];
                                })
                                .map(Ni);
                        return { slideSizes: u, slideSizesWithGaps: p };
                    })(b, g, v, n, d || "" !== m),
                    T = E.slideSizes,
                    $ = E.slideSizesWithGaps,
                    k = (function (e, t, n) {
                        var i = _i(n),
                            s = {
                                groupSlides: function (s) {
                                    return i
                                        ? (function (e, t) {
                                              return zi(e)
                                                  .filter(function (e) {
                                                      return e % t == 0;
                                                  })
                                                  .map(function (n) {
                                                      return e.slice(n, n + t);
                                                  });
                                          })(s, n)
                                        : (function (n) {
                                              return zi(n)
                                                  .reduce(function (n, i) {
                                                      var s = t.slice(Bi(n), i + 1).reduce(function (e, t) {
                                                          return e + t;
                                                      }, 0);
                                                      return !i || s > e ? n.concat(i) : n;
                                                  }, [])
                                                  .map(function (e, t, i) {
                                                      return n.slice(e, i[t + 1]);
                                                  });
                                          })(s);
                                },
                            };
                        return s;
                    })(w, $, h),
                    M = (function (e, t, n, i, s, r, a) {
                        var o,
                            l = e.startEdge,
                            c = e.endEdge,
                            d = r.groupSlides,
                            u = d(i)
                                .map(function (e) {
                                    return Bi(e)[c] - e[0][l];
                                })
                                .map(Ni)
                                .map(t.measure),
                            p = i
                                .map(function (e) {
                                    return n[l] - e[l];
                                })
                                .map(function (e) {
                                    return -Ni(e);
                                }),
                            h =
                                ((o = Bi(p) - Bi(s)),
                                d(p)
                                    .map(function (e) {
                                        return e[0];
                                    })
                                    .map(function (e, t, n) {
                                        var i = !t,
                                            s = t === qi(n);
                                        return a && i ? 0 : a && s ? o : e + u[t];
                                    }));
                        return { snaps: p, snapsAligned: h };
                    })(b, x, g, v, $, k, S),
                    L = M.snaps,
                    A = M.snapsAligned,
                    I = -Bi(L) + Bi($),
                    _ = (function (e, t, n, i) {
                        var s = Gi(-t + e, n[0]),
                            r = n.map(s.constrain);
                        return {
                            snapsContained: (function () {
                                if (t <= e) return [s.max];
                                if ("keepSnaps" === i) return r;
                                var n,
                                    a,
                                    o = ((n = r[0]), (a = Bi(r)), Gi(r.lastIndexOf(n), r.indexOf(a) + 1)),
                                    l = o.min,
                                    c = o.max;
                                return r.slice(l, c);
                            })(),
                        };
                    })(w, I, A, m).snapsContained,
                    P = S ? _ : A,
                    D = (function (e, t, n) {
                        var i, s;
                        return { limit: ((i = t[0]), (s = Bi(t)), Gi(n ? i - e : s, i)) };
                    })(I, P, d).limit,
                    O = Wi(qi(P), l, d),
                    N = O.clone(),
                    F = zi(n),
                    j = (function (e) {
                        var t = 0;
                        function n(e, n) {
                            return function () {
                                e === !!t && n();
                            };
                        }
                        function i() {
                            t = window.requestAnimationFrame(e);
                        }
                        return {
                            proceed: n(!0, i),
                            start: n(!1, i),
                            stop: n(!0, function () {
                                window.cancelAnimationFrame(t), (t = 0);
                            }),
                        };
                    })(function () {
                        d || U.scrollBounds.constrain(U.dragHandler.pointerDown()), U.scrollBody.seek(q).update();
                        var e = U.scrollBody.settle(q);
                        e && !U.dragHandler.pointerDown() && (U.animation.stop(), s.emit("settle")),
                            e || s.emit("scroll"),
                            d && (U.scrollLooper.loop(U.scrollBody.direction()), U.slideLooper.loop()),
                            U.translate.to(B),
                            U.animation.proceed();
                    }),
                    z = P[O.get()],
                    B = Xi(z),
                    q = Xi(z),
                    H = (function (e, t, n) {
                        var i,
                            s =
                                ((i = Math.pow(10, 2)),
                                function (e) {
                                    return Math.round(e * i) / i;
                                }),
                            r = Xi(0),
                            a = Xi(0),
                            o = Xi(0),
                            l = 0,
                            c = t,
                            d = n;
                        function u(e) {
                            return (c = e), h;
                        }
                        function p(e) {
                            return (d = e), h;
                        }
                        var h = {
                            direction: function () {
                                return l;
                            },
                            seek: function (t) {
                                o.set(t).subtract(e);
                                var n,
                                    i = 0 + ((o.get() - 0) / 100) * (c - 0);
                                return (
                                    (l = Fi(o.get())),
                                    o.normalize().multiply(i).subtract(r),
                                    (n = o).divide(d),
                                    a.add(n),
                                    h
                                );
                            },
                            settle: function (t) {
                                var n = t.get() - e.get(),
                                    i = !s(n);
                                return i && e.set(t), i;
                            },
                            update: function () {
                                r.add(a), e.add(r), a.multiply(0);
                            },
                            useBaseMass: function () {
                                return p(n);
                            },
                            useBaseSpeed: function () {
                                return u(t);
                            },
                            useMass: p,
                            useSpeed: u,
                        };
                        return h;
                    })(B, u, 1),
                    R = (function (e, t, n, i, s) {
                        var r = i.reachedAny,
                            a = i.removeOffset,
                            o = i.constrain;
                        function l(e) {
                            return e.concat().sort(function (e, t) {
                                return Ni(e) - Ni(t);
                            })[0];
                        }
                        function c(t, i) {
                            var s = [t, t + n, t - n];
                            if (!e) return s[0];
                            if (!i) return l(s);
                            var r = s.filter(function (e) {
                                return Fi(e) === i;
                            });
                            return l(r);
                        }
                        var d = {
                            byDistance: function (n, i) {
                                var l = s.get() + n,
                                    d = (function (n) {
                                        var i = e ? a(n) : o(n),
                                            s = t
                                                .map(function (e) {
                                                    return e - i;
                                                })
                                                .map(function (e) {
                                                    return c(e, 0);
                                                })
                                                .map(function (e, t) {
                                                    return { diff: e, index: t };
                                                })
                                                .sort(function (e, t) {
                                                    return Ni(e.diff) - Ni(t.diff);
                                                });
                                        return { index: s[0].index, distance: i };
                                    })(l),
                                    u = d.index,
                                    p = d.distance,
                                    h = !e && r(l);
                                return !i || h ? { index: u, distance: n } : { index: u, distance: n + c(t[u] - p, 0) };
                            },
                            byIndex: function (e, n) {
                                return { index: e, distance: c(t[e] - s.get(), n) };
                            },
                            shortcut: c,
                        };
                        return d;
                    })(d, P, I, D, q),
                    V = (function (e, t, n, i, s, r) {
                        function a(i) {
                            var a = i.distance,
                                o = i.index !== t.get();
                            a && (e.start(), s.add(a)), o && (n.set(t.get()), t.set(i.index), r.emit("select"));
                        }
                        var o = {
                            distance: function (e, t) {
                                a(i.byDistance(e, t));
                            },
                            index: function (e, n) {
                                var s = t.clone().set(e);
                                a(i.byIndex(s.get(), n));
                            },
                        };
                        return o;
                    })(j, O, N, R, q, s),
                    G = (function (e, t, n, i, s, r, a) {
                        var o = s.removeOffset,
                            l = s.constrain,
                            c = r ? [0, t, -t] : [0],
                            d = u(c, a);
                        function u(t, s) {
                            var r = t || c,
                                a = (function (e) {
                                    var t = e || 0;
                                    return n.map(function (e) {
                                        return Gi(0.5, e - 0.5).constrain(e * t);
                                    });
                                })(s);
                            return r.reduce(function (t, s) {
                                var r = i.map(function (t, i) {
                                    return { start: t - n[i] + a[i] + s, end: t + e - a[i] + s, index: i };
                                });
                                return t.concat(r);
                            }, []);
                        }
                        return {
                            check: function (e, t) {
                                var n = r ? o(e) : l(e);
                                return (t || d).reduce(function (e, t) {
                                    var i = t.index,
                                        s = t.start,
                                        r = t.end;
                                    return -1 === e.indexOf(i) && s < n && r > n ? e.concat([i]) : e;
                                }, []);
                            },
                            findSlideBounds: u,
                        };
                    })(w, I, T, L, D, d, c),
                    W = (function (e, t, n, i, s, r, a, o, l, c, d, u, p, h, f, m) {
                        var g = e.cross,
                            v = ["INPUT", "SELECT", "TEXTAREA"],
                            y = { passive: !1 },
                            b = Xi(0),
                            w = Ui(),
                            C = Ui(),
                            x = p.measure(20),
                            S = { mouse: 300, touch: 400 },
                            E = { mouse: 500, touch: 600 },
                            T = f ? 5 : 16,
                            $ = 1,
                            k = 0,
                            M = 0,
                            L = !1,
                            A = !1,
                            I = !1,
                            _ = !1;
                        function P(e) {
                            if (
                                !(
                                    ((_ = !s.isTouchEvent(e)) && 0 !== e.button) ||
                                    ((t = e.target), (a = t.nodeName || ""), v.indexOf(a) > -1)
                                )
                            ) {
                                var t,
                                    a,
                                    o = ji(i.get(), r.get()) >= 2,
                                    c = _ || !o;
                                (L = !0),
                                    s.pointerDown(e),
                                    b.set(i),
                                    i.set(r),
                                    l.useBaseMass().useSpeed(80),
                                    (function () {
                                        var e = _ ? document : n;
                                        C.add(e, "touchmove", D, y)
                                            .add(e, "touchend", O)
                                            .add(e, "mousemove", D, y)
                                            .add(e, "mouseup", O);
                                    })(),
                                    (k = s.readPoint(e)),
                                    (M = s.readPoint(e, g)),
                                    u.emit("pointerDown"),
                                    c && (I = !1);
                            }
                        }
                        function D(e) {
                            if (!A && !_) {
                                if (!e.cancelable) return O(e);
                                var n = s.readPoint(e),
                                    r = s.readPoint(e, g),
                                    o = ji(n, k),
                                    l = ji(r, M);
                                if (!(A = o > l) && !I) return O(e);
                            }
                            var c = s.pointerMove(e);
                            !I && c && (I = !0), a.start(), i.add(t.apply(c)), e.preventDefault();
                        }
                        function O(e) {
                            var n = c.byDistance(0, !1).index !== d.get(),
                                r = s.pointerUp(e) * (f ? E : S)[_ ? "mouse" : "touch"],
                                a = (function (e, t) {
                                    var n = d.clone().add(-1 * Fi(e)),
                                        i = n.get() === d.min || n.get() === d.max,
                                        s = c.byDistance(e, !f).distance;
                                    return f || Ni(e) < x
                                        ? s
                                        : !h && i
                                          ? 0.4 * s
                                          : m && t
                                            ? 0.5 * s
                                            : c.byIndex(n.get(), 0).distance;
                                })(t.apply(r), n),
                                p = (function (e, t) {
                                    if (0 === e || 0 === t) return 0;
                                    if (Ni(e) <= Ni(t)) return 0;
                                    var n = ji(Ni(e), Ni(t));
                                    return Ni(n / e);
                                })(r, a),
                                g = ji(i.get(), b.get()) >= 0.5,
                                v = n && p > 0.75,
                                y = Ni(r) < x,
                                w = v ? 10 : T,
                                k = v ? $ + 2.5 * p : $;
                            g && !_ && (I = !0),
                                (A = !1),
                                (L = !1),
                                C.removeAll(),
                                l.useSpeed(y ? 9 : w).useMass(k),
                                o.distance(a, !f),
                                (_ = !1),
                                u.emit("pointerUp");
                        }
                        function N(e) {
                            I && (e.stopPropagation(), e.preventDefault());
                        }
                        return {
                            addActivationEvents: function () {
                                var e = n;
                                w.add(
                                    e,
                                    "dragstart",
                                    function (e) {
                                        return e.preventDefault();
                                    },
                                    y
                                )
                                    .add(e, "touchmove", function () {}, y)
                                    .add(e, "touchend", function () {})
                                    .add(e, "touchstart", P)
                                    .add(e, "mousedown", P)
                                    .add(e, "touchcancel", O)
                                    .add(e, "contextmenu", O)
                                    .add(e, "click", N, !0);
                            },
                            clickAllowed: function () {
                                return !I;
                            },
                            pointerDown: function () {
                                return L;
                            },
                            removeAllEvents: function () {
                                w.removeAll(), C.removeAll();
                            },
                        };
                    })(
                        b,
                        y,
                        e,
                        q,
                        (function (e) {
                            var t, n;
                            function i(e) {
                                return "undefined" != typeof TouchEvent && e instanceof TouchEvent;
                            }
                            function s(e) {
                                return e.timeStamp;
                            }
                            function r(t, n) {
                                var s = n || e.scroll,
                                    r = "client".concat("x" === s ? "X" : "Y");
                                return (i(t) ? t.touches[0] : t)[r];
                            }
                            return {
                                isTouchEvent: i,
                                pointerDown: function (e) {
                                    return (t = e), (n = e), r(e);
                                },
                                pointerMove: function (e) {
                                    var i = r(e) - r(n),
                                        a = s(e) - s(t) > 170;
                                    return (n = e), a && (t = e), i;
                                },
                                pointerUp: function (e) {
                                    if (!t || !n) return 0;
                                    var i = r(n) - r(t),
                                        a = s(e) - s(t),
                                        o = s(e) - s(n) > 170,
                                        l = i / a;
                                    return a && !o && Ni(l) > 0.1 ? l : 0;
                                },
                                readPoint: r,
                            };
                        })(b),
                        B,
                        j,
                        V,
                        H,
                        R,
                        O,
                        s,
                        C,
                        d,
                        p,
                        f
                    ),
                    U = {
                        containerRect: g,
                        slideRects: v,
                        animation: j,
                        axis: b,
                        direction: y,
                        dragHandler: W,
                        eventStore: Ui(),
                        percentOfView: C,
                        index: O,
                        indexPrevious: N,
                        limit: D,
                        location: B,
                        options: i,
                        scrollBody: H,
                        scrollBounds: Yi(D, B, q, H, C),
                        scrollLooper: Ki(I, D, B, [B, q]),
                        scrollProgress: Qi(D),
                        scrollSnaps: P,
                        scrollTarget: R,
                        scrollTo: V,
                        slideLooper: Zi(b, y, w, I, $, P, G, B, n),
                        slidesToScroll: k,
                        slidesInView: G,
                        slideIndexes: F,
                        target: q,
                        translate: Ji(b, y, t),
                    };
                return U;
            }
            var ts = {
                align: "center",
                axis: "x",
                container: null,
                slides: null,
                containScroll: "",
                direction: "ltr",
                slidesToScroll: 1,
                breakpoints: {},
                dragFree: !1,
                draggable: !0,
                inViewThreshold: 0,
                loop: !1,
                skipSnaps: !1,
                speed: 10,
                startIndex: 0,
                active: !0,
            };
            function ns() {
                function e(e, t) {
                    return Ri(e, t || {});
                }
                return {
                    merge: e,
                    areEqual: function (e, t) {
                        return (
                            JSON.stringify(Hi(e.breakpoints || {})) === JSON.stringify(Hi(t.breakpoints || {})) &&
                            Vi(e, t)
                        );
                    },
                    atMedia: function (t) {
                        var n = t.breakpoints || {},
                            i = Hi(n)
                                .filter(function (e) {
                                    return window.matchMedia(e).matches;
                                })
                                .map(function (e) {
                                    return n[e];
                                })
                                .reduce(function (t, n) {
                                    return e(t, n);
                                }, {});
                        return e(t, i);
                    },
                };
            }
            function is(e, t, n) {
                var i,
                    s,
                    r,
                    a,
                    o = Ui(),
                    l = ns(),
                    c = (function () {
                        var e = ns(),
                            t = e.atMedia,
                            n = e.areEqual,
                            i = [],
                            s = [];
                        function r(e) {
                            var i = t(e.options);
                            return function () {
                                return !n(i, t(e.options));
                            };
                        }
                        var a = {
                            init: function (e, n) {
                                return (
                                    (s = e.map(r)),
                                    (i = e.filter(function (e) {
                                        return t(e.options).active;
                                    })).forEach(function (e) {
                                        return e.init(n);
                                    }),
                                    e.reduce(function (e, t) {
                                        var n;
                                        return Object.assign(e, (((n = {})[t.name] = t), n));
                                    }, {})
                                );
                            },
                            destroy: function () {
                                i = i.filter(function (e) {
                                    return e.destroy();
                                });
                            },
                            haveChanged: function () {
                                return s.some(function (e) {
                                    return e();
                                });
                            },
                        };
                        return a;
                    })(),
                    d = (function () {
                        var e = {};
                        function t(t) {
                            return e[t] || [];
                        }
                        var n = {
                            emit: function (e) {
                                return (
                                    t(e).forEach(function (t) {
                                        return t(e);
                                    }),
                                    n
                                );
                            },
                            off: function (i, s) {
                                return (
                                    (e[i] = t(i).filter(function (e) {
                                        return e !== s;
                                    })),
                                    n
                                );
                            },
                            on: function (i, s) {
                                return (e[i] = t(i).concat([s])), n;
                            },
                        };
                        return n;
                    })(),
                    u = d.on,
                    p = d.off,
                    h = w,
                    f = !1,
                    m = l.merge(ts, is.globalOptions),
                    g = l.merge(m),
                    v = [],
                    y = 0;
                function b(t, n) {
                    if (!f) {
                        if (
                            ((m = l.merge(m, t)),
                            (g = l.atMedia(m)),
                            (function () {
                                var t = g.container,
                                    n = g.slides,
                                    i = Pi(t) ? e.querySelector(t) : t;
                                r = i || e.children[0];
                                var s = Pi(n) ? r.querySelectorAll(n) : n;
                                a = [].slice.call(s || r.children);
                            })(),
                            (i = es(e, r, a, g, d)),
                            (y = i.axis.measureSize(e.getBoundingClientRect())),
                            !g.active)
                        )
                            return C();
                        if ((i.translate.to(i.location), (v = n || v), (s = c.init(v, T)), g.loop)) {
                            if (!i.slideLooper.canLoop())
                                return C(), b({ loop: !1 }, n), void (m = l.merge(m, { loop: !0 }));
                            i.slideLooper.loop();
                        }
                        g.draggable && r.offsetParent && a.length && i.dragHandler.addActivationEvents();
                    }
                }
                function w(e, t) {
                    var n = E();
                    C(), b(l.merge({ startIndex: n }, e), t), d.emit("reInit");
                }
                function C() {
                    i.dragHandler.removeAllEvents(),
                        i.animation.stop(),
                        i.eventStore.removeAll(),
                        i.translate.clear(),
                        i.slideLooper.clear(),
                        c.destroy();
                }
                function x(e) {
                    var t = i[e ? "target" : "location"].get(),
                        n = g.loop ? "removeOffset" : "constrain";
                    return i.slidesInView.check(i.limit[n](t));
                }
                function S(e, t, n) {
                    g.active &&
                        !f &&
                        (i.scrollBody.useBaseMass().useSpeed(t ? 100 : g.speed), i.scrollTo.index(e, n || 0));
                }
                function E() {
                    return i.index.get();
                }
                var T = {
                    canScrollNext: function () {
                        return i.index.clone().add(1).get() !== E();
                    },
                    canScrollPrev: function () {
                        return i.index.clone().add(-1).get() !== E();
                    },
                    clickAllowed: function () {
                        return i.dragHandler.clickAllowed();
                    },
                    containerNode: function () {
                        return r;
                    },
                    internalEngine: function () {
                        return i;
                    },
                    destroy: function () {
                        f || ((f = !0), o.removeAll(), C(), d.emit("destroy"));
                    },
                    off: p,
                    on: u,
                    plugins: function () {
                        return s;
                    },
                    previousScrollSnap: function () {
                        return i.indexPrevious.get();
                    },
                    reInit: h,
                    rootNode: function () {
                        return e;
                    },
                    scrollNext: function (e) {
                        S(i.index.clone().add(1).get(), !0 === e, -1);
                    },
                    scrollPrev: function (e) {
                        S(i.index.clone().add(-1).get(), !0 === e, 1);
                    },
                    scrollProgress: function () {
                        return i.scrollProgress.get(i.location.get());
                    },
                    scrollSnapList: function () {
                        return i.scrollSnaps.map(i.scrollProgress.get);
                    },
                    scrollTo: S,
                    selectedScrollSnap: E,
                    slideNodes: function () {
                        return a;
                    },
                    slidesInView: x,
                    slidesNotInView: function (e) {
                        var t = x(e);
                        return i.slideIndexes.filter(function (e) {
                            return -1 === t.indexOf(e);
                        });
                    },
                };
                return (
                    b(t, n),
                    o.add(window, "resize", function () {
                        var t = l.atMedia(m),
                            n = !l.areEqual(t, g),
                            s = i.axis.measureSize(e.getBoundingClientRect()),
                            r = y !== s,
                            a = c.haveChanged();
                        (r || n || a) && w(), d.emit("resize");
                    }),
                    setTimeout(function () {
                        return d.emit("init");
                    }, 0),
                    T
                );
            }
            (is.globalOptions = void 0), (is.optionsHandler = ns);
            class ss {
                constructor() {
                    is(document.getElementById("cart-carousel").querySelector(".cart-embla__viewport"), {
                        loop: !0,
                        slidesToScroll: "auto",
                        containScroll: "trimSnaps",
                    });
                }
                destroy() {}
            }
            class rs extends V {
                constructor(e) {
                    super(e, "ajax-cart"),
                        (this.ajaxCart = new oi($("[data-ajax-cart]", this.$container).first())),
                        this.$container.find("[cart-collection]").map((e, t) => {
                            new ss(t);
                        }),
                        this.$container.find("[data-quick-add]").map((e, t) => {
                            new fe(t);
                        }),
                        (this.expanderGroup = new Te(this.$container.find("[data-expander-group]"))),
                        (this.ajaxFormManager = new oe()),
                        (this.callbacks = {
                            changeSuccess: (e) => this.ajaxCart.onChangeSuccess(e.cart),
                            changeFail: (e) => this.ajaxCart.onChangeFail(e.description),
                        }),
                        $(window).on(re, this.callbacks.changeSuccess),
                        $(window).on(ae, this.callbacks.changeFail),
                        ee().then((e) => {
                            this.ajaxCart.render(e), q().cart && this.open({ delay: !0 });
                        });
                }
                open(e) {
                    let { delay: t = !1 } = e;
                    setTimeout(
                        () => {
                            this.ajaxCart.open();
                        },
                        t ? 500 : 0
                    );
                }
                close() {
                    this.ajaxCart.close();
                }
                onSelect() {
                    this.open();
                }
                onDeselect() {
                    this.close();
                }
                onUnload() {
                    this.ajaxCart.destroy(),
                        $(window).off(re, this.callbacks.changeSuccess),
                        $(window).off(ae, this.callbacks.changeFail);
                }
            }
            class as {
                constructor(e) {
                    (this.$el = $(e)), this.initializeTimer();
                }
                initializeTimer() {
                    const e = this.$el.data("timer");
                    let t = new Date(e).getTime();
                    const n = setInterval(() => {
                        const e = new Date().getTime();
                        let i = t - e;
                        i < 0 ? clearInterval(n) : this.updateTimerElements(i, 864e5, 36e5, 6e4, 1e3);
                    }, 1e3);
                }
                updateTimerElements(e, t, n, i, s) {
                    this.$el.find(".js-timer-days").text(("0" + Math.floor(e / t)).slice(-2)),
                        this.$el.find(".js-timer-hours").text(("0" + Math.floor((e % t) / n)).slice(-2)),
                        this.$el.find(".js-timer-minutes").text(("0" + Math.floor((e % n) / i)).slice(-2)),
                        this.$el.find(".js-timer-seconds").text(("0" + Math.floor((e % i) / s)).slice(-2));
                }
                destroy() {}
            }
            class os extends V {
                constructor(e) {
                    super(e, "hero"),
                        (this.$timer = $("[data-timer]", this.$container)),
                        this.$timer.length && (this.$timer = new as(this.$timer)),
                        (this.$newsletterForm = $(ln, this.$container)),
                        this.$newsletterForm.length && (this.newsletterForm = new cn(this.$newsletterForm)),
                        (this.$form = $("[data-newsletter-form]", this.$container)),
                        this.$form.length &&
                            ((this.newsletterForm = new Ei(this.$form)),
                            (this.ajaxForm = new wi(this.$form, {
                                listId: this.$form.data("klaviyo-list-id"),
                                source: this.$form.data("klaviyo-source"),
                                countryCode: this.$form.data("country-code"),
                                onSubmitStart: () => this.newsletterForm.onSubmitStart(),
                                onSubmitFail: (e) => this.newsletterForm.onSubmitFail(e),
                                onSubscribeSuccess: (e) => this.newsletterForm.onSubscribeSuccess(e),
                                onSubscribeFail: (e) => this.newsletterForm.onSubscribeFail(e),
                            })));
                }
            }
            (window.app = window.app || {}),
                (window.app.taxi = null),
                ((e) => {
                    void 0 === typeof e && console.warn("jQuery must be loaded before app.js");
                    const t = e(document.body),
                        n = /(^|\s)template-\S+/g;
                    window.addEventListener("resize", F), z();
                    const i = new X();
                    i.register("header", yi),
                        i.register("footer", Ti),
                        i.register("mobile-menu", Ii),
                        i.register("ajax-cart", rs),
                        i.register("hero", os);
                    const s = i.getSingleInstance("header"),
                        r = i.getSingleInstance("mobile-menu"),
                        a = i.getSingleInstance("ajax-cart");
                    window.Shopify && window.Shopify.designMode && e("a").attr("data-taxi-ignore", !0),
                        e("a").attr("data-taxi-ignore", !0);
                    const o = new A({
                        renderers: {
                            default: Y,
                            index: ke,
                            collection: Me,
                            product: fn,
                            page: Tn,
                            cart: mn,
                            blog: _n,
                            article: kn,
                            search: Dn,
                            addresses: On,
                            account: Fn,
                            login: zn,
                            "page-custom": Tn,
                            "page-about": Tn,
                            "page-legal": Tn,
                            "page-404": Tn,
                            "page-contact": Tn,
                            "page-faq": qn,
                            "page-sizecharts": Tn,
                            "page-rewards": Un,
                            password: Wn,
                            "list-collections": Y,
                            404: Y,
                            register: Y,
                            order: Y,
                            reset_password: Y,
                            "reset-password": Y,
                            error: Y,
                        },
                    });
                    o.on("NAVIGATE_OUT", (e) => {
                        let { from: t, trigger: n } = e;
                        a.close(), s.onNavigateOut(), r.close();
                    }),
                        o.on("NAVIGATE_IN", (e) => {
                            let { to: i, trigger: r } = e;
                            t.removeClass((e, t) =>
                                t
                                    .split(" ")
                                    .map((e) => e.match(n))
                                    .join(" ")
                            ),
                                t.addClass(() =>
                                    i.page.body.classList.value
                                        .split(" ")
                                        .map((e) => e.match(n))
                                        .join(" ")
                                ),
                                s.onNavigateIn(i);
                        }),
                        o.on("NAVIGATE_END", (e) => {
                            let { to: t, from: n, trigger: i } = e;
                            q().cart && a.open({ delay: !0 }), H();
                        }),
                        (window.app.taxi = o),
                        e(".in-page-link").on("click", (t) => B(e(t.currentTarget.hash))),
                        B(e(window.location.hash)),
                        window.addEventListener("resize", I(250, R)),
                        document.addEventListener("scroll", I(100, R)),
                        R(),
                        (function () {
                            const e = navigator.userAgent,
                                t = document.documentElement;
                            let n,
                                i = t.className;
                            /iPad|iPhone|iPod/.test(e) &&
                                !window.MSStream &&
                                ((i += " ua-ios"),
                                (n = e.match(/((\d+_?){2,3})\slike\sMac\sOS\sX/)),
                                n && (i += " ua-ios-" + n[1]),
                                /Twitter/.test(e) && (i += " ua-ios-twitter"),
                                /CriOS/.test(e) && (i += " ua-ios-chrome")),
                                /Android/.test(e) &&
                                    ((n = e.match(/Android\s([0-9]*)/)),
                                    (i += n ? " ua-aos ua-aos-" + n[1].replace(/\./g, "_") : " ua-aos")),
                                /webOS|hpwOS/.test(e) && (i += " ua-webos"),
                                /SamsungBrowser/.test(e) && (i += " ua-samsung"),
                                -1 != e.indexOf("safari") && (e.indexOf("chrome") > -1 || (i += " ua-safari")),
                                (t.className = i);
                        })(),
                        H(),
                        window.history &&
                            window.history.scrollRestoration &&
                            (window.history.scrollRestoration = "manual"),
                        e(() => {
                            // document.body.classList.add("is-loaded");
                        });
                })(window.jQuery);
        })();
})();
